export const lastMax = 1778660601000; export default {
    "localization": [
        {
            "id": "addChild_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter date of birth",
            "be": "Увядзіце дату нараджэння"
        },
        {
            "id": "addChild_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "addChild_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "addChild_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "addChild_sex.placeholder",
            "ru": "Укажите пол",
            "en": "Specify gender",
            "be": "Пазначце пол"
        },
        {
            "id": "addChild.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "addChild.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "addChild.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "addChild.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "addChild.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "addRelativeWithOtherInt_relKind.placeholder",
            "ru": "Укажите кем приходится",
            "en": "Specify relation",
            "be": "Пазначце кім прыходзіцца"
        },
        {
            "id": "addRelativeWithOtherInt_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter date of birth",
            "be": "Увядзіце дату нараджэння"
        },
        {
            "id": "addRelativeWithOtherInt_sex.placeholder",
            "ru": "Укажите пол",
            "en": "Specify gender",
            "be": "Пазначце пол"
        },
        {
            "id": "addRelativeWithOtherInt_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "addRelativeWithOtherInt_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "addRelativeWithOtherInt_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "addRelativeWithOtherInt_phones.placeholder",
            "ru": "Введите номер телефона родственника",
            "en": "Enter relative's phone number",
            "be": "Калі ласка, увядзіце нумар тэлефона сваяка"
        },
        {
            "id": "addRelativeWithOtherInt.relKind",
            "ru": "КЕМ ПРИХОДИТСЯ",
            "en": "RELATION ",
            "be": "КІМ ПРЫХОДЗІЦЦА"
        },
        {
            "id": "addRelativeWithOtherInt.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "addRelativeWithOtherInt.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "addRelativeWithOtherInt.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "addRelativeWithOtherInt.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "addRelativeWithOtherInt.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "addRelativeWithOtherInt.phones",
            "ru": "НОМЕР ТЕЛЕФОНА В ФОРМАТЕ {code}...",
            "en": "PHONE NUMBER IN FORMAT {code}...",
            "be": "НУМАР ТЭЛЕФОН У ФАРМАЦЕ {code} ..."
        },
        {
            "id": "addRelativeWithOther_relKind.placeholder",
            "ru": "Укажите кем приходится",
            "en": "Specify relation",
            "be": "Пазначце кім прыходзіцца"
        },
        {
            "id": "addRelativeWithOther_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter date of birth",
            "be": "Увядзіце дату нараджэння"
        },
        {
            "id": "addRelativeWithOther_sex.placeholder",
            "ru": "Укажите пол",
            "en": "Specify gender",
            "be": "Пазначце пол"
        },
        {
            "id": "addRelativeWithOther_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "addRelativeWithOther_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "addRelativeWithOther_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "addRelativeWithOther_phones.placeholder",
            "ru": "Введите номер телефона родственника",
            "en": "Enter relative's phone number",
            "be": "Калі ласка, увядзіце нумар тэлефона сваяка"
        },
        {
            "id": "addRelativeWithOther.relKind",
            "ru": "КЕМ ПРИХОДИТСЯ",
            "en": "RELATION ",
            "be": "КІМ ПРЫХОДЗІЦЦА"
        },
        {
            "id": "addRelativeWithOther.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "addRelativeWithOther.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "addRelativeWithOther.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "addRelativeWithOther.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "addRelativeWithOther.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "addRelativeWithOther.phones",
            "ru": "НОМЕР ТЕЛЕФОНА В ФОРМАТЕ +375...",
            "en": "PHONE NUMBER IN FORMAT +52...",
            "be": "НУМАР ТЭЛЕФОН У ФАРМАЦЕ +375 ..."
        },
        {
            "id": "addRelative_relKind.placeholder",
            "ru": "Укажите кем приходится",
            "en": "Specify relation",
            "be": "Пазначце кім прыходзіцца"
        },
        {
            "id": "addRelative_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter date of birth",
            "be": "Увядзіце дату нараджэння"
        },
        {
            "id": "addRelative_sex.placeholder",
            "ru": "Укажите пол",
            "en": "Select gender",
            "be": "Пазначце пол"
        },
        {
            "id": "addRelative_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "addRelative_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "addRelative_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "addRelative_phones.placeholder",
            "ru": "Введите номер телефона родственника",
            "en": "Enter relative's phone number",
            "be": "Калі ласка, увядзіце нумар тэлефона сваяка"
        },
        {
            "id": "addRelative.relKind",
            "ru": "КЕМ ПРИХОДИТСЯ",
            "en": "RELATION ",
            "be": "КІМ ПРЫХОДЗІЦЦА"
        },
        {
            "id": "addRelative.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "addRelative.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "addRelative.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "addRelative.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "addRelative.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "addRelative.phones",
            "ru": "НОМЕР ТЕЛЕФОНА В ФОРМАТЕ +375...",
            "en": "PHONE NUMBER IN FORMAT +52...",
            "be": "НУМАР ТЭЛЕФОН У ФАРМАЦЕ +375 ..."
        },
        {
            "id": "button.agree",
            "ru": "СОГЛАСЕН(А)",
            "en": "AGREE",
            "be": "ЗГОДНЫ(А)"
        },
        {
            "id": "button.check_services",
            "ru": "ПОСМОТРЕТЬ",
            "en": "VIEW",
            "be": "ПАГЛЯДЗЕЦЬ"
        },
        {
            "id": "button.create_relative_card",
            "ru": "СОЗДАТЬ ЗАПИСЬ",
            "en": "CREATE",
            "be": "СТВАРЫЦЬ ЗАПІС"
        },
        {
            "id": "button.invite_relative",
            "ru": "ПРИГЛАСИТЬ РОДСТВЕННИКА",
            "en": "INVITE RELATIVE",
            "be": "ЗАПРАСІЦЬ СВАЯКА"
        },
        {
            "id": "button.join_the_family",
            "ru": "ПРИСОЕДИНИТЬСЯ",
            "en": "JOIN",
            "be": "ДАЛУЧЫЦЦА"
        },
        {
            "id": "button.not_agree",
            "ru": "НЕ СОГЛАСЕН(А)",
            "en": "DISAGREE",
            "be": "НЕ ЗГОДНЫ (А)"
        },
        {
            "id": "button.stay",
            "ru": "ОСТАТЬСЯ",
            "en": "STAY",
            "be": "ЗАСТАЦЦА"
        },
        {
            "id": "button.understand",
            "ru": "ПОНЯТНО",
            "en": "UNDERSTOOD",
            "be": "ЗРАЗУМЕЛА"
        },
        {
            "id": "buttons.add_to_calendar",
            "ru": "Добавить в календарь",
            "en": "Add to calendar",
            "be": "Дадаць у каляндар"
        },
        {
            "id": "buttons.addFeedback",
            "ru": "ДОБАВИТЬ ОТЗЫВ",
            "en": "ADD A FEEDBACK",
            "be": "ДАДАЦЬ ВОДГУК"
        },
        {
            "id": "buttons.choose_doctor",
            "ru": "ВЫБРАТЬ ВРАЧА",
            "en": "SELECT DOCTOR",
            "be": "ВЫБРАЦЬ ЛЕКАРА"
        },
        {
            "id": "buttons.cancel",
            "ru": "ОТМЕНИТЬ",
            "en": "CANCEL",
            "be": "АДМЯНIЦЬ"
        },
        {
            "id": "buttons.cancel_visit",
            "ru": "Отменить визит",
            "en": "Cancel visit",
            "be": "Скасаваць візіт"
        },
        {
            "id": "buttons.cancel_manual_visit",
            "ru": "Удалить визит",
            "en": "Delete visit",
            "be": "Выдаліць візіт"
        },
        {
            "id": "buttons.close",
            "ru": "ЗАКРЫТЬ",
            "en": "CLOSE",
            "be": "ЗАЧЫНІЦЬ"
        },
        {
            "id": "buttons.code_confirm",
            "ru": "ПОДТВЕРДИТЬ КОД",
            "en": "CONFIRM CODE",
            "be": "ПАЦВЕРДЗІЦЬ КОД"
        },
        {
            "id": "buttons.confirm",
            "ru": "ПОДТВЕРДИТЬ",
            "en": "CONFIRM",
            "be": "ПАЦВЕРДЗІЦЬ"
        },
        {
            "id": "buttons.confirm_all_payment",
            "ru": "ПОДТВЕРДИТЬ ВЕСЬ СЧЕТ",
            "en": "CONFIRM PAYMENT",
            "be": "ПАЦВЕРДЗІЦЬ УВЕСЬ КОШТ"
        },
        {
            "id": "buttons.confirm_payment_partially",
            "ru": "ПОДТВЕРДИТЬ СЧЕТ ЧАСТИЧНО",
            "en": "CONFIRM PAYMENT PARTIALLY",
            "be": "ЧАСТКОВА"
        },
        {
            "id": "buttons.confirmed",
            "ru": "ПОДТВЕРЖДАЮ",
            "en": "CONFIRM",
            "be": "ПАЦВЯРДЖАЮ"
        },
        {
            "id": "buttons.continue",
            "ru": "ПРОДОЛЖИТЬ",
            "en": "CONTINUE",
            "be": "ПРАЦЯГНУЦЬ"
        },
        {
            "id": "buttons.correct_answer",
            "ru": "ИСПРАВИТЬ ОТВЕТ",
            "en": "CORRECT ANSWER",
            "be": "ВЫПРАВІЦЬ АДКАЗ"
        },
        {
            "id": "buttons.create_relative_card",
            "ru": "Добавить ребенка",
            "en": "Add a child",
            "be": "Дадаць дзіцяці"
        },
        {
            "id": "buttons.add_relative",
            "ru": "Добавить родственника",
            "en": "Add a relative",
            "be": "Дадаць сваяка"
        },
        {
            "id": "buttons.delete",
            "ru": "УДАЛИТЬ",
            "en": "DELETE",
            "be": "ВЫДАЛIЦЬ"
        },
        {
            "id": "buttons.edit",
            "ru": "РЕДАКТИРОВАТЬ",
            "en": "EDIT",
            "be": "РЭДАГАВАЦЬ"
        },
        {
            "id": "buttons.enter_spouse_code",
            "ru": "Ввести код своего супруга(и)",
            "en": "Enter spouse code",
            "be": "Увесці код свайго сваяка"
        },
        {
            "id": "buttons.enter_to_aibolit",
            "ru": "ВХОД В AIBOLIT",
            "en": "LOGIN TO AIBOLIT",
            "be": "УВАХОД У AIBOLIT"
        },
        {
            "id": "buttons.exit",
            "ru": "ВЫЙТИ",
            "en": "LOG OUT",
            "be": "ВЫЙСЦІ"
        },
        {
            "id": "buttons.facebook",
            "ru": "FACEBOOK",
            "en": "FACEBOOK",
            "be": "FACEBOOK"
        },
        {
            "id": "buttons.fill",
            "ru": "ЗАПОЛНИТЬ",
            "en": "FILL IN",
            "be": "Запоўнiць"
        },
        {
            "id": "buttons.find_doctor",
            "ru": "НАЙТИ ВРАЧА",
            "en": "FIND DOCTOR",
            "be": "ЗНАЙСЦІ ЛЕКАРА"
        },
        {
            "id": "buttons.further",
            "ru": "ДАЛЕЕ",
            "en": "NEXT",
            "be": "ДАЛЕЙ"
        },
        {
            "id": "buttons.google",
            "ru": "GOOGLE",
            "en": "GOOGLE",
            "be": "GOOGLE"
        },
        {
            "id": "buttons.invite_relative",
            "ru": "Пригласить супруга (супругу)",
            "en": "Invite spouse",
            "be": "Запрасіць сваяка"
        },
        {
            "id": "buttons.join_the_family",
            "ru": "ПРИСОЕДИНИТЬСЯ К СЕМЬЕ",
            "en": "JOIN FAMILY",
            "be": "Далучыцца да сям'і"
        },
        {
            "id": "buttons.later",
            "ru": "ПОЗЖЕ",
            "en": "LATER",
            "be": "Пазней"
        },
        {
            "id": "buttons.link_medical_program",
            "ru": "ВХОД В AIBOLIT",
            "en": "LOGIN TO AIBOLIT",
            "be": "УВАХОД У AIBOLIT"
        },
        {
            "id": "buttons.make_appointment_doctor",
            "ru": "ЗАПИСАТЬСЯ НА ПРИЁМ",
            "en": "MAKE AN APPOINTMENT",
            "be": "ЗАПІСАЦЦА НА ПРЫЁМ"
        },
        {
            "id": "buttons.make_appointment_medcenter",
            "ru": "ЗАПИСАТЬСЯ В МЕДЦЕНТР",
            "en": "MAKE AN APPOINTMENT",
            "be": "ЗАПІСАЦЦА Ў МЕДЦЭНТР"
        },
        {
            "id": "buttons.make_appointment_visit",
            "ru": "ЗАПИСАТЬСЯ НА ПРИЁМ",
            "en": "MAKE AN APPOINTMENT",
            "be": "ЗАПІСАЦЦА НА ПРЫЁМ"
        },
        {
            "id": "buttons.mark_every_service",
            "ru": "ОТМЕТЬТЕ КАЖДУЮ УСЛУГУ",
            "en": "MARK EACH SERVICE",
            "be": "Адзначце кожную паслугу"
        },
        {
            "id": "buttons.my_linking_code",
            "ru": "Мой код для присоединения к семье",
            "en": "My code to join the family",
            "be": "Мой код для далучэння да сям'і"
        },
        {
            "id": "buttons.no",
            "ru": "НЕТ",
            "en": "NO",
            "be": "НЕ"
        },
        {
            "id": "buttons.registry_numbers",
            "ru": "НОМЕРА РЕГИСТРАТУРЫ",
            "en": "REGISTRATION NUMBERS",
            "be": "НУМАРА РЭГІСТРАТУРЫ"
        },
        {
            "id": "buttons.reject",
            "ru": "ОТКЛОНИТЬ",
            "en": "REJECT",
            "be": "АДХІЛІЛІЦЬ"
        },
        {
            "id": "buttons.reject_all_payment",
            "ru": "ОТКЛОНИТЬ ВЕСЬ СЧЕТ",
            "en": "REJECT PAYMENT",
            "be": "АДХІЛІЛІЦЬ УВЕСЬ КОШТ"
        },
        {
            "id": "buttons.reschedule_visit",
            "ru": "Перенести дату/время визита",
            "en": "Change the date / time of the visit",
            "be": "Перанесці дату/час візіту"
        },
        {
            "id": "buttons.reset_filter",
            "ru": "СБРОСИТЬ ФИЛЬТР",
            "en": "RESET FILTERS",
            "be": "СКІНУЦЬ ФІЛЬТР"
        },
        {
            "id": "buttons.save",
            "ru": "СОХРАНИТЬ",
            "en": "SAVE",
            "be": "ЗАХАВАЦЬ"
        },
        {
            "id": "buttons.save_changes",
            "ru": "СОХРАНИТЬ ИЗМЕНЕНИЯ",
            "en": "SAVE CHANGES",
            "be": "ЗАХАВАЦЬ ЗМЕНЫ"
        },
        {
            "id": "buttons.send",
            "ru": "ОТПРАВИТЬ",
            "en": "SEND",
            "be": "АДПРАВІЦЬ"
        },
        {
            "id": "buttons.send_feedback",
            "ru": "ДОБАВИТЬ ОТЗЫВ",
            "en": "ADD FEEDBACK",
            "be": "ДАДАЦЬ ВОДГУК"
        },
        {
            "id": "buttons.settings",
            "ru": "Настройки",
            "en": "Settings",
            "be": "Налады"
        },
        {
            "id": "buttons.share_app",
            "ru": "Поделиться приложением",
            "en": "Share app",
            "be": "Падзяліцца дадаткам"
        },
        {
            "id": "buttons.show_on_map",
            "ru": "Показать на карте",
            "en": "Show on map",
            "be": "Паказаць на карце"
        },
        {
            "id": "buttons.sign_in",
            "ru": "Вход",
            "en": "Login",
            "be": "Уваход"
        },
        {
            "id": "buttons.switch_patient",
            "ru": "Переназначить посетителя",
            "en": "Reassign visitor",
            "be": "Перапрызначыць наведвальніка"
        },
        {
            "id": "buttons.try_again",
            "ru": "ПОПРОБОВАТЬ СНОВА",
            "en": "TRY AGIAN",
            "be": "ПАСПРАБАВАЦЬ ЯШЧЭ"
        },
        {
            "id": "buttons.upgradeApp",
            "ru": "ОБНОВИТЬ ПРИЛОЖЕНИЕ",
            "en": "UPDATE APPLICATION",
            "be": "АБНАВIЦЬ ДАДАТАК"
        },
        {
            "id": "buttons.write",
            "ru": "НАПИСАТЬ",
            "en": "WRITE",
            "be": "НАПІСАЦЬ"
        },
        {
            "id": "buttons.yes",
            "ru": "ДА",
            "en": "YES",
            "be": "ТАК"
        },
        {
            "id": "corporatePrograms.epam",
            "ru": "EPAM Health Care",
            "en": "EPAM Health Care",
            "be": "EPAM Health Care"
        },
        {
            "id": "corporatePrograms.no",
            "ru": "Без программы",
            "en": "Without program",
            "be": "Без праграмы"
        },
        {
            "id": "corporatePrograms.bns",
            "ru": "Белнефтестрах",
            "en": "Белнефтестрах",
            "be": "Белнафтастрах"
        },
        {
            "id": "days.short.fri",
            "ru": "ПТ",
            "en": "Fr",
            "be": "ПТ"
        },
        {
            "id": "days.short.mon",
            "ru": "ПН",
            "en": "Mo",
            "be": "ПН"
        },
        {
            "id": "days.short.sat",
            "ru": "СБ",
            "en": "Sa",
            "be": "СБ"
        },
        {
            "id": "days.short.sun",
            "ru": "ВС",
            "en": "Su",
            "be": "НД"
        },
        {
            "id": "days.short.thu",
            "ru": "ЧТ",
            "en": "Th",
            "be": "ЧЦ"
        },
        {
            "id": "days.short.tue",
            "ru": "ВТ",
            "en": "Tu",
            "be": "АЎТ"
        },
        {
            "id": "days.short.wed",
            "ru": "СР",
            "en": "We",
            "be": "СР"
        },
        {
            "id": "detailsNavigation.MedCenterFeedbacks",
            "ru": "Отзывы о медцентре",
            "en": "Medical сenter feedback",
            "be": "Водгукі аб медцэнтры"
        },
        {
            "id": "detailsNavigation.MedCenterInfo",
            "ru": "Информация о медцентре",
            "en": "Information about the medical center",
            "be": "Інфармацыя пра медцэнтры"
        },
        {
            "id": "detailsNavigation.DoctorList",
            "ru": "Специалисты медцентра",
            "en": "Medical сenter specialists",
            "be": "Спецыялісты медцэнтра"
        },
        {
            "id": "detailsNavigation.MedCenterServices",
            "ru": "Услуги медцентра",
            "en": "Medical сenter services",
            "be": "Паслугі медцэнтра"
        },
        {
            "id": "doctors*.few",
            "ru": "{{count}} ВРАЧА",
            "en": "{{count}} DOCTOR",
            "be": "{{count}} ЛЕКАРА"
        },
        {
            "id": "doctors*.many",
            "ru": "{{count}} ВРАЧЕЙ",
            "en": "{{count}} DOCTORS",
            "be": "{{count}} лекараў"
        },
        {
            "id": "doctors*.one",
            "ru": "{{count}} ВРАЧ",
            "en": "{{count}} DOCTOR",
            "be": "{{count}} лекараў"
        },
        {
            "id": "doctors*.zero",
            "ru": "НЕТ ВРАЧЕЙ",
            "en": "NO DOCTORS",
            "be": "Лекараў няма"
        },
        {
            "id": "doctorsDetailsNavigation.DoctorFeedbacks",
            "ru": "Отзывы о враче",
            "en": "Doctor feedback",
            "be": "Водгукі пра лекара"
        },
        {
            "id": "doctorsDetailsNavigation.DoctorInfo",
            "ru": "Информация о враче",
            "en": "Information about the doctor",
            "be": "Інфармацыя пра лекара"
        },
        {
            "id": "doctorsDetailsNavigationWithFeedbacks.myFeedback",
            "ru": "Мой отзыв",
            "en": "My feedback",
            "be": "Мой водгук"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.fullName",
            "ru": "ФИО",
            "en": "Full name",
            "be": "ПРОЗВІШЧА, ІМЯ, ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.qualification",
            "ru": "Категория",
            "en": "Category",
            "be": "Катэгорыя"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.specialization",
            "ru": "Специальность",
            "en": "Specialty",
            "be": "Спецыяльнасць"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.profile",
            "ru": "Профиль",
            "en": "Profile",
            "be": "Профіль"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.worksAt",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "Медцэнтр"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.workStart",
            "ru": "Стаж",
            "en": "Experience",
            "be": "Стаж"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.academicTitle",
            "ru": "Ученое звание",
            "en": "Academic title",
            "be": "Вучонае званне"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.category",
            "ru": "Категория",
            "en": "Category",
            "be": "Катэгорыя"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.degree",
            "ru": "Ученая степень",
            "en": "Academic degree",
            "be": "Вучоная ступень"
        },
        {
            "id": "doctorsInfoFieldsWithDescription.experienceYears",
            "ru": "Стаж (лет)",
            "en": "Experience (Years)",
            "be": "Стаж (Гадоу)"
        },
        {
            "id": "doctorsInfoFields.fullName",
            "ru": "ФИО",
            "en": "Full name",
            "be": "ПРОЗВІШЧА, ІМЯ, ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "doctorsInfoFields.qualification",
            "ru": "Категория",
            "en": "Category",
            "be": "Катэгорыя"
        },
        {
            "id": "doctorsInfoFields.specialization",
            "ru": "Специальность",
            "en": "Specialty",
            "be": "Спецыяльнасць"
        },
        {
            "id": "doctorsInfoFields.profile",
            "ru": "Профиль",
            "en": "Profile",
            "be": "Профіль"
        },
        {
            "id": "doctorsInfoFields.worksAt",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "Медцэнтр"
        },
        {
            "id": "doctorsInfoFields.workStart",
            "ru": "Стаж",
            "en": "Experience",
            "be": "Стаж"
        },
        {
            "id": "doctorSort.byDate",
            "ru": "По дате визита",
            "en": "By visit date",
            "be": "Па даце візіту"
        },
        {
            "id": "doctorSort.byFeedbacks",
            "ru": "По количеству отзывов",
            "en": "By number of feedback",
            "be": "Па колькасці водгукаў"
        },
        {
            "id": "doctorSort.byName",
            "ru": "По фамилии",
            "en": "By last name",
            "be": "Па прозвішчы"
        },
        {
            "id": "doctorSort.byRecommend",
            "ru": "По количеству положительных рекомендаций",
            "en": "By number of positive recommendations",
            "be": "Па колькасці станоўчых рэкамендацый"
        },
        {
            "id": "doctorSort.byRecommendIndex",
            "ru": "По индексу рекомендаций",
            "en": "By recommendation index",
            "be": "Па індэксе рэкамендацый"
        },
        {
            "id": "drugs",
            "ru": "СПИСОК ПРЕПАРАТОВ",
            "en": "LIST OF DRUGS",
            "be": "СПІС ПРЭПАРАТАЎ"
        },
        {
            "id": "drugs-address*.few",
            "ru": "{{count}} ДОСТУПНЫХ ВАРИАНТА",
            "en": "{{count}} AVAILABLE OPTIONS",
            "be": "{{count}} даступных варыянтаў"
        },
        {
            "id": "drugs-address*.many",
            "ru": "{{count}} ДОСТУПНЫХ ВАРИАНТА",
            "en": "{{count}} AVAILABLE OPTIONS",
            "be": "{{count}} даступных варыянтаў"
        },
        {
            "id": "drugs-address*.one",
            "ru": "{{count}} ДОСТУПНЫЙ ВАРИАНТ",
            "en": "{{count}} AVAILABLE OPTION",
            "be": "{{count}} даступных варыянтаў"
        },
        {
            "id": "drugs-results*.few",
            "ru": "{{count}} РЕЗУЛЬТАТА",
            "en": "{{count}} RESULT",
            "be": "{{count}} ВЫНІКУ"
        },
        {
            "id": "drugs-results*.many",
            "ru": "{{count}} РЕЗУЛЬТАТОВ",
            "en": "{{count}} RESULTS",
            "be": "{{count}} ВЫНІКАЎ"
        },
        {
            "id": "drugs-results*.one",
            "ru": "{{count}} РЕЗУЛЬТАТ",
            "en": "{{count}} RESULT",
            "be": "{{count}} ВЫНІК"
        },
        {
            "id": "drugs-results*.other",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "drugs-results*.zero",
            "ru": "НЕТ РЕЗУЛЬТАТОВ",
            "en": "NO RESULTS",
            "be": "ВЫНІКАЎ НЯМА"
        },
        {
            "id": "drugsTotal*.few",
            "ru": "{{count}} ПРЕПАРАТА ИЗ {total}",
            "en": "{{count}} DRUGS OF {{total}}",
            "be": "{{count}} прэпарат з {{count}}"
        },
        {
            "id": "drugsTotal*.many",
            "ru": "{{count}} ПРЕПАРАТОВ ИЗ {total}",
            "en": "{{count}} DRUGS OF {{total}}",
            "be": "{{count}} прэпарат з {{count}}"
        },
        {
            "id": "drugsTotal*.NaN",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "drugsTotal*.one",
            "ru": "{{count}} ПРЕПАРАТ ИЗ {total}",
            "en": "{{count}} DRUG OF {{total}}",
            "be": "{{count}} прэпарат з {{count}}"
        },
        {
            "id": "drugsTotal*.other",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "drugsTotal*.zero",
            "ru": "ПРЕПАРАТЫ",
            "en": "DRUGS",
            "be": "ПРЭПАРАТЫ"
        },
        {
            "id": "drugs*.few",
            "ru": "{{count}} ПРЕПАРАТА",
            "en": "{{count}} DRUGS",
            "be": "{{count}} прэпарат"
        },
        {
            "id": "drugs*.many",
            "ru": "{{count}} ПРЕПАРАТОВ",
            "en": "{{count}} DRUGS",
            "be": "{{count}} прэпарат"
        },
        {
            "id": "drugs*.NaN",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "drugs*.one",
            "ru": "{{count}} ПРЕПАРАТ",
            "en": "{{count}} DRUG",
            "be": "{{count}} прэпарат"
        },
        {
            "id": "drugs*.other",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "drugs*.zero",
            "ru": "ПРЕПАРАТЫ",
            "en": "NO DRUGS",
            "be": "ПРЭПАРАТЫ"
        },
        {
            "id": "drugstoresSortItems.distance",
            "ru": "ПО РАССТОЯНИЮ",
            "en": "BY DISTANCE",
            "be": "ПА АДЛЕГЛАСЦІ"
        },
        {
            "id": "drugstoresSortItems.rank",
            "ru": "ЛУЧШИЙ ВЫБОР",
            "en": "THE BEST CHOICE",
            "be": "ЛЕПШЫ ВЫБАР"
        },
        {
            "id": "drugstoresSortItems.totalPrice",
            "ru": "ПО ЦЕНЕ",
            "en": "BY PRICE",
            "be": "ПА КОШЦЕ"
        },
        {
            "id": "editAccount_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter date of birth",
            "be": "Увядзіце дату рожения"
        },
        {
            "id": "editAccount_email.placeholder",
            "ru": "Введите ваш e-mail",
            "en": "Enter e-mail",
            "be": "Увядзіце ваш e-mail"
        },
        {
            "id": "editAccount_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "editAccount_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "editAccount_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "editAccount_sex.placeholder",
            "ru": "Введите ваш пол",
            "en": "Specify gender",
            "be": "Увядзіце ваш пол"
        },
        {
            "id": "editAccount.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "editAccount.email",
            "ru": "ВАШ E-MAIL",
            "en": "YOUR E-MAIL",
            "be": "ВАШ E-MAIL"
        },
        {
            "id": "editAccount.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "editAccount.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "editAccount.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "editAccount.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "enrollVisitInfoFields.service",
            "ru": "Услуга",
            "en": "Service",
            "be": "Сэрвіс"
        },
        {
            "id": "enrollVisitInfoFields.serviceDescription",
            "ru": "Описание",
            "en": "Description",
            "be": "Апісанне"
        },
        {
            "id": "enrollVisitInfoFields.date",
            "ru": "Дата",
            "en": "Date",
            "be": "дата"
        },
        {
            "id": "enrollVisitInfoFields.doctorInfo",
            "ru": "Врач",
            "en": "Doctor",
            "be": "лекар"
        },
        {
            "id": "enrollVisitInfoFields.mdInfo",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "медцэнтр"
        },
        {
            "id": "enrollVisitInfoFields.time",
            "ru": "Время",
            "en": "Time",
            "be": "час"
        },
        {
            "id": "error.auth/app-not-authorized",
            "ru": "Во избежание злоупотреблений аутентификация приложения работающего в эмуляторе запрещена.\nЕсли вы хотите использовать приложение в эмуляторе для тестирования, то вам необходимо обратиться в службу технической поддержки для добавления вашего номера в Firebase",
            "en": "In order to avoid abuse of phone authentication in Firebase, it will not work in the emulator.\nBut if you want to use it for testing, you should add a phone number for testing in the Firebase console that will work in the emulator.",
            "be": "Каб пазбегнуць злоўжыванняў аўтэнтыфікацыя тэлефона ў Firebase, ён не будзе працаваць у эмулятары.\nАле калі вы хочаце выкарыстоўваць яго для тэставання, вам варта дадаць нумар тэлефона для тэставання ў кансолі Firebase, які будзе працаваць у эмулятары."
        },
        {
            "id": "error.auth/claims-too-large",
            "ru": "Претензии полезной нагрузки предоставляется setCustomUserClaims () превышает максимально допустимый размер 1000 байт.",
            "en": "The claims payload provided to setCustomUserClaims() exceeds the maximum allowed size of 1000 bytes.",
            "be": "Прэтэнзіі карыснай нагрузкі прадастаўляецца setCustomUserClaims () перавышае максімальна дапушчальны памеры 1000 байт."
        },
        {
            "id": "error.auth/code-expired",
            "ru": "Срок действи СМС-кода истёк. Пожалуйста, отправьте код заново и попробуйте снова.",
            "en": "The SMS code has expired. Please re-send the verification code and try again.",
            "be": "Тэрмін дзеяння СМС-кода неактуальны. Калі ласка, адпраўце код зноў і паспрабуйце яшчэ раз."
        },
        {
            "id": "error.auth/email-already-exists",
            "ru": "Предоставленная электронная почта уже используются для существующего пользователя. Каждый пользователь должен иметь уникальную почту.",
            "en": "The provided e-mail is already in use by an existing user. Each user must have a unique email.",
            "be": "Прадстаўленая электронная пошта ўжо выкарыстоўваецца для існуючага карыстальніка. Кожны карыстальнік павінен мець унікальную пошту."
        },
        {
            "id": "error.auth/id-token-expired",
            "ru": "При условии, Firebase ID маркера истек.",
            "en": "The provided Firebase ID token is expired.",
            "be": "Пры ўмове, Firebase ID маркера мінуў."
        },
        {
            "id": "error.auth/id-token-revoked",
            "ru": "Маркер Firebase ID был аннулирован.",
            "en": "The Firebase ID token has been revoked.",
            "be": "Маркер Firebase ID быў ануляваны."
        },
        {
            "id": "error.auth/insufficient-permission",
            "ru": "Учетные данные используются для инициализации Admin SDK имеет недостаточно прав для доступа к запрошенному ресурсу аутентификации. Смотрите Добавить Firebase в приложение для документации о том, как генерировать удостоверение с соответствующими правами доступа и использовать его для аутентификации администратора SDKs.",
            "en": "The credential used to initialize the Admin SDK has insufficient permission to access the requested Authentication resource. See Add Firebase to your app for documentation on how to generate a credential with appropriate permissions and use it to authenticate the Admin SDKs.",
            "be": "Уліковыя дадзеныя выкарыстоўваюцца для ініцыялізацыі Admin SDK мае недастаткова правоў для доступу да запытанага рэсурсу аўтэнтыфікацыі. Глядзіце Дадаць Firebase ў дадатак для дакументацыі аб тым, як генераваць пасведчанне з адпаведнымі правамі доступу і выкарыстоўваць яго для аўтэнтыфікацыі адміністратара SDKs."
        },
        {
            "id": "error.auth/internal-error",
            "ru": "Ошибка при попытке обработать запрос, проверьте интернет-соединение или обратитесь в поддержку.",
            "en": "Error while trying to process the request, check the Internet connection, or contact support.",
            "be": "Памылка пры спробе апрацаваць запыт, праверце інтэрнэт-злучэнне, або звярніцеся ў падтрымку."
        },
        {
            "id": "error.auth/invalid-argument",
            "ru": "Неверный аргумент был предоставлен метод проверки подлинности. Сообщение об ошибке должно содержать дополнительную информацию.",
            "en": "An invalid argument was provided to an Authentication method. The error message should contain additional information.",
            "be": "Няправільны аргумент быў прадстаўлены метад праверкі сапраўднасці. Паведамленне пра памылку павінна ўтрымліваць дадатковую інфармацыю."
        },
        {
            "id": "error.auth/invalid-claims",
            "ru": "Атрибуты претензии на заказ, предоставляемые setCustomUserClaims () являются недействительными.",
            "en": "The custom claim attributes provided to setCustomUserClaims() are invalid.",
            "be": "Атрыбуты прэтэнзіі на заказ, якія прадстаўляюцца setCustomUserClaims () з'яўляюцца несапраўднымі."
        },
        {
            "id": "error.auth/invalid-continue-uri",
            "ru": "Продолжить URL должны быть действительной строкой URL.",
            "en": "The continue URL must be a valid URL string.",
            "be": "Працягнуць URL павінны быць сапраўднай радком URL."
        },
        {
            "id": "error.auth/invalid-creation-time",
            "ru": "Время создания должна быть действительной строкой даты UTC.",
            "en": "The creation time must be a valid UTC date string.",
            "be": "Час стварэння павінна быць сапраўднай радком даты UTC."
        },
        {
            "id": "error.auth/invalid-credential",
            "ru": "Учетные данные, используемые для аутентификации администратора SDKs не могут быть использованы для выполнения требуемого действия. Некоторые методы аутентификации, такие как createCustomToken () и verifyIdToken () требует SDK для инициализации с сертификатом верительных в отличие от обновления маркера или приложения по умолчанию учетных данных. SeeInitialize в SDK для документации о том, как для аутентификации администратора SDKs с сертификатом удостоверением.",
            "en": "The credential used to authenticate the Admin SDKs cannot be used to perform the desired action. Certain Authentication methods such as createCustomToken() and verifyIdToken() require the SDK to be initialized with a certificate credential as opposed to a refresh token or Application Default credential. SeeInitialize the SDK for documentation on how to authenticate the Admin SDKs with a certificate credential.",
            "be": "Уліковыя дадзеныя, якія выкарыстоўваюцца для аўтэнтыфікацыі адміністратара SDKs не могуць быць выкарыстаны для выканання патрабаванага дзеянні. Некаторыя метады аўтэнтыфікацыі, такія як createCustomToken () і verifyIdToken () патрабуе SDK для ініцыялізацыі з сертыфікатам даверчых у адрозненне ад абнаўлення маркера або прыкладання па змаўчанні уліковых дадзеных. SeeInitialize ў SDK для дакументацыі аб тым, як для аўтэнтыфікацыі адміністратара SDKs з сертыфікатам пасведчаннем."
        },
        {
            "id": "error.auth/invalid-disabled-field",
            "ru": "Предоставленное значение для инвалидов собственности пользователя недействительно. Это должно быть логическое значение.",
            "en": "The provided value for the disabled user property is invalid. It must be a boolean.",
            "be": "Прадастаўленае значэнне для інвалідаў уласнасці карыстальніка несапраўднае. Гэта павінна быць лагічнае значэнне."
        },
        {
            "id": "error.auth/invalid-display-name",
            "ru": "Предоставленное значение свойства пользователя DISPLAYNAME является недействительным. Она должна быть не пустая строка.",
            "en": "The provided value for the displayName user property is invalid. It must be a non-empty string.",
            "be": "Прадастаўленае значэнне ўласцівасці карыстальніка DISPLAYNAME з'яўляецца несапраўдным. Яна павінна быць не пусты радок."
        },
        {
            "id": "error.auth/invalid-dynamic-link-domain",
            "ru": "Предоставленный динамический домен ссылки не настроен или уполномоченный для текущего проекта.",
            "en": "The provided dynamic link domain is not configured or authorized for the current project.",
            "be": "Прадстаўлены дынамічны дамен спасылкі не настроены або ўпаўнаважаны для бягучага праекта."
        },
        {
            "id": "error.auth/invalid-email",
            "ru": "Предоставленное значение свойства пользователя электронной почты является недействительным. Она должна быть строка адреса электронной почты.",
            "en": "The provided value for the email user property is invalid. It must be a string email address.",
            "be": "Прадастаўленае значэнне ўласцівасці карыстальніка электроннай пошты з'яўляецца несапраўдным. Яна павінна быць радок адрасу электроннай пошты."
        },
        {
            "id": "error.auth/invalid-email-verified",
            "ru": "Предоставленное значение свойства пользователя emailVerified является недействительным. Это должно быть логическое значение.",
            "en": "The provided value for the emailVerified user property is invalid. It must be a boolean.",
            "be": "Прадастаўленае значэнне ўласцівасці карыстальніка emailVerified з'яўляецца несапраўдным. Гэта павінна быць лагічнае значэнне."
        },
        {
            "id": "error.auth/invalid-hash-algorithm",
            "ru": "Алгоритм хеширования должен соответствовать одной из строк в списке поддерживаемых алгоритмов.",
            "en": "The hash algorithm must match one of the strings in the list of supported algorithms.",
            "be": "Алгарытм хэшавання павінен адпавядаць адной з радкоў у спісе падтрымоўваных алгарытмаў."
        },
        {
            "id": "error.auth/invalid-hash-block-size",
            "ru": "Размер блока хэш должен быть действительным числом.",
            "en": "The hash block size must be a valid number.",
            "be": "Памер блока хэш павінен быць сапраўдным лікам."
        },
        {
            "id": "error.auth/invalid-hash-derived-key-length",
            "ru": "Хэш выведенного ключа длина должна быть действительным числом.",
            "en": "The hash derived key length must be a valid number.",
            "be": "Хэш выведзенага ключа даўжыня павінна быць сапраўдным лікам."
        },
        {
            "id": "error.auth/invalid-hash-key",
            "ru": "Хэш-ключ должен действительный буфер байт.",
            "en": "The hash key must a valid byte buffer.",
            "be": "Хэш-ключ павінен сапраўдны буфер байт."
        },
        {
            "id": "error.auth/invalid-hash-memory-cost",
            "ru": "Стоимость хеш-памяти должен быть действительным числом.",
            "en": "The hash memory cost must be a valid number.",
            "be": "Кошт Хэш-памяці павінен быць сапраўдным лікам."
        },
        {
            "id": "error.auth/invalid-hash-parallelization",
            "ru": "Хэш распараллеливание должно быть действительным числом.",
            "en": "The hash parallelization must be a valid number.",
            "be": "Хэш распаралельванне павінна быць сапраўдным лікам."
        },
        {
            "id": "error.auth/invalid-hash-rounds",
            "ru": "Хеши раунды должны быть действительным числом.",
            "en": "The hash rounds must be a valid number.",
            "be": "Хеши раўнды павінны быць сапраўдным лікам."
        },
        {
            "id": "error.auth/invalid-hash-salt-separator",
            "ru": "Разделитель полей соли алгоритм хэширования должен быть допустимым буфер байт.",
            "en": "The hashing algorithm salt separator field must be a valid byte buffer.",
            "be": "Падзельнік палёў солі алгарытм хэшавання павінен быць дапушчальным буфер байт."
        },
        {
            "id": "error.auth/invalid-id-token",
            "ru": "Предоставленный ID маркера не является допустимым маркер Firebase ID.",
            "en": "The provided ID token is not a valid Firebase ID token.",
            "be": "Прадстаўлены ID маркера не з'яўляецца дапушчальным маркер Firebase ID."
        },
        {
            "id": "error.auth/invalid-last-sign-in-time",
            "ru": "Последний вход в время должна быть действительной строкой даты UTC.",
            "en": "The last sign-in time must be a valid UTC date string.",
            "be": "Апошні ўваход у час павінна быць сапраўднай радком даты UTC."
        },
        {
            "id": "error.auth/invalid-page-token",
            "ru": "Предоставленная следующая лексема страницы в ListUsers () является недействительной. Он должен быть действительным непустой строкой.",
            "en": "The provided next page token in listUsers() is invalid. It must be a valid non-empty string.",
            "be": "Прадстаўленая наступная лексема старонкі ў ListUsers () з'яўляецца несапраўднай. Ён павінен быць сапраўдным непусты радком."
        },
        {
            "id": "error.auth/invalid-password",
            "ru": "Предоставленное значение свойства пользователя пароль неверен. Она должна быть строка, по крайней мере, шесть символов.",
            "en": "The provided value for the password user property is invalid. It must be a string with at least six characters.",
            "be": "Прадастаўленае значэнне ўласцівасці карыстальніка пароль няслушны. Яна павінна быць радок, па меншай меры, шэсць знакаў."
        },
        {
            "id": "error.auth/invalid-password-hash",
            "ru": "Хэш пароля должен быть допустимым буфер байт.",
            "en": "The password hash must be a valid byte buffer.",
            "be": "Хэш пароля павінен быць дапушчальным буфер байт."
        },
        {
            "id": "error.auth/invalid-password-salt",
            "ru": "Соль пароль должен быть действительным буфер байт",
            "en": "The password salt must be a valid byte buffer",
            "be": "Соль пароль павінен быць сапраўдным буфер байт"
        },
        {
            "id": "error.auth/invalid-phone-number",
            "ru": "Неверный формат предоставленного номера телефона.",
            "en": "The format of the phone number provided is incorrect.",
            "be": "Фармат нумара тэлефона з'яўляецца некарэктным."
        },
        {
            "id": "error.auth/invalid-photo-url",
            "ru": "Предоставленное значение свойства пользователя photoURL является недействительным. Она должна быть строка URL.",
            "en": "The provided value for the photoURL user property is invalid. It must be a string URL.",
            "be": "Прадастаўленае значэнне ўласцівасці карыстальніка photoURL з'яўляецца несапраўдным. Яна павінна быць радок URL."
        },
        {
            "id": "error.auth/invalid-provider-data",
            "ru": "ProviderData должен быть действительным массивом объектов USERINFO.",
            "en": "The providerData must be a valid array of UserInfo objects.",
            "be": "ProviderData павінен быць сапраўдным масівам аб'ектаў USERINFO."
        },
        {
            "id": "error.auth/invalid-provider-id",
            "ru": "ProviderId должен быть действительным поддерживается строковый идентификатор поставщика.",
            "en": "The providerId must be a valid supported provider identifier string.",
            "be": "ProviderId павінен быць сапраўдным падтрымліваецца радковы ідэнтыфікатар пастаўшчыка."
        },
        {
            "id": "error.auth/invalid-session-cookie-duration",
            "ru": "Продолжительность сеанса печенья должна быть действительным числом в миллисекундах от 5 минут до 2-х недель.",
            "en": "The session cookie duration must be a valid number in milliseconds between 5 minutes and 2 weeks.",
            "be": "Працягласць сеансу печыва павінна быць сапраўдным лікам у мілісекундах ад 5 хвілін да 2-х тыдняў."
        },
        {
            "id": "error.auth/invalid-uid",
            "ru": "Предоставленный UID должен быть непустой строкой из наиболее 128 символов.",
            "en": "The provided uid must be a non-empty string with at most 128 characters.",
            "be": "Прадстаўлены UID павінен быць непусты радком з найбольш 128 знакаў."
        },
        {
            "id": "error.auth/invalid-user-import",
            "ru": "Запись пользователя для импорта является недействительной.",
            "en": "The user record to import is invalid.",
            "be": "Запіс карыстальніка для імпарту з'яўляецца несапраўднай."
        },
        {
            "id": "error.auth/invalid-verification-code",
            "ru": "Неверный код подтверждения. Пожалуйста, проверьте правильность ввода или запросите повторную отправку кода подтверждения.",
            "en": "Invalid confirmation code. Please verify the input is correct, or re-send the verification code.",
            "be": "Няправільны код пацверджання. Калі ласка, праверце правільнасць ўводу або запытайце паўторную адпраўку кода пацверджання."
        },
        {
            "id": "error.auth/maximum-user-count-exceeded",
            "ru": "Максимально допустимое количество пользователей для импорта было превышено.",
            "en": "The maximum allowed number of users to import has been exceeded.",
            "be": "Максімальна дапушчальная колькасць карыстальнікаў для імпарту было перавышана."
        },
        {
            "id": "error.auth/missing-android-pkg-name",
            "ru": "Android Имя пакета должно быть обеспечено, если Android App требуется установить.",
            "en": "An Android Package Name must be provided if the Android App is required to be installed.",
            "be": "Android Імя пакета павінна быць забяспечана, калі Android App патрабуецца ўсталяваць."
        },
        {
            "id": "error.auth/missing-continue-uri",
            "ru": "Действительный продолжить URL должен быть предоставлен в запросе.",
            "en": "A valid continue URL must be provided in the request.",
            "be": "Сапраўдны працягнуць URL павінен быць прадастаўлены ў запыце."
        },
        {
            "id": "error.auth/missing-hash-algorithm",
            "ru": "Импорт пользователей хэшей паролей требует, чтобы алгоритм хеширования и его параметры будут предусмотрены.",
            "en": "Importing users with password hashes requires that the hashing algorithm and its parameters be provided.",
            "be": "Імпарт карыстальнікаў хэшаў пароляў патрабуе, каб алгарытм хэшавання і яго параметры будуць прадугледжаны."
        },
        {
            "id": "error.auth/missing-ios-bundle-id",
            "ru": "Запрос отсутствует идентификатор IOS Bundle.",
            "en": "The request is missing an iOS Bundle ID.",
            "be": "Запыт адсутнічае ідэнтыфікатар IOS Bundle."
        },
        {
            "id": "error.auth/missing-uid",
            "ru": "UID идентификатор необходим для текущей операции.",
            "en": "A uid identifier is required for the current operation.",
            "be": "UID ідэнтыфікатар неабходны для бягучай аперацыі."
        },
        {
            "id": "error.auth/network-error",
            "ru": "Пожалуйста, проверьте ваше подключение к интернету или повторите попытку позже.",
            "en": "Please check your internet connection, or try again later.",
            "be": "Калі ласка, праверце ваша падлучэнне да інтэрнэту ці паспрабуйце пазней."
        },
        {
            "id": "error.auth/network-request-failed",
            "ru": "Сетевая ошибка. Проверьте интернет-соединение или обратитесь в поддержку.",
            "en": "Network error. Check your internet connection, or contact support.",
            "be": "Сеткавая памылка. Праверце інтэрнэт-злучэнне або звярніцеся ў падтрымку."
        },
        {
            "id": "error.auth/operation-not-allowed",
            "ru": "При условии входа поставщика отключен для вашего проекта Firebase. Включить его от способа входа в секции консоли Firebase.",
            "en": "The provided sign-in provider is disabled for your Firebase project. Enable it from the Sign-in Method section of the Firebase console.",
            "be": "Пры ўмове ўваходу пастаўшчыка адключаны для вашага праекта Firebase. Ўключыць яго ад спосабу ўваходу ў секцыі кансолі Firebase."
        },
        {
            "id": "error.auth/phone-number-already-exists",
            "ru": "Предоставленный номер телефона уже используется существующим пользователем. Каждый пользователь должен иметь уникальный номер телефона.",
            "en": "The provided phoneNumber is already in use by an existing user. Each user must have a unique phoneNumber.",
            "be": "Прадстаўлены нумар тэлефона ўжо выкарыстоўваецца існуючым карыстальнікам. Кожны карыстальнік павінен мець унікальны нумар тэлефона."
        },
        {
            "id": "error.auth/project-not-found",
            "ru": "Нет Firebase проект не был найден верительных используется для инициализации администратора SDKs. Смотрите Добавить Firebase в приложение для документации о том, как сформировать учетные данные для вашего проекта и использовать его для аутентификации администратора SDKs.",
            "en": "No Firebase project was found for the credential used to initialize the Admin SDKs. See Add Firebase to your app for documentation on how to generate a credential for your project and use it to authenticate the Admin SDKs.",
            "be": "Няма Firebase праект не быў знойдзены даверчых выкарыстоўваецца для ініцыялізацыі адміністратара SDKs. Глядзіце Дадаць Firebase ў дадатак для дакументацыі аб тым, як сфармаваць ўліковыя дадзеныя для вашага праекта і выкарыстоўваць яго для аўтэнтыфікацыі адміністратара SDKs."
        },
        {
            "id": "error.auth/reserved-claims",
            "ru": "Один или несколько пользовательских требований пользователей, предоставляемые setCustomUserClaims () зарезервированы. Например, OIDCspecific утверждает, такие, как (суб, IAT, ISS, Exp, ауд, auth_time и т.д.) не должны быть использованы в качестве ключей для пользовательских требований.",
            "en": "One or more custom user claims provided to setCustomUserClaims() are reserved. For example, OIDCspecific claims such as (sub, iat, iss, exp, aud, auth_time, etc) should not be used as keys for custom claims.",
            "be": "Адзін або некалькі карыстацкіх патрабаванняў карыстальнікаў, якія прадстаўляюцца setCustomUserClaims () зарэзерваваны. Напрыклад, OIDCspecific сцвярджае, такія, як (суб, IAT, ISS, Exp, аўд, auth_time і г.д.) не павінны быць выкарыстаны ў якасці ключоў для карыстацкіх патрабаванняў."
        },
        {
            "id": "error.auth/session-cookie-expired",
            "ru": "Предоставленный Firebase куки сессии истек.",
            "en": "The provided Firebase session cookie is expired.",
            "be": "Прадстаўлены Firebase печыва сесіі мінуў."
        },
        {
            "id": "error.auth/session-cookie-revoked",
            "ru": "Куки сессии Firebase были аннулированы.",
            "en": "The Firebase session cookie has been revoked.",
            "be": "Печыва сесіі Firebase былі ануляваныя."
        },
        {
            "id": "error.auth/session-expired",
            "ru": "Срок действи СМС-кода истёк. Пожалуйста, отправьте код заново и попробуйте снова.",
            "en": "The SMS code has expired. Please re-send the verification code and try again.",
            "be": "Тэрмін дзеяння СМС-кода неактуальны. Калі ласка, адпраўце код зноў і паспрабуйце яшчэ раз."
        },
        {
            "id": "error.auth/too-many-requests",
            "ru": "Мы заблокировали все запросы от этого устройства из-за необычной активности. Попробуйте ещё раз через 3 часа.",
            "en": "We blocked all requests from this device due to unusual activity. Please try again in 24 hours.",
            "be": "Мы заблакавалі ўсе запыты ад прылады з-за незвычайнай актыўнасці. Паспрабуйце яшчэ раз праз 2-3 гадзіны."
        },
        {
            "id": "error.auth/uid-already-exists",
            "ru": "Предоставленный UID уже используется существующим пользователем. Каждый пользователь должен иметь уникальный идентификатор пользователя.",
            "en": "The provided uid is already in use by an existing user. Each user must have a unique uid.",
            "be": "Прадстаўлены UID ўжо выкарыстоўваецца існуючым карыстальнікам. Кожны карыстальнік павінен мець унікальны ідэнтыфікатар карыстальніка."
        },
        {
            "id": "error.auth/unauthorized-continue-uri",
            "ru": "Домен продолжения URL нет разрешения. Белый список домен в Firebase консоли.",
            "en": "The domain of the continue URL is not whitelisted. Whitelist the domain in the Firebase Console.",
            "be": "Дамен працягу URL няма дазволу. Белы спіс дамен у Firebase кансолі."
        },
        {
            "id": "error.auth/unknown",
            "ru": "Мы заблокировали все запросы от этого устройства из-за необычной активности. Попробуйте ещё раз через 3 часа.",
            "en": "We blocked all requests from this device due to unusual activity. Please try again in 24 hours.",
            "be": "Мы заблакавалі ўсе запыты ад прылады з-за незвычайнай актыўнасці. Паспрабуйце яшчэ раз праз 2-3 гадзіны."
        },
        {
            "id": "error.auth/user-not-found",
            "ru": "Там нет существующей записи пользователя, соответствующего идентификатору.",
            "en": "There is no existing user record corresponding to the provided identifier.",
            "be": "Там няма існуючай запісу карыстальніка, адпаведнага ідэнтыфікатару."
        },
        {
            "id": "error.birthday_error",
            "ru": "Только пользователь старше 18 лет может создать учетную запись. После внесения данных владельца профиля вы сможете добавить информацию о детях в разделе «Моя семья»",
            "en": "This field contains incorrect date of birth",
            "be": "Поле ўтрымлівае некарэктную дату нараджэння"
        },
        {
            "id": "error.email_format_error",
            "ru": "Поле содержит некорректный e-mail. Пример: example@gmail.com",
            "en": "The field contains an invalid email address. Example: example@gmail.com",
            "be": "Поле ўтрымлівае некарэктны e-mail. Прыклад: example@gmail.com"
        },
        {
            "id": "error.epam_email_format_error",
            "ru": "Поле содержит некорректный e-mail или домен. Пример: example@epam.com",
            "en": "\"The field contains an invalid email address. Example: example@gmail.com\"",
            "be": "Поле павінна ўтрымліваць карэктны e-mail або дамен. Заўв: example@epam.com"
        },
        {
            "id": "error.ERROR_INVALID_VERIFICATION_CODE",
            "ru": "Неверный код подтверждения. Пожалуйста, проверьте правильность ввода или запросите повторную отправку кода подтверждения.",
            "en": "Invalid confirmation code. Please check the correctness of the input or re-send the confirmation code.",
            "be": "Няправільны код пацверджання. Калі ласка, праверце правільнасць ўводу або запытайце паўторную адпраўку кода пацверджання."
        },
        {
            "id": "error.date_format_error",
            "ru": "Поле содержит некорректную дату. Пример правильной даты: 2001-01-28",
            "en": "This field contains an incorrect date. A correct date example: 2001-01-28",
            "be": "Поле ўтрымлівае некарэктную дату. Прыклад: 2001-01-28"
        },
        {
            "id": "error.phone_format_error",
            "ru": "Поле содержит некорректный номер телефона.",
            "en": "The field contains an incorrect phone number.",
            "be": "Поле ўтрымлівае некарэктны нумар тэлефона."
        },
        {
            "id": "error.format_error",
            "ru": "Поле содержит некорректную дату. Пример правильной даты: 1 мар 2001",
            "en": "This field contains an incorrect date. A correct date example: March 1, 2001",
            "be": "Поле ўтрымлівае некарэктную дату. Прыклад: 1 сак 2001"
        },
        {
            "id": "error.child_birthday_error",
            "ru": "Поле содержит некорректную дату рождения ребенка",
            "en": "The field contains incorrect child's date of birth",
            "be": "Поле ўтрымлівае некарэктную дату нараджэння дзіцяці"
        },
        {
            "id": "error.invalidCodeSent",
            "ru": "Неверный код. Пожалуйста, сверьте код с кодом вашего родственника.",
            "en": "Incorrect code. Please verify the code with your relative's code.",
            "be": "Няправільны код. Калі ласка, параўнайце код з кодам вашага сваяка."
        },
        {
            "id": "error.network_connection",
            "ru": "Проверьте интернет-соединение",
            "en": "Check Internet connection",
            "be": "Праверце інтэрнэт-злучэнне"
        },
        {
            "id": "error.onlineBooking/Forbidden0",
            "ru": "Онлайн-запись запрещена.",
            "en": "Online booking is forbidden",
            "be": "Анлайн-запіс забаронены"
        },
        {
            "id": "error.onlineBooking/Forbidden1",
            "ru": "Онлайн-запись к этому врачу ограничена медцентром. Вы можете выбрать время и записаться через звонок в регистратуру.",
            "en": "Online appointments with this doctor are limited by the medical center. You can select a time and make an appointment by calling the registry.",
            "be": "Анлайн-запіс да гэтага лекара абмежаваны медцэнтрам. Вы можаце абраць час і запісацца праз званок у рэгістратуру."
        },
        {
            "id": "error.onlineBooking/Forbidden2",
            "ru": "Онлайн-запись в данной клинике невозможна.",
            "en": "Online booking is disabled for clinic",
            "be": "Анлайн-запіс у гэтай клініцы не магчымы"
        },
        {
            "id": "error.onlineBooking/Forbidden3",
            "ru": "Онлайн-запись запрещена администратором.",
            "en": "Online booking is forbidden for user by administrator",
            "be": "Анлайн-запіс забаронены адміністратарам"
        },
        {
            "id": "error.onlineBooking/Forbidden4",
            "ru": "Ваш профиль не активирован в клинике. Обратитесь в поддержку.",
            "en": "Your account is not active on clinic side. Please contact support team to resolve it.",
            "be": "Ваш прафайл не актыўны ў клiнiцы"
        },
        {
            "id": "error.onlineBooking/Forbidden7",
            "ru": "Только совершеннолетние пользователи могут записываться онлайн. Проверьте свою дату рождения в учётной карте. Записать ребёнка можно добавив его в раздел \"Моя семья\".",
            "en": "Only adult users can make online appointments. Please check your date of birth in your account profile. You can schedule an appointment for a child by adding them in 'My Family' section.",
            "be": "Толькі паўналетнія карыстальнікі могуць запісвацца анлайн. Праверце сваю дату нараджэння ў уліковым карце. Запісаць дзіця можна дадаўшы яго ў раздзел \"Мая сям'я\"."
        },
        {
            "id": "error.onlineBooking/Forbidden8",
            "ru": "Онлайн-запись невозможна по возрастным ограничениям",
            "en": "Online booking is unavailable because of age limits",
            "be": "Анлайн-запіс немагчымы па ўзроставым абмежаванням"
        },
        {
            "id": "error.onlineBooking/Forbidden9",
            "ru": "Необходимо заполнить профиль для онлайн-записи к врачам.",
            "en": "You need to complete your profile to make online appointments with doctors.",
            "be": "Неабходна запоўніць профіль для анлайн-запіса да лекараў."
        },
        {
            "id": "error.outdatedAppVersion",
            "ru": "Версия приложения устарела",
            "en": "Application is out of date",
            "be": "Версія прыкладання састарэла"
        },
        {
            "id": "error.request_time_out",
            "ru": "Истекло время запроса",
            "en": "Request timed out",
            "be": "Скончыўся час запыту"
        },
        {
            "id": "error.required_field",
            "ru": "Поле обязательно для заполенения",
            "en": "Field is required for filling",
            "be": "Поле абавязкова для заполенения"
        },
        {
            "id": "error.text_format_error",
            "ru": "Поле содержит недопустимое значение",
            "en": "This field contains an invalid value",
            "be": "Поле ўтрымлівае недапушчальнае значэнне"
        },
        {
            "id": "error.activation_canceled/minutes",
            "ru": "Активация отменена! Вы сможете запросить повторную отправку SMS-сообщения с кодом активации через {time} минут(ы)",
            "en": "Activation canceled! You can request a resend of the SMS-message with the activation code through {time} minute(s)",
            "be": "Актывацыя адменена! Вы зможаце запытаць паўторную адпраўку SMS-паведамленні з кодам актывацыі праз {time} хвілін(ы)"
        },
        {
            "id": "error.activation_canceled/seconds",
            "ru": "Активация отменена! Вы сможете запросить повторную отправку SMS-сообщения с кодом активации через {time} секунд(ы)",
            "en": "Activation canceled! You can request a resend of the SMS-message with the activation code through {time} seconds(s)",
            "be": "Актывацыя адменена! Вы зможаце запытаць паўторную адпраўку SMS-паведамленні з кодам актывацыі праз {time} секунд(ы)"
        },
        {
            "id": "error.input_code_was_entered_incorrectly",
            "ru": "Неверный код подтверждения. Пожалуйста, проверьте правильность ввода.",
            "en": "Invalid confirmation code. Please check the correctness of the input.",
            "be": "Няправільны код пацверджання. Калі ласка, праверце правільнасць уводу."
        },
        {
            "id": "error.input_code_was_entered_incorrectly/minutes",
            "ru": "Код был введен неверно. Вы сможете ввести код активации еще раз через  {time} минут(ы)",
            "en": "The code was entered incorrectly. You will be able to enter the activation code again in {time} minute(s)",
            "be": "Код быў уведзены няправільна. Вы зможаце ўвесці код актывацыі яшчэ раз праз {time} хвілін(ы)"
        },
        {
            "id": "error.input_code_was_entered_incorrectly/seconds",
            "ru": "Код был введен неверно. Вы сможете ввести код активации еще раз через  {time} секунд(ы)",
            "en": "The code was entered incorrectly. You will be able to enter the activation code again after {time} seconds(s)",
            "be": "Код быў уведзены няправільна. Вы зможаце ўвесці код актывацыі яшчэ раз праз {time} секунд(ы)"
        },
        {
            "id": "error.code_was_entered_incorrectly/minutes",
            "ru": "Смс-код был введен неверно. Вы сможете ввести код активации еще раз через  {time} минут(ы)",
            "en": "The SMS code was entered incorrectly. You can enter the activation code once again in {time} minute(s)",
            "be": "Смс-код быў уведзены няправільна. Вы зможаце ўвесці код актывацыі яшчэ раз праз {time} хвілін(ы)"
        },
        {
            "id": "error.code_was_entered_incorrectly/seconds",
            "ru": "Смс-код был введен неверно. Вы сможете ввести код активации еще раз через  {time} секунд(ы)",
            "en": "The SMS code was entered incorrectly. You can enter the activation code once again in {time} seconds(s)",
            "be": "Смс-код быў уведзены няправільна. Вы зможаце ўвесці код актывацыі яшчэ раз праз {time} секунд(ы)"
        },
        {
            "id": "error.INCORRECT_CONTRACT_CODE",
            "ru": "Неверный номер штрих-кода",
            "en": "Invalid barcode number",
            "be": "Няправільны нумар штрых-кода"
        },
        {
            "id": "error.EXPIRED_CONTRACT",
            "ru": "Срок действия договора страхования истек. Пожалуйста, обратитесь в страховух компанию, позвонив по номерам указанным в карте застрахованного лица.",
            "en": "The insurance contract has expired. Please contact the insurance company by calling the numbers provided on the insured person's card.",
            "be": "Тэрмін дзеяння дагавора страхавання мінуў. Калі ласка, звярніцеся ў страховух кампанію, патэлефанаваўшы па нумарах паказаным у карце застрахаванай асобы."
        },
        {
            "id": "error.SERVICE_IS_NOT_SUPPORTED",
            "ru": "Ваша страховая программа не поддерживает данный сервис.",
            "en": "Your insurance does not support this service.",
            "be": "Ваша страхавая праграма не падтрымлівае гэты сэрвіс."
        },
        {
            "id": "error.INCORRECT_PHONE_NUMBER",
            "ru": "Введённый при регистрации номер телефона не соответствует указанному в договоре. Пожалуйста, обратитесь в страховую компанию, позвонив по номерам указанным в карте застрахованного лица.",
            "en": "The phone number entered during registration does not match the one specified in the contract. Please contact the insurance company by calling the numbers provided on the insured person's card.",
            "be": "Уведзены пры рэгістрацыі нумар тэлефона не адпавядае паказаным у дамове. Калі ласка, звярніцеся ў страхавую кампанію, патэлефанаваўшы па нумарах паказаным у карце застрахаванай асобы."
        },
        {
            "id": "error.INVALID_ARGUMENT",
            "ru": "Неверные введённые данные",
            "en": "Incorrect entered data",
            "be": "Няслушныя уведзеныя дадзеныя"
        },
        {
            "id": "error.ERROR_NETWORK_REQUEST_FAILED",
            "ru": "Сетевая ошибка. Проверьте интернет-соединение или обратитесь в поддержку.",
            "en": "Network error. Please check your internet connection or contact support.",
            "be": "Сеткавая памылка. Праверце інтэрнэт-злучэнне, або звярніцеся ў падтрымку."
        },
        {
            "id": "error.ERROR_TOO_MANY_REQUESTS",
            "ru": "Мы заблокировали все запросы от этого устройства из-за необычной активности. Попробуйте ещё раз через 3 часа.",
            "en": "We've blocked all requests from this device due to unusual activity. Please try again in 3 hours.",
            "be": "Мы заблякавалі ўсе запыты ад гэтай прылады з-за незвычайнай актыўнасці. Паспрабуйце яшчэ раз праз 24 гадзіны."
        },
        {
            "id": "error.CONTRACT_IS_NOT_SYNCHRONIZED",
            "ru": "Контракт ещё не был синхронизирован с приложением. Пожалуйста, попытайтесь позже.",
            "en": "The contract has not yet been synchronized with the application. Please try again later.",
            "be": "Кантракт яшчэ не быў сінхранізаваны з дадаткам. Калі ласка, паспрабуйце пазней."
        },
        {
            "id": "error.ERROR_SESSION_EXPIRED",
            "ru": "Срок действи СМС-кода истёк. Пожалуйста, отправьте код заново и попробуйте снова.",
            "en": "The SMS code has expired. Please re-send the verification code and try again.",
            "be": "Тэрмін дзеяння СМС-неактуальны код. Калі ласка, адпраўце код зноўку і паспрабуйце зноў."
        },
        {
            "id": "error.PROFILE_MISSING",
            "ru": "Пожалуйста, подтвердите ваш профиль для получения онлайн-расписания доктора.",
            "en": "Please confirm your profile to access the doctor's online schedule.",
            "be": "Please confirm your profile for online calendars doctor."
        },
        {
            "id": "error.NO_CARD_FROM_COVERER",
            "ru": "Нет медицинского покрытия",
            "en": "No medical coverage",
            "be": "Няма медыцынскага пакрыцця"
        },
        {
            "id": "error.CODE_COVERER_CARD_INACTIVE",
            "ru": "Нет медицинского покрытия",
            "en": "No medical coverage",
            "be": "Няма медыцынскага пакрыцця"
        },
        {
            "id": "error.INVALID_CONTRACT_KEY",
            "ru": "Для указанных данных программа не найдена",
            "en": "The program can not be found for specified data",
            "be": "Для ўказаных даных праграма не знойдзена"
        },
        {
            "id": "error.CONTRACT_CLOSED",
            "ru": "Программа неактивна или закрыта",
            "en": "The program is inactive or closed",
            "be": "Праграма неактыўная ці зачынена"
        },
        {
            "id": "error.CONTRACT_NOT_READY",
            "ru": "Корпоративная программа ещё не готова для использования в Aibolit. Обратитесь к вашему HR-менеджеру.",
            "en": "The corporate program is not yet ready for use in Aibolit. Contact your HR-manager.",
            "be": "Карпаратыўная праграма яшчэ не гатовая для выкарыстання ў Aibolit. Звярніцеся да вашага HR-мэнэджэра."
        },
        {
            "id": "error.NO_ASSIGNMENT_BOOKING",
            "ru": "Онлайн-запись к этому врачу ограничена медцентром. Вы можете выбрать время и записаться через звонок в регистратуру.",
            "en": "Online appointments with this doctor are restricted by the medical center. You can select a time and schedule an appointment by calling the reception desk",
            "be": "Анлайн-запіс да гэтага лекара абмежаваны медцэнтрам. Вы можаце абраць час і запісацца праз званок у рэгістратуру."
        },
        {
            "id": "error.CLINIC_UNAVAILABLE",
            "ru": "Клиника временно недоступна",
            "en": "The clinic is temporarily unavailable",
            "be": "Клініка часова недаступная"
        },
        {
            "id": "error.SYNC_FAILED",
            "ru": "Сервис временно недоступен",
            "en": "Service is temporarily unavailable",
            "be": "Сэрвіс часова недаступны"
        },
        {
            "id": "favoriteDoctors*.few",
            "ru": "{{count}} ВРАЧА В ЗАКЛАДКАХ",
            "en": "{{count}} DOCTORS IN BOOKMARKS",
            "be": "{{count}} ЛЕКАРА Ў ЗАКЛАДЦЫ"
        },
        {
            "id": "favoriteDoctors*.many",
            "ru": "{{count}} ВРАЧЕЙ В ЗАКЛАДКАХ",
            "en": "{{count}} DOCTORS IN BOOKMARKS",
            "be": "{{count}} лекараў у закладцы"
        },
        {
            "id": "favoriteDoctors*.one",
            "ru": "{{count}} ВРАЧ В ЗАКЛАДКАХ",
            "en": "{{count}} DOCTOR IN BOOKMARKS",
            "be": "{{count}} лекар у закладцы"
        },
        {
            "id": "favoriteDoctors*.zero",
            "ru": "НЕТ ВРАЧЕЙ В ЗАКЛАДКАХ",
            "en": "NO DOCTORS IN BOOKMARKS",
            "be": "ЛЕКАРАЎ НЯМА Ў ЗАКЛАДКАХ"
        },
        {
            "id": "feedback.anonumous",
            "ru": "Анонимно",
            "en": "Anonymously",
            "be": "Ананімна"
        },
        {
            "id": "feedback.clinicsInputPlaceholder",
            "ru": "Ваш отзыв может значительно помочь другим пользователям",
            "en": "Your feedback can significantly help other users",
            "be": "Увядзіце ў вольнай форме водгук пра наведванне медыцынскага цэнтра."
        },
        {
            "id": "feedback.formEditTitle",
            "ru": "Вы можете исправить отзыв:",
            "en": "You can update a feedback:",
            "be": "Вы можаце выправіць каментар:"
        },
        {
            "id": "feedback.formTitle",
            "ru": "Вы можете оставить отзыв:",
            "en": "You can leave a feedback:",
            "be": "Вы можаце пакінуць каментар:"
        },
        {
            "id": "feedback.physiciansInputPlaceholder",
            "ru": "Опишите подробнее, с какой проблемой вы обратились и/или какие услуги вам оказали, почему вы готовы, либо не готовы рекомендовать данного врача",
            "en": "Please provide more details about the issue you encountered and/or the services provided to you, and explain why you are willing or unwilling to recommend this doctor",
            "be": "Напішыце падрабязней, з якой праблемай вы звярнуліся і/або якія паслугі вам аказаліся, чаму вы гатовыя, альбо не гатовыя рэкамендаваць гэтага лекара"
        },
        {
            "id": "feedback.doNotPublicName",
            "ru": "Не публиковать мое имя",
            "en": "Do not publish my name",
            "be": "Не публікаваць маё імя"
        },
        {
            "id": "feedback.publicName",
            "ru": "Опубликовать моё имя",
            "en": "Publish my name",
            "be": "Апублікаваць маё імя"
        },
        {
            "id": "feedback.addToFavorites",
            "ru": "Добавить врача в закладки",
            "en": "Add the doctor to bookmarks",
            "be": "Дадаць лекара ў закладкі"
        },
        {
            "id": "feedbacks*.few",
            "ru": "{{count}} отзыва",
            "en": "{{count}} feedback",
            "be": "{{count}} водгука"
        },
        {
            "id": "feedbacks*.many",
            "ru": "{{count}} отзывов",
            "en": "{{count}} feedback",
            "be": "{{count}} водгукаў"
        },
        {
            "id": "feedbacks*.one",
            "ru": "{{count}} отзыв",
            "en": "{{count}} feedback",
            "be": "{{count}} водгук"
        },
        {
            "id": "feedbacks*.other",
            "ru": "ПОИСК…",
            "en": "SEARCH…",
            "be": "ПОШУК ..."
        },
        {
            "id": "feedbacks*.zero",
            "ru": "Нет отзывов",
            "en": "No feedback",
            "be": "Водгукаў няма"
        },
        {
            "id": "feedbacksSortItems.allFeedbacks",
            "ru": "ВСЕ ОТЗЫВЫ",
            "en": "ALL FEEDBACK",
            "be": "УСЕ ВОДГУКІ"
        },
        {
            "id": "feedbacksSortItems.myFeedbacks",
            "ru": "МОИ ОТЗЫВЫ",
            "en": "MY FEEDBACK",
            "be": "МАЕ ВОДГУКІ"
        },
        {
            "id": "hint.not_active_child_program",
            "ru": "Корпоративная программа ребёнка не активна. По вопросам активации напишите вашему HR-менеджеру.",
            "en": "The child's corporate program is not active. For activation, please contact your HR manager.",
            "be": "Карпаратыўная праграма дзіцяці не актыўная. Па пытаннях актывацыі звярніцеся да вашага HR-мэнэджара."
        },
        {
            "id": "hint.not_active_program",
            "ru": "Ваша корпоративная программа не активна. По вопросам активации напишите вашему HR-менеджеру.",
            "en": "Your corporate program is not active. For activation, please contact your HR manager.",
            "be": "Ваша карпаратыўная праграма не актыўная. Калі ласка, удакладніце магчымасць абслугоўвання па праграме ў вашага HR мэнэджэра"
        },
        {
            "id": "hint.follow_program_details_link",
            "ru": "Перейдите по ссылке, чтобы ознакомиться с вашей программой",
            "en": "Follow the link below for more details",
            "be": "Перайдзіце па спасылцы, каб азнаёміцца з вашай праграмай"
        },
        {
            "id": "link.program_details",
            "ru": "Условия программы",
            "en": "Program terms",
            "be": "Умовы праграмы"
        },
        {
            "id": "link.program_details_link",
            "ru": "Условия программы добровольного страхования",
            "en": "Insurance program terms",
            "be": "Умовы праграмы добраахвотнага страхавання"
        },
        {
            "id": "hint.online_booking_disabled",
            "ru": "Возможность онлайн-записи отключена для вашего акаунта",
            "en": "Online booking capability is disabled for your account",
            "be": "Магчымасць анлайн-запісу адключана для вашага акаўнта"
        },
        {
            "id": "hint.online_booking_is_available",
            "ru": "Эта клиника поддерживает онлайн-запись",
            "en": "This clinic supports online booking.",
            "be": "Клiнiка прадастаўляе магчымасць анлайн-запісу"
        },
        {
            "id": "hint.online_booking_is_not_available",
            "ru": "Эта клиника не поддерживает онлайн-запись",
            "en": "This clinic doesn't support online booking.",
            "be": "Магчымасць анлайн-запісу адсутнiчае"
        },
        {
            "id": "hint.outdatedAppVersion",
            "ru": "Пожалуйста обновите версию приложения",
            "en": "Please update the app version",
            "be": "Калі ласка, абнавіце версію прыкладання"
        },
        {
            "id": "hints.add_online-visit",
            "ru": "Визит может быть отменен не позднее, чем за 30 минут до начала приёма. Если количество непосещений превысит 5%, возможность онлайн-записи будет отключена.",
            "en": "An appointment can be canceled no later than 30 minutes before the scheduled time. If missed appointments exceed 5%, online booking capability will be disabled.",
            "be": "Вы зможаце адмяніць ваш візіт не пазней, чым за 30 хвілін да пачатку прыёму. Калі колькасць вашых ненаведваннеў перавысіць 5%, магчымасць анлайн-запіса для вас будзе адключана."
        },
        {
            "id": "hints.add-visit",
            "ru": "Информация о враче, клинике и стоимости визита появится автоматически после синхронизации.",
            "en": "Information about the doctor, clinic and cost of the visit will appear automatically or after synchronization.",
            "be": "Інфармацыя пра лекара, клініцы і кошту візіту з'явіцца аўтаматычна або пасля сінхранізацыі."
        },
        {
            "id": "hints.child_not_in_program",
            "ru": "Выбранный ребёнок не обслуживается программой",
            "en": "The selected child is not served by the program",
            "be": "Абраны дзіця не абслугоўваецца праграмай"
        },
        {
            "id": "hints.edit_profile",
            "ru": "Пожалуйста, проверяйте корректность введённых данных: они будут использованы при записи к врачам.",
            "en": "Please verify the correctness of the entered data. It will be used for scheduling appointments with doctors.",
            "be": "Звярніце ўвагу, што гэтыя дадзеныя будуць выкарыстаны пры запісе да лекараў. Калі ласка, правярайце карэктнасць уведзеных дадзеных."
        },
        {
            "id": "hints.edit_child_profile",
            "ru": "Можно добавить только несовершеннолетнего ребёнка.",
            "en": "You can add only a minor child.",
            "be": "Можна дадаць толькі непаўналетняга дзіцяці."
        },
        {
            "id": "hints.edit_relative_profile",
            "ru": "Вы можете создать учетную запись или добавить уже существующую учетную запись вашего родственника. Введите данные родственника: ФИО, дату рождения, номер телефона",
            "en": "You can create an account or add an existing account of your relative. ",
            "be": "Вы можаце стварыць уліковы запіс для вашага сваяка."
        },
        {
            "id": "hints.home",
            "ru": "ПОСЛЕДНЕЕ ОБНОВЛЕНИЕ БАЗЫ {date}",
            "en": "DATABASE UPDATE {date}",
            "be": "АПОШНЯЕ АБНАЎЛЕННЕ БАЗЫ {date}"
        },
        {
            "id": "hints.impossible_determine_location",
            "ru": "Невозможно определить ваше местоположение",
            "en": "Unable to determine your location",
            "be": "Немагчыма вызначыць ваша месцазнаходжанне"
        },
        {
            "id": "hints.info_about_doctor",
            "ru": "Информация о враче, клинике и стоимости визита появится автоматически после синхронизации.",
            "en": "Information about the doctor, clinic and cost of the visit will appear automatically or after synchronization.",
            "be": "Інфармацыя пра лекара, клініцы і кошту візіту з'явіцца аўтаматычна або пасля сінхранізацыі."
        },
        {
            "id": "hints.medcenter-details-record",
            "ru": "На текущий момент у выбранного врача нет свободных слотов для записи. Попробуйте позже.",
            "en": "The selected doctor currently has no available appointment slots. Please try again later.",
            "be": "На бягучы момант у абранага лекара няма вольных слотаў для запісу. Паспрабуйце пазней."
        },
        {
            "id": "hints.online_booking_try_again",
            "ru": "Ваш онлайн-визит не был забронирован. Проверьте, возможно пропало интернет-соединение. Пожалуйста, попробуйте записаться онлайн снова",
            "en": "Your online visit has not been booked. Check your internet connection.\nPlease try to schedule online appointment again.",
            "be": "Ваш анлайн-візіт не быў забраніраваны. Праверце iнтэрнэт. Калі ласка, паспрабуйце запісацца анлайн зноў"
        },
        {
            "id": "hints.online_visit_record_available_from_second_time",
            "ru": "Онлайн-запись к этому врачу станет доступна со второго визита. Сейчас вы можете записаться на визит, позвонив по одному из телефонов:",
            "en": "Online booking to this doctor will be available from the second visit. Now you can make an appointment by calling one of the phone numbers:",
            "be": "Анлайн-запіс да гэтага лекара стане даступны з другога візіту. Зараз вы можаце запісацца на візіт, патэлефанаваўшы па адным з тэлефонаў:"
        },
        {
            "id": "hints.online_visit_record_not_available_for_not_authorized_users",
            "ru": "Неавторизованные пользователи не могут записываться к врачу онлайн. Авторизируйтесь или запишитесь на визит, позвонив по любому из телефонов.",
            "en": "Unauthorized users can not schedule appointments with doctor online. Please log in or schedule a visit by calling any of the phones.",
            "be": "Несанкцыянаваные карыстальнікі не могуць запісвацца да лекара онлайн. Аўтарызіруйцеся або запішыцеся на візіт праз званок па любым з тэлефонаў."
        },
        {
            "id": "hints.online_visit_record_not_available_for_this_doctor",
            "ru": "Вы можете записаться на визит, позвонив по одному из телефонов:",
            "en": "You can schedule an appointment by calling one of the phone numbers:",
            "be": "Вы можаце запісацца на візіт, патэлефанаваўшы па адным з тэлефонаў:"
        },
        {
            "id": "hints.online_visit_record_not_available_no_program",
            "ru": "На данный момент онлайн-запись доступна только для участников корпоративной программы. Вы можете записаться на визит, позвонив по одному из телефонов:",
            "en": "At the moment, online booking is only available for members of the corporate program. You can make an appointment by calling one of the numbers:",
            "be": "На дадзены момант анлайн-запіс даступны толькі для ўдзельнікаў карпаратыўнай праграмы. Вы можаце запісацца на візіт, патэлефанаваўшы па адным з тэлефонаў:"
        },
        {
            "id": "imagePickerOptions.cancelButtonTitle",
            "ru": "ОТМЕНА",
            "en": "CANCEL",
            "be": "АДМЕНА"
        },
        {
            "id": "imagePickerOptions.chooseFromLibraryButtonTitle",
            "ru": "Из Галереи…",
            "en": "From Gallery ...",
            "be": "З Галерэі ..."
        },
        {
            "id": "imagePickerOptions.takePhotoButtonTitle",
            "ru": "С камеры…",
            "en": "With the camera ...",
            "be": "З камеры ..."
        },
        {
            "id": "imagePickerOptions.title",
            "ru": "Выбор фото",
            "en": "Select photos",
            "be": "выбар фота"
        },
        {
            "id": "language.be",
            "ru": "Белорусский",
            "en": "Belarusian",
            "be": "Беларуская"
        },
        {
            "id": "language.en",
            "ru": "Английский",
            "en": "English",
            "be": "Ангельская"
        },
        {
            "id": "language.ru",
            "ru": "Русский",
            "en": "Russian",
            "be": "Руская"
        },
        {
            "id": "locations.0",
            "ru": "Все регионы",
            "en": "All regions",
            "be": "Усе рэгіёны"
        },
        {
            "id": "locations.1511",
            "ru": "Берестовица",
            "en": "Berestovitsa",
            "be": "Бераставіца"
        },
        {
            "id": "locations.1512",
            "ru": "Волковыск",
            "en": "Volkovysk",
            "be": "Ваўкавыск"
        },
        {
            "id": "locations.1513",
            "ru": "Свислочь",
            "en": "Svisloch",
            "be": "Свіслач"
        },
        {
            "id": "locations.1514",
            "ru": "Щучин",
            "en": "Shchuchin",
            "be": "Шчучын"
        },
        {
            "id": "locations.1718",
            "ru": "Узда",
            "en": "Uzda",
            "be": "Узда"
        },
        {
            "id": "locations.1515",
            "ru": "Мосты",
            "en": "Mosty",
            "be": "Масты"
        },
        {
            "id": "locations.152",
            "ru": "Гродно",
            "en": "Grodno",
            "be": "Гродна"
        },
        {
            "id": "locations.1520001",
            "ru": "Скидель",
            "en": "Skidel",
            "be": "Скідаль"
        },
        {
            "id": "locations.1545",
            "ru": "Березовка",
            "en": "Berezovka",
            "be": "Бярозаўка"
        },
        {
            "id": "locations.154",
            "ru": "Лида",
            "en": "Lida",
            "be": "Ліда"
        },
        {
            "id": "locations.1562",
            "ru": "Слоним",
            "en": "Slonim",
            "be": "Слонім"
        },
        {
            "id": "locations.1563",
            "ru": "Дятлово",
            "en": "Dyatlovo",
            "be": "Дзятлава"
        },
        {
            "id": "locations.1564",
            "ru": "Зельва",
            "en": "Zelva",
            "be": "Зэльва"
        },
        {
            "id": "locations.1591",
            "ru": "Островец",
            "en": "Ostrowiec",
            "be": "Астравец"
        },
        {
            "id": "locations.1592",
            "ru": "Сморгонь",
            "en": "Smorgon",
            "be": "Смаргонь"
        },
        {
            "id": "locations.1593",
            "ru": "Ошмяны",
            "en": "Oshmjany",
            "be": "Ашмяны"
        },
        {
            "id": "locations.1594",
            "ru": "Вороново",
            "en": "Voronovo",
            "be": "Воранава"
        },
        {
            "id": "locations.1595",
            "ru": "Ивье",
            "en": "Ivie",
            "be": "Іўе"
        },
        {
            "id": "locations.15960001",
            "ru": "Мир",
            "en": "Mir",
            "be": "Мiр"
        },
        {
            "id": "locations.1596",
            "ru": "Кореличи",
            "en": "Korelichi",
            "be": "Карэлічы"
        },
        {
            "id": "locations.1597",
            "ru": "Новогрудок",
            "en": "Novogrudok",
            "be": "Навагрудак"
        },
        {
            "id": "locations.162",
            "ru": "Брест",
            "en": "Brest",
            "be": "Брэст"
        },
        {
            "id": "locations.163",
            "ru": "Барановичи",
            "en": "Baranovichi",
            "be": "Баранавічы"
        },
        {
            "id": "locations.1631",
            "ru": "Каменец",
            "en": "Kamenetz",
            "be": "Камянец"
        },
        {
            "id": "locations.16310001",
            "ru": "Высокое",
            "en": "Visokoye",
            "be": "Высокае"
        },
        {
            "id": "locations.16320001",
            "ru": "Ружаны",
            "en": "Ruzhany",
            "be": "Ружаны"
        },
        {
            "id": "locations.1632",
            "ru": "Пружаны",
            "en": "Pruzhany",
            "be": "Пружаны"
        },
        {
            "id": "locations.1633",
            "ru": "Ляховичи",
            "en": "Lyahovichi",
            "be": "Ляхавічы"
        },
        {
            "id": "locations.1641",
            "ru": "Жабинка",
            "en": "Zhabinka",
            "be": "Жабінка"
        },
        {
            "id": "locations.1642",
            "ru": "Кобрин",
            "en": "Kobrin",
            "be": "Кобрын"
        },
        {
            "id": "locations.1643",
            "ru": "Береза",
            "en": "Bereza",
            "be": "Бяроза"
        },
        {
            "id": "locations.16430001",
            "ru": "Белоозерск",
            "en": "Beloozersk",
            "be": "Белаазёрск"
        },
        {
            "id": "locations.1644",
            "ru": "Дрогичин",
            "en": "Drogichin",
            "be": "Драгічын"
        },
        {
            "id": "locations.16450001",
            "ru": "Телеханы",
            "en": "Telekhany",
            "be": "Тэлеханы"
        },
        {
            "id": "locations.1645",
            "ru": "Ивацевичи",
            "en": "Ivatsevichi",
            "be": "Івацэвічы"
        },
        {
            "id": "locations.16450002",
            "ru": "Коссово",
            "en": "Kossovo",
            "be": "Косава"
        },
        {
            "id": "locations.1646",
            "ru": "Ганцевичи",
            "en": "Gantsevichi",
            "be": "Ганцавічы"
        },
        {
            "id": "locations.16470001",
            "ru": "Микашевичи",
            "en": "Mikashevichi",
            "be": "Мікашэвічы"
        },
        {
            "id": "locations.1647",
            "ru": "Лунинец",
            "en": "Luninets",
            "be": "Лунінец"
        },
        {
            "id": "locations.165",
            "ru": "Пинск",
            "en": "Pinsk",
            "be": "Пінск"
        },
        {
            "id": "locations.1651",
            "ru": "Малорита",
            "en": "Malorita",
            "be": "Маларыта"
        },
        {
            "id": "locations.1652",
            "ru": "Иваново",
            "en": "Ivanovo",
            "be": "Іванава"
        },
        {
            "id": "locations.1655",
            "ru": "Столин",
            "en": "Stolin",
            "be": "Столін"
        },
        {
            "id": "locations.16550001",
            "ru": "Давид-Городок",
            "en": "David-Gorodok",
            "be": "Давыд-Гарадок"
        },
        {
            "id": "locations.16550002",
            "ru": "Ольшаны",
            "en": "Olshany",
            "be": "Альшаны"
        },
        {
            "id": "locations.17",
            "ru": "Минск",
            "en": "Minsk",
            "be": "Мінск"
        },
        {
            "id": "locations.170004",
            "ru": "Боровляны",
            "en": "Borovliany",
            "be": "Бараўляны"
        },
        {
            "id": "locations.170005",
            "ru": "Гатово",
            "en": "Gatovo",
            "be": "Гатава"
        },
        {
            "id": "locations.170003",
            "ru": "Заславль",
            "en": "Zaslavl",
            "be": "Заслаўе"
        },
        {
            "id": "locations.170006",
            "ru": "Колодищи",
            "en": "Kolodishchi",
            "be": "Калодзішчы"
        },
        {
            "id": "locations.2337",
            "ru": "Корма",
            "en": "Korma",
            "be": "Корма"
        },
        {
            "id": "locations.170007",
            "ru": "Мачулищи",
            "en": "Machulishchy",
            "be": "Мачулішчы"
        },
        {
            "id": "locations.170002",
            "ru": "Михановичи",
            "en": "Mihanovichi",
            "be": "Міханавічы"
        },
        {
            "id": "locations.170008",
            "ru": "Острошицкий городок",
            "en": "Ostroshitsky gorodok",
            "be": "Астрашыцкі гарадок"
        },
        {
            "id": "locations.170001",
            "ru": "Самохваловичи",
            "en": "Samokhvalovichy",
            "be": "Самахвалавічы"
        },
        {
            "id": "locations.174",
            "ru": "Солигорск",
            "en": "Soligorsk",
            "be": "Салігорск"
        },
        {
            "id": "locations.17130002",
            "ru": "Руденск",
            "en": "Rudensk",
            "be": "Рудзенск"
        },
        {
            "id": "locations.17130001",
            "ru": "Дружный пос.",
            "en": "Dryzhnii poselok",
            "be": "Дружны пас."
        },
        {
            "id": "locations.1713",
            "ru": "Марьина Горка",
            "en": "Marina Gorka",
            "be": "Мар'іна Горка"
        },
        {
            "id": "locations.1714",
            "ru": "Червень",
            "en": "Cherven",
            "be": "Чэрвень"
        },
        {
            "id": "locations.17140001",
            "ru": "Смиловичи",
            "en": "Smilovichi",
            "be": "Смілавічы"
        },
        {
            "id": "locations.1715",
            "ru": "Березино",
            "en": "Berezino",
            "be": "Беразіно"
        },
        {
            "id": "locations.17160001",
            "ru": "Фаниполь",
            "en": "Fanipol",
            "be": "Фаніпаль"
        },
        {
            "id": "locations.1716",
            "ru": "Дзержинск",
            "en": "Dzerzhinsk",
            "be": "Дзяржынск"
        },
        {
            "id": "locations.1717",
            "ru": "Столбцы",
            "en": "Stolbtsi",
            "be": "Стоўбцы"
        },
        {
            "id": "locations.1719",
            "ru": "Копыль",
            "en": "Kopyl",
            "be": "Копыль"
        },
        {
            "id": "locations.1771",
            "ru": "Вилейка",
            "en": "Vileika",
            "be": "Вілейка"
        },
        {
            "id": "locations.1772",
            "ru": "Воложин",
            "en": "Volozhin",
            "be": "Валожын"
        },
        {
            "id": "locations.176",
            "ru": "Молодечно",
            "en": "Molodechno",
            "be": "Маладзечна"
        },
        {
            "id": "locations.1774",
            "ru": "Логойск",
            "en": "Logoisk",
            "be": "Лагойск"
        },
        {
            "id": "locations.1775",
            "ru": "Жодино",
            "en": "Zhodino",
            "be": "Жодзіна"
        },
        {
            "id": "locations.1776",
            "ru": "Смолевичи",
            "en": "Smolevichi",
            "be": "Смалявічы"
        },
        {
            "id": "locations.1777",
            "ru": "Борисов",
            "en": "Borisov",
            "be": "Барысаў"
        },
        {
            "id": "locations.17740001",
            "ru": "Плещеницы",
            "en": "Pleshchenitsy",
            "be": "Плешчаніцы"
        },
        {
            "id": "locations.1792",
            "ru": "Старые Дороги",
            "en": "Stariye Dorogi",
            "be": "Старыя Дарогі"
        },
        {
            "id": "locations.1793",
            "ru": "Клецк",
            "en": "Kleck",
            "be": "Клецк"
        },
        {
            "id": "locations.1794",
            "ru": "Любань",
            "en": "Luban",
            "be": "Любань"
        },
        {
            "id": "locations.1770",
            "ru": "Несвиж",
            "en": "Nesvish",
            "be": "Нясвіж"
        },
        {
            "id": "locations.1795",
            "ru": "Слуцк",
            "en": "Slutsk",
            "be": "Слуцк"
        },
        {
            "id": "locations.17970001",
            "ru": "Нарочь",
            "en": "Naroch",
            "be": "Нарач"
        },
        {
            "id": "locations.1797",
            "ru": "Мядель",
            "en": "Myadel",
            "be": "Мядзел"
        },
        {
            "id": "locations.212",
            "ru": "Витебск",
            "en": "Vitebsk",
            "be": "Віцебск"
        },
        {
            "id": "locations.2130",
            "ru": "Шумилино",
            "en": "Shumilino",
            "be": "Шуміліна"
        },
        {
            "id": "locations.2131",
            "ru": "Бешенковичи",
            "en": "Beshenkovichi",
            "be": "Бешанковічы"
        },
        {
            "id": "locations.2132",
            "ru": "Лепель",
            "en": "Lepel",
            "be": "Лепель"
        },
        {
            "id": "locations.21330001",
            "ru": "Чашники",
            "en": "Chashniki",
            "be": "Чашнікі"
        },
        {
            "id": "locations.2133",
            "ru": "Новолукомль",
            "en": "Novolukoml",
            "be": "Новалукомль"
        },
        {
            "id": "locations.2135",
            "ru": "Сенно",
            "en": "Senno",
            "be": "Сянно"
        },
        {
            "id": "locations.2136",
            "ru": "Толочин",
            "en": "Tolochin",
            "be": "Талачын"
        },
        {
            "id": "locations.2137",
            "ru": "Дубровно",
            "en": "Dubrovno",
            "be": "Дуброўна"
        },
        {
            "id": "locations.2138",
            "ru": "Лиозно",
            "en": "Liozno",
            "be": "Лёзна"
        },
        {
            "id": "locations.2139",
            "ru": "Городок",
            "en": "Gorodok",
            "be": "Гарадок"
        },
        {
            "id": "locations.214",
            "ru": "Полоцк",
            "en": "Polotsk",
            "be": "Полацк"
        },
        {
            "id": "locations.2140001",
            "ru": "Новополоцк",
            "en": "Novopolotsk",
            "be": "Наваполацк"
        },
        {
            "id": "locations.2151",
            "ru": "Верхнедвинск",
            "en": "Verhnedvinsk",
            "be": "Верхнядзвінск"
        },
        {
            "id": "locations.2152",
            "ru": "Миоры",
            "en": "Miory",
            "be": "Мёры"
        },
        {
            "id": "locations.2153",
            "ru": "Браслав",
            "en": "Braslav",
            "be": "Браслаў"
        },
        {
            "id": "locations.2154",
            "ru": "Шарковщина",
            "en": "Sharkovshchina",
            "be": "Шаркаўшчына"
        },
        {
            "id": "locations.2155",
            "ru": "Поставы",
            "en": "Postavy",
            "be": "Паставы"
        },
        {
            "id": "locations.2156",
            "ru": "Глубокое",
            "en": "Glubokoye",
            "be": "Глыбокае"
        },
        {
            "id": "locations.2157",
            "ru": "Докшицы",
            "en": "Dokshitsy",
            "be": "Докшыцы"
        },
        {
            "id": "locations.2158",
            "ru": "Ушачи",
            "en": "Ushachi",
            "be": "Ушачы"
        },
        {
            "id": "locations.2159",
            "ru": "Россоны",
            "en": "Rossony",
            "be": "Расоны"
        },
        {
            "id": "locations.2160001",
            "ru": "Барань",
            "en": "Baran",
            "be": "Барань"
        },
        {
            "id": "locations.216",
            "ru": "Орша",
            "en": "Orsha",
            "be": "Орша"
        },
        {
            "id": "locations.222",
            "ru": "Могилёв",
            "en": "Mogilev",
            "be": "Магілёў"
        },
        {
            "id": "locations.2230",
            "ru": "Глуск",
            "en": "Glusk",
            "be": "Глуск"
        },
        {
            "id": "locations.2231",
            "ru": "Быхов",
            "en": "Byhov",
            "be": "Быхаў"
        },
        {
            "id": "locations.2232",
            "ru": "Белыничи",
            "en": "Belynichi",
            "be": "Бялынічы"
        },
        {
            "id": "locations.1796",
            "ru": "Крупки",
            "en": "Krupki",
            "be": "Крупкі"
        },
        {
            "id": "locations.2233",
            "ru": "Горки",
            "en": "Gorki",
            "be": "Горкі"
        },
        {
            "id": "locations.2234",
            "ru": "Круглое",
            "en": "Krugloye",
            "be": "Круглае"
        },
        {
            "id": "locations.2235",
            "ru": "Осиповичи",
            "en": "Osipovichi",
            "be": "Асіповічы"
        },
        {
            "id": "locations.2236",
            "ru": "Кличев",
            "en": "Klichev",
            "be": "Клічаў"
        },
        {
            "id": "locations.2237",
            "ru": "Кировск",
            "en": "Kirovsk",
            "be": "Кіраўск"
        },
        {
            "id": "locations.2238",
            "ru": "Краснополье",
            "en": "Krasnopole",
            "be": "Краснаполле"
        },
        {
            "id": "locations.2239",
            "ru": "Шклов",
            "en": "Shklov",
            "be": "Шклоў"
        },
        {
            "id": "locations.2240",
            "ru": "Мстиславль",
            "en": "Mstislavl",
            "be": "Мсціслаў"
        },
        {
            "id": "locations.2241",
            "ru": "Кричев",
            "en": "Krichev",
            "be": "Крычаў"
        },
        {
            "id": "locations.2243",
            "ru": "Чериков",
            "en": "Cherikov",
            "be": "Чэрыкаў"
        },
        {
            "id": "locations.2242",
            "ru": "Чаусы",
            "en": "Chausy",
            "be": "Чавусы"
        },
        {
            "id": "locations.2244",
            "ru": "Климовичи",
            "en": "Klimovichi",
            "be": "Клімавічы"
        },
        {
            "id": "locations.2245",
            "ru": "Костюковичи",
            "en": "Kostyukovichi",
            "be": "Касцюковічы"
        },
        {
            "id": "locations.2246",
            "ru": "Славгород",
            "en": "Slavgorod",
            "be": "Слаўгарад"
        },
        {
            "id": "locations.2247",
            "ru": "Хотимск",
            "en": "Hotimsk",
            "be": "Хоцімск"
        },
        {
            "id": "locations.2248",
            "ru": "Дрибин",
            "en": "Drybin",
            "be": "Дрыбін"
        },
        {
            "id": "locations.225",
            "ru": "Бобруйск",
            "en": "Bobruisk",
            "be": "Бабруйск"
        },
        {
            "id": "locations.232",
            "ru": "Гомель",
            "en": "Gomel",
            "be": "Гомель"
        },
        {
            "id": "locations.2330",
            "ru": "Ветка",
            "en": "Vetka",
            "be": "Ветка"
        },
        {
            "id": "locations.2332",
            "ru": "Чечерск",
            "en": "Chechersk",
            "be": "Чачэрск"
        },
        {
            "id": "locations.2333",
            "ru": "Добруш",
            "en": "Dobrush",
            "be": "Добруш"
        },
        {
            "id": "locations.2334",
            "ru": "Жлобин",
            "en": "Zhlobin",
            "be": "Жлобін"
        },
        {
            "id": "locations.2336",
            "ru": "Буда-Кошелево",
            "en": "Buda-Koshelevo",
            "be": "Буда-Кашалёва"
        },
        {
            "id": "locations.2339",
            "ru": "Рогачев",
            "en": "Rogachev",
            "be": "Рагачоў"
        },
        {
            "id": "locations.2340",
            "ru": "Речица",
            "en": "Rechitsa",
            "be": "Рэчыца"
        },
        {
            "id": "locations.2342",
            "ru": "Светлогорск",
            "en": "Svetlogorsk",
            "be": "Светлагорск"
        },
        {
            "id": "locations.2344",
            "ru": "Брагин",
            "en": "Bragin",
            "be": "Брагін"
        },
        {
            "id": "locations.2345",
            "ru": "Калинковичи",
            "en": "Kalinkovichi",
            "be": "Калінкавічы"
        },
        {
            "id": "locations.2346",
            "ru": "Хойники",
            "en": "Khoiniki",
            "be": "Хойнікі"
        },
        {
            "id": "locations.2347",
            "ru": "Лоев",
            "en": "Loev",
            "be": "Лоеў"
        },
        {
            "id": "locations.235",
            "ru": "Петриков",
            "en": "Petrikov",
            "be": "Петрыкаў"
        },
        {
            "id": "locations.2351",
            "ru": "Мозырь",
            "en": "Mozyr",
            "be": "Мазыр"
        },
        {
            "id": "locations.23530001",
            "ru": "Туров",
            "en": "Turov",
            "be": "Турау"
        },
        {
            "id": "locations.2353",
            "ru": "Житковичи",
            "en": "Zhitkovichi",
            "be": "Жыткавічы"
        },
        {
            "id": "locations.2354",
            "ru": "Ельск",
            "en": "Yelsk",
            "be": "Ельск"
        },
        {
            "id": "locations.2355",
            "ru": "Наровля",
            "en": "Narovlya",
            "be": "Нароўля"
        },
        {
            "id": "locations.2356",
            "ru": "Лельчицы",
            "en": "Lelchitsy",
            "be": "Лельчыцы"
        },
        {
            "id": "locations.2357",
            "ru": "Октябрьский",
            "en": "Octyabrski",
            "be": "Актябрскi"
        },
        {
            "id": "locations.2120001",
            "ru": "Витьба",
            "en": "Vitba",
            "be": "Віцьба"
        },
        {
            "id": "locations.1540001",
            "ru": "Островля",
            "en": "Ostrovlya",
            "be": "Астроўля"
        },
        {
            "id": "locations.23390001",
            "ru": "Шапчицы",
            "en": "Shapchitsy",
            "be": "Шапчыцы"
        },
        {
            "id": "locations.1520002",
            "ru": "Поречье",
            "en": "Porechye",
            "be": "Парэчча"
        },
        {
            "id": "locations.33",
            "ru": "Guadalajara",
            "en": "Guadalajara",
            "be": "Guadalajara"
        },
        {
            "id": "medcenterFilter.any",
            "ru": "Любой медцентр",
            "en": "Any medical center",
            "be": "Любы медцэнтр"
        },
        {
            "id": "medcenterFilter.byFavorite",
            "ru": "Из закладок",
            "en": "From bookmarks",
            "be": "З закладак"
        },
        {
            "id": "medcenterFilter.byProgram",
            "ru": "Медцентры программы",
            "en": "Medical centers of program",
            "be": "Медцэнтры праграмы"
        },
        {
            "id": "medcenterFilter.byOnlineService",
            "ru": "Медцентры с онлайн записью",
            "en": "Medical centers with online booking",
            "be": "Медцэнтры з анлайн запісам"
        },
        {
            "id": "medcenterInfoFields.address",
            "ru": "Адрес",
            "en": "Address",
            "be": "Адрас"
        },
        {
            "id": "medcenterInfoFields.emails",
            "ru": "E-mail",
            "en": "E-mail",
            "be": "E-mail"
        },
        {
            "id": "medcenterInfoFields.name",
            "ru": "Учреждение",
            "en": "Institution",
            "be": "Установа"
        },
        {
            "id": "medcenterInfoFields.phones",
            "ru": "Телефоны",
            "en": "Phones",
            "be": "Тэлефоны"
        },
        {
            "id": "medcenterInfoFields.schedule",
            "ru": "Время работы",
            "en": "Working hours",
            "be": "Час працы"
        },
        {
            "id": "my-card.emptyFavList",
            "ru": "Здесь будут отображаться\nдобавленные в закладки доктора и медцентры.",
            "en": "Here will be displayed doctors and medical centers added to bookmarks.",
            "be": "Тут будуць адлюстроўвацца дададзеныя ў закладкі доктара і медцэнтры."
        },
        {
            "id": "my-card.favHeaderTitle",
            "ru": "ЗАКЛАДКИ",
            "en": "BOOKMARKS",
            "be": "Закладкі"
        },
        {
            "id": "my-card.needToSignIn",
            "ru": "Для использования закладок необходимо авторизоваться и заполнить данные о себе",
            "en": "To use the bookmarks, you need to log in and fill out your profile",
            "be": "Для выкарыстання закладак неабходна аўтарызавацца уліковым запісам з запоўненым профілем"
        },
        {
            "id": "my-card.visitsHeader",
            "ru": "ИСТОРИЯ ПОСЕЩЕНИЙ",
            "en": "VISIT HISTORY",
            "be": "ГІСТОРЫЯ НАВЕДВАННЯЎ"
        },
        {
            "id": "my-card.testsHeader",
            "ru": "АНАЛИЗЫ",
            "en": "TESTS",
            "be": "АНАЛІЗЫ"
        },
        {
            "id": "my-card.visitsTab",
            "ru": "ВИЗИТЫ",
            "en": "VISITS",
            "be": "НАВЕДВАННІ"
        },
        {
            "id": "my-card.testsTab",
            "ru": "АНАЛИЗЫ",
            "en": "TESTS",
            "be": "АНАЛІЗЫ"
        },
        {
            "id": "my-card.reportsHeader",
            "ru": "ОТЧЕТЫ",
            "en": "REPORTS",
            "be": "СПРАВАЗДАЧЫ"
        },
        {
            "id": "navigationItemsList.doctors",
            "ru": "Поиск врача",
            "en": "Doctor Search",
            "be": "Пошук лекара"
        },
        {
            "id": "navigationItemsList.drugs",
            "ru": "Поиск лекарств",
            "en": "Drug Search",
            "be": "Пошук лекаў"
        },
        {
            "id": "navigationItemsList.ums",
            "ru": "Поиск услуги",
            "en": "Service Search",
            "be": "Пошук паслуг"
        },
        {
            "id": "navigationItemsList.medcenters",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "notes.added",
            "ru": "добавлено",
            "en": "added",
            "be": "дададзена"
        },
        {
            "id": "notes.doctorsFilterPeriod",
            "ru": "Не все центры поддерживают эту опцию. Там, где данных по времени према нет, мы покажем вам врача без отметки о его приемных часах.",
            "en": "Not all centers support this option, but where at the time of receiving no data, we'll show you a doctor without a mark on his reception hours",
            "be": "Не ўсе цэнтры падтрымліваюць гэтую опцыю, але там, дзе дадзеных па часе прыёму няма, мы пакажам вам лекара без адзнакі аб яго прыёмных гадзінах"
        },
        {
            "id": "notes.socialSignInWarningText",
            "ru": "Функция входа через социальные сети будет доступна в ближайшее время. Пожалуйста, воспользуйтесь стандартной формой входа.",
            "en": "Input function through social networks will be available in the near future. Please use the standard login form.",
            "be": "Функцыя ўваходу праз сацыяльныя сеткі будзе даступная ў бліжэйшы час. Калі ласка, скарыстайцеся стандартнай формай ўваходу."
        },
        {
            "id": "notes.triggeredNotificationType",
            "ru": "warn",
            "en": "warn",
            "be": "warn"
        },
        {
            "id": "notes.visitAdditionalPhrase",
            "ru": "Вы действительно хотите отменить визит к этому врачу?",
            "en": "Are you sure you want to cancel your appointment with this doctor?",
            "be": "Вы сапраўды жадаеце адмяніць візіт да гэтага ўрача?"
        },
        {
            "id": "notes.you_have_no_visits",
            "ru": "Просмотр визитов будет доступен сразу после авторизации",
            "en": "You will be able to view appointments immediately after authorization",
            "be": "Прагляд візітаў будзе даступны адразу пасля аўтарызацыі"
        },
        {
            "id": "notes.you_have_no_visits_auth",
            "ru": "У вас пока нет визитов",
            "en": "You have no visits",
            "be": "У вас пакуль няма візітаў"
        },
        {
            "id": "notes.you_have_no_tests_auth",
            "ru": "Здесь будут отображаться результаты анализов из клиник, которые используют личный кабинет пациента. Вы можете уточнить наличие данной функции в своем медицинском центре.",
            "en": "Here will be displayed test results from clinics that use the patient' personal account. You can clarify the availability of this feature in your medical center.",
            "be": "Тут будуць адлюстроўвацца вынікі клінік, якія выкарыстоўваюць асабісты ўліковы запіс пацыента. Вы можаце ўдакладніць наяўнасць гэтай функцыі ў вашым медыцынскім цэнтры."
        },
        {
            "id": "notes.you_have_no_reports_auth",
            "ru": "У вас пока нет отчетов",
            "en": "You don't have any reports yet",
            "be": "У вас пакуль няма справаздач"
        },
        {
            "id": "notes.you_have_no_visitsLoading",
            "ru": "Просмотр визитов будет доступен сразу после авторизации",
            "en": "Visits will be available for viewing immediately after authorization",
            "be": "Прагляд візітаў будзе даступны адразу пасля аўтарызацыі"
        },
        {
            "id": "notes.you_have_no_visitsLoading_auth",
            "ru": "Идет загрузка данных",
            "en": "Data is loading",
            "be": "Идет загрузка дадзеных"
        },
        {
            "id": "notes.you_have_no_testsLoading_auth",
            "ru": "Идет загрузка данных",
            "en": "Data is loading",
            "be": "Идет загрузка дадзеных"
        },
        {
            "id": "notes.you_have_no_reportsLoading_auth",
            "ru": "Идет загрузка данных",
            "en": "Data is loading",
            "be": "Идет загрузка дадзеных"
        },
        {
            "id": "others.mainGoal",
            "ru": "Поиск врачей и лекарств онлайн",
            "en": "Search for doctors and medicines online",
            "be": "Пошук лекараў і лекаў анлайн"
        },
        {
            "id": "others.serviceSource",
            "ru": "Информация о лекарствах\nпредоставлена сервисом tabletka.by",
            "be": "Інфармацыя аб леках прадастаўлена сэрвісам tabletka.by"
        },
        {
            "id": "others.version",
            "ru": "Версия {version}",
            "en": "Version {version}",
            "be": "Версія {version}"
        },
        {
            "id": "othersNavigation.about",
            "ru": "О проекте",
            "en": "About the project",
            "be": "Аб праекце"
        },
        {
            "id": "othersNavigation.improving",
            "ru": "Предложения по улучшению Aibolit",
            "en": "Suggestions for improving Aibolit",
            "be": "Прапановы па паляпшэнню Aibolit"
        },
        {
            "id": "othersNavigation.privacy",
            "ru": "Политика конфиденциальности",
            "en": "Privacy policy",
            "be": "Палітыка прыватнасці"
        },
        {
            "id": "othersNavigation.support",
            "ru": "Обратиться в поддержку",
            "en": "Contact support",
            "be": "Звярнуцца ў падтрымку"
        },
        {
            "id": "othersNavigation.user_agreement",
            "ru": "Пользовательское соглашение",
            "en": "Terms of use",
            "be": "Карыстальніцкае пагадненне"
        },
        {
            "id": "othersNavigation.personalData",
            "ru": "Согласие на обработку персональных данных",
            "en": "Consent to the processing of personal data",
            "be": "Згода на апрацоўку персанальных даных"
        },
        {
            "id": "placeholder.rejected_this_service",
            "ru": "Пожалуйста, напишите, почему вы отклонили эту услугу?",
            "en": "Please write why you rejected this service?",
            "be": "Калі ласка, напішыце, чаму вы адхілілі гэтую паслугу?"
        },
        {
            "id": "placeholder.why_you_not_confirm_some_services",
            "ru": "Пожалуйста, напишите почему вы не подтвердили некоторые услуги?",
            "en": "Why do not you have confirmed some of the services?",
            "be": "Чаму вы не пацвердзілі некаторыя паслугі?"
        },
        {
            "id": "placeholders.code",
            "ru": "Код",
            "en": "Code",
            "be": "Код"
        },
        {
            "id": "placeholders.epamEmail",
            "ru": "Name_Lastname@epam.com",
            "en": "Name_Lastname@epam.com",
            "be": "Name_Lastname@epam.com"
        },
        {
            "id": "placeholders.number",
            "ru": "Номер",
            "en": "Number",
            "be": "Нумар"
        },
        {
            "id": "placeholders.search",
            "ru": "Поиск…",
            "en": "Search…",
            "be": "Пошук ..."
        },
        {
            "id": "placeholders.search_doctors",
            "ru": "от трёх символов…",
            "en": "from three characters ...",
            "be": "ад трох знакаў ..."
        },
        {
            "id": "placeholders.search_drugs",
            "ru": "Поиск (по полному названию)…",
            "en": "Search (by full name)...",
            "be": "Пошук (ад трох знакаў)..."
        },
        {
            "id": "placeholders.search_medcenters",
            "ru": "Поиск медцентра ...",
            "en": "Search medical center ...",
            "be": "Пошук медцэнтра ..."
        },
        {
            "id": "popularQueries.doctors.Гинеколог",
            "ru": "Гинеколог",
            "en": "Gynecologist",
            "be": "Гінеколаг"
        },
        {
            "id": "popularQueries.doctors.Невролог",
            "ru": "Невролог",
            "en": "Neurologist",
            "be": "Неўролаг"
        },
        {
            "id": "popularQueries.doctors.Оториноларинголог",
            "ru": "Оториноларинголог",
            "en": "Otolaryngologist",
            "be": "Отарыналарынголаг"
        },
        {
            "id": "popularQueries.doctors.Офтальмолог",
            "ru": "Офтальмолог",
            "en": "Ophthalmologist",
            "be": "Афтальмолаг"
        },
        {
            "id": "popularQueries.doctors.Педиатр",
            "ru": "Педиатр",
            "en": "Pediatrician",
            "be": "Педыятр"
        },
        {
            "id": "popularQueries.doctors.Терапевт",
            "ru": "Терапевт",
            "en": "Therapist",
            "be": "Тэрапеўт"
        },
        {
            "id": "popularQueries.doctors.Хирург",
            "ru": "Хирург",
            "en": "Surgeon",
            "be": "Хірург"
        },
        {
            "id": "popularQueries.drugs.Фурасол",
            "ru": "Фурасол",
            "en": "Furasol",
            "be": "Фурасол"
        },
        {
            "id": "popularQueries.drugs.Мирасептин",
            "ru": "Мирасептин",
            "en": "Miraseptin",
            "be": "Мирасепцін"
        },
        {
            "id": "popularQueries.drugs.Септоцид",
            "ru": "Септоцид",
            "en": "Septotsid",
            "be": "Септоцід"
        },
        {
            "id": "popularQueries.drugs.Маска_медицинская",
            "ru": "Маска медицинская",
            "en": "Medical mask",
            "be": "Маска медыцынская"
        },
        {
            "id": "popularQueries.drugs.Подорожника_лист",
            "ru": "Подорожника лист",
            "en": "Plantain leaf",
            "be": "Трыпутніка ліст"
        },
        {
            "id": "popularQueries.drugs.Валериана",
            "ru": "Валериана",
            "en": "Valerian",
            "be": "Валяр'яна"
        },
        {
            "id": "popularQueries.doctors.Исследование_на_covid-19",
            "ru": "Исследование на covid-19",
            "en": "Research on covid-19",
            "be": "Даследаванне на covid-19"
        },
        {
            "id": "positions*.few",
            "ru": "ПОСМОТРЕТЬ ВЕСЬ СЧЕТ ({{count}} ПОЗИЦИИ)",
            "en": "See whole SCORE ({{count}} POSITION)",
            "be": "ПАГЛЯДЗЕЦЬ УВЕСЬ КОШТ ({{count}} ПАЗІЦЫІ)"
        },
        {
            "id": "positions*.many",
            "ru": "ПОСМОТРЕТЬ ВЕСЬ СЧЕТ ({{count}} ПОЗИЦИЙ)",
            "en": "See whole SCORE ({{count}} NUMERALS)",
            "be": "ПАГЛЯДЗЕЦЬ УВЕСЬ КОШТ ({{count}} пазіцыі)"
        },
        {
            "id": "positions*.one",
            "ru": "ПОСМОТРЕТЬ ВЕСЬ СЧЕТ ({{count}} ПОЗИЦИЯ)",
            "en": "See whole SCORE ({{count}} POSITION)",
            "be": "ПАГЛЯДЗЕЦЬ УВЕСЬ КОШТ ({{count}} ПАЗІЦЫЯ)"
        },
        {
            "id": "preferredDates.0",
            "ru": "Любая дата",
            "en": "Any date",
            "be": "Любая дата"
        },
        {
            "id": "preferredDates.3",
            "ru": "В ближайшие 3 дня",
            "en": "In the next 3 days",
            "be": "У бліжэйшыя 3 дні"
        },
        {
            "id": "preferredDates.30",
            "ru": "Ближайший месяц",
            "en": "Next month",
            "be": "Бліжэйшы месяц"
        },
        {
            "id": "preferredDates.7",
            "ru": "Ближайшая неделя",
            "en": "Next week",
            "be": "Бліжэйшы тыдзень"
        },
        {
            "id": "preferredTimes.0",
            "ru": "Любое время",
            "en": "Any time",
            "be": "Любы час"
        },
        {
            "id": "preferredTimes.1",
            "ru": "6:00 - 10:00",
            "en": "6:00 - 10:00",
            "be": "06:00 - 10:00"
        },
        {
            "id": "preferredTimes.2",
            "ru": "10:00 - 14:00",
            "en": "10:00 - 14:00",
            "be": "10:00 - 14:00"
        },
        {
            "id": "preferredTimes.3",
            "ru": "14:00 - 18:00",
            "en": "14:00 - 18:00",
            "be": "14:00 - 18:00"
        },
        {
            "id": "preferredTimes.4",
            "ru": "18:00 - 22:00",
            "en": "18:00 - 22:00",
            "be": "18:00 - 22:00"
        },
        {
            "id": "preferredAges.0",
            "ru": "Не учитывается",
            "en": "Not counted",
            "be": "Не ўлічваецца"
        },
        {
            "id": "preferredAges.1",
            "ru": "Врач принимает детей",
            "en": "The doctor sees the children",
            "be": "Лекар прымае дзяцей"
        },
        {
            "id": "preferredAges.2",
            "ru": "Врач принимает взрослых",
            "en": "Doctor seeing adults",
            "be": "Лекар прымае дарослых"
        },
        {
            "id": "price",
            "ru": "от {value} руб.",
            "en": "{value} from RUB.",
            "be": "ад {value} руб."
        },
        {
            "id": "priceFromTo",
            "ru": "{from} - {to} руб.",
            "en": "{from} - {to} rub.",
            "be": "{from} - {to} руб."
        },
        {
            "id": "rel.CHILD",
            "ru": "Ребёнок",
            "en": "Child",
            "be": "Дзіця"
        },
        {
            "id": "rel.OWNER",
            "ru": "Создатель",
            "en": "Creator",
            "be": "Стваральнік"
        },
        {
            "id": "rel.SPOUSE",
            "ru": "Супруг(а)",
            "en": "Spouse",
            "be": "Сваяк"
        },
        {
            "id": "rootNavigation.Doctors",
            "ru": "Врачи",
            "en": "Doctors",
            "be": "Лекары"
        },
        {
            "id": "screenTitles.Tabs",
            "ru": "Главная",
            "en": "Main",
            "be": "Галоўная"
        },
        {
            "id": "screenTitles.Home",
            "ru": "Главная",
            "en": "Main",
            "be": "Галоўная"
        },
        {
            "id": "rootNavigation.Home",
            "ru": "Главная",
            "en": "Main",
            "be": "Галоўная"
        },
        {
            "id": "rootNavigation.MedCentersList",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "rootNavigation.MyCard",
            "ru": "Карточка",
            "en": "Card",
            "be": "Картка"
        },
        {
            "id": "rootNavigation.MainFeedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "rootNavigation.Other",
            "ru": "Прочее",
            "en": "Other",
            "be": "Іншае"
        },
        {
            "id": "rootNavigation.SearchDrugs",
            "ru": "Лекарства",
            "en": "Drugs",
            "be": "Лекі"
        },
        {
            "id": "screenTitles.Account",
            "ru": "Учётная запись",
            "en": "Account",
            "be": "Ўліковы запіс"
        },
        {
            "id": "screenTitles.AccessCheck",
            "ru": "Профиль",
            "en": "Profile",
            "be": "Профіль"
        },
        {
            "id": "screenTitles.AccountReset",
            "ru": "Профиль",
            "en": "Profile",
            "be": "Профіль"
        },
        {
            "id": "screenTitles.AddFeedbacks",
            "ru": "Добавить отзыв",
            "en": "Add a feedback",
            "be": "Дадаць водгук"
        },
        {
            "id": "screenTitles.AddRelative",
            "ru": "Моя семья",
            "en": "My family",
            "be": "Мая сям'я"
        },
        {
            "id": "screenTitles.ChooseProgram",
            "ru": "Программа",
            "en": "Program",
            "be": "Праграма"
        },
        {
            "id": "screenTitles.CodeConfirmation",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.DoctorDetails",
            "ru": "Врач",
            "en": "About the doctor",
            "be": "Аб лекары"
        },
        {
            "id": "screenTitles.DoctorFeedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "screenTitles.DoctorFilters",
            "ru": "Поиск врача",
            "en": "Doctor Search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.DoctorInfo",
            "ru": "О враче",
            "en": "About the doctor",
            "be": "Аб лекары"
        },
        {
            "id": "screenTitles.DoctorListClinic",
            "ru": "Поиск врача",
            "en": "Doctor Search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.DoctorList",
            "ru": "Поиск врача",
            "en": "Doctor Search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.DoctorRecordDatePickRout",
            "ru": "Запись к врачу",
            "en": "Appointment to the doctor",
            "be": "Запіс да ўрача"
        },
        {
            "id": "screenTitles.DoctorRecordDatePick",
            "ru": "Запись к врачу",
            "en": "Appointment to the doctor",
            "be": "Запіс да ўрача"
        },
        {
            "id": "screenTitles.DoctorSpecialization",
            "ru": "Выбор врача",
            "en": "Choosing a doctor",
            "be": "Выбар лекара"
        },
        {
            "id": "screenTitles.Documents",
            "ru": "Документы",
            "en": "Documents",
            "be": "Дакументы"
        },
        {
            "id": "screenTitles.DocumentsSlider",
            "ru": "Просмотр",
            "en": "View",
            "be": "Прагляд"
        },
        {
            "id": "screenTitles.DrugDetails",
            "ru": "Лекарства",
            "en": "Drugs",
            "be": "Лекі"
        },
        {
            "id": "screenTitles.DrugDetailsForVisit",
            "ru": "Aптеки по визиту",
            "en": "Pharmacies by visit",
            "be": "Aптэкі па візіце"
        },
        {
            "id": "screenTitles.DrugsList",
            "ru": "Лекарства",
            "en": "Drugs",
            "be": "Лекі"
        },
        {
            "id": "screenTitles.DrugsListForVisit",
            "ru": "Лекарства по визиту",
            "en": "Drugs by visit",
            "be": "Лекі па візіце"
        },
        {
            "id": "screenTitles.DrugstoreDetails",
            "ru": "Aптека",
            "en": "Pharmacy",
            "be": "Aптэка"
        },
        {
            "id": "screenTitles.DrugstoreDetailsForVisit",
            "ru": "Aптека",
            "en": "Pharmacy",
            "be": "Aптэка"
        },
        {
            "id": "screenTitles.DrugstoresMap",
            "ru": "Aптеки",
            "en": "Pharmacies",
            "be": "Aптэкі"
        },
        {
            "id": "screenTitles.EditAccount",
            "ru": "Редактирование",
            "en": "Editing",
            "be": "Рэдагаванне"
        },
        {
            "id": "screenTitles.EditFeedback",
            "ru": "Исправить отзыв",
            "en": "Edit the feedback",
            "be": "Выправіць водгук"
        },
        {
            "id": "screenTitles.EditUserPD",
            "ru": "Учетная запись ребенка",
            "en": "Child's account",
            "be": "Уліковы запіс дзіцяці"
        },
        {
            "id": "screenTitles.EditRelative",
            "ru": "Добавление ребенка",
            "en": "Adding a child",
            "be": "Дадаць дзiця"
        },
        {
            "id": "screenTitles.EditResult",
            "ru": "Учётная запись",
            "en": "Account",
            "be": "Ўліковы запіс"
        },
        {
            "id": "screenTitles.EnrollVisit",
            "ru": "Запись к врачу",
            "en": "Appointment to the doctor",
            "be": "Запіс да ўрача"
        },
        {
            "id": "screenTitles.EpamProgram",
            "ru": "Программа",
            "en": "Program",
            "be": "Праграма"
        },
        {
            "id": "screenTitles.EpamSignIn",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.FamilyInviteConfirm",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.FamilyInvitePermission",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.FamilyJoin",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.FirstAidKit",
            "ru": "Аптечка",
            "en": "First aid kit",
            "be": "Аптэчка"
        },
        {
            "id": "screenTitles.Home",
            "ru": "Главная",
            "en": "Main",
            "be": "Галоўная"
        },
        {
            "id": "screenTitles.BnsSignIn",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "screenTitles.BnsProgram",
            "ru": "Программа",
            "en": "Program",
            "be": "Праграма"
        },
        {
            "id": "screenTitles.InvoiceConfirmation",
            "ru": "Подтверждение",
            "en": "Confirmation",
            "be": "Пацверджанне"
        },
        {
            "id": "screenTitles.InvoiceMultiService",
            "ru": "Об услуге",
            "en": "About service",
            "be": "Пра паслугу"
        },
        {
            "id": "screenTitles.InvoiceReviewedInfo",
            "ru": "Об услуге",
            "en": "About service",
            "be": "Пра паслугу"
        },
        {
            "id": "screenTitles.MedCenterAddFeedback",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "screenTitles.MedCenterDetails",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "Медцэнтр"
        },
        {
            "id": "screenTitles.MedCenterFeedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "screenTitles.MedCenterInfo",
            "ru": "О медцентре",
            "en": "About the Medical Center",
            "be": "Аб медцэнтры"
        },
        {
            "id": "screenTitles.MedCenterRecord",
            "ru": "Запись в медцентр",
            "en": "Appointment at the medical center",
            "be": "Запіс у медцэнтр"
        },
        {
            "id": "screenTitles.MedCenterServices",
            "ru": "Услуги",
            "en": "Services",
            "be": "Паслугі"
        },
        {
            "id": "screenTitles.MedcentersFilter",
            "ru": "Выбор медцентра",
            "en": "Choosing a medical center",
            "be": "Выбар медцэнтра"
        },
        {
            "id": "screenTitles.MedCentersListRoute",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "screenTitles.MedCentersList",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "screenTitles.AllFeedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "screenTitles.MyCard",
            "ru": "Карточка",
            "en": "Card",
            "be": "Картка"
        },
        {
            "id": "screenTitles.NotificationsSettings",
            "ru": "Напоминания",
            "en": "Reminders",
            "be": "Напамін"
        },
        {
            "id": "screenTitles.Other",
            "ru": "Прочее",
            "en": "Other",
            "be": "Іншае"
        },
        {
            "id": "screenTitles.OutdatedAppVersion",
            "ru": "Ошибка системы",
            "en": "System Error",
            "be": "Памылка сiстэмы"
        },
        {
            "id": "screenTitles.PreferredDateFilter",
            "ru": "Дата визита",
            "en": "Date of visit",
            "be": "Дата візіту"
        },
        {
            "id": "screenTitles.Relatives",
            "ru": "Моя семья",
            "en": "My family",
            "be": "Мая сям'я"
        },
        {
            "id": "screenTitles.SearchDrugs",
            "ru": "Лекарства",
            "en": "Drugs",
            "be": "Лекі"
        },
        {
            "id": "screenTitles.SearchDrugsForVisit",
            "ru": "Лекарства по визиту",
            "en": "Drugs by visit",
            "be": "Лекі па візіце"
        },
        {
            "id": "screenTitles.SearchDrugsSettings",
            "ru": "Настройки",
            "en": "Settings",
            "be": "Налады"
        },
        {
            "id": "screenTitles.SearchDrugsSettingsForVisit",
            "ru": "Настройки",
            "en": "Settings",
            "be": "Налады"
        },
        {
            "id": "screenTitles.SearchDrugstores",
            "ru": "Лекарства",
            "en": "Drugs",
            "be": "Лекі"
        },
        {
            "id": "screenTitles.SearchDrugstoresForVisit",
            "ru": "Aптеки по визиту",
            "en": "Pharmacies by visit",
            "be": "Аптэкі па візіце"
        },
        {
            "id": "screenTitles.ServiceDetails",
            "ru": "Услуга",
            "en": "Service",
            "be": "Паслуга"
        },
        {
            "id": "screenTitles.SignIn",
            "ru": "Вход",
            "en": "Log in",
            "be": "Уваход"
        },
        {
            "id": "screenTitles.UmsMain",
            "ru": "Все услуги",
            "en": "All services",
            "be": "Усе паслуги"
        },
        {
            "id": "screenTitles.ViewImage",
            "ru": "Просмотр",
            "en": "View",
            "be": "Прагляд"
        },
        {
            "id": "screenTitles.VisitRelative",
            "ru": "О визите",
            "en": "About the visit",
            "be": "Пра візіт"
        },
        {
            "id": "screenTitles.Visit",
            "ru": "О визите",
            "en": "About the visit",
            "be": "Пра візіт"
        },
        {
            "id": "screenTitles.LoadVisits",
            "ru": "Загрузить визиты",
            "en": "Download visits",
            "be": "Загрузіць візіты"
        },
        {
            "id": "screenTitles.VisitsFilter",
            "ru": "История визитов",
            "en": "Visits history",
            "be": "Гісторыя візітаў"
        },
        {
            "id": "screenTitles.VisitImagesSlider",
            "ru": "Просмотр",
            "en": "Review",
            "be": "Прагляд"
        },
        {
            "id": "screenTitles.Feedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Водгукі"
        },
        {
            "id": "screenTitles.AddAdultRelative",
            "ru": "Добавить родственника",
            "en": "Add a relative",
            "be": "Дадаць сваяка"
        },
        {
            "id": "screenTitles.EditAdultRelative",
            "ru": "Редактировать родственника",
            "en": "Edit relative",
            "be": "Рэдагаваць сваяка"
        },
        {
            "id": "screenTitles.RelativeGrants",
            "ru": "Управление правами",
            "en": "Permissions management",
            "be": "Кіраванне правамі"
        },
        {
            "id": "screenTitles.RelativeSmsSend",
            "ru": "Отправить код",
            "en": "Send code",
            "be": "адправіць код"
        },
        {
            "id": "screenTitles.RelativeCodeConfirmation",
            "ru": "Ввод кода",
            "en": "Enter code",
            "be": "ўвод кода"
        },
        {
            "id": "screenTitles.DoctorsMap",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "screenTitles.DoctorsMapVisit",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "screenTitles.DoctorsMapClinic",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "screenTitles.MedCentersMap",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "screenTitles.UMSMedCentersMap",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "screenTitles.EditDoctorFeedback",
            "ru": "Исправить отзыв",
            "en": "Edit feedback",
            "be": "Выправіць водгук"
        },
        {
            "id": "screenTitles.AddDoctorFeedbacks",
            "ru": "Добавить отзыв",
            "en": "Add feedback",
            "be": "Дадаць водгук"
        },
        {
            "id": "screenTitles.ACodeConfirmation",
            "ru": "Ввод А-кода",
            "en": "Enter A-code",
            "be": "ўвод А-кода"
        },
        {
            "id": "screenTitles.PDFViewer",
            "ru": "Просмотр результата",
            "en": "View the result",
            "be": "Прагледзець вынік"
        },
        {
            "id": "screenTitles.AccessSettings",
            "ru": "Безопасность",
            "en": "Security",
            "be": "Бяспека"
        },
        {
            "id": "screenTitles.MainScreenSettings",
            "ru": "Главный экран",
            "en": "Main screen",
            "be": "Асноўны экран"
        },
        {
            "id": "screenTitles.UMSDoctorsList",
            "ru": "Врачи",
            "en": "Doctors",
            "be": "Лекары"
        },
        {
            "id": "screenTitles.MedCenterRecordFull",
            "ru": "Запись в медцентр",
            "en": "Appointment at the medical center",
            "be": "Запіс у медцэнтр"
        },
        {
            "id": "screenTitles.SearchListDrugs",
            "ru": "Поиск нескольких препаратов",
            "en": "Search for multiple drugs",
            "be": "Пошук некалькіх прэпаратаў"
        },
        {
            "id": "screenTitles.AddFutureVisitManually",
            "ru": "Добавить визит",
            "en": "Add a visit",
            "be": "Дадаць візіт"
        },
        {
            "id": "screenTitles.AddPastVisitManually",
            "ru": "Добавить визит",
            "en": "Add a visit",
            "be": "Дадаць візіт"
        },
        {
            "id": "screenTitles.DoctorsSpecialtiesSearch",
            "ru": "Поиск врача",
            "en": "Doctor search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.DoctorsSpecialtiesSearchVisit",
            "ru": "Поиск врача",
            "en": "Doctor search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.DoctorsSpecialtiesSearchClinic",
            "ru": "Поиск врача",
            "en": "Doctor search",
            "be": "Пошук лекара"
        },
        {
            "id": "screenTitles.Restore",
            "ru": "Загрузка из резервной копии",
            "en": "Restore from backup",
            "be": "Аднаўленне з рэзервовай копіі"
        },
        {
            "id": "screenTitles.CloudConnectSettings",
            "ru": "Резервное копирование",
            "en": "Backup",
            "be": "Рэзервовае капіраванне"
        },
        {
            "id": "screenTitles.DoctorsFavorites",
            "ru": "Врачи в закладках",
            "en": "Doctors in bookmarks",
            "be": "Лекары ў закладках"
        },
        {
            "id": "screenTitles.DebugScreen",
            "ru": "Отладка",
            "en": "Debug",
            "be": "Отладка"
        },
        {
            "id": "screenTitles.TestConsentsScreen",
            "ru": "Тест консентов",
            "en": "Consents test",
            "be": "Тест консентов"
        },
        {
            "id": "sex.MALE",
            "ru": "Мужской",
            "en": "Male",
            "be": "Мужчынскі"
        },
        {
            "id": "sex.FEMALE",
            "ru": "Женский",
            "en": "Female",
            "be": "Жаночы"
        },
        {
            "id": "relKind.SPOUSE",
            "ru": "Супруг(а)",
            "en": "Spouse",
            "be": "Муж / жонка"
        },
        {
            "id": "relKind.PARENT",
            "ru": "Родитель",
            "en": "Parent",
            "be": "Бацька / мацi"
        },
        {
            "id": "relKindWithOther.SPOUSE",
            "ru": "Супруг(а)",
            "en": "Spouse",
            "be": "Муж / жонка"
        },
        {
            "id": "relKindWithOther.PARENT",
            "ru": "Родитель",
            "en": "Parent",
            "be": "Бацька / мацi"
        },
        {
            "id": "relKindWithOther.OTHER",
            "ru": "Родственник",
            "en": "Relative",
            "be": "Сваяк"
        },
        {
            "id": "stubs.empty-druglist.subTitle",
            "ru": "Выберите лекарства для поиска в аптечке",
            "en": "Select drugs to search in the first aid kit",
            "be": "Абярыце лекi для пошуку ў аптэчцы"
        },
        {
            "id": "stubs.empty-druglist.title",
            "ru": "Список препаратов пуст",
            "en": "Drug list is empty",
            "be": "Спіс прэпаратаў пусты"
        },
        {
            "id": "stubs.empty-basket.subTitle",
            "ru": "Добавьте лекарства в аптечку. Это позволит вам найти все необходимые препараты в одной аптеке одним кликом.",
            "en": "You can add drugs in the first aid kit,\n to find them in a pharmacy with a single click",
            "be": "Вы можаце дадаць лекі ў аптэчку, каб знайсці іх у адной аптэцы націскам адной кнопкі"
        },
        {
            "id": "stubs.empty-basket.title",
            "ru": "Аптечка пока пуста",
            "en": "First aid kit is empty",
            "be": "Аптэчка пакуль пустая"
        },
        {
            "id": "stubs.empty-contacts.subTitle",
            "ru": "К сожалению, контактная информация медцентра отсутствует.",
            "en": "Unfortunately, the medical center's contact information is missing.",
            "be": "На жаль, кантактная інфармацыя медцэнтра адсутнічае."
        },
        {
            "id": "stubs.empty-contacts.title",
            "ru": "Нет контактов",
            "en": "No contacts",
            "be": "Няма кантактаў"
        },
        {
            "id": "stubs.empty-default",
            "ru": "Данные не найдены",
            "en": "Data not found",
            "be": "Дадзеныя не знойдзены"
        },
        {
            "id": "stubs.empty-default_auth",
            "ru": "Данные не найдены",
            "en": "Data not found",
            "be": "Дадзеныя не знойдзены"
        },
        {
            "id": "stubs.empty-clinics.subTitle",
            "ru": "Медцентры не найдены в выбранном регионе.",
            "en": "Medical centers were not found in the selected region.",
            "be": "Медцэнтры не знойдзены ў абраным рэгіёне."
        },
        {
            "id": "stubs.empty-clinics.title"
        },
        {
            "id": "stubs.empty-drugstores",
            "ru": "Аптеки не найдены в выбранном регионе",
            "en": "Pharmacies not found in the selected region",
            "be": "Аптэкі не знойдзены ў абраным рэгіёне"
        },
        {
            "id": "stubs.empty-drugs",
            "ru": "Препарат отсутствует в аптеках выбранного региона",
            "en": "The drug is not available in pharmacies of the selected region",
            "be": "Прэпарат адсутнічае ў аптэках абранага рэгіёну"
        },
        {
            "id": "stubs.empty-drugs-history",
            "ru": "После авторизации здесь будет отображаться ваша история поиска лекарств.",
            "en": "After logging in, your medication search history will be displayed here.",
            "be": "Тут будзе адлюстроўвацца ваша гісторыя пошуку лекаў."
        },
        {
            "id": "stubs.empty-user-drugs-history",
            "ru": "История поиска отсутствует",
            "en": "Search history is empty",
            "be": "Гісторыя пошуку адсутнічае"
        },
        {
            "id": "stubs.empty-drugs-suggestions",
            "ru": "Лекарства для запроса не найдены",
            "en": "Drugs for the request is not found",
            "be": "Лекі для запыту не знойдзены"
        },
        {
            "id": "stubs.empty-feedbacks.subTitle",
            "ru": "Здесь пока нет ни одного отзыва.\nНо скоро они появятся",
            "en": "There are no feedback here yet.\nBut they will appear soon",
            "be": "Тут пакуль няма ніводнага водгуку.\nАле хутка яны з'явяцца"
        },
        {
            "id": "stubs.empty-feedbacks.title",
            "ru": "Собираем первые отзывы",
            "en": "Collecting the first feedback",
            "be": "Збіраны першыя водгукі"
        },
        {
            "id": "stubs.empty-feedbacksTab.title",
            "ru": "Здесь пока нет ни одного отзыва",
            "en": "There are no feedback here yet",
            "be": "Тут пакуль няма ніводнага водгуку"
        },
        {
            "id": "stubs.empty-feedbacksTab.subTitle",
            "ru": "Мы обновляем их постоянно",
            "en": "We update them constantly",
            "be": "Мы абнаўляем іх увесь час"
        },
        {
            "id": "stubs.empty-visit-drugs",
            "ru": "Нет добавленных препаратов",
            "en": "No added drugs",
            "be": "Няма дададзеных прэпаратаў"
        },
        {
            "id": "stubs.empty-visit-drugs.subTitle",
            "ru": "Нет добавленных препаратов",
            "en": "No added drugs",
            "be": "Няма дададзеных прэпаратаў"
        },
        {
            "id": "stubs.not-authorized.subTitle",
            "ru": "Отзывы могут оставлять только авторизированные и совершеннолетние пользователи.",
            "en": "Only authorized and adult users can leave feedback",
            "be": "Водгукі могуць пакідаць толькі аўтарызаваныя і паўналетнія карыстальнікі."
        },
        {
            "id": "titles.notAuthorizedForMyFeedbacks",
            "ru": "Отзывы могут оставлять только авторизованные и совершеннолетние пользователи",
            "en": "Only authorized and adult users can leave feedback",
            "be": "Водгукі могуць пакідаць толькі аўтарызаваныя і паўналетнія карыстальнікі"
        },
        {
            "id": "stubs.not-authorized.title",
            "ru": "Вы не можете оставить отзыв",
            "en": "You can not leave a feedback",
            "be": "Вы не можаце пакінуць водгук"
        },
        {
            "id": "timeSortItems.afternoon",
            "ru": "ДНЕМ",
            "en": "AFTERNOON",
            "be": "ДЗЕНЬ"
        },
        {
            "id": "timeSortItems.evening",
            "ru": "ВЕЧЕРОМ",
            "en": "EVENING",
            "be": "ВЕЧАР"
        },
        {
            "id": "timeSortItems.morning",
            "ru": "УТРОМ",
            "en": "MORNING",
            "be": "РАНIЦА"
        },
        {
            "id": "timeSortItems.all",
            "ru": "ВСЕ",
            "en": "ALL",
            "be": "УСЕ"
        },
        {
            "id": "titles.account_other",
            "ru": "ДРУГОЕ",
            "en": "OTHER",
            "be": "ІНШАЕ"
        },
        {
            "id": "titles.add_child_header",
            "ru": "Добавить ребенка",
            "en": "Add a child",
            "be": "Дадаць дзіцяці"
        },
        {
            "id": "titles.add_child_text",
            "ru": "Добавьте несовершеннолетних членов вашей семьи, чтобы иметь возможность записывать их на визиты к врачу.",
            "en": "Add your family members to be able to schedule their doctor appointments",
            "be": "Дадайце непаўналетніх членаў вашай сям'і, каб мець магчымасць запісваць іх на візіты да лекара."
        },
        {
            "id": "titles.additional_information_about_visit",
            "ru": "Дополнительная информация о посещении врача",
            "en": "For more information about visiting the doctor",
            "be": "Дадатковая інфармацыя пра наведванне лекара"
        },
        {
            "id": "titles.addRelative",
            "ru": "Добавление родственника",
            "en": "Adding a relative",
            "be": "Даданне сваяка"
        },
        {
            "id": "titles.all_services",
            "ru": "ВСЕ УСЛУГИ",
            "en": "ALL SERVICES",
            "be": "УСЕ ПАСЛУГІ"
        },
        {
            "id": "titles.allPrograms",
            "ru": "Все программы",
            "en": "All programs",
            "be": "Усе праграмы"
        },
        {
            "id": "titles.any_filter",
            "ru": "Любое",
            "en": "Any",
            "be": "Любое"
        },
        {
            "id": "titles.any_speciality",
            "ru": "Любая специальность",
            "en": "Any specialty",
            "be": "Любая спецыяльнасць"
        },
        {
            "id": "titles.anyMedcenter",
            "ru": "Любой медцентр",
            "en": "Any medical center",
            "be": "Любы медцэнтар"
        },
        {
            "id": "titles.are_you_sure",
            "ru": "Вы действительно хотите выйти?",
            "en": "Do you really want to log out?",
            "be": "Вы сапраўды хочаце выйсці?"
        },
        {
            "id": "titles.at_registry",
            "ru": "В регистратуре",
            "en": "At the registry",
            "be": "У рэгістратуры"
        },
        {
            "id": "titles.attachments",
            "ru": "ДОКУМЕНТЫ",
            "en": "DOCUMENTS",
            "be": "ДАКУМЕНТЫ"
        },
        {
            "id": "titles.back",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "titles.bind_the_program",
            "ru": "Привязать программу",
            "en": "Link the program",
            "be": "Далучыць праграму"
        },
        {
            "id": "title.visit_own_funds",
            "ru": "За счёт собственных средств",
            "en": "By own funds",
            "be": "За кошт уласных сродкаў"
        },
        {
            "id": "titles.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "titles.bookmarkDoctorsPrompt",
            "ru": "Добавляйте в закладки врачей, которые вам понравились. Так их всегда будет легко найти.",
            "en": "Add doctors you liked to bookmarks. This will make them easy to find.",
            "be": "Дадавайце ў закладкі лекараў, якія вам спадабаліся. Так іх заўсёды будзе лёгка знайсці."
        },
        {
            "id": "titles.cancel",
            "ru": "Отмена",
            "en": "Сancel",
            "be": "Адмена"
        },
        {
            "id": "titles.cancel_visit",
            "ru": "Отмена визита",
            "en": "Cancel visit",
            "be": "Адмена візіту"
        },
        {
            "id": "titles.check_correctness",
            "ru": "Пожалуйста, проверьте корректность введённых данных: они будут использованы при записи к врачам.",
            "en": "Please check the accuracy of the entered data: it will be used for scheduling doctor appointments.",
            "be": "Уведзеныя вамі дадзеныя будуць выкарыстаны для запісу вас да ўрача. Калі ласка, праверце іх карэктнасць"
        },
        {
            "id": "titles.check_services",
            "ru": "Пожалуйста, проверьте правильность \nоказанных вам услуг затем подтвердите или отклоните их.",
            "en": "Please check the correctness of the \nservices rendered to you, confirming or\nrejecting them.",
            "be": "Калі ласка, праверце правільнасць\r\nаказаных вам паслуг, пацвердзіўшы або\r\nадхіліўшы іх."
        },
        {
            "id": "titles.check_your_details",
            "ru": "Проверьте данные",
            "en": "Check entered data",
            "be": "Праверце свае дадзеныя"
        },
        {
            "id": "titles.check_your_internet_connections",
            "ru": "Проверьте ваше интернет-соединение",
            "en": "Check your internet connection",
            "be": "Праверце ваша інтэрнэт-злучэнне"
        },
        {
            "id": "titles.choose_a_medical_center",
            "ru": "Выберите медцентр, в который хотели бы записаться",
            "en": "Select a medical center you would like to register with",
            "be": "Пазначце медцэнтр, у які хацелі б запісацца:"
        },
        {
            "id": "titles.choose_birthday_date",
            "ru": "Введите дату своего рождения",
            "en": "Enter your date of birth",
            "be": "Калі ласка, увядзіце дату свайго нараджэння"
        },
        {
            "id": "titles.choose_date_of_birthday",
            "ru": "Выберите дату рождения",
            "en": "Select your date of birth",
            "be": "Пазначце дату нараджэння"
        },
        {
            "id": "titles.choose_medcenter",
            "ru": "ВЫБЕРИТЕ НУЖНЫЙ МЕДЦЕНТР:",
            "en": "Select the desired medical centers:",
            "be": "Пазначце патрэбны медцэнтр:"
        },
        {
            "id": "titles.choose_program_subtitle",
            "ru": "Если вы видите свою компанию в списке и состоите в её программе здоровья, вы можете привязать её к Aibolit.\nВы сможете привязаться к корпоративной программе в любой момент из своего аккаунта.",
            "en": "If you see your company in the list and are a member of its health program, you can link it to Aibolit.\nYou can link to the corporate program at any time from your account.",
            "be": "Калі вы бачыце сваю кампанію ў спісе і ўваходзіце ў яе праграму здароўя, вы можаце далучыць яе да Aibolit.\nВы зможаце далучыцца да карпаратыўнай праграмы ў любы момант са свайго акаўнта."
        },
        {
            "id": "titles.choose_contract",
            "ru": "Выбрать контракт",
            "en": "Select contract",
            "be": "Абраць кантракт"
        },
        {
            "id": "titles.choose_the_date",
            "ru": "Выбрать дату",
            "en": "Select date",
            "be": "Абраць дату"
        },
        {
            "id": "titles.choose_the_time",
            "ru": "Выбрать время",
            "en": "Select time",
            "be": "Абраць час"
        },
        {
            "id": "titles.clear",
            "ru": "Очистить",
            "en": "Clear",
            "be": "Ачысціць"
        },
        {
            "id": "titles.code_to_relative",
            "ru": "Покажите код родственнику",
            "en": "Show the code to the relative",
            "be": "Пакажыце код сваяку"
        },
        {
            "id": "titles.codeHasBeenSent",
            "ru": "На номер {phone}  отправлено \nSMS-сообщение с кодом активации.\nЕго доставка может занять до минуты.",
            "en": "On the phone number {phone} \nan SMS activation code has been sent.\nDelivery may take up to a minute.",
            "be": "На нумар {phone} адпраўлена\r\nSMS-паведамленне з кодам актывацыі.\r\nЯго дастаўка можа заняць да хвіліны."
        },
        {
            "id": "titles.comment",
            "ru": "КОММЕНТАРИЙ",
            "en": "COMMENT",
            "be": "КАМЕНТАР"
        },
        {
            "id": "titles.comment_has_been_added",
            "ru": "Ваш отзыв добавлен!",
            "en": "Your feedback is added!",
            "be": "Ваш водгук дададзены!"
        },
        {
            "id": "titles.comment_has_been_edited",
            "ru": "Ваш отзыв изменен!",
            "en": "Your feedback is changed!",
            "be": "Ваш водгук зменены!"
        },
        {
            "id": "titles.comment_has_been_deleted",
            "ru": "Ваш отзыв удален!",
            "en": "Your feedback is deleted!",
            "be": "Ваш водгук выдалены!"
        },
        {
            "id": "titles.comment_to_rejected",
            "ru": "Ваш комментарий (к отклоненным):",
            "en": "Your comment (to reject):",
            "be": "Ваш каментар (да адхіленных):"
        },
        {
            "id": "titles.comments",
            "ru": "Отзыв {date}",
            "en": "Feedback {date}",
            "be": "Каментар {date}"
        },
        {
            "id": "titles.confirm_affinity",
            "ru": "Для добавления супруга в семью, он должен перейти в раздел \"Моя семья\", нажать \"+\" и выбрать \"Ввести код своего супруга\".",
            "en": "To add a spouse to the family, he/she needs to go to the \"My Family\" section, click \"+\" and choose \"Enter spouse code\".",
            "be": "Для дадання сваяка ў сям'ю, ён павінен перайсці ў раздзел \"Мая сям'я\", націснуць \"+\" і выбраць \"Увесці код свайго сваяка\"."
        },
        {
            "id": "titles.confirmed",
            "ru": "ПОДТВЕРЖДЕНО!",
            "en": "CONFIRMED!",
            "be": "ПАЦВЕРДЖАНА!"
        },
        {
            "id": "titles.confirmed_partially",
            "ru": "ПОДТВЕРЖДЕНО ЧАСТИЧНО",
            "en": "PARTIALLY CONFIRMED",
            "be": "ПАЦВЕРДЖАНА ЧАСТКОВА"
        },
        {
            "id": "titles.congratulations",
            "ru": "Поздравляем!",
            "en": "Congratulations!",
            "be": "Віншуем!"
        },
        {
            "id": "titles.corporate_programs",
            "ru": "КОРПОРАТИВНЫЕ ПРОГРАММЫ",
            "en": "CORPORATE PROGRAMS",
            "be": "КАРПАРАТЫЎНЫЯ ПРАГРАМЫ"
        },
        {
            "id": "titles.create_relative",
            "ru": "Создать запись",
            "en": "Create a record",
            "be": "Стварыць запіс"
        },
        {
            "id": "titles.data_loading",
            "ru": "Загружаются данные. Пожалуйста, подождите.",
            "en": "Please wait while data is loading",
            "be": "Дадзеныя загружаюцца. Калі ласка, пачакайце"
        },
        {
            "id": "titles.date_in_not_defined",
            "ru": "Дата не указана",
            "en": "Date is not specified",
            "be": "Дата не пазначана"
        },
        {
            "id": "titles.declineReasonCode_1"
        },
        {
            "id": "titles.declineReasonCode_10",
            "ru": "Страна не поддерживается",
            "en": "The country is not supported yet",
            "be": "Краіна не падтрымліваецца дадаткам"
        },
        {
            "id": "titles.declineReasonCode_11",
            "ru": "Город не поддерживается",
            "en": "The city is not supported yet",
            "be": "Горад не падтрымліваецца"
        },
        {
            "id": "titles.declineReasonCode_12"
        },
        {
            "id": "titles.declineReasonCode_13"
        },
        {
            "id": "titles.declineReasonCode_14"
        },
        {
            "id": "titles.declineReasonCode_15"
        },
        {
            "id": "titles.declineReasonCode_16"
        },
        {
            "id": "titles.declineReasonCode_17",
            "ru": "Не сотрудник и неподдерживаемый родственник",
            "en": "Nor an eligible relative, nor an active employee",
            "be": "Не супрацоўнік і ня падтрымліваецца сваяк"
        },
        {
            "id": "titles.declineReasonCode_18"
        },
        {
            "id": "titles.declineReasonCode_19"
        },
        {
            "id": "titles.declineReasonCode_2",
            "ru": "Отсутствует дата рождения",
            "en": "Date of birth is missing",
            "be": "Адсутнічае дата нараджэння"
        },
        {
            "id": "titles.declineReasonCode_20"
        },
        {
            "id": "titles.declineReasonCode_21"
        },
        {
            "id": "titles.declineReasonCode_22",
            "ru": "Не обслуживается. Ребенок старше 18 лет",
            "en": "Is not served. Child is older than 18",
            "be": "Дзіця старэйшыя за 18 гадоў"
        },
        {
            "id": "titles.declineReasonCode_23",
            "ru": "Не обслуживается",
            "en": "Is not served",
            "be": "Ня абслугоўваецца"
        },
        {
            "id": "titles.declineReasonCode_24"
        },
        {
            "id": "titles.declineReasonCode_25",
            "ru": "Поддержка региона в разработке"
        },
        {
            "id": "titles.declineReasonCode_26",
            "ru": "Программа еще не активна",
            "en": "The program is not active yet",
            "be": "Праграма яшчэ не актыўна"
        },
        {
            "id": "titles.declineReasonCode_3"
        },
        {
            "id": "titles.declineReasonCode_4"
        },
        {
            "id": "titles.declineReasonCode_5"
        },
        {
            "id": "titles.declineReasonCode_6"
        },
        {
            "id": "titles.declineReasonCode_7",
            "ru": "Только совершеннолетние пользователи могуть делать онлайн-запись. Записать ребёнка можно после добавления в семью",
            "en": "Only adult users can make online appointments. To schedule appointments for children, they must first be added to the family",
            "be": "Толькі паўналетнія карыстальнікі могуть рабіць анлайн-запіс. Запісаць дзіця можна пасля дадання ў сям'ю"
        },
        {
            "id": "titles.declineReasonCode_8",
            "ru": "Поддерживается только для сотрудников",
            "en": "Supported only for employees",
            "be": "Падтрымліваецца толькі для супрацоўнікаў"
        },
        {
            "id": "titles.declineReasonCode_9"
        },
        {
            "id": "titles.delete_review",
            "ru": "Удалить отзыв?",
            "en": "Delete the feedback?",
            "be": "Выдаліць водгук?"
        },
        {
            "id": "titles.delete_visit",
            "ru": "Удаление визита",
            "en": "Deleting a visit",
            "be": "Выдаленне візіту"
        },
        {
            "id": "titles.details_of_visit_header",
            "ru": "ПОДРОБНОСТИ ВИЗИТА",
            "en": "VISIT DETAILS",
            "be": "ПАДРАБЯЗНАСЦІ ВІЗІТУ"
        },
        {
            "id": "titles.displayProgram",
            "ru": "Программа для отображения",
            "en": "The program for displaying",
            "be": "Праграма для адлюстравання"
        },
        {
            "id": "titles.doctor_speciality",
            "ru": "СПЕЦИАЛЬНОСТЬ ВРАЧА",
            "en": "DOCTOR SPECIALTY",
            "be": "СПЕЦЫЯЛЬНАСЦЬ ЛЕКАРА"
        },
        {
            "id": "titles.drug_stores",
            "ru": "СПИСОК АПТЕК",
            "en": "LIST OF PHARMACIES",
            "be": "СПІС АПТЭК"
        },
        {
            "id": "titles.drugs_list",
            "ru": "ДОБАВИТЬ ПРЕПАРАТЫ ДЛЯ ПОИСКА",
            "en": "ADD DRUGS TO SEARCH",
            "be": "ДАДАЦЬ ПРЕПАРАТЫ ДЛЯ ПОШУКУ"
        },
        {
            "id": "titles.edit",
            "ru": "Редактировать",
            "en": "Edit",
            "be": "Рэдагаваць"
        },
        {
            "id": "titles.email",
            "ru": "ВАШ E-MAIL",
            "en": "YOUR E-MAIL",
            "be": "ВАШ E-MAIL"
        },
        {
            "id": "titles.email_placeholder",
            "ru": "example@mail.com",
            "en": "example@mail.com",
            "be": "example@mail.com"
        },
        {
            "id": "titles.enter",
            "ru": "ВОЙТИ",
            "en": "SIGN IN",
            "be": "Увайсцi"
        },
        {
            "id": "titles.enter_code",
            "ru": "Введите код из SMS",
            "en": "Enter the code from the SMS",
            "be": "Калі ласка, увядзіце код з SMS"
        },
        {
            "id": "titles.enter_code_relative",
            "ru": "Введите код родственника",
            "en": "Enter the relative's code",
            "be": "Калі ласка, увядзіце код сваяка"
        },
        {
            "id": "titles.enter_info",
            "ru": "Заполните информацию о себе",
            "en": "Fill in the information about yourself",
            "be": "Запоўніце інфармацыю аб сабе"
        },
        {
            "id": "titles.enter_price_of_visit",
            "ru": "Введите стоимость визита",
            "en": "Please submit visit costs",
            "be": "Увядзіце кошт візіту"
        },
        {
            "id": "titles.enter_your_phone_number",
            "ru": "Введите свой номер телефона",
            "en": "Enter your phone number",
            "be": "Увядзіце свой нумар тэлефона"
        },
        {
            "id": "titles.enter_captcha_code",
            "ru": "Введите код с картинки",
            "en": "Enter the code from the image",
            "be": "Калі ласка, увядзіце код з малюнка"
        },
        {
            "id": "titles.error",
            "ru": "Ошибка!",
            "en": "Error!",
            "be": "Памылка!"
        },
        {
            "id": "titles.errorSearchDrugs",
            "ru": "Возможно у вас отсутствует соединение с интернетом или сервис поиска лекарств временно недоступен. Проверьте подключение к сети или обратитесь в поддержку.",
            "en": "Perhaps you do not have an Internet connection or the drug search service is temporarily unavailable. Check your network connection or contact support.",
            "be": "Магчыма, ў вас адсутнічае злучэнне з інтэрнэтам або сэрвіс пошуку лекаў часова недаступны. Праверце падлучэнне або звярніцеся ў падтрымку."
        },
        {
            "id": "titles.exit",
            "ru": "Выйти",
            "en": "Log out",
            "be": "Выйсці"
        },
        {
            "id": "titles.expecting_confirmations",
            "ru": "ОЖИДАЮЩИЕ ПОДТВЕРЖДЕНИЯ",
            "en": "PENDING CONFIRMATION",
            "be": "ЧАКАЕ ПАЦВЯРДЖЭННЯ"
        },
        {
            "id": "titles.allMedcentersFromFavorites",
            "ru": "Все медцентры из закладок",
            "en": "All medical centers from bookmarks",
            "be": "Усе медцэнтры з закладак"
        },
        {
            "id": "titles.feature_visit",
            "ru": "Будущий визит",
            "en": "Future visit",
            "be": "Будучы візіт"
        },
        {
            "id": "titles.feedbacks",
            "ru": "ОТЗЫВЫ",
            "en": "FEEDBACK",
            "be": "ВОДГУКІ"
        },
        {
            "id": "titles.fio_placeholder",
            "ru": "Иван Иванович Иванов",
            "en": "Ivan Ivanovich Ivanov",
            "be": "Іван Іванавіч Іваноў"
        },
        {
            "id": "titles.first-aid-kit",
            "ru": "Аптечка",
            "en": "First aid kit",
            "be": "Аптэчка"
        },
        {
            "id": "titles.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "titles.for_example_consultation",
            "ru": "Например, консультация",
            "en": "For example, consultation",
            "be": "Напрыклад, кансультацыя"
        },
        {
            "id": "titles.for_me",
            "ru": "Для меня",
            "en": "For me",
            "be": "Для мяне"
        },
        {
            "id": "titles.future_visit_to",
            "ru": "Будущий визит",
            "en": "Future visit",
            "be": "Будучы візіт"
        },
        {
            "id": "titles.general_info",
            "ru": "ОСНОВНАЯ ИНФОРМАЦИЯ",
            "en": "BASIC INFORMATION",
            "be": "АСНОЎНАЯ ІНФАРМАЦЫЯ"
        },
        {
            "id": "titles.history_search",
            "ru": "ИСТОРИЯ ПОИСКА",
            "en": "SEARCH HISTORY",
            "be": "ГІСТОРЫЯ ПОШУКУ "
        },
        {
            "id": "titles.history_visits",
            "ru": "ИСТОРИЯ ПОСЕЩЕНИЙ",
            "en": "VISITS HISTORY",
            "be": "ГІСТОРЫЯ НАВЕДВАННЯЎ"
        },
        {
            "id": "titles.if_you_logout",
            "ru": "Если вы выйдете из учетной записи, вы не сможете записываться к врачам онлайн.",
            "en": "If you log out of your account, you won't be able to schedule doctor appointments online.",
            "be": "Калі вы выйдзеце з уліковага запісу, вы не зможаце запісацца да лекара анлайн."
        },
        {
            "id": "titles.invite_relative_header",
            "ru": "Пригласить в семью",
            "en": "Invite to the family",
            "be": "Запрасіць у сям'ю"
        },
        {
            "id": "titles.invite_relative_text",
            "ru": "Вы можете поделиться приложением Aibolit со своим родственником и дать ему код для присоединения",
            "en": "You can share the Aibolit app with your relative and give them a code to join",
            "be": "Вы можаце падзяліцца дадаткам Aibolit са сваім сваяком і даць яму код для далучэння"
        },
        {
            "id": "titles.join_relative",
            "ru": "Для добавления вас к своей семье, ваш супруг (а) должен (а) перейти в раздел “Моя семья” в своём аккаунте, нажать кнопку \"+\" и выбрать “Мой код для присоединения к семье”. После этого на его экране появится код, который вы должны ввести сюда:",
            "en": "To add you to their family, your spouse should go to the \"My Family\" section in their account, click the \"+\" button and select \"My code to join the family\". After that, a code will appear on their screen that you should enter here:",
            "be": "Для дадання вас да сваёй сям'і, ваш сваяк павінен перайсці ў раздзел \"Мая сям'я\" ў сваім акаўнце, націснуць кнопку \"+\" і выбраць \"Мой код для далучэння да сям'і\". Пасля гэтага на яго экране з'явіцца код, які вы павінны ўвесці сюды:"
        },
        {
            "id": "titles.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "titles.edit_feedback",
            "ru": "ИЗМЕНИТЬ ОТЗЫВ",
            "en": "EDIT FEEDBACK",
            "be": "ЗМЯНІЦЬ ВОДГУК"
        },
        {
            "id": "titles.leave_feedback",
            "ru": "ОСТАВИТЬ ОТЗЫВ",
            "en": "GIVE FEEDBACK",
            "be": "ПАКІЦЬ ВОДГУК"
        },
        {
            "id": "titles.leave_DoctorFeedback",
            "ru": "ОСТАВИТЬ ОТЗЫВ",
            "en": "GIVE FEEDBACK",
            "be": "ПАКІЦЬ ВОДГУК"
        },
        {
            "id": "titles.linkToFamily",
            "ru": "Присоединиться к семье",
            "en": "Join the family",
            "be": "Далучыцца да сям'і"
        },
        {
            "id": "titles.make_a_call",
            "ru": "Позвонить",
            "en": "Call",
            "be": "Патэлефанаваць"
        },
        {
            "id": "titles.medcenter_type",
            "ru": "Тип медцентра",
            "en": "Type of medical center",
            "be": "Тып медцэнтра"
        },
        {
            "id": "titles.medcenters*.few",
            "ru": "{{count}} МЕДЦЕНТРА",
            "en": "{{count}} Medical centers",
            "be": "{{count}} медцэнтраў"
        },
        {
            "id": "titles.medcenters*.many",
            "ru": "{{count}} МЕДЦЕНТРОВ",
            "en": "{{count}} Medical centers",
            "be": "{{count}} медцэнтраў"
        },
        {
            "id": "titles.medcenters*.one",
            "ru": "{{count}} МЕДЦЕНТР",
            "en": "{{count}} Medical center",
            "be": "{{count}} медцэнтраў"
        },
        {
            "id": "titles.medcenters*.zero",
            "ru": "НЕТ МЕДЦЕНТРОВ",
            "en": "No medical centers",
            "be": "НЯМА МЕДЦЭНТРАЎ"
        },
        {
            "id": "titles.medical_center",
            "ru": "Медцентр:",
            "en": "Medical center:",
            "be": "Медцэнтр:"
        },
        {
            "id": "titles.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ПА БАЦЬКУ"
        },
        {
            "id": "titles.more",
            "ru": "Ещё",
            "en": "More",
            "be": "Яшчэ"
        },
        {
            "id": "titles.my",
            "ru": "Мой",
            "en": "My",
            "be": "Mой"
        },
        {
            "id": "titles.my_account",
            "ru": "МОЙ АККАУНТ",
            "en": "MY ACCOUNT",
            "be": "МОЙ АКАЎНТ"
        },
        {
            "id": "titles.my_family",
            "ru": "Моя семья",
            "en": "My family",
            "be": "Мая сям'я"
        },
        {
            "id": "titles.my_visit",
            "ru": "Мой визит",
            "en": "My visit",
            "be": "Мой візіт"
        },
        {
            "id": "titles.my_visits",
            "ru": "МОИ ВИЗИТЫ",
            "en": "MY VISITS",
            "be": "МАЕ ВІЗІТЫ"
        },
        {
            "id": "titles.myFamily",
            "ru": "МОЯ СЕМЬЯ",
            "en": "MY FAMILY",
            "be": "МАЯ СЯМ'Я"
        },
        {
            "id": "titles.nearest_date",
            "ru": "БЛИЖАЙШАЯ ДАТА",
            "en": "THE NEAREST DATE",
            "be": "Бліжэйшая ДАТА"
        },
        {
            "id": "titles.nearest_visits",
            "ru": "БЛИЖАЙШИЕ ВИЗИТЫ",
            "en": "UPCOMING VISITS",
            "be": "Бліжэйшыя візіты"
        },
        {
            "id": "titles.no_schedule",
            "ru": "Нет расписания",
            "en": "No schedule ",
            "be": "Няма раскладу"
        },
        {
            "id": "titles.noFamily",
            "ru": "У вас в семье пока никого нет.",
            "en": "You don't have any family member so far",
            "be": "У вас у сям'і пакуль нікога няма"
        },
        {
            "id": "titles.noFavoriteDoctors",
            "ru": "У вас в закладках пока нет врачей",
            "en": "You have no doctors in your bookmarks yet",
            "be": "У вас у закладках пакуль няма лекараў"
        },
        {
            "id": "titles.not_confirmed_services",
            "ru": "НЕПОДТВЕРЖДЕННЫЕ УСЛУГИ",
            "en": "UNCONFIRMED SERVICES",
            "be": "НЕПАЦВЕРДЖАНЫЯ ПАСЛУГІ"
        },
        {
            "id": "titles.not_mandatory",
            "ru": "(НЕОБЯЗАТЕЛЬНО)",
            "en": "(NOT NECESSARY)",
            "be": "(НЕ АБАВЯЗКОВА)"
        },
        {
            "id": "titles.notAdultCanNotEditProfile",
            "ru": "Вы не можете редактировать профиль.\nЕсли дата рождения была указана ошибочно, обратитесь в поддержку.",
            "en": "You cannot edit your profile.\nIf the date of birth was enteres incorrectly, please contact support.",
            "be": "Вы не можаце рэдагаваць профіль.\nКалі дата нараджэння была пазначана памылкова, звярніцеся ў тэхпадтрымку."
        },
        {
            "id": "titles.notAdultCantHaveFamily",
            "ru": "Раздел моя семья доступен только совершеннолетним пользователям. Если дата рождения была указана ошибочно, вы можете отредактировать данные в своей учетной записи.",
            "en": "The \"My Family\" section is only available to adult users. If the date of birth was specified incorrectly, you can edit the information in your account.",
            "be": "Раздзел мая сям'я даступны толькі паўналетнім карыстальнікам. Калі дата нараджэння была пазначана памылкова, вы можаце адрэдагаваць дадзеныя ў сваім уліковым запісу."
        },
        {
            "id": "titles.notAllowedAnotherFamily",
            "ru": "Вы не можете добавить еще одного супруга.\nЕсли вы хотите поменять состав вашей семьи, обратитесь в поддержку.",
            "en": "You cannot add another spouse. If you want to change your family composition, please contact support.",
            "be": "Вы не можаце дадаць яшчэ аднаго сваяка.\nКалі вы хочаце змяніць склад вашай сям'і, звярніцеся ў падтрымку."
        },
        {
            "id": "titles.notAllowedAnotherChild",
            "ru": "Для того, чтобы добавить еще одного ребенка, обратитесь в поддержку.",
            "en": "To add another child, please contact support.",
            "be": "Для таго, каб дадаць яшчэ адно дзіця, звярніцеся ў падтрымку."
        },
        {
            "id": "titles.nothing_about_you",
            "ru": "Пока Aibolit ничего о вас не знает и не может записать вас к врачу или добавить родственников. Пожалуйста, заполните данные о себе. Вы можете заполнить данные позже в настройках своего аккаунта.",
            "en": "Aibolit doesn't have any information about you and cannot schedule doctor appointments or add relatives for you. Please fill out your information. If you skip this step, you can always do this later in your account settings.",
            "be": "Пакуль Aibolit нічога пра вас не ведае і не зможа запісаць вас да лекара цi дадаць сваяка. Калі ласка, запоўніце дадзеныя аб сабе. Прапусціўшы гэты крок, вы зможаце ў любы момант запоўніць дадзеныя аб сабе ў сваім акаунце."
        },
        {
            "id": "titles.notServiced",
            "ru": "Не обслуживается по программе",
            "en": "Not served by the program",
            "be": "Ня абслугоўваецца па праграме"
        },
        {
            "id": "titles.notSupported",
            "ru": "Не поддерживается: {message}",
            "en": "Not supported: {message}",
            "be": "Не падтрымліваецца: {message}"
        },
        {
            "id": "titles.options",
            "ru": "Опции",
            "en": "Options",
            "be": "Опцыі"
        },
        {
            "id": "titles.optionsNotification",
            "ru": "У данной услуги есть опции, которые могут повлиять на стоимость и медцентр, в котором она предоставляется.",
            "en": "This service has options that may affect the cost and the medical center where it is provided.",
            "be": "У дадзенай паслугі ёсць опцыі, якія могуць паўплываць на кошт і медцэнтр, у якім яна прадастаўляецца"
        },
        {
            "id": "titles.optionsWarningMessage",
            "ru": "Выбранное сочетание опций не поддерживается. Пожалуйста, выберите другие опции.",
            "en": "Selected combination of options is not supported. Please select other options.",
            "be": "Абранае спалучэнне опцый не падтрымліваецца. Калі ласка, абярыце іншыя опцыі."
        },
        {
            "id": "titles.allMedcentersFromPartner",
            "ru": "Все медцентры \"{programName}\"",
            "en": "All medical centers of \"{programName}\"",
            "be": "Усе медцэнтры \"{programName}\""
        },
        {
            "id": "titles.pay_attention",
            "ru": "Обратите внимание",
            "en": "Please note",
            "be": "Звярніце ўвагу"
        },
        {
            "id": "titles.payment_details",
            "ru": "ПОДРОБНОСТИ СЧЕТА",
            "en": "INVOICE DETAILS",
            "be": "ПАДРАБЯЗНЫ КОШТ"
        },
        {
            "id": "titles.permanentCode",
            "ru": "Это ваш код",
            "en": "Your code",
            "be": "Гэта ваш код"
        },
        {
            "id": "titles.permission_to_relatives",
            "ru": "После добавления ваш родственник сможет записывать ваших детей к врачам онлайн.\n\nВы согласны с этим?",
            "en": "Your relative will be able to schedule doctor appointments for your children, after adding.\nDo you agree with that?",
            "be": "Пасля дадання ваш сваяк зможа запісваць вашых дзяцей да лекараў анлайн.\n\nВы згодныя з гэтым?"
        },
        {
            "id": "titles.phone_numbers",
            "ru": "Номера телефонов",
            "en": "Phone numbers",
            "be": "Нумары тэлефонаў"
        },
        {
            "id": "titles.pick_visit_date",
            "ru": "ВЫБЕРИТЕ ДАТУ ВИЗИТА",
            "en": "SELECT A VISIT DATE",
            "be": "ПАЗНАЧЦЕ ДАТУ ВІЗІТУ"
        },
        {
            "id": "titles.pick_visit_time",
            "ru": "ВЫБЕРИТЕ ВРЕМЯ",
            "en": "SELECT TIME",
            "be": "ПАЗНАЧЦЕ ЧАС"
        },
        {
            "id": "titles.popularQueries",
            "ru": "ПОПУЛЯРНЫЕ ЗАПРОСЫ",
            "en": "POPULAR REQUESTS",
            "be": "ПАПУЛЯРНЫЯ ЗАПЫТЫ"
        },
        {
            "id": "titles.preferable_visit_date",
            "ru": "КОГДА НУЖНО НА ПРИЕМ",
            "en": "WHEN AN APPOINTMENT IS NEEDED",
            "be": "КАЛІ ТРЭБА НА ПРЫЁМ"
        },
        {
            "id": "titles.price",
            "ru": "Цена:",
            "en": "Price:",
            "be": "кошт:"
        },
        {
            "id": "titles.price_of_visit",
            "ru": "СТОИМОСТЬ ВИЗИТА, РУБ",
            "en": "COST OF THE VISIT, rub",
            "be": "КОШТ ВІЗІТУ, РУБ"
        },
        {
            "id": "titles.price_of_visit_hint",
            "ru": "Стоимость визита появится автоматически",
            "en": "The cost of the visit will appear automatically",
            "be": "Кошт візіту падцягнецца аўтаматычна"
        },
        {
            "id": "titles.program_selection",
            "ru": "Желаете привязать корпоративную программу?",
            "en": "Would you like to link a Health Care program?",
            "be": "Выбар карпаратыўнай праграмы"
        },
        {
            "id": "titles.programNotActiveYet",
            "ru": "Программа еще не активна {activated}",
            "en": "The program is not active yet {activated}",
            "be": "Праграма яшчэ не актыўна {activated}"
        },
        {
            "id": "titles.quantity",
            "ru": "Кол-во:",
            "en": "Quantity:",
            "be": "Колькасць:"
        },
        {
            "id": "titles.registry",
            "ru": "РЕГИСТРАТУРА {name}",
            "en": "REGISTRY {name}",
            "be": "Рэгістратура {name}"
        },
        {
            "id": "titles.rejected",
            "ru": "ОТКЛОНЕНО",
            "en": "REJECTED",
            "be": "АДХІЛЕНА"
        },
        {
            "id": "titles.request_correction",
            "ru": "Сообщить об изменениях",
            "en": "Report changes",
            "be": "Паведаміць пра змены"
        },
        {
            "id": "titles.requirePrescript",
            "ru": "По рецепту",
            "en": "On prescription",
            "be": "Па рэцэпце"
        },
        {
            "id": "titles.results_on_request",
            "ru": "РЕЗУЛЬТАТЫ ПО ЗАПРОСУ",
            "en": "SEARCH RESULTS",
            "be": "ВЫНІКІ ПА ЗАПЫЦЕ"
        },
        {
            "id": "titles.search_services",
            "ru": "Поиск услуги...",
            "en": "Search for a service...",
            "be": "Пошук паслуг ..."
        },
        {
            "id": "titles.select_language",
            "ru": "Выберите язык",
            "en": "Select language",
            "be": "Пазначце мову"
        },
        {
            "id": "titles.select_program",
            "ru": "По какой программе",
            "en": "What program to be used",
            "be": "Па якой праграме"
        },
        {
            "id": "titles.select_visitor",
            "ru": "Для кого этот визит",
            "en": "Visit for",
            "be": "Для каго гэты візіт"
        },
        {
            "id": "titles.selection.sex",
            "ru": "Укажите пол",
            "en": "Specify gender",
            "be": "Пазначце пол"
        },
        {
            "id": "titles.selection.relKind",
            "ru": "Кем приходится",
            "en": "Relationship",
            "be": "Кім прыходзіцца"
        },
        {
            "id": "titles.selection.relKindWithOther",
            "ru": "Кем приходится",
            "en": "Relationship",
            "be": "Кім прыходзіцца"
        },
        {
            "id": "titles.selectYourCity",
            "ru": "Выберите ваш город",
            "en": "Select your city",
            "be": "Пазначце ваш горад"
        },
        {
            "id": "titles.send_email",
            "ru": "*Мы вышлем письмо с подтверждением на ваш e-mail",
            "en": "* We will send a confirmation email to your e-mail",
            "be": "* Мы вышлем ліст з пацвярджэннем на ваш e-mail"
        },
        {
            "id": "titles.send_other_data",
            "ru": "ОТПРАВИТЬ ДРУГИЕ ДАННЫЕ",
            "en": "SEND OTHER DATA",
            "be": "АДПРАВІЦЬ ІНШЫЯ ДАДЗЕНЫЯ"
        },
        {
            "id": "titles.sendAgain",
            "ru": "Отправить SMS-сообщение ещё раз",
            "en": "Send an SMS-message again",
            "be": "Адправіць SMS-паведамленне яшчэ раз"
        },
        {
            "id": "titles.service_unavailable",
            "ru": "Сервис временно недоступен, попробуйте позже",
            "en": "The service is temporarily unavailable, please try again later",
            "be": "Сэрвіс часова недаступны, паспрабуйце пазней."
        },
        {
            "id": "titles.services",
            "ru": "УСЛУГИ",
            "en": "SERVICES",
            "be": "ПАСЛУГІ"
        },
        {
            "id": "titles.several_medical_centers",
            "ru": "Этот врач работает в нескольких медцентрах",
            "en": "This doctor works in several medical centers",
            "be": "Гэты лекар працуе ў некалькіх медыцынскіх цэнтрах"
        },
        {
            "id": "titles.sex",
            "ru": "Пол",
            "en": "Gender",
            "be": "Пол"
        },
        {
            "id": "titles.shareAppText",
            "ru": "Поделиться через приложение",
            "en": "Share via app",
            "be": "Падзяліцца праз дадатак"
        },
        {
            "id": "titles.showAnalogues",
            "ru": "ПОКАЗЫВАТЬ АНАЛОГИ?",
            "en": "SHOW ANALOGS?",
            "be": "Паказваць аналагі?"
        },
        {
            "id": "titles.sms_activation_message",
            "ru": "Активация производится с помощью SMS-сообщения, которое будет выслано на ваш номер. Убедитесь, что ваше устройство сможет его принять.",
            "en": "Activation is done via an SMS message that will be sent to your number. Make sure your device can receive it.",
            "be": "Актывацыя вырабляецца з дапамогай SMS-паведамленні, якое будзе выслана на ваш нумар. Пераканайцеся, што ваша прылада зможа яго прыняць."
        },
        {
            "id": "titles.someOptionsAreIncompatible",
            "ru": "Некоторые опции могут не сочетаться с уже выбранными. В этом случае они обозначены звёздочками.",
            "en": "Some options can not be combined with the already selected. In this case, they are indicated by asterisks.",
            "be": "Некаторыя опцыі могуць не спалучацца з ужо абранымі. У гэтым выпадку яны пазначаныя зорачкамі."
        },
        {
            "id": "titles.something_went_wrong",
            "ru": "Что-то пошло не так :(",
            "en": "Something went wrong :(",
            "be": "Нешта пайшло не так :("
        },
        {
            "id": "titles.somethingWentWrong",
            "ru": "Вероятно, пропало интернет-соединение или сервис недоступен. Попробуйте еще раз или повторите попытку позже.",
            "en": "Probably Internet connection has been lost or service is unavailable. Please try again or retry later.",
            "be": "Верагодна, знiк Iнтэрнэт або сэрвіс недаступны. Паспрабуйце яшчэ раз цi паспрабуйце пазней"
        },
        {
            "id": "titles.sort_list_of_doctors",
            "ru": "Сортировать список врачей",
            "en": "Sort the list of doctors",
            "be": "Сартаваць спіс лекараў"
        },
        {
            "id": "titles.sort_list_of_medcenters",
            "ru": "Сортировать список медцентров",
            "en": "Sort the list of medical centers",
            "be": "Сартаваць спіс медцэнтраў"
        },
        {
            "id": "titles.submit",
            "ru": "ДА",
            "en": "YES",
            "be": "ДА"
        },
        {
            "id": "titles.support",
            "ru": "Поддержка",
            "en": "Support",
            "be": "Падтрымка"
        },
        {
            "id": "titles.textNoFamily",
            "ru": "Вы можете добавить детей/супруга(у)/родителей, чтобы записывать их на прием к врачу. Также, можете присоединить к семье супруга(у), чтобы вы оба могли следить за визитами ваших детей, редактировать или переносить их.",
            "en": "You can add children/spouse/parents to schedule appointments with their doctors. You can also join your spouse to the family so both of you can track, edit, or reschedule your children's visits.",
            "be": "Вы можаце дадаць дзяцей / жонка або жонку / бацькоў, каб запісваць іх на прыём да доктара. Таксама, можаце далучыць да сям'і мужа (у), каб вы абодва маглі сачыць за візітамі вашых дзяцей, рэдагаваць або пераносіць іх."
        },
        {
            "id": "titles.to_enter",
            "ru": "Ввести",
            "en": "Enter",
            "be": "Увесці"
        },
        {
            "id": "titles.tryAgain",
            "ru": "Попробовать еще",
            "en": "Try again",
            "be": "Паспрабаваць ящчэ"
        },
        {
            "id": "titles.umsListsHeader",
            "ru": "Каталог услуг",
            "en": "Service catalog",
            "be": "Каталог паслуг"
        },
        {
            "id": "titles.unconfirmed_services",
            "ru": "У вас есть неподтверждённые услуги",
            "en": "You have unconfirmed services.",
            "be": "У вас ёсць непацверджаных паслугі"
        },
        {
            "id": "titles.user",
            "ru": "Пользователь",
            "en": "User",
            "be": "Карыстальнік"
        },
        {
            "id": "titles.userAgreement",
            "ru": "Условия пользовательского соглашения",
            "en": "Terms of use",
            "be": "Ўмовы карыстацкага пагаднення"
        },
        {
            "id": "titles.visit_date",
            "ru": "ДАТА ВИЗИТА",
            "en": "VISIT DATE",
            "be": "ДАТА ВІЗІТУ"
        },
        {
            "id": "titles.visit_name",
            "ru": "НАЗВАНИЕ ВИЗИТА",
            "en": "VISIT NAME",
            "be": "НАЗВА ВІЗІТУ (*)"
        },
        {
            "id": "titles.visit_to",
            "ru": "Визит:",
            "en": "Visit:",
            "be": "Візіт:"
        },
        {
            "id": "titles.visit_to_doctor",
            "ru": "Визит к врачу",
            "en": "Visit to the doctor",
            "be": "Візіт да ўрача"
        },
        {
            "id": "titles.visitCancelError",
            "ru": "Ошибка отмены визита:",
            "en": "Appointment cancellation error:",
            "be": "Памылка адмены візіту:"
        },
        {
            "id": "titles.visitDeleteError",
            "ru": "Ошибка удаления визита:",
            "en": "Appointment deletion error:",
            "be": "Памылка выдалення візіту:"
        },
        {
            "id": "titles.visitWasCancelled",
            "ru": "Визит на {visitDate} отменён",
            "en": "The appointment on {visitDate} is canceled",
            "be": "Візіт на {visitDate} адменены"
        },
        {
            "id": "titles.visitWasDeleted",
            "ru": "Визит на {visitDate} удалён",
            "en": "The appointment on {visitDate} is deleted",
            "be": "Візіт на {visitDate} выдалены"
        },
        {
            "id": "titles.what_visit_program",
            "ru": "ПО КАКОЙ ПРОГРАММЕ",
            "en": "WHAT PROGRAM TO BE USED",
            "be": "ПА ЯКОЙ ПРАГРАМЕ"
        },
        {
            "id": "titles.whereToGo",
            "ru": "Куда обратиться? ({currentCity})",
            "en": "Where to go? ({currentCity})",
            "be": "Куды звярнуцца? ({currentCity})"
        },
        {
            "id": "titles.whose_visit",
            "ru": "ДЛЯ КОГО ЭТОТ ВИЗИТ",
            "en": "WHO IS THIS VISIT FOR",
            "be": "ДЛЯ КАГО ГЭТЫ ВІЗІТ"
        },
        {
            "id": "titles.without_permission",
            "ru": "Без вашего разрешения мы не можем добавить родственника.",
            "en": "We cannot add a family member without your permission ",
            "be": "Без вашага дазволу мы не можам дадаць сваяка"
        },
        {
            "id": "titles.without_program",
            "ru": "Продолжить без программы",
            "en": "Continue without program",
            "be": "Працягнуць без праграмы"
        },
        {
            "id": "titles.withoutPrescript",
            "ru": "Без рецепта",
            "en": "Without a prescription",
            "be": "Без рэцэпту"
        },
        {
            "id": "titles.withoutProgrammMessage",
            "ru": "У данной услуги есть опции, которые могут повлиять на стоимость и медцентр, в котором она предоставляется.",
            "en": "This service has options that may affect the cost and the medical center where it is provided.",
            "be": "У некаторых выпадках гэта паслуга можа не аплачвацца. Падрабязнасці удакладняйце ў рэгістратуры медыцынскага цэнтра."
        },
        {
            "id": "titles.withProgrammMessage",
            "ru": "У данной услуги есть опции, которые могут повлиять на покрытие программой и медцентр, в котором она предоставляется.",
            "en": "This service has options that may affect coverage and the medical center where it is provided.",
            "be": "У дадзенай паслугі ёсць опцыі, якія могуць паўплываць на пакрыццё праграмай і медцэнтр, у якім яна прадастаўляецца."
        },
        {
            "id": "titles.work_place",
            "ru": "МЕСТО РАБОТЫ",
            "en": "PLACE OF WORK",
            "be": "МЕСЦА ПРАЦЫ"
        },
        {
            "id": "titles.working_time",
            "ru": "ВРЕМЯ РАБОТЫ",
            "en": "WORKING HOURS",
            "be": "ЧАС ПРАЦЫ"
        },
        {
            "id": "titles.writeToSupport",
            "ru": "Обратиться в поддержку",
            "en": "Write to support",
            "be": "Напісаць у падтрымку"
        },
        {
            "id": "titles.you_are_linked_to_family",
            "ru": "Теперь “{owner}” в вашей семье. Вы оба можете:\n- записывать несовершеннолетних детей к врачам, просматривать их медицинскую информацию, редактировать и переносить визиты;\n- разрешить супругу (е) записывать вас к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Now \"{owner}\" is in your family. Both of you can:\n- schedule appointments for minor children, view their medical information, edit and reschedule visits;\n- allow your spouse to schedule appointments for you, view medical information, edit and rechedule visits.",
            "be": "Зараз \"{owner}\" у вашай сям'і. Вы абодва можаце:\n- запісваць непаўналетніх дзяцей да лекараў, праглядаць іх медыцынскую інфармацыю, рэдагаваць і пераносіць візіты;\n- дазволіць жонке або мужу запісваць вас да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.you_are_record_to",
            "ru": "Вы записаны к",
            "en": "You have an appointment with",
            "be": "Вы запісаныя да"
        },
        {
            "id": "titles.youCanLinkToFamily",
            "ru": "Если ваш родственник уже есть в системе Aibolit, вы можете присоединиться к его семье.",
            "en": "If your relative is already in the Aibolit system, you can join his family.",
            "be": "Калі ваш сваяк ўжо ёсць у сістэме Aibolit, вы можаце далучыцца да яго сям'і."
        },
        {
            "id": "titles.your_comment_required",
            "ru": "Ваш комментарий (обязательно):",
            "en": "Your comment (required):",
            "be": "Ваш каментар (абавязкова):"
        },
        {
            "id": "titles.your_sex",
            "ru": "ВАШ ПОЛ",
            "en": "YOUR GENDER",
            "be": "ВАШ ПОЛ"
        },
        {
            "id": "titles.yourCity",
            "ru": "ВАШ ГОРОД",
            "en": "YOUR CITY",
            "be": "ВАШ ГОРАД"
        },
        {
            "id": "userFields.birthday",
            "ru": "Дата рождения",
            "en": "Date of Birth",
            "be": "Дата нараджэння"
        },
        {
            "id": "userFields.email",
            "ru": "E-mail",
            "en": "E-mail",
            "be": "E-mail"
        },
        {
            "id": "userFields.firstName",
            "ru": "Имя",
            "en": "First Name",
            "be": "Імя"
        },
        {
            "id": "userFields.lastName",
            "ru": "Фамилия",
            "en": "Last Name",
            "be": "Прозвішча"
        },
        {
            "id": "userFields.middleName",
            "ru": "Отчество",
            "en": "Middle Name",
            "be": "Імя па бацьку"
        },
        {
            "id": "userFields.phone",
            "ru": "Телефон",
            "en": "Phone number ",
            "be": "Тэлефон"
        },
        {
            "id": "userFields.phones",
            "ru": "Телефон",
            "en": "Phone number",
            "be": "Тэлефон"
        },
        {
            "id": "userFields.sex",
            "ru": "Пол",
            "en": "Gender",
            "be": "Пол"
        },
        {
            "id": "userInfoFields.birthday",
            "ru": "Дата рожд",
            "en": "Date of birth",
            "be": "Дата нараджэння"
        },
        {
            "id": "userInfoFields.email",
            "ru": "Личный e-mail",
            "en": "Personal e-mail",
            "be": "Асабісты e-mail"
        },
        {
            "id": "userInfoFields.location",
            "ru": "Город",
            "en": "City",
            "be": "Горад"
        },
        {
            "id": "userInfoFields.phone",
            "ru": "Телефон",
            "en": "Phone number",
            "be": "Тэлефон"
        },
        {
            "id": "visitInfoFields.doctorInfo",
            "ru": "Врач",
            "en": "Doctor",
            "be": "Лекар"
        },
        {
            "id": "visitInfoFields.mdInfo",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "Медцэнтр"
        },
        {
            "id": "visitInfoFields.targetDateInfo",
            "ru": "Дата",
            "en": "Date",
            "be": "Дата"
        },
        {
            "id": "visitInfoFields.service",
            "ru": "Услуга",
            "en": "Service",
            "be": "Паслуга"
        },
        {
            "id": "visitInfoFields.visitorNameInfo",
            "ru": "Визит для",
            "en": "Visit for",
            "be": "Візіт для"
        },
        {
            "id": "visitInfoFields.paymentMethod",
            "ru": "Оплата",
            "en": "Payment",
            "be": "Аплата"
        },
        {
            "id": "visitsInvoicesItems.invoices",
            "ru": "ИСТОРИЯ УСЛУГ",
            "en": "SERVICE HISTORY",
            "be": "ПАСЛУГІ"
        },
        {
            "id": "visitsInvoicesItems.visits",
            "ru": "ИСТОРИЯ ПОСЕЩЕНИЙ",
            "en": "VISIT HISTORY",
            "be": "ГІСТОРЫЯ НАВЕДВАННЯЎ"
        },
        {
            "id": "titles.doctorAgeHandlingInterval",
            "ru": "{from} до {to}",
            "en": "{from} to {to}",
            "be": "{from} да {to}"
        },
        {
            "id": "titles.adults",
            "ru": "Взрослые",
            "en": "Adults",
            "be": "Дарослыя"
        },
        {
            "id": "titles.childrenFrom",
            "ru": "Дети с {from} лет",
            "en": "Children from {from} years",
            "be": "Дзеці з {from} гадоў"
        },
        {
            "id": "titles.childrenFromTo",
            "ru": "Дети с {from} до {to} лет",
            "en": "Children from {from} to {to} years",
            "be": "Дзеці з {from} да {to} гадоў"
        },
        {
            "id": "titles.profile",
            "ru": "ВОЗРАСТНОЙ ПРОФИЛЬ",
            "en": "AGE PROFILE",
            "be": "ПРОФІЛЬ"
        },
        {
            "id": "titles.doctorProfile",
            "ru": "Возрастной профиль врача",
            "en": "Doctor's age profile",
            "be": "Профіль лекара"
        },
        {
            "id": "titles.anyProfile",
            "ru": "Любой",
            "en": "Any",
            "be": "Любы"
        },
        {
            "id": "doctorProfile.adults",
            "ru": "Взрослые",
            "en": "Adults",
            "be": "Дарослыя"
        },
        {
            "id": "doctorProfile.children",
            "ru": "Дети",
            "en": "Children",
            "be": "Дзеці"
        },
        {
            "id": "titles.child_account",
            "ru": "УЧЕТНАЯ ЗАПИСЬ РЕБЁНКА",
            "en": "CHILD'S ACCOUNT",
            "be": "УЛIКОВЫ ЗАПIС ДЗIЦЕМ"
        },
        {
            "id": "titles.relative_account",
            "ru": "УЧЕТНАЯ ЗАПИСЬ РОДСТВЕННИКА",
            "en": "RELATIVE'S ACCOUNT",
            "be": "УЛIКОВЫ ЗАПIС СВАЯКОМ"
        },
        {
            "id": "titles.newRelativesFound",
            "ru": "У вас в семье появился кто-то новенький!",
            "en": "Someone new has joined your family!",
            "be": "У вашай сям'і з'явіліся новыя сваякі."
        },
        {
            "id": "titles.profileUpdatingHint",
            "ru": "Идёт обновление данных пользователя. Пожалуйста, подождите...",
            "en": "User data update in progress. Please wait...",
            "be": "Ідзе абнаўленне дадзеных карыстача. Калі ласка, пачакайце ..."
        },
        {
            "id": "titles.enterBnsCode",
            "ru": "Уважаемые пользователи!",
            "en": "Enter the barcode number card of the insured person.",
            "be": "Калі ласка, увядзіце нумар штрых-кода карты застрахаванай асобы."
        },
        {
            "id": "titles.enterBnsCodeHint",
            "ru": "К сожалению, c 1.1.2022 подключение и использование страховых программ от Белнефтестрах больше не поддерживается в мобильном приложении Aibolit. По всем вопросам, связанным с условиями договора страхования, вы можете обратиться в Белнефтестрах по контактным данным, указанным в карточке застрахованного лица или в договоре страхования.\n\nТем не менее, вы и дальше сможете следить за здоровьем с Aibolit: записываться онлайн к врачам (без выбора страховой программы), отменять и переносить визиты, видеть историю посещений.",
            "en": "This number can be found on the map of the insured person, for example 97045xxxxxxxx.\n\nIf your card is not provided, use the insurance contract number. Example of entry: ASBxxxxxxxxxxxx-x or ASBxxxxxxxxxxxx-x / xxx, where ASBxxxxxxxxxxxx-x - contract number and / xxx - the prefix of additional SMS-messages.",
            "be": "Дадзены нумар вы можаце знайсці на карце застрахаванай асобы, напрыклад 97045xxxxxxxx.\n\nКалі наяўнасць карты не прадугледжана, выкарыстоўвайце нумар дагавора страхавання. Прыклад уводу: АСБxxxxxxxxxxxx-x або АСБxxxxxxxxxxxx-x / xxx, дзе АСБxxxxxxxxxxxx-x - нумар дамовы, а / xxx - прыстаўка з дадатковага SMS-паведамленні."
        },
        {
            "id": "titles.insuranceBalance",
            "ru": "Страховая сумма",
            "en": "Insurance amount",
            "be": "Страхавая сума"
        },
        {
            "id": "titles.insuranceBalanceParts",
            "ru": "Включено в страховую сумму",
            "en": "Included into amount",
            "be": "Уваходзiць у страхавую суму"
        },
        {
            "id": "titles.bns_registered",
            "ru": "Теперь вы подключены к программе добровольного медицинского страхования",
            "en": "Now you have added an insurance program",
            "be": "Цяпер вы падлучаныя да праграмы добраахвотнага медыцынскага страхавання"
        },
        {
            "id": "programFields.coverer",
            "ru": "Компания",
            "en": "Insurance Company",
            "be": "Кампанiя"
        },
        {
            "id": "programFields.programCaption",
            "ru": "Программа ДМС",
            "en": "Insurance Program",
            "be": "Праграма ДМС"
        },
        {
            "id": "coverer.epam",
            "ru": "ЭПАМ Системз",
            "en": "EPAM Systems",
            "be": "ЭПАМ Сiстэмз"
        },
        {
            "id": "coverer.bns",
            "ru": "Белнефтестрах",
            "en": "Belneftestrakh",
            "be": "Белнафтастрах"
        },
        {
            "id": "titles.expandFeedback",
            "ru": "Читать далее",
            "en": "Read more",
            "be": "Чытаць далей"
        },
        {
            "id": "titles.shrinkFeedback",
            "ru": "Скрыть",
            "en": "Hide",
            "be": "Схаваць"
        },
        {
            "id": "titles.availableVisitorsLoadingHint",
            "ru": "Идёт загрузка доступных посетителей. Пожалуйста, подождите.",
            "en": "Loading available visitors is in progress. Please wait.",
            "be": "Ідзе загрузка даступных наведвальнікаў. Калі ласка, пачакайце."
        },
        {
            "id": "epamProgramFields.coverer",
            "ru": "Компания",
            "en": "Company",
            "be": "Кампанiя"
        },
        {
            "id": "epamProgramFields.programCaption",
            "ru": "Программа",
            "en": "Program",
            "be": "Праграма"
        },
        {
            "id": "titles.haveUpcomingVisitWithoutTime",
            "ru": "Предстоит визит к врачу: {date}",
            "en": "You have a doctor's appointment scheduled for {date}.",
            "be": "Наперадзе візіт да ўрача: {date}"
        },
        {
            "id": "titles.haveUpcomingVisit",
            "ru": "Предстоит визит к врачу: {date} в {time}",
            "en": "You have a doctor's appointment scheduled for {date} at {time}",
            "be": "Наперадзе візіт да ўрача: {date} у {time}"
        },
        {
            "id": "titles.tomorrow",
            "ru": "завтра",
            "en": "tomorrow",
            "be": "заўтра"
        },
        {
            "id": "titles.yesterday",
            "ru": "вчера",
            "en": "yesterday",
            "be": "учора"
        },
        {
            "id": "titles.days",
            "ru": "{days} дня назад",
            "en": "{days} days ago",
            "be": "{days} дня таму"
        },
        {
            "id": "titles.today",
            "ru": "сегодня",
            "en": "today",
            "be": "сёння"
        },
        {
            "id": "titles.notifications",
            "ru": "Напоминания о визитах",
            "en": "Appointment reminders",
            "be": "Напамін пра візіт"
        },
        {
            "id": "titles.doNotRemind",
            "ru": "Не напоминать",
            "en": "Do not remind",
            "be": "Ня нагадваць"
        },
        {
            "id": "reminderTime.30minutes",
            "ru": "За 30 минут",
            "en": "30 minutes before",
            "be": "За 30 хвілін"
        },
        {
            "id": "reminderTime.1hour",
            "ru": "За 1 час",
            "en": "1 hour before",
            "be": "За 1 гадзіну"
        },
        {
            "id": "reminderTime.2hours",
            "ru": "За 2 часа",
            "en": "2 hours before",
            "be": "За 2 гадзіны"
        },
        {
            "id": "reminderTime.4hours",
            "ru": "За 4 часа",
            "en": "4 hours before",
            "be": "За 4 гадзіны"
        },
        {
            "id": "reminderTime.1dayMorning",
            "ru": "За 1 день, в 10:00 утра",
            "en": "1 day before, at 10:00 AM",
            "be": "За 1 дзень раніцай"
        },
        {
            "id": "reminderTime.1dayEvening",
            "ru": "За 1 день, в 20:00 вечера",
            "en": "1 day before, at 8:00 PM",
            "be": "За 1 дзень увечары"
        },
        {
            "id": "hint.commonNotificationsSettings",
            "ru": "Настройки напоминаний будут применяться по умолчанию ко всем вашим визитам",
            "en": "Reminders setup will be applied by default to all your visits",
            "be": "Налада напаміну будзе прымяняцца да ўсіх вашых візітаў"
        },
        {
            "id": "titles.showOnMap",
            "ru": "Поcмотреть на карте",
            "en": "Show on map",
            "be": "Паглядзець на карце"
        },
        {
            "id": "titles.noFavoriteMedcenters",
            "ru": "У вас в закладках пока нет медцентров",
            "en": "You don't have medical centers in your bookmarks yet.",
            "be": "У вас у закладках пакуль няма медцэнтраў"
        },
        {
            "id": "titles.bookmarkMedcentersPrompt",
            "ru": "Добавляйте в закладки медцентры, которые вам понравились. Так их всегда будет легко найти.",
            "en": "Bookmark the medical centers you like. This will make them easy to find.",
            "be": "Дадавайце ў закладкі медцэнтры, якія вам спадабаліся. Так іх заўсёды будзе лёгка знайсці."
        },
        {
            "id": "title.visit_own_expenses",
            "ru": "За свой счёт",
            "en": "At own expense",
            "be": "За свой кошт"
        },
        {
            "id": "title.by_program",
            "ru": "По программе",
            "en": "By program",
            "be": "Па праграме"
        },
        {
            "id": "medcenterSort.byDoctorsCount",
            "ru": "По количеству докторов",
            "en": "By number of doctors",
            "be": "Па колькасці дактароў"
        },
        {
            "id": "medcenterSort.byFeedbacks",
            "ru": "По количеству отзывов",
            "en": "By number of feedback",
            "be": "Па колькасці водгукаў"
        },
        {
            "id": "medcenterSort.byFeedbacksMedcenter",
            "ru": "По количеству отзывов",
            "en": "By number of feedback",
            "be": "Па колькасці водгукаў"
        },
        {
            "id": "medcenterSort.byMedcenterName",
            "ru": "По названию медцентра",
            "en": "By medical center name",
            "be": "Па назве медцэнтра"
        },
        {
            "id": "titles.doctorHandlesChildren",
            "ru": "ВРАЧ ПРИНИМАЕТ",
            "en": "DOCTOR RECEIVES",
            "be": "УРАЧЫ ПРЫМАЮЦЬ"
        },
        {
            "id": "titles.doctorSpeciality",
            "ru": "СПЕЦИАЛЬНОСТЬ ВРАЧА",
            "en": "DOCTOR'S SPECIALTY",
            "be": "СПЕЦЫЯЛЬНАСЦЬ ЛЕКАРА"
        },
        {
            "id": "placeholders.doctorSpecialization",
            "ru": "Терапевт",
            "en": "Therapist",
            "be": "Тэрапеўт"
        },
        {
            "id": "titles.allowNotificationsPrompt",
            "ru": "Для отображения напоминаний приложению требуется разрешение на использование нотификаций. Пожалуйста, включите разрешение нотификаций в настройках телефона.",
            "en": "To display reminders, the application requires permission to user notifications. Please enable permission notifications in your phone settings.",
            "be": "Для адлюстравання напамінку дадатку патрабуецца дазвол на карыстанне натыфікацыяй. Калі ласка, уключыце дазвол натыфікацый у наладах прыкладання."
        },
        {
            "id": "title.whereDoctorWorks",
            "ru": "МЕДЦЕНТР",
            "en": "MEDICAL CENTER",
            "be": "МЕДЦЭНТР"
        },
        {
            "id": "titles.any",
            "ru": "Любой",
            "en": "Any",
            "be": "Любы"
        },
        {
            "id": "titles.fromFavorites",
            "ru": "Из закладок",
            "en": "From bookmarks",
            "be": "З закладак"
        },
        {
            "id": "titles.enterEpamEmail",
            "ru": "Введите корпоративный EPAM E-mail",
            "en": "Enter corporate EPAM E-mail",
            "be": "Увядзіце карпаратыўны EPAM E-mail"
        },
        {
            "id": "titles.enterEpamEmailHint",
            "ru": "Запрос для активации программы придёт на ваш корпоративный E-mail в течение 5 минут.",
            "en": "A request for activation of the program will come to your corporate E-mail within 5 minutes.",
            "be": "Запыт для актывацыі праграмы прыйдзе на ваш карпаратыўны E-mail на працягу 5 хвілін."
        },
        {
            "id": "titles.allMedicalCenters",
            "ru": "Все медицинские центры",
            "en": "All medical centers",
            "be": "Усе медыцынскія цэнтры"
        },
        {
            "id": "titles.programConfirmationEmailWasSent",
            "ru": "Запрос для активации программы выслан на ваш корпоративный Email \"{address}\". Пожалуйста, подтвердите запрос, чтобы завершить привязку программы.",
            "en": "The activation request has been sent to your corporate email '{address}'. Please confirm the request to complete the program binding.",
            "be": "Запыт для актывацыі праграмы высланы на ваш карпаратыўны Email \"{address}\". Калі ласка, пацвердзіце запыт, каб завяршыць прывязку праграмы."
        },
        {
            "id": "titles.awaitingYourConfirm",
            "ru": "Ожидает вашего подтверждения",
            "en": "Awaiting your confirmation",
            "be": "Чакае вашага пацверджання"
        },
        {
            "id": "hint.corporateDataWillBeFetched",
            "ru": "Автоматическое заполнение ваших данных из корпоративной программы",
            "en": "Your data will be automatically filling from the corporate program",
            "be": "Вашы дадзеныя аўтаматычна падцягнуцца з карпаратыўнай праграмы"
        },
        {
            "id": "titles.programs",
            "ru": "ПРОГРАММЫ",
            "en": "PROGRAMS",
            "be": "ПРАГРАМЫ"
        },
        {
            "id": "titles.programLinked",
            "ru": "Корпоративная программа привязана",
            "en": "Corporate program is linked",
            "be": "Карпаратыўная праграма прывязаная"
        },
        {
            "id": "titles.addMail",
            "ru": "Добавьте личную почту",
            "en": "Add a personal e-mail",
            "be": "Дадаць асабістую пошту"
        },
        {
            "id": "titles.yourPersonalEmail",
            "ru": "Ваш личный e-mail",
            "en": "Your personal e-mail.",
            "be": "Ваш асабісты e-mail"
        },
        {
            "id": "titles.addPersonalEmailHint",
            "ru": "Личный e-mail нужен, чтобы иметь возможность восстановить доступ к своему аккаунту при смене телефонного номера или мобильного устройства.",
            "en": "Your personal email is needed to be able to recover access to your account in case of changing your phone number or mobile device.",
            "be": "Асабісты e-mail патрэбны, каб мець магчымасць аднавіць доступ да свайго акаўнта пры змене тэлефоннага нумара або мабільнай прылады."
        },
        {
            "id": "titles.enterActualEmailHint",
            "ru": "Введите свой актуальный e-mail в поле ниже и нажмите \"сохранить\".",
            "en": "Enter your current e-mail address in the field below and click \"Save\" button",
            "be": "Калі ласка, увядзіце свой актуальны e-mail ў поле ніжэй і націсніце \"захаваць\"."
        },
        {
            "id": "titles.add",
            "ru": "ДОБАВИТЬ",
            "en": "ADD",
            "be": "ДАДАЦЬ"
        },
        {
            "id": "placeholders.email",
            "ru": "Name_Lastname@epam.com",
            "en": "Name_Lastname@epam.com",
            "be": "Name_Lastname@epam.com"
        },
        {
            "id": "titles.emailLinkConfirmSent",
            "ru": "Запрос для привязки вашей личной почты выслан на адрес \"{email}\". Пожалуйста, подтвердите запрос, чтобы завершить привязку личной почты.",
            "en": "The request to bind your personal email has been sent to the address \"{email}\". Please confirm the request to complete the linking of your personal mail.",
            "be": "Запыт для прывязкі вашай асабістай пошты высланы на адрас \"{email}\". Калі ласка, пацвердзіце запыт, каб завяршыць прывязку асабістай пошты."
        },
        {
            "id": "titles.emailLinkConfirmSentError",
            "ru": "Ошибка отправки запроса для привязки вашей личной почты \"{email}\".",
            "en": "Error sending request to bind your personal email \"{email}\".",
            "be": "Памылка адпраўкі запыту для прывязкі вашай асабістай пошты \"{email}\"."
        },
        {
            "id": "titles.weWaitingForConfirm",
            "ru": "Мы ждём вашего подтверждения",
            "en": "We are waiting for your confirmation",
            "be": "Мы чакаем вашага пацверджання"
        },
        {
            "id": "titles.newDeviceWaitingConfirm",
            "ru": "Новое устройство ожидает подтверждения",
            "en": "A new device is pending confirmation",
            "be": "Новая прылада чакае пацверджання"
        },
        {
            "id": "titles.canCancelAccountLink",
            "ru": "Вы можете отменить подключение к учётной записи {email}",
            "en": "You can cancel the connection to the account {email}",
            "be": "Вы можаце адмяніць падлучэнне да ўліковага запісу {email}"
        },
        {
            "id": "titles.createNewAccount",
            "ru": "Создать новую учётную запись",
            "en": "Create a new account",
            "be": "Стварыць новы акаўнт"
        },
        {
            "id": "titles.resetAndCreateNewAccount",
            "ru": "Сброс и создание нового аккаунта",
            "en": "Reset and create a new account",
            "be": "Скід і стварэнне новага акаўнта"
        },
        {
            "id": "titles.resetAndCreateNewAccountConfirm",
            "ru": "Вы точно хотите сбросить e-mail {email} и создать новую учётную запись?\nВы не сможете подключиться к аккаунту, который привязан к этому e-mail.",
            "en": "Are you sure you want to reset email {email} and create a new account?\nYou will not be able to connect to your account, which is attached to this e-mail.",
            "be": "Вы дакладна хочаце скінуць email {email} і стварыць новы акаўнт?\nВы не зможаце падключыцца да акаўнта, які прывязаны да гэтага e-mail."
        },
        {
            "id": "titles.creatingNewProfileForNumber",
            "ru": "Создание нового профиля для номера:",
            "en": "Create a new profile for the number:",
            "be": "Стварэнне новага профілю для нумара:"
        },
        {
            "id": "titles.userWithNumberWasRegistered",
            "ru": "Пользователь с таким номером уже был зарегестрирован ранее.",
            "en": "A person with this number has already been registered earlier.",
            "be": "Карыстальнік з такім нумарам ужо быў зарэгістраваны раней."
        },
        {
            "id": "titles.canCreateProfileIfNumberOwner",
            "ru": "Если вы являетесь новым владельцем этого номера - можете создать новый профиль.",
            "en": "If you are a new owner of this number - you can create a new profile.",
            "be": "Калі вы з'яўляецеся новым уладальнікам гэтага нумара - можаце стварыць новы профіль."
        },
        {
            "id": "buttons.createNewProfile",
            "ru": "СОЗДАТЬ НОВЫЙ ПРОФИЛЬ",
            "en": "CREATE NEW PROFILE",
            "be": "СТВАРЫЦЬ НОВЫ ПРОФIЛЬ"
        },
        {
            "id": "titles.accessCheck",
            "ru": "Проверка доступа",
            "en": "Access verification",
            "be": "Праверка доступу"
        },
        {
            "id": "titles.accessCheckHint",
            "ru": "Вы хотите зайти в свой профиль с нового устройства.\nПожалуйста, подтвердите возможность доступа к своим персональным данным.",
            "en": "You want to access your profile from a new device. Please, confirm the access to your personal data.",
            "be": "Вы хочаце зайсці ў свой профіль з новай прылады.\nКалі ласка, пацвердзіце магчымасць доступу да сваіх персанальных дадзеных."
        },
        {
            "id": "titles.confirmViaEmail",
            "ru": "Подтвердить через почту",
            "en": "Validate by email",
            "be": "Пацвердзіць праз пошту"
        },
        {
            "id": "buttons.sendConfirmationCode",
            "ru": "ОТПРАВИТЬ КОД ПОДТВЕРЖДЕНИЯ",
            "en": "SEND A VERIFICATION CODE",
            "be": "АДПРАВІЦЬ КОД ПАЦВЕРДЖАННЕ"
        },
        {
            "id": "titles.isNotMyMail",
            "ru": "Это не моя почта!",
            "en": "This is not my email!",
            "be": "Гэта не мая пошта!"
        },
        {
            "id": "titles.noConfirmationWays",
            "ru": "Для вашего телефонного номера уже существует аккаунт в приложении, но у него отсутствует подтверждённый email.",
            "en": "An account already exists for your phone number in the app, but it doesn't have a confirmed email.",
            "be": "Для вашага тэлефоннага нумара ўжо існуе акаўнт у дадатку, але ў яго адсутнічае пацверджаны email."
        },
        {
            "id": "titles.createNewProfile",
            "ru": "СОЗДАТЬ НОВЫЙ ПРОФИЛЬ",
            "en": "CREATE NEW PROFILE",
            "be": "СТВАРЫЦЬ НОВЫ ПРОФIЛЬ"
        },
        {
            "id": "buttons.writeToSupport",
            "ru": "Обратиться в поддержку",
            "en": "Contact support",
            "be": "Звярнуцца ў падтрымку"
        },
        {
            "id": "titles.nowLinkedToProgram_epam",
            "ru": "Теперь вы подключены к корпоративной программе \"{programName}\"",
            "en": "Now you are connected to the corporate program \"{programName}\"",
            "be": "Цяпер вы падлучаны да карпаратыўнай праграмы \"{programName}\""
        },
        {
            "id": "titles.nowLinkedToProgram_bns",
            "ru": "Теперь вы подключены к страховой программе \"{programName}\"",
            "en": "You are now connected to the insurance program \"{programName}\"",
            "be": "Цяпер вы падлучаны да страхавой праграмы \"{programName}\""
        },
        {
            "id": "titles.nowLinkedToProgram_bns-limited",
            "ru": "Теперь вы подключены к программе добровольного медицинского страхования \"{programName}\"",
            "en": "You are now connected to the program of voluntary health insurance \"{programName}\"",
            "be": "Цяпер вы падлучаны да праграмы добраахвотнага медыцынскага страхавання \"{programName}\""
        },
        {
            "id": "titles.nowRelativeLinkedToProgram_bns",
            "ru": "Теперь ваш родственник подключен к страховой программе \"{programName}\"",
            "en": "Now your relative is connected to the insurance program \"{PROGRAMNAME}\"",
            "be": "Цяпер ваш сваяк падлучаны да страхавой праграмы \"{programName}\""
        },
        {
            "id": "titles.nowRelativeLinkedToProgram_bns-limited",
            "ru": "Теперь ваш родственник подключен к программе добровольного медицинского страхования \"{programName}\"",
            "en": "Now your relative is connected to the Voluntary Medical Insurance Program \"{PROGRAMNAME}\"",
            "be": "Цяпер ваш сваяк падлучаны да праграмы добраахвотнага медыцынскага страхавання \"{programName}\""
        },
        {
            "id": "titles.nowRelativeLinkedToProgram_epam",
            "ru": "Теперь ваш родственник подключен к корпоративной программе \"{programName}\"",
            "en": "Now your relative is connected to the corporate program \"{programName}\"",
            "be": "Цяпер ваш сваяк падлучаны да карпаратыўнай праграмы \"{programName}\""
        },
        {
            "id": "titles.nowVisitsAreCovered_epam",
            "ru": "Вашей программой покрываются визиты к врачам с маркером \"EPAM\"",
            "en": "Your program covers visits to doctors with \"Epam\" marker",
            "be": "Вашай праграмай пакрываюцца візіты да лекараў з маркерам \"EPAM\""
        },
        {
            "id": "titles.nowServicesAreCovered_epam",
            "ru": "Ещё вашей программой покрываются услуги, возле которых есть маркер в виде голубой точки",
            "en": "More services are covered by your program, near which there is an indicator in the form of a blue dot",
            "be": "Яшчэ вашай праграмай пакрываюцца паслугі, каля якіх ёсць маркер у выглядзе блакітнай кропкі"
        },
        {
            "id": "titles.nowVisitsAreCovered_bns",
            "ru": "Вашей программой покрываются визиты к врачам с маркером \"БЕЛНЕФТЕСТРАХ\"",
            "en": "Your program covers visits to doctors with \"БЕЛНЕФТЕСТРАХ\" marker",
            "be": "Вашай праграмай пакрываюцца візіты да лекараў з маркерам \"Белнафтастрах\""
        },
        {
            "id": "titles.nowServicesAreCovered_bns",
            "ru": "Ещё вашей программой покрываются услуги, возле которых есть маркер в виде синей точки",
            "en": "More services are covered by your program, near which there is an indicator as a blue dot",
            "be": "Яшчэ вашай праграмай пакрываюцца паслугі, каля якіх ёсць маркер у выглядзе сіняй кропкі"
        },
        {
            "id": "titles.nowRelativeVisitsAreCovered_bns",
            "ru": "Программой вашего родственника покрываются визиты к врачам с маркером \"БЕЛНЕФТЕСТРАХ\"",
            "en": "The program of your relative is covered by visits to doctors with a marker \"Beneftestrakh\"",
            "be": "Праграмай вашага сваяка пакрываюцца візіты да лекараў з маркерам \"Белнафтастрах\""
        },
        {
            "id": "titles.nowRelativeVisitsAreCovered_bns-limited",
            "ru": "Программой вашего родственника покрываются визиты с маркером \"БЕЛНЕФТЕСТРАХ\"",
            "en": "The program of your relative is covered by visits with the marker \"Belnevesters\"",
            "be": "Праграмай вашага сваяка пакрываюцца візіты з маркерам \"Белнафтастрах\""
        },
        {
            "id": "titles.nowServicesAreCovered_bns-limited",
            "ru": "Доступен просмотр страховых сумм по мере расходования в режиме online",
            "en": "You can browse the sums insured as an expenditure in the online mode",
            "be": "Прагляд страхавых сум даступны па меры выдаткоўвання ў рэжыме online"
        },
        {
            "id": "titles.nowVisitsAreCovered_bns-limited",
            "ru": "Вашей программой покрываются визиты с маркером \"БЕЛНЕФТЕСТРАХ\"",
            "en": "Your program covers visits with \"БЕЛНЕФТЕСТРАХ\" marker",
            "be": "Вашай праграмай пакрываюцца візіты з маркерам \"Белнафтастрах\""
        },
        {
            "id": "titles.nowRelativeServicesAreCovered_bns-limited",
            "ru": "Доступен просмотр страховых сумм по мере расходования в режиме online",
            "en": "Insurance amounts are available as expenditure in Online mode.",
            "be": "Даступны прагляд страхавых сум па меры выдаткоўвання ў рэжыме online"
        },
        {
            "id": "titles.nowRelativeServicesAreCovered_bns",
            "ru": "Ещё программой вашего родственника покрываются услуги, возле которых есть маркер в виде синей точки",
            "en": "Another program of your relative is covered by services, near which there is a marker in the form of a blue point",
            "be": "Яшчэ праграмай вашага сваяка пакрываюцца паслугі, каля якіх ёсць маркер ў выглядзе сіняй кропкі"
        },
        {
            "id": "titles.nowRelativeVisitsAreCovered_epam",
            "ru": "Программой вашего родственника покрываются визиты к врачам с маркером \"EPAM\"",
            "en": "The program of your relative is covered visits to doctors with the \"EPAM\" marker",
            "be": "Праграмай вашага сваяка пакрываюцца візіты да лекараў з маркерам \"EPAM\""
        },
        {
            "id": "titles.nowRelativeServicesAreCovered_epam",
            "ru": "Ещё программой вашего родственника покрываются услуги, возле которых есть маркер в виде голубой точки",
            "en": "Another program of your relative is covered by services, near which there is a marker in the form of a blue point",
            "be": "Яшчэ праграмай вашага сваяка пакрываюцца паслугі, каля якіх ёсць маркер ў выглядзе блакітнай пункту"
        },
        {
            "id": "buttons.without_program",
            "ru": "ПРОДОЛЖИТЬ БЕЗ ПРОГРАММЫ",
            "en": "CONTINUE WITHOUT PROGRAM",
            "be": "ПРАЦЯГНУЦЬ БЕЗ ПРАГРАМЫ"
        },
        {
            "id": "buttons.bind_the_program",
            "ru": "ПРИВЯЗАТЬ ПРОГРАММУ",
            "en": "LINK THE PROGRAM",
            "be": "ДАЛУЧЫЦЬ ПРАГРАМУ"
        },
        {
            "id": "buttons.sendNumber",
            "ru": "ОТПРАВИТЬ НОМЕР",
            "en": "SEND NUMBER",
            "be": "АДПРАВІЦЬ НУМАР"
        },
        {
            "id": "titles.signOut",
            "ru": "Выход",
            "en": "Log out",
            "be": "Выхад"
        },
        {
            "id": "titles.profileCheckSignOutConfirm",
            "ru": "Вы уверены, что хотите выйти, не подтвердив актуальность профиля?\nНомер телефона: {phoneNumber}",
            "en": "Are you sure you want to log out without confirming the relevance of the profile?\nphone number: {phoneNumber}",
            "be": "Вы ўпэўненыя, што хочаце выйсці, ня пацвердзіўшы актуальнасць профілю?\nНумар тэлефона: {phoneNumber}"
        },
        {
            "id": "titles.personalEmailHint",
            "ru": "(ДЛЯ ЗАЩИТЫ ДАННЫХ)",
            "en": "(TO PROTECT YOUR DATA)",
            "be": "(ДЛЯ АБАРОНЫ ДАНЫХ)"
        },
        {
            "id": "titles.deviceConfirmWasSent",
            "ru": "Запрос выслан на почту \"{email}\". Пожалуйста, подтвердите его, чтобы разрешить доступ с данного устройства.",
            "en": "Request sent to email \"{email}\". Please confirm it to allow access to the device.",
            "be": "Запыт высланы на пошту \"{email}\". Калі ласка, пацвердзіце яго, каб дазволіць доступ з дадзенай прылады."
        },
        {
            "id": "titles.enterProfile",
            "ru": "Заполните ваш профиль для записи к врачам",
            "en": "Complete your profile to schedule appointments with doctors",
            "be": "Запоўніце ваш профіль для запісу да лекараў"
        },
        {
            "id": "titles.doctorNotFound",
            "ru": "Доктор не найден",
            "en": "Doctor not found",
            "be": "Доктар не знойдзены"
        },
        {
            "id": "titles.emailAlreadyLinked",
            "ru": "Этот E-mail уже привязан к вашему аккаунту.",
            "en": "This E-mail is already linked to your account.",
            "be": "Гэты E-mail ўжо прывязаны да вашага акаўнта."
        },
        {
            "id": "titles.childAlreadyExists",
            "ru": "Такой ребёнок уже есть",
            "en": "Such a child already exists",
            "be": "Такі дзіця ўжо ёсць"
        },
        {
            "id": "titles.addSimilarChildConfirm",
            "ru": "Ребёнок с такими данными уже добавлен в систему.\nПрисоединитесь к семье, чтобы избежать дублирования или обратитесь в поддержку.",
            "en": "A child with these data is already added to the system.\nJoin the family in order to avoid duplication or contact support.",
            "be": "Дзіця з такімі дадзенымі ўжо дададзены ў сістэму.\nДалучыцеся да сям'і, каб пазбегнуць дублявання, або звярніцеся ў падтрымку."
        },
        {
            "id": "button.support",
            "ru": "ПОДДЕРЖКА",
            "en": "SUPPORT",
            "be": "ПАДТРЫМКА"
        },
        {
            "id": "button.cancelButton",
            "ru": "ОТМЕНА",
            "en": "CANCEL",
            "be": "АДМЕНА"
        },
        {
            "id": "hint.medcardNotActiveForClinic",
            "ru": "Медицинская карта для обслуживания по программе ещё не активна в выбранной клинике.",
            "en": "The medical card for the service under the program is not active at the selected clinic.",
            "be": "Медыцынская карта для абслугоўвання па праграме яшчэ не актыўна ў абранай клініцы."
        },
        {
            "id": "titles.contactRegistryToDeclineVisit",
            "ru": "Обратитесь в регистратуру для отмены этого визита:",
            "en": "Please contact the reception desk to cancel this appointment:",
            "be": "Звярніцеся ў рэгістратуру для адмены гэтага візіту:"
        },
        {
            "id": "titles.contactRegistryToEditVisit",
            "ru": "Обратитесь в регистратуру для изменения этого визита:",
            "en": "Please contact the reception desk to change this appointment:",
            "be": "Звярніцеся ў рэгістратуру для змянення гэтага візіту:"
        },
        {
            "id": "titles.didLikeApp",
            "ru": "Вы довольны приложением Aibolit?",
            "en": "Are you satisfied with the Aibolit application?",
            "be": "Вы задаволеныя дадаткам Aibolit?"
        },
        {
            "id": "buttons.notQuite",
            "ru": "НЕ СОВСЕМ",
            "en": "NOT QUITE",
            "be": "НЕ ЗУСІМ"
        },
        {
            "id": "buttons.ofCourse",
            "ru": "КОНЕЧНО",
            "en": "OF COURSE",
            "be": "ВЯДОМА"
        },
        {
            "id": "titles.tellWhatToImprove",
            "ru": "Расскажите нам, что можно улучшить",
            "en": "Tell us, what can be improved",
            "be": "Раскажыце нам, што можна палепшыць"
        },
        {
            "id": "placeholders.yourFeedback",
            "ru": "Ваш отзыв...",
            "en": "Your feedback...",
            "be": "Ваш водгук ..."
        },
        {
            "id": "titles.thanksForFeedback",
            "ru": "Спасибо за ваш отзыв",
            "en": "Thanks for your feedback",
            "be": "Дзякуй за ваш водгук"
        },
        {
            "id": "placeholders.yourAbuse",
            "ru": "Дополнительное описание...",
            "en": "Additional description...",
            "be": "Дадатковае апiсанне..."
        },
        {
            "id": "titles.androidSupportByGoodMark",
            "ru": "Поддержите Aibolit отличной оценкой в Play Market!",
            "en": "Support Aibolit with an excellent rating on the Play Market!",
            "be": "Падтрымайце Aibolit выдатнай адзнакай ў Play Market!"
        },
        {
            "id": "titles.iosSupportByGoodMark",
            "ru": "Поддержите Aibolit отличной оценкой в App Store!",
            "en": "Support Aibolit with an excellent rating on the  App Store!",
            "be": "Падтрымайце Aibolit выдатнай адзнакай ў App Store!"
        },
        {
            "id": "titles.webSupportByGoodMark",
            "ru": "Поддержите Aibolit отличной оценкой в Play Market!",
            "en": "Support Aibolit with an excellent rating on the Play Market!",
            "be": "Падтрымайце Aibolit выдатнай адзнакай ў Play Market!"
        },
        {
            "id": "titles.supportByGoodMarkHint",
            "ru": "Это поможет другим пользователям узнать о нашем приложении",
            "en": "This will help other users learn about our app",
            "be": "Гэта дапаможа іншым карыстальнікам даведацца аб нашым дадатку"
        },
        {
            "id": "buttons.rateApp",
            "ru": "ПОСТАВИТЬ ОЦЕНКУ",
            "en": "RATE",
            "be": "ПАСТАВIЦЬ АДЗНАКУ"
        },
        {
            "id": "buttons.remindMeLater",
            "ru": "НАПОМНИТЬ ПОЗЖЕ",
            "en": "REMIND ME LATER",
            "be": "НАГАДАЦЬ ПАЗЬНЕЙ"
        },
        {
            "id": "buttons.noThanks",
            "ru": "НЕТ, СПАСИБО",
            "en": "NO THANKS",
            "be": "НЕ, ДЗЯКУЙ"
        },
        {
            "id": "buttons.find",
            "ru": "НАЙТИ",
            "en": "FIND",
            "be": "ЗНАЙСЦІ"
        },
        {
            "id": "titles.attachmentsPresence",
            "ru": "Наличие вложений",
            "en": "Presence of attachments",
            "be": "Наяўнасць укладанняў"
        },
        {
            "id": "titles.forWhomVisitsSection",
            "ru": "ДЛЯ КОГО ВИЗИТЫ",
            "en": "FOR WHOM ARE THE VISITS",
            "be": "ДЛЯ КАГО ВIЗIТЫ"
        },
        {
            "id": "titles.forWhomVisits",
            "ru": "Для кого визиты",
            "en": "For whom are the visits",
            "be": "Для каго вiзiты"
        },
        {
            "id": "titles.anyVisitor",
            "ru": "Любой посетитель",
            "en": "Any visitor",
            "be": "Любы наведвальнік"
        },
        {
            "id": "titles.myVisits",
            "ru": "Мои визиты",
            "en": "My visits",
            "be": "Мае візіты"
        },
        {
            "id": "titles.visitsNotFound",
            "ru": "Просмотр ближайших визитов будет доступен сразу после авторизации.",
            "en": "You will be able to view upcoming visits immediately after authorization.",
            "be": "Прагляд бліжэйшых візітаў будзе даступны для прагляду адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.FeedbacksNotFoundSearch",
            "ru": "Данные не найдены",
            "en": "Data not found",
            "be": "Дадзеныя не знойдзены"
        },
        {
            "id": "titles.visitsNotFoundSearch",
            "ru": "Данные не найдены",
            "en": "Data not found",
            "be": "Дадзеныя не знойдзены"
        },
        {
            "id": "titles.visitsNotFoundSearch_auth",
            "ru": "Данные не найдены",
            "en": "Data not found",
            "be": "Дадзеныя не знойдзены"
        },
        {
            "id": "titles.visitsNotFound_auth",
            "ru": "Визиты не найдены",
            "en": "Visits not found",
            "be": "Візіты не знойдзены"
        },
        {
            "id": "titles.visitsNotFoundLoading",
            "ru": "Просмотр ближайших визитов будет доступен сразу после авторизации.",
            "en": "You will be able to view upcoming visits immediately after authorization.",
            "be": "Прагляд бліжэйшых візітаў будзе даступны для прагляду адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.visitsNotFoundLoading_auth",
            "ru": "Идет загрузка данных",
            "en": "Data is loading",
            "be": "Ідзе загрузка даных"
        },
        {
            "id": "titles.reportsNotFound",
            "ru": "Просмотр отчетов будет доступен сразу после авторизации.",
            "en": "You will be able to view reports immediately after authorization.",
            "be": "Прагляд справаздач будзе даступны адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.reportsNotFound_auth",
            "ru": "Отчеты не найдены",
            "en": "No reports found",
            "be": "Справаздачы не знойдзены"
        },
        {
            "id": "titles.testsNotFound",
            "ru": "Просмотр анализов будет доступен сразу после авторизации.",
            "en": "You will be able to view tests immediately after authorization.",
            "be": "Прагляд аналізаў будзе даступны адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.testsNotFoundLoading",
            "ru": "Просмотр анализов будет доступен сразу после авторизации.",
            "en": "You will be able to view tests immediately after authorization.",
            "be": "Прагляд аналізаў будзе даступны адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.testsNotFoundLoading_auth",
            "ru": "Идет загрузка данных",
            "en": "Data is loading",
            "be": "Ідзе загрузка даных"
        },
        {
            "id": "titles.testsNotFound_auth",
            "ru": "Анализы не найдены",
            "en": "No tests found",
            "be": "Аналіз не знойдзены"
        },
        {
            "id": "titles.unknown",
            "ru": "Неизвестен",
            "en": "Unknown",
            "be": "Невядомы"
        },
        {
            "id": "titles.cancelVisit",
            "ru": "Отмена визита",
            "en": "Cancel appointment",
            "be": "Адмена візіту"
        },
        {
            "id": "titles.changeVisit",
            "ru": "Изменение визита",
            "en": "Changing appointment",
            "be": " візіту"
        },
        {
            "id": "titles.canDeleteVisitTomorrow",
            "ru": "Визит будет доступен для удаления завтра",
            "en": "The appointment will be available for cancellation tomorrow.",
            "be": "Візіт будзе даступны для выдалення заўтра"
        },
        {
            "id": "tiles.positionFromTotal",
            "ru": "{position} из {total}",
            "en": "{position} out of {total}",
            "be": "{position} з {total}"
        },
        {
            "id": "titles.myDocuments",
            "ru": "Мои документы",
            "en": "My documents",
            "be": "Мае дакументы"
        },
        {
            "id": "titles.documents",
            "ru": "Документы",
            "en": "Documents",
            "be": "Дакументы"
        },
        {
            "id": "titles.filesStoredLocallyHint",
            "ru": "Обращаем ваше внимание, что все файлы хранятся только на данном мобильном устройстве и не сохранятся при его смене.",
            "en": "Please note that all files are stored only on this mobile device and will not be saved if you change it.",
            "be": "Звяртаем вашу ўвагу, што ўсе файлы захоўваюцца толькі на дадзенай мабільнай прыладзе і не захаваюцца пры яе змене."
        },
        {
            "id": "titles.attachmentsStoredLocallyHint",
            "ru": "Файлы хранятся только на данном мобильном устройстве и не сохранятся при его смене",
            "en": "The files are stored only on this mobile device and will not be saved when changing",
            "be": "Файлы захоўваюцца толькі на дадзенай мабільнай прыладзе і не захаваюцца пры яе змене"
        },
        {
            "id": "titles.attachmentsStoredLocallyHintBackup",
            "ru": "Сейчас файлы хранятся только на этом устройстве. Включите облачное резервное копирование в настройках, чтобы иметь доступ к файлам на новом устройстве в будущем.",
            "en": "Here you can attach identification documents. Please note that all files are stored only on this device. Enable cloud backup in settings to have access to files on a new device in the future.",
            "be": "Файлы захоўваюцца толькі на дадзенай мабільнай прыладзе і не захаваюцца пры яе змене"
        },
        {
            "id": "titles.localFileAdded",
            "ru": "Файл добавлен! Он сохранён только на данном мобильном устройстве.",
            "en": "The file is added! It is only stored in this mobile device.",
            "be": "Тут вы можаце прымацаваць дакументы, якія пацвярджаюць асобу. Звяртаем вашу ўвагу, што ўсе файлы захоўваюцца толькі на гэтай прыладзе. Уключыце хмарнае рэзервовае капіраванне ў наладах, каб мець доступ да файлаў на новым прыладзе ў будучыні."
        },
        {
            "id": "titles.noAttachedDocs",
            "ru": "У вас пока нет прикреплённых документов",
            "en": "You don't have any attached documents yet",
            "be": "У вас пакуль няма прымацаваных дакументаў"
        },
        {
            "id": "titles.noAttachedDocsHint",
            "ru": "Здесь вы можете прикрепить документы, удостоверяющие личность. Обращаем ваше внимание, что все файлы хранятся только на данном мобильном устройстве и не сохранятся при его смене.",
            "en": "Here you can attach identity documents. Please note that all files are stored only on this mobile device and will not be saved when it is changing.",
            "be": "Тут вы можаце прымацаваць дакументы, якія сведчаць асобу. Звяртаем вашу ўвагу, што ўсе файлы захоўваюцца толькі на дадзенай мабільнай прыладзе і не захаваюцца пры яе змене."
        },
        {
            "id": "titles.noAttachedDocsHintBackup",
            "ru": "Здесь вы можете прикрепить документы, удостоверяющие личность. Обращаем ваше внимание, что все файлы хранятся только на этом устройстве. Включите облачное резервное копирование в настройках, чтобы иметь доступ к файлам на новом устройстве в будущем.",
            "en": "Here you can attach identification documents. Please note that all files are stored only on this device. Enable cloud backup in settings to have access to files on a new device in the future.",
            "be": "Тут вы можаце прымацаваць дакументы, якія пацвярджаюць асобу. Звяртаем вашу ўвагу, што ўсе файлы захоўваюцца толькі на гэтай прыладзе. Уключыце хмарнае рэзервовае капіраванне ў наладах, каб мець доступ да файлаў на новым прыладзе ў будучыні."
        },
        {
            "id": "titles.coveredMedcenters",
            "ru": "Оплачиваемые медцентры",
            "en": "Covered medical centers",
            "be": "Аплатныя медцэнтры"
        },
        {
            "id": "titles.notCoveredMedcenters",
            "ru": "Неоплачиваемые медцентры",
            "en": "Not covered medical centers",
            "be": "Неаплатныя медцэнтры"
        },
        {
            "id": "titles.docDeleteConfirm",
            "ru": "Вы уверены, что хотите удалить документ?",
            "en": "Are you sure you want to delete the document?",
            "be": "Вы ўпэўненыя, што жадаеце выдаліць дакумент?"
        },
        {
            "id": "titles.sameDateBookingError",
            "ru": "Этот посетитель уже записан на данное время к другому врачу (проверьте время начала и окончания запланированных визитов). Рекомендуется выбрать другое время или посетителя.",
            "en": "This visitor is already scheduled for another doctor at this time (check the start and end time of scheduled visits). It is recommended to choose another time or visitor.",
            "be": "Гэты наведвальнік ужо запісаны на дадзены час да іншага лекара. Рэкамендуецца выбраць іншы час або наведвальніка."
        },
        {
            "id": "titles.sameDateBookingChangeDateError",
            "ru": "Этот посетитель уже записан на данное время к другому врачу (проверьте время начала и окончания запланированных визитов). Рекомендуется выбрать другое время.",
            "en": "This visitor is already scheduled for another doctor at this time (check the start and end time of scheduled visits). It is recommended to choose another time or visitor.",
            "be": "Гэты наведвальнік ужо запісаны на дадзены час да іншага лекара. Рэкамендуецца выбраць іншы час."
        },
        {
            "id": "buttons.chooseAnotherDate",
            "ru": "ВЫБРАТЬ ДРУГОЕ ВРЕМЯ",
            "en": "CHOOSE ANOTHER DATE",
            "be": "ВЫБРАЦЬ IНШУЮ ДАТУ"
        },
        {
            "id": "buttons.bookAnyway",
            "ru": "ВСЁ РАВНО ЗАПИСАТЬСЯ",
            "en": "BOOK ANYWAY",
            "be": "УСЁ РОЎНА ЗАПIСАЦЦА"
        },
        {
            "id": "titles.addYourInsurerLink",
            "ru": "Не нашли свою страховую программу?",
            "en": "Did not find your insurance program?",
            "be": "Не знайшлі сваю страхавую праграму?"
        },
        {
            "id": "titles.enterNameOfYourCompany",
            "ru": "Введите название своей страховой компании и работодателя",
            "en": "Enter the name of your insurance company and employer",
            "be": "Калі ласка, увядзіце назву сваёй страхавой кампаніі і працадаўца"
        },
        {
            "id": "titles.addInsurerCompanyMessage",
            "ru": "Спасибо!\nВаш запрос на добавление страховой программы отправлен.",
            "en": "Thanks!\nYour request to add an insurance program has been sent.",
            "be": "Дзякуй!\nВаш запыт на даданне страхавой праграмы адпраўлены."
        },
        {
            "id": "titles.layersSwitchStandard",
            "ru": "Стандарт",
            "en": "Standard",
            "be": "Стандарт"
        },
        {
            "id": "titles.layersSwitchSatellite",
            "ru": "Спутник",
            "en": "Satellite",
            "be": "Спадарожнік"
        },
        {
            "id": "titles.layersSwitchHybrid",
            "ru": "Гибрид",
            "en": "Hybrid",
            "be": "Гібрыд"
        },
        {
            "id": "titles.layers",
            "ru": "Слои карты",
            "en": "Map layers",
            "be": "Пласты карты"
        },
        {
            "id": "titles.errorAddDocuments",
            "ru": "Произошла ошибка при получении данных. Пожалуйста, проверьте разрешения приложения и попробуйте снова",
            "en": "An error occurred while retrieving data. Please check the app permissions and try again.",
            "be": "Адбылася памылка пры атрыманні дадзеных. Калі ласка, праверце дазволы прыкладання і паспрабуйце зноў"
        },
        {
            "id": "titles.todayToFormat",
            "ru": "Сегодня до {time}",
            "en": "Today, up to {time}",
            "be": "Сёння да {time}"
        },
        {
            "id": "titles.toFromFormat",
            "ru": "{day} с {firstTime} до {secondTime}",
            "en": "{day} from {firstTime} to {secondTime}",
            "be": "{day} з {firstTime} да {secondTime}"
        },
        {
            "id": "titles.monday",
            "ru": "Понедельник",
            "en": "Monday",
            "be": "панядзелак"
        },
        {
            "id": "titles.tuesday",
            "ru": "Вторник",
            "en": "Tuesday",
            "be": "аўторак"
        },
        {
            "id": "titles.wednesday",
            "ru": "Среда",
            "en": "Wednesday",
            "be": "серада"
        },
        {
            "id": "titles.thursday",
            "ru": "Четверг",
            "en": "Thursday",
            "be": "чацвер"
        },
        {
            "id": "titles.friday",
            "ru": "Пятница",
            "en": "Friday",
            "be": "пятніца"
        },
        {
            "id": "titles.saturday",
            "ru": "Суббота",
            "en": "Saturday",
            "be": "субота"
        },
        {
            "id": "titles.sunday",
            "ru": "Воскресенье",
            "en": "Sunday",
            "be": "нядзеля"
        },
        {
            "id": "titles.versionOnMap",
            "ru": "Вариант(ов) на карте",
            "en": "Option(s) on the map",
            "be": "Варыянт(аў) на карце"
        },
        {
            "id": "titles.TotalAmount",
            "ru": "Общая сумма",
            "en": "Total amount",
            "be": "Агульная сума"
        },
        {
            "id": "titles.shortMonday",
            "ru": "Пн",
            "en": "Mon",
            "be": "Пн"
        },
        {
            "id": "titles.shortTuesday",
            "ru": "Вт",
            "en": "Tue",
            "be": "Аўт"
        },
        {
            "id": "titles.shortWednesday",
            "ru": "Ср",
            "en": "Wed",
            "be": "Ср"
        },
        {
            "id": "titles.shortThursday",
            "ru": "Чт",
            "en": "Thu",
            "be": "ЧЦ"
        },
        {
            "id": "titles.shortFriday",
            "ru": "Пт",
            "en": "Fri",
            "be": "Пт"
        },
        {
            "id": "titles.shortSaturday",
            "ru": "Сб",
            "en": "Sat",
            "be": "Сб"
        },
        {
            "id": "titles.shortSunday",
            "ru": "Вс",
            "en": "Sun",
            "be": "Нд"
        },
        {
            "id": "titles.onlyDrugstoresWithAllDrugs",
            "ru": "Только аптеки с полным списком лекарств",
            "en": "Only pharmacies with a full list of drugs",
            "be": "Толькі аптэкі з поўным спісам лекаў"
        },
        {
            "id": "buttons.excellent",
            "ru": "ОТЛИЧНО!",
            "en": "EXCELLENT!",
            "be": "ВЫДАТНА!"
        },
        {
            "id": "titles.drugstoresCount",
            "ru": "{count} аптек(и)",
            "en": "{Count} pharmacies(s)",
            "be": "{Count} аптэк (і)"
        },
        {
            "id": "titles.doctorIs",
            "ru": "Врач {doctor}",
            "en": "Doctor {doctor}",
            "be": "Лекар {doctor}"
        },
        {
            "id": "titles.dateWithEmptyTime",
            "ru": "{date} в -:-",
            "en": "{date} at -:-",
            "be": "{date} у -:-"
        },
        {
            "id": "titles.activateProfile",
            "ru": "Для этого активируйте ваш профиль:",
            "en": "To do this, activate your profile:",
            "be": "Для гэтага актывуйце ваш профіль:"
        },
        {
            "id": "titles.nowCanManageVisits",
            "ru": "Теперь вы сможете управлять своими визитами в медцентры в режиме онлайн!",
            "en": "Now you can manage your visits to medical centers online!",
            "be": "Зараз вы зможаце кіраваць сваімі візітамі ў медцэнтры ў рэжыме анлайн!"
        },
        {
            "id": "titles.enterSignIn",
            "ru": "Нажмите «Вход» и введите номер телефона, который вы указали в медицинском центре",
            "en": "Click \"Login\" and enter the phone number you entered in the medical center",
            "be": "Націсніце \"Уваход\" і ўвядзіце нумар тэлефона, які вы паказалі ў медыцынскім цэнтры"
        },
        {
            "id": "titles.fillOutProfile",
            "ru": "Заполните Учетную карту корректными данными: ФИО и дата рождения",
            "en": "Fill out the registration cards with correct data: name and date of birth",
            "be": "Запоўніце уліковых карту карэктнымі дадзенымі: Прозвішча, імя і дата нараджэння"
        },
        {
            "id": "titles.addKids",
            "ru": "Добавьте детей в «Семью» к своему аккаунту",
            "en": "Add children to the \"My family\" to your account",
            "be": "Дадайце дзяцей у «Сям'ю» да свайго акаўнта"
        },
        {
            "id": "titles.onlyWithFeedbacks",
            "ru": "Только с отзывами",
            "en": "Only with feedback",
            "be": "Толькі з водгукамі"
        },
        {
            "id": "titles.fixedPrice",
            "ru": "{value} руб. ",
            "en": "{value} rubles.",
            "be": "{value} руб."
        },
        {
            "id": "titles.priceFromTo",
            "ru": "от {firstValue} до {secondValue} руб. ",
            "en": "from {firstValue} to {secondValue} rubles.",
            "be": "ад {firstValue} да {secondValue} руб."
        },
        {
            "id": "serviceMedcentersSort.byOnlineBooking",
            "ru": "По онлайн записи",
            "en": "By online booking",
            "be": "Па анлайн запісу"
        },
        {
            "id": "serviceMedcentersSort.withoutSort",
            "ru": "Без сортировки",
            "en": "Unsorted",
            "be": "Без сартавання"
        },
        {
            "id": "serviceMedcentersSort.byDoctorsCount",
            "ru": "По количеству докторов",
            "en": "By the number of doctors",
            "be": "Па колькасці дактароў"
        },
        {
            "id": "serviceMedcentersSort.byMedcenterName",
            "ru": "По названию медцентров",
            "en": "By the name of the medical centers",
            "be": "Па назве медцэнтраў"
        },
        {
            "id": "serviceMedcentersSort.byFeedbacks",
            "ru": "По количеству отзывов",
            "en": "By the number of reviews",
            "be": "Па колькасці водгукаў"
        },
        {
            "id": "serviceMedcentersSort.byPrice",
            "ru": "По цене",
            "en": "By price",
            "be": "Па цане"
        },
        {
            "id": "titles.params",
            "ru": "ПАРАМЕТРЫ",
            "en": "PARAMETERS",
            "be": "ПАРАМЕТРЫ"
        },
        {
            "id": "titles.date",
            "ru": "ДАТА",
            "en": "DATE",
            "be": "ДАТА"
        },
        {
            "id": "titles.time",
            "ru": "ВРЕМЯ",
            "en": "TIME",
            "be": "ЧАС"
        },
        {
            "id": "titles.convenientTime",
            "ru": "Наиболее удобное время визита",
            "en": "The most convenient time of the visit",
            "be": "Найбольш зручны час візіту"
        },
        {
            "id": "titles.yourProgram",
            "ru": "Ваша программа",
            "en": "Your program",
            "be": "Ваш кліент"
        },
        {
            "id": "titles.programInfo",
            "ru": "Бейдж и точка покажут, какие услуги входят в программу.",
            "en": "The badge and point will indicate which services are included in the program.",
            "be": "Бейдж і кропка пакажуць, якія паслугі ўваходзяць у праграму."
        },
        {
            "id": "titles.programInfoLimited",
            "ru": "Бейдж и точка покажут, какие услуги входят в программу, но имеют ограничения.",
            "en": "The badge and point will indicate which services are included in the program, but have restrictions.",
            "be": "Бейдж і кропка пакажуць, якія паслугі ўваходзяць у праграму, але маюць абмежаванні."
        },
        {
            "id": "link.see_terms_of_program",
            "ru": "Показать информацию о программе",
            "en": "Show information about the program",
            "be": "Паказаць інфармацыю аб праграме"
        },
        {
            "id": "error.fieldsAreRequired",
            "ru": "При выбранных опциях, выделенные поля являются обязательными.",
            "en": "With the selected options, the highlighted fields are mandatory.",
            "be": "Пры абраных опцыях, выдзеленыя поля з'яўляюцца абавязковымі."
        },
        {
            "id": "titles.successfulBooking",
            "ru": "Визит на {date} в {time} создан",
            "en": "Visit on {date} at {time} is created",
            "be": "Візіт на {date} у {time} створаны"
        },
        {
            "id": "titles.withoutProgramInfoText",
            "ru": "Вы можете воспользоваться поиском услуг, чтобы найти информацию: в каких медцентрах оказываются необходимые услуги и их стоимость.",
            "en": "You can use the service search to find information about which medical centers offer the necessary services and their costs.",
            "be": "Вы можаце скарыстацца пошукам паслуг, каб знайсці інфармацыю: у якіх медцэнтрах аказваюцца неабходныя паслугі і іх кошт."
        },
        {
            "id": "titles.addRelativesHint",
            "ru": "Добавьте детей/супуга (у), чтобы записывать их на прием к врачу. Также, присоедините к семье супруга(у) нажав на \"Мой код для присоединения к семье\" или \"Ввести код своего супруга(и)\", чтобы вы оба могли следить за визитами ваших детей, редактировать или переносить их.",
            "en": "Add children to schedule their appointments with the doctors. Also, join the family of the spouse by clicking on \"My code to join the family\" or \"Enter spouse code\" so both of you can track, edit, or reschedule your children's visits.",
            "be": "Дадайце дзяцей, каб запісваць іх на прыём да доктара. Таксама, далучыце да сям'і сваяка націснуўшы на \"Мой код для далучэння да сям'і\" ці \"Увесці код свайго сваяка (і)\", каб вы абодва маглі сачыць за візітамі вашых дзяцей, рэдагаваць або пераносіць іх."
        },
        {
            "id": "error.CONTRACT_MISSMATCH",
            "ru": "Данные из присоединяемого контракта '{name}' не соответствуют текущей учетной записи пользователя. Проверьте учетную запись/контракт.",
            "en": "Data from the merging of the contract '{name}' does not correspond to the current user account. Check account / contract.",
            "be": "Дадзеныя з далучаемага кантракту '{name}' не адпавядаюць цяперашняму ўліковаму запісу карыстальніка. Праверце ўліковы запіс / кантракт."
        },
        {
            "id": "buttons.edit_child",
            "ru": "Редактировать",
            "en": "Edit",
            "be": "Рэдагаваць"
        },
        {
            "id": "buttons.delete_child",
            "ru": "Удалить",
            "en": "Delete",
            "be": "Выдаліць"
        },
        {
            "id": "titles.delete_child",
            "ru": "Удалить ребенка?",
            "en": "Delete child?",
            "be": "Выдаліць дзіцяці?"
        },
        {
            "id": "screenTitles.EditChild",
            "ru": "Редактировать ребенка",
            "en": "Edit child",
            "be": "Рэдагаваць дзіцяці"
        },
        {
            "id": "titles.delete_child_hint",
            "ru": "Обратите внимание, что ребенок и связанные с ним визиты будут полностью удалены из системы (в том числе у второго супруга).",
            "en": "Please note that the child and related visits will be completely removed from the system (including for the other spouse).",
            "be": "Звярніце ўвагу, што дзіця і звязаныя з ім візіты будуць цалкам выдалены з сістэмы (у тым ліку ў сваяка)."
        },
        {
            "id": "titles.child_cannot_be_deleted",
            "ru": "Невозможно удалить запись. Необходимо отменить все запланированные визиты ребенка и повторить попытку.",
            "en": "It is impossible to delete the entry. Please cancel all scheduled visits for the child and try again.",
            "be": "Немагчыма выдаліць запіс. Неабходна адмяніць усе запланаваныя візіты дзіцяці і паўтарыць спробу."
        },
        {
            "id": "hints.ums_prices",
            "ru": "Указанные цены носят информационный характер.",
            "en": "The prices provided are for informational purposes.",
            "be": "Названыя цэны носяць інфармацыйны характар."
        },
        {
            "id": "titles.clean_options",
            "ru": "Очистить опции",
            "en": "Clear options",
            "be": "Ачысціць опцыі"
        },
        {
            "id": "placeholders.date_of_birth",
            "ru": "Дата рождения",
            "en": "Date of Birth",
            "be": "Дата нараджэння"
        },
        {
            "id": "titles.enter_date_of_birth",
            "ru": "Для подтверждения введите дату рождения:",
            "en": "To confirm, enter your date of birth:",
            "be": "Для пацверджання увядзіце дату нараджэння:"
        },
        {
            "id": "titles.bns_code",
            "ru": "Номер штрих-кода карты",
            "en": "Card number barcode",
            "be": "Нумар штрых-кода карты"
        },
        {
            "id": "titles.attention",
            "ru": "Внимание!",
            "en": "Attention!",
            "be": "Увага!"
        },
        {
            "id": "titles.finish_enroll_visit_hint",
            "ru": "Для завершения записи на визит к врачу вам необходимо зарегистрироваться или войти.",
            "en": "To complete scheduling an appointment with the doctor, you need to register or log in.",
            "be": "Для завяршэння запісу на візіт да лекара вам неабходна зарэгістравацца або ўвайсці ў сістэму."
        },
        {
            "id": "titles.registration",
            "ru": "регистрация/вход",
            "en": "Register/Login",
            "be": "рэгістрацыя/уваход"
        },
        {
            "id": "preEnrollVisit.forMe",
            "ru": "Мой визит",
            "en": "My appointment",
            "be": "Мой візіт"
        },
        {
            "id": "preEnrollVisit.forChild",
            "ru": "Визит для ребёнка",
            "en": "Appointment for child",
            "be": "Візіт для дзіцяці"
        },
        {
            "id": "preEnrollVisit.forRelative",
            "ru": "Визит для супруга/родителя",
            "en": "Appointment for spouse / parent",
            "be": "Візіт для мужа / аднаго з бацькоў"
        },
        {
            "id": "titles.no_visitor_error",
            "ru": "В вашем профиле отсутствуют пациенты, которых можно записать к этому врачу. Пожалуйста, выберите вариант \"Новый пациент\" для ввода информации о новом пациенте.",
            "en": "There are no patients in your profile who can be scheduled with this doctor. Please select the 'New patient' option to enter infrmation about a new patient.",
            "be": "У вашым профілі адсутнічаюць пацыенты, якіх можна запісаць да гэтага лекара. Калі ласка, абярыце варыянт \"Новы пацыент\" для ўводу інфармацыі аб новым пацыенце."
        },
        {
            "id": "titles.reload_app_warning",
            "ru": "Внимание! После смены языка приложение перезагрузится.",
            "en": "Attention! The app will be reloaded after changing the language.",
            "be": "Увага! Пасля змены мовы прыкладанне перазагрузіцца."
        },
        {
            "id": "titles.selectLanguage",
            "ru": "Выбрать язык",
            "en": "Select language",
            "be": "Выбраць мову"
        },
        {
            "id": "titles.doctor_takes",
            "ru": "Врач принимает:",
            "en": "Doctor is available for:",
            "be": "Лекар прымае:"
        },
        {
            "id": "preferredProfile.0",
            "ru": "Взрослых и детей",
            "en": "Adults and children",
            "be": "Дарослых і дзяцей"
        },
        {
            "id": "preferredProfile.1",
            "ru": "Взрослых",
            "en": "Adults",
            "be": "Дарослых"
        },
        {
            "id": "preferredProfile.2",
            "ru": "Детей",
            "en": "Children",
            "be": "Дзяцей"
        },
        {
            "id": "link.program_memo_link",
            "ru": "Памятка по работе с приложением",
            "en": "App usage guide",
            "be": "Памятка па рабоце з прыкладаннем"
        },
        {
            "id": "titles.consultation",
            "ru": "Консультация",
            "en": "Consultation",
            "be": "Кансультацыя"
        },
        {
            "id": "titles.specializations_section",
            "ru": "Специальности",
            "en": "Specialties",
            "be": "Спецыяльнасці"
        },
        {
            "id": "titles.medcenters_section",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "hints.no_matches_by_name",
            "ru": "Нет совпадений по ФИО",
            "en": "No matches by full name",
            "be": "Нічога не знойдзена па імя і прозвішчы"
        },
        {
            "id": "titles.perhaps_you_were_looking_for",
            "ru": "Возможно вы искали...",
            "en": "Perhaps you were looking for...",
            "be": "Магчыма вы шукалі..."
        },
        {
            "id": "titles.advanced_search",
            "ru": "Поиск по несистематизированным позициям",
            "en": "Search by unstructured positions",
            "be": "Пошук па несістэматызаваных пазіцыях"
        },
        {
            "id": "hints.advanced_search",
            "ru": "Поиск работает по полному названию.",
            "en": "Search operates by the full name.",
            "be": "Пошук працуе па поўным назве."
        },
        {
            "id": "titles.ums_filter_only_with_program",
            "ru": "Только входящие в программу",
            "en": "Only included in the program",
            "be": "Толькі ўваходныя ў праграму"
        },
        {
            "id": "titles.ums_filter_only_with_online",
            "ru": "Только с онлайн записью",
            "en": "Only with online-booking",
            "be": "Толькі з online запісам"
        },
        {
            "id": "titles.ums_filter_section_services",
            "ru": "Услуги",
            "en": "Services",
            "be": "Паслугі"
        },
        {
            "id": "titles.ums_filter_section_medcenters",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцэнтры"
        },
        {
            "id": "titles.ums_section",
            "ru": "Услуги",
            "en": "Services",
            "be": "Паслугі"
        },
        {
            "id": "screenTitles.UmsFilter",
            "ru": "Параметры",
            "en": "Parameters",
            "be": "Параметры"
        },
        {
            "id": "titles.choose_photo_from",
            "ru": "Выбор фото",
            "en": "Select photos",
            "be": "Выбар фота"
        },
        {
            "id": "buttons.from_gallery",
            "ru": "Из галереи",
            "en": "From the gallery",
            "be": "З галерэі"
        },
        {
            "id": "buttons.from_camera",
            "ru": "С камеры",
            "en": "With camera",
            "be": "З камеры"
        },
        {
            "id": "titles.relative_send_sms",
            "ru": "Отправить sms-код на номер телефона родственника",
            "en": "Send an SMS code to the relative's phone number",
            "be": "Адправіць sms-код на нумар тэлефона сваяка"
        },
        {
            "id": "titles.relative_send_sms_description",
            "ru": "Нажмите \"Отправить\", чтобы получить разрешение вашего родственника на добавление в Семью. Вы сможете записывать его к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Click \"Send\" to obtain your relative's permission to add to the Family. You will be able to schedule appointments for him, view medical information, edit and reschedule visits.",
            "be": "Націсніце \"Даслаць\", каб атрымаць дазвол вашага сваяка на даданне ў Сям'ю. Вы зможаце запісваць яго да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.relative_code_confirm",
            "ru": "Введите sms-код",
            "en": "Enter the SMS code",
            "be": "Увядзіце sms-код"
        },
        {
            "id": "titles.relative_code_confirm_description",
            "ru": "Введите sms-код, отправленный на номер телефона вашего родственника.",
            "en": "Enter the SMS code sent to your relative's phone number.",
            "be": "Увядзіце sms-код, адпраўлены на нумар тэлефона вашага сваяка."
        },
        {
            "id": "titles.SpouseAlreadyExists",
            "ru": "Родственник с такими данными уже добавлен в систему.",
            "en": "A relative with such data is already added to the system.",
            "be": "Сваяк з такімі дадзенымі ўжо дададзены ў сістэму."
        },
        {
            "id": "titles.SpouseAlreadyExistsDescription",
            "ru": "Объединитесь в Семью с супругом (ой). После этого, вы сможете записывать его (ее) к врачам, просматривать медицинскую информацию, редактировать и переносить визиты. Также, вы сможете разрешить супругу (е) записывать вас к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Join the Family with your spouse. After that, you will be ablee to schedule appointments for him (her), view medical information, edit and reschedule visits. Additionally, you can allow your spouse to schedule appoinments, view medical information, edit and reschedule visits.",
            "be": "Аб'яднайцеся ў сям'ю з мужам або жонкай. Пасля гэтага вы зможаце запісваць яе (яе) да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і адкладаць наведвання. Акрамя таго, вы зможаце дазволіць мужу або жонке запісваць вас да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і адкладаць наведвання."
        },
        {
            "id": "titles.newAdultRelatives",
            "ru": "{fullName} теперь в вашей семье. Учетная запись обозначена специальным зеленым бейджем. Это значит, вы можете записывать родственника к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "{fullName} is now part of your family. The account is marked with a special green badge, meaning you can schedule appointments for your relative, view medical information, edit and reshedule visits.",
            "be": "{fullName} цяпер у вашай сям'і. Уліковы запіс пазначаны спецыяльны зялёным бэйджам. Гэта значыць, вы можаце запісваць сваяка да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.pressAllow",
            "ru": "Нажмите Разрешить, чтобы {fullName} мог(ла)\nзаписывать вас к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Click Allow to allow {fullName} to\nbook you to doctors, view medical information, edit and reschedule visits.",
            "be": "Націсніце Дазволіць, каб {fullName} мог(ла)\nзапісваць вас да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.pressForbidden",
            "ru": "Нажмите Запретить, чтобы {fullName} не мог(ла) записывать вас к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Click Prohibit to prevent {fullName} from scheduling appointments for you, viewing medical information, and editing or rescheduling visits.",
            "be": "Націсніце Забараніць, каб {fullName} не мог(ла) запісваць вас да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "buttons.allow",
            "ru": "Разрешить",
            "en": "Allow",
            "be": "дазволіць"
        },
        {
            "id": "buttons.forbid",
            "ru": "Запретить",
            "en": "Prohibit",
            "be": "забараніць"
        },
        {
            "id": "error.relativeCodeValidationError",
            "ru": "Неверный код подтверждения. Пожалуйста, проверьте правильность ввода.",
            "en": "Invalid confirmation code. Please check the correctness of the input.",
            "be": "Няправільны код пацверджання. Калі ласка, праверце правільнасць ўводу."
        },
        {
            "id": "error.relativeWaitTilError",
            "ru": "Сейчас операция недоступна. Пожалуйста, попробуйте после {time}.",
            "en": "The operation is currently unavailable, please try again after {time}.",
            "be": "Зараз аперацыя недаступная, калі ласка, паспрабуйце пасля {time}."
        },
        {
            "id": "error.relativePhoneValidationError",
            "ru": "Введите реальный номер телефона родственника, медцентр будет использовать его для связи с пациентом.",
            "en": "Enter the real phone number of the relative. The medical center will use it to communicate with the patient.",
            "be": "Нельга дадаць сябе ў спіс сваіх сваякоў."
        },
        {
            "id": "error.relativeTryCountError",
            "ru": "Слишком много неверных попыток. Пожалуйста, запросите повторное sms-сообщенние.",
            "en": "Too many incorrect attempts. Please request a new SMS message.",
            "be": "Занадта шмат няслушных спроб. Калі ласка, запытаеце паўторнае sms-паведамленні."
        },
        {
            "id": "error.relativeInvalidData",
            "ru": "ФИО и/или день рождения не совпадают с существующим профилем для телефона {phone}. Обратитесь в поддержку.",
            "en": "The full name and/or date of birth do not match an existing profile for phone number {phone}. Please contact support.",
            "be": "Прозвішча, імя і дзень нараджэння не супадаюць з існуючым профілем для тэлефона {phone}. Звернецеся ў падтрымку."
        },
        {
            "id": "titles.delete_relative_hint",
            "ru": "Обратите внимание, что родственник и связанные с ним визиты будут полностью удалены из системы.",
            "en": "Please note that a relative and related visits will be completely removed from the system.",
            "be": "Звярніце ўвагу, што сваяк і звязаныя з ім візіты будуць цалкам выдалены з сістэмы."
        },
        {
            "id": "titles.delete_relative",
            "ru": "Удалить родственника?",
            "en": "Delete relative?",
            "be": "Выдаліць сваяка?"
        },
        {
            "id": "titles.relative_cannot_be_deleted",
            "ru": "Невозможно удалить запись. Необходимо отменить все запланированные визиты родственника и повторить попытку.",
            "en": "Unable to delete record.  Please cancel all scheduled visits for the relative and try again.",
            "be": "Немагчыма сцерці допіс. Неабходна адмяніць усе запланаваныя візіты сваяка і паўтарыць спробу."
        },
        {
            "id": "buttons.add_rel_program",
            "ru": "Добавить программу",
            "en": "Add program",
            "be": "Дадаць праграму"
        },
        {
            "id": "titles.allow_visits_management",
            "ru": "Разрешить управление визитами",
            "en": "Allow visit management",
            "be": "Дазволіць кіраванне візітамі"
        },
        {
            "id": "titles.forbid_visits_management",
            "ru": "Запретить управление визитами",
            "en": "Disable visit management",
            "be": "Забараніць кіраванне візітамі"
        },
        {
            "id": "titles.person_exist",
            "ru": "Пользователь с такими данными уже добавлен в систему. Обратитесь в поддержку, чтобы избежать дублирования: укажите, пожалуйста, номер телефона, с которым вошли в Aibolit и код ниже. ",
            "en": "A user with these data is already added to the system. Please contact support to avoid duplication: please provide the phone number you used to log into Aibolit and the code below.",
            "be": "Карыстальнік з такімі дадзенымі ўжо дададзены ў сістэму. Звярніцеся ў падтрымку, каб пазбегнуць дублявання: пазначце, калі ласка, нумар тэлефона, з якім ўвайшлі ў Aibolit і код ніжэй."
        },
        {
            "id": "titles.cannotAddEpamProgramToRelative",
            "ru": "Вы не можете привязать программу EPAM Health Care своему родственнику. ",
            "en": "You cannot link the EPAM Health Care program to your relative",
            "be": "Вы не можаце дадаць EPAM праграму сваяку"
        },
        {
            "id": "titles.cannotAddEpamProgramToRelativeHint",
            "ru": "Сотруднику компании необходимо зарегистрироваться в Aibolit самостоятельно и привязать программу EPAM. \nПосле этого необходимо «Объединиться в Семью с супругом (ой)». Вы сможете просматривать медицинскую информацию и управлять его (ее) визитами. Также, вы сможете разрешить супругу (е) просматривать вашу медицинскую информацию и управлять вашими визитами.\n\n«Объединиться в Семью» можно в разделе \"Моя Семья\", нажав на кнопку \"+\". Далее нужно нажать «ввести код супруга» или «Мой код для присоединения к семье»\n\nЧтобы избежать дублирования профилей при самостоятельной регистрации сотрудника EPAM, удалите карту только что добавленного супруга (и). ",
            "en": "The company employee needs to register in Aibolit independently and link the EPAM Health Care program. After that, it is necessary to \"Join the Family with spouse\". You will be able to view medical information and manage his (her) visits. Also, you can allow your spouse to view your medical information and manage your visits.\n\nYou can \"Join the Family\" in the \"My Family\" section by clicking on the \"+\" button. Then you need to press \"Enter spouse code\" or \"My code to join the family\"\n\nTo avoid profile duplication when registers independently as an EPAM employee, please delete the card of the spouse you just added.",
            "be": "Супрацоўніку кампаніі неабходна зарэгістравацца ў Aibolit самастойна і дадаць праграму EPAM.\nПасля гэтага неабходна «Аб'яднацца ў Сям'ю з мужам або жонкай». Вы зможаце праглядаць медыцынскую інфармацыю і кіраваць яго (яе) візітамі. Таксама, вы зможаце дазволіць жонке або мужу праглядаць вашу медыцынскую інфармацыю і кіраваць вашымі візітамі.\n\n«Аб'яднацца ў Сям'ю» можна ў раздзеле \"Мая Сям'я\", націснуўшы на кнопку \"\" + \"\". Далей трэба націснуць «ўвесці код сваяка» або «Мой код для далучэння да сям'і»\n\nКаб пазбегнуць дублявання профіляў пры самастойнай рэгістрацыі супрацоўніка EPAM, выдаліце ​​карту толькі што дададзенага сваяка.\n"
        },
        {
            "id": "screenTitles.EpamAddRelativeHint",
            "ru": "Назад",
            "en": "Back",
            "be": "Назад"
        },
        {
            "id": "titles.textWasCopied",
            "ru": "Текст успешно скопирован!",
            "en": "The text is successfully copied!",
            "be": "Тэкст паспяхова скапіяваны!"
        },
        {
            "id": "titles.notAllowedAnotherRelative",
            "ru": "Для того, чтобы добавить еще одного взрослого родственника, обратитесь в поддержку.",
            "en": "To add another adult relative, please contact support.",
            "be": "Для таго, каб дадаць яшчэ аднаго дарослага сваяка, звярніцеся ў падтрымку."
        },
        {
            "id": "titles.notAllowedAnotherSpouse",
            "ru": "Вы не можете добавить еще одного супруга.\nЕсли вы хотите поменять состав вашей семьи, обратитесь в поддержку.",
            "en": "You cannot add one more spouse.\nIf you want to change the composition of your family, please contact support.",
            "be": "Вы не можаце дадаць яшчэ аднаго мужа.\nКалі вы хочаце памяняць склад вашай сям'і, звярніцеся ў падтрымку."
        },
        {
            "id": "titles.notAllowedAnotherParent",
            "ru": "Для того, чтобы добавить еще одного родителя, обратитесь в поддержку.",
            "en": "To add another parent, please contact support.",
            "be": "Для таго, каб дадаць яшчэ аднаго з бацькоў, звярніцеся ў падтрымку."
        },
        {
            "id": "titles.RelativeBadgeHintAllow",
            "ru": "Вы можете записывать вашего Родственника к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "You can schedule appointments for your relative, view medical information, edit and reschedule visits.",
            "be": "Вы можаце запісваць вашага Сваяка да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.RelativeBadgeHintForbid",
            "ru": "Вы НЕ можете записывать вашего Родственника к врачам, просматривать медицинскую информацию, редактировать и переносить визиты.\nЧтобы получить разрешение вашего родственника, ему необходимо перейти в Учетную карту/Моя Семья/Ваша карточка и нажать Разрешить.",
            "en": "You cannot schedule appointments for your relative, view medical information, edit and reschedule visits. \nTo obtain permission from your relative, he needs to go to the My Account/My family/Your card and click 'Allow'.",
            "be": "Вы НЕ можаце запісваць вашага Сваяка да лекараў, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты.\nКаб атрымаць дазвол вашага сваяка, яму неабходна перайсці ў ўліковую картку / Мая Сям'я / Ваша картка і націснуць Дазволіць."
        },
        {
            "id": "titles.RelativeBadgePD",
            "ru": "В целях повышения безопасности в ряде случаев мы больше не сохраняем персональные данные детей на наших серверах. Они хранятся только на вашем устройстве и в медицинских центрах. После смены мобильного телефона эти данные необходимо ввести повторно. При заполнении для идентификации пациента можно использовать информацию о визитах и анализах.",
            "en": "To improve security, in some cases we no longer store children's personal information on our servers. They are only stored on your device and in health centers. After changing your mobile phone, this data must be entered again. When filling out, you can use information about visits and tests to identify the patient.",
            "be": "У мэтах павышэння бяспекі ў шэрагу выпадкаў мы больш не захоўваем персанальныя даныя дзяцей на нашых серверах. Яны захоўваюцца толькі на вашым прыладзе і ў медыцынскіх цэнтрах. Пасля змены мабільнага тэлефона гэтыя дадзеныя неабходна ўвесці паўторна. Пры запаўненні для ідэнтыфікацыі пацыента можна выкарыстоўваць інфармацыю аб візітах і аналізах."
        },
        {
            "id": "titles.designations",
            "ru": "Обозначения",
            "en": "Symbols",
            "be": "Абазначэння"
        },
        {
            "id": "titles.mother",
            "ru": "Мать",
            "en": "Mother",
            "be": "Маці"
        },
        {
            "id": "titles.father",
            "ru": "Отец",
            "en": "Father",
            "be": "Бацька"
        },
        {
            "id": "titles.wnRelatives",
            "ru": "У нас обновился раздел Моя Семья!",
            "en": "We have updated the My family section!",
            "be": "У нас абнавіўся раздзел Мая Сям'я!"
        },
        {
            "id": "titles.wnRelativesHint",
            "ru": "Теперь вы можете добавлять родителей и супругов, чтобы записывать их на прием к врачу, просматривать медицинскую информацию, редактировать и переносить визиты.",
            "en": "Now you can add parents and spouses to schedule their appointments with doctors, view medical information, edit and reschedule visits.",
            "be": "Цяпер вы можаце дадаваць бацькоў і мужоў, каб запісваць іх на прыём да лекара, праглядаць медыцынскую інфармацыю, рэдагаваць і пераносіць візіты."
        },
        {
            "id": "titles.notFoundBnsError",
            "ru": "Неправильный номер",
            "en": "Invorrect number",
            "be": "Няправільны нумар"
        },
        {
            "id": "titles.codeNoChildLinkageBnsError",
            "ru": "Нельзя привязывать программу ребёнка к своему профилю, такую программу нужно привязывать к профилю ребёнка в своей семье.",
            "en": "You cannot link the program of the child to your own profile, such a program should be linked to the child's profile withing your family.",
            "be": "Нельга прывязваць праграму дзіцяці да свайго профілю, такую ​​праграму трэба прывязваць да профілі дзіцяці ў сваёй сям'і."
        },
        {
            "id": "editUserAccount_birthday.placeholder",
            "ru": "Введите дату рождения",
            "en": "Enter your date of birth",
            "be": "Увядзіце дату рожения"
        },
        {
            "id": "editUserAccount_email.placeholder",
            "ru": "Введите ваш e-mail",
            "en": "Enter your e-mail",
            "be": "Увядзіце ваш e-mail"
        },
        {
            "id": "editUserAccount_firstName.placeholder",
            "ru": "Введите имя",
            "en": "Enter first name",
            "be": "Увядзіце імя"
        },
        {
            "id": "editUserAccount_lastName.placeholder",
            "ru": "Введите фамилию",
            "en": "Enter last name",
            "be": "Увядзіце прозвішча"
        },
        {
            "id": "editUserAccount_middleName.placeholder",
            "ru": "Введите отчество",
            "en": "Enter middle name",
            "be": "Увядзіце імя па бацьку"
        },
        {
            "id": "editUserAccount_sex.placeholder",
            "ru": "Введите ваш пол",
            "en": "Specify gender",
            "be": "Увядзіце ваш пол"
        },
        {
            "id": "editUserAccount.birthday",
            "ru": "ДАТА РОЖДЕНИЯ",
            "en": "DATE OF BIRTH",
            "be": "ДАТА НАРАДЖЭННЯ"
        },
        {
            "id": "editUserAccount.email",
            "ru": "ВАШ E-MAIL",
            "en": "YOUR E-MAIL",
            "be": "ВАШ E-MAIL"
        },
        {
            "id": "editUserAccount.firstName",
            "ru": "ИМЯ",
            "en": "FIRST NAME",
            "be": "ІМЯ"
        },
        {
            "id": "editUserAccount.lastName",
            "ru": "ФАМИЛИЯ",
            "en": "LAST NAME",
            "be": "ПРОЗВІШЧА"
        },
        {
            "id": "editUserAccount.middleName",
            "ru": "ОТЧЕСТВО",
            "en": "MIDDLE NAME",
            "be": "ІМЯ ПА БАЦЬКУ"
        },
        {
            "id": "editUserAccount.sex",
            "ru": "ПОЛ",
            "en": "GENDER",
            "be": "ПОЛ"
        },
        {
            "id": "titles.enterEmail",
            "ru": "     Добавьте email, чтобы иметь возможность восстановить доступ к своему аккаунту при смене мобильного устройства",
            "en": "     Add an email to be able to restore access to your account when you change your mobile device",
            "be": "     Дадайце email, каб мець магчымасць аднавіць доступ да свайго акаўнта"
        },
        {
            "id": "titles.choose_app",
            "ru": "Выберите приложение",
            "en": "Select an application",
            "be": "Выберыце дадатак"
        },
        {
            "id": "titles.open_app_failed",
            "ru": "Не удалось открыть приложение {name}",
            "en": "Could not open the {name} application",
            "be": "Не можа адкрыць {name}"
        },
        {
            "id": "buttons.on_map",
            "ru": "На карте",
            "en": "On the map",
            "be": "На карце"
        },
        {
            "id": "titles.in_reception",
            "ru": "В регистратуре",
            "en": "In the registry ",
            "be": "На прыёме"
        },
        {
            "id": "mcMapDetailsNavigation.ChooseDoctor",
            "ru": "Выбрать врача",
            "en": "Choose a doctor",
            "be": "Выбраць лекара"
        },
        {
            "id": "mcMapDetailsNavigation.MedCenterInfo",
            "ru": "Информация о медцентре",
            "en": "Information about the medical center",
            "be": "Інфармацыя пра медыцынскі цэнтр"
        },
        {
            "id": "mcMapDetailsNavigation.MedCenterFeedbacks",
            "ru": "Отзывы о медцентре",
            "en": "Feedback on the medical center",
            "be": "Водгукі аб медцэнтры"
        },
        {
            "id": "mcMapDetailsNavigation.MedCenterServices",
            "ru": "Услуги медцентра",
            "en": "Medical Center services",
            "be": "Паслугі медцэнтра"
        },
        {
            "id": "titles.online",
            "ru": "Онлайн",
            "en": "Online",
            "be": "Онлайн"
        },
        {
            "id": "titles.ofline",
            "ru": "Офлайн",
            "en": "Offline",
            "be": "Офлайн"
        },
        {
            "id": "titles.onlineConnectivityMessage",
            "ru": "Эта клиника поддерживает онлайн-запись",
            "en": "This clinic supports online appointments",
            "be": "Гэтая клініка падтрымлівае онлайн запіс."
        },
        {
            "id": "buttons.findAllPositions",
            "ru": "Найти все позиции",
            "en": "Find all items",
            "be": "Знайсці ўсе пазіцыі"
        },
        {
            "id": "titles.useFirstAidKit",
            "ru": "Добавляйте лекарства в аптечку для того, чтобы найти аптеки, где присутствуют сразу все нужные вам позиции",
            "en": "Add drugs to the first aid kit in order to find pharmacies where all the positions you need are at once.",
            "be": "Дадаць лекі ў аптэцы, каб знайсці аптэкі, дзе ўсе пазіцыі вам трэба адразу."
        },
        {
            "id": "titles.useFirstAidKitNonAuth",
            "ru": "Для возможности добавлять лекарства в аптечку необходимо авторизоваться",
            "en": "To be able to add medicines to the first-aid kit, you must log in.",
            "be": "Для магчымасці дадаваць лекі ў аптэку неабходна аўтарызавацца"
        },
        {
            "id": "buttons.remove",
            "ru": "Удалить профиль",
            "en": "Delete profile",
            "be": "Выдаліць профіль"
        },
        {
            "id": "titles.are_you_sure_remove_account",
            "ru": "Вы действительно хотите удалить все данные без возможности восстановления",
            "en": "Are you sure you want to delete all data permanently with no option for recovery?",
            "be": "Вы сапраўды жадаеце выдаліць усе дадзеныя без магчымасці аднаўлення"
        },
        {
            "id": "titles.if_you_remove_account",
            "ru": "Уважаемый пользователь, все данные о вашем профиле, включая настройки, закладки и историю визитов, будут удалены. Операция удаления затрагивает только платформу Aibolit, вся информация о пациенте, его визитах и консультативных заключениях на стороне клиники остается неизменной.",
            "en": "Dear user, all data related to your profile, including settings, bookmarks and visit history, will be deleted. The deletion only affects the Aibolit platform, all information about the patient, his visits and advisory opinions on the side of the clinic remain unchanged.",
            "be": "Паважаны карыстальнік, усе дадзеныя аб вашым профілі, у тым ліку налады, закладкі і гісторыю візітаў, будуць выдаленыя. Аперацыя выдалення закранае толькі платформу Aibolit, уся інфармацыя аб пацыенце, яго візітах і кансультатыўных заключэннях на баку клінікі застаецца нязменнай."
        },
        {
            "id": "titles.removeAccount",
            "ru": "Удаление профиля",
            "en": "Delete profile",
            "be": "Выдаленне профілю"
        },
        {
            "id": "titles.personalData",
            "ru": "ПЕРСОНАЛЬНЫЕ ДАННЫЕ",
            "en": "PERSONAL DATA",
            "be": "ПЕРСАНАЛЬНЫЯ ДАДЗЕНЫЯ"
        },
        {
            "id": "screenTitles.AccountRemove",
            "ru": "Удаление профиля",
            "en": "Delete profile",
            "be": "Выдаленне профілю"
        },
        {
            "id": "titles.childDataAgreement",
            "ru": "Я даю {согласие на обработку персональных данных ребенка::links.childDataLink}",
            "en": "I give {consent to the processing of the child’s personal data::links.childDataLink}",
            "be": "Я даю {згоду на апрацоўку персанальных дадзеных дзіцяці::links.childDataLink}"
        },
        {
            "id": "links.childDataLink",
            "ru": "https://aibolit.by/personal-data-processing-agreement-child",
            "en": "https://aibolit.by/personal-data-processing-agreement-child",
            "be": "https://aibolit.by/personal-data-processing-agreement-child"
        },
        {
            "id": "titles.personalDataAgreement",
            "ru": "Я даю {согласие на обработку моих персональных данных::links.personalDataLink}",
            "en": "I give {consent to the processing of my personal data::links.personalDataLink}",
            "be": "Я даю {згоду на апрацоўку маіх персанальных дадзеных::links.personalDataLink}"
        },
        {
            "id": "links.personalDataLink",
            "ru": "https://aibolit.by/pdp",
            "en": "https://aibolit.by/pdp",
            "be": "https://aibolit.by/pdp"
        },
        {
            "id": "links.user_agreement",
            "ru": "https://aibolit.by/user-agreement",
            "en": "https://aibolit.by/user-agreement",
            "be": "https://aibolit.by/user-agreement"
        },
        {
            "id": "links.privacy",
            "ru": "https://aibolit.by/privacy",
            "en": "https://aibolit.by/privacy",
            "be": "https://aibolit.by/privacy"
        },
        {
            "id": "titles.userAgreement",
            "ru": "Я принимаю {условия пользовательского соглашения::links.user_agreement} и {политику конфиденциальности::links.confidential}",
            "en": "I accept the {Terms of User Agreement::links.user_agreement} and {Privacy Policy::links.confidential}",
            "be": "Я прымаю {ўмовы карыстацкай дамовы::links.user agreement} і {палітыку канфідэнцыяльнасьці::links.confidential}"
        },
        {
            "id": "buttons.confirmAgreements",
            "ru": "ПОДТВЕРЖДАЮ",
            "en": "CONFIRM",
            "be": "ПАДЦЯРЖВАЮ"
        },
        {
            "id": "links.confidential",
            "ru": "https://aibolit.by/privacy",
            "en": "https://aibolit.by/privacy",
            "be": "https://aibolit.by/privacy"
        },
        {
            "id": "titles.agreementsComment"
        },
        {
            "id": "titles.confirmationEmail",
            "ru": "Подтверждение e-mail",
            "en": "Email confirmation",
            "be": "Пацвярджэнне e-mail"
        },
        {
            "id": "titles.personalDataConfirmHint",
            "ru": "Необходимо подтвердить доступ к данным. Запрос выслан на \"{email}\".",
            "en": "Access to the data needs to be confirmed. The request is sent to \"{email}\".",
            "be": "Вы павінны пацвердзіць доступ да дадзеных. Запыт адпраўляецца ў «{Email}»."
        },
        {
            "id": "titles.personalDataConfirmTitle",
            "ru": "Необходима проверка доступа",
            "en": "Access verification is required",
            "be": "Неабходна праверыць доступ"
        },
        {
            "id": "titles.personalDataConfirmSubtitle",
            "ru": "Пожалуйста, подтвердите возможность доступа к своим персональным данным.",
            "en": "Please confirm your ability to access your personal data.",
            "be": "Калі ласка, пацвердзіце магчымасць доступу да вашых асабістых дадзеных."
        },
        {
            "id": "buttons.openProfile",
            "ru": "ОТКРЫТЬ ПРОФИЛЬ",
            "en": "OPEN PROFILE",
            "be": "АДКРЫЦЬ ПРОФIЛЬ"
        },
        {
            "id": "titles.inAppUpdateTitle",
            "ru": "Проверка обновления",
            "en": "Check for updates",
            "be": "Праверка абнаўлення"
        },
        {
            "id": "titles.haveNewVersion",
            "ru": "Доступна новая версия Aibolit",
            "en": "New version of Aibolit available",
            "be": "Даступная новая версія Aibolit"
        },
        {
            "id": "buttons.update",
            "ru": "Обновить приложение",
            "en": "Update the App",
            "be": "Абнавіць дадатак"
        },
        {
            "id": "titles.outdatedVersionTitle",
            "ru": "Неподдерживаемая версия",
            "en": "Unsupported version",
            "be": "Непадтрымліваемая версія"
        },
        {
            "id": "titles.outdatedVersionMessage",
            "ru": "Вы пользуетесь неподдерживаемой версией приложения, необходимо обновление",
            "en": "You are using an unsupported version of the application, an update is required",
            "be": "Вы карыстаецеся непадтрымліваемай версіяй прыкладання, неабходна абнаўленне"
        },
        {
            "id": "titles.positiveFeedbackModal",
            "ru": "Рекомендую этого врача ",
            "en": "I recommend this doctor",
            "be": "Рэкамендую гэтага лекара"
        },
        {
            "id": "titles.neutralFeedbackModal",
            "ru": "Все хорошо / нейтрально ",
            "en": "Good / Neutral",
            "be": "Усё добра / нейтральна"
        },
        {
            "id": "titles.negativeFeedbackModal",
            "ru": "Не рекомендую этого врача ",
            "en": "I do not recommend this doctor",
            "be": "Не рэкамендую гэтага лекара"
        },
        {
            "id": "titles.notConfirmedFeedbackModal",
            "ru": "Прием не подтвержден",
            "en": "Visit not confirmed",
            "be": "Прыём не пацверджаны"
        },
        {
            "id": "titles.positiveFeedbackExplainModal",
            "ru": "Хороший врач, я готов(а) рекомендовать этого врача своим коллегам, друзьям, знакомым и другим пользователям",
            "en": "Good doctor, I am ready to recommend this doctor to my colleagues, friends, acquaintances and other users",
            "be": "Добры лекар, я гатовы(ая) рэкамендаваць гэтага лекара сваім калегам, сябрам, знаёмым і іншым карыстальнікам"
        },
        {
            "id": "titles.negativeFeedbackExplainModal",
            "ru": "Не рекомендую другим пользователям обращаться к данному врачу",
            "en": "I do not recommend other users to visit this doctor",
            "be": "Не рэкамендую іншым карыстальнікам звяртацца да гэтага лекара"
        },
        {
            "id": "titles.neutralFeedbackExplainModal",
            "ru": "В целом все прошло хорошо/нейтрально, но пока не готов(а) рекомендовать этого врача другим пользователям ",
            "en": "Overall, everything went well/neutral, but I'm not ready to recommend this doctor to other users",
            "be": "Усё прайшло добра/нейтральна, але пакуль не гатовы(а) рэкамендаваць гэтага лекара іншым карыстальнікам"
        },
        {
            "id": "titles.notConfirmedFeedbackExplainModal",
            "ru": "У нас пока нет информации о том, что пользователь был на приеме у данного врача",
            "en": "We currently have no information that the user has visited this doctor",
            "be": "У нас пакуль няма інфармацыі аб тым, што карыстальнік быў на прыёме ў дадзенага лекара"
        },
        {
            "id": "titles.positiveFeedbackShort",
            "ru": "Рекомендую",
            "en": "I recommend",
            "be": "Рэкамендую"
        },
        {
            "id": "titles.neutralFeedbackShort",
            "ru": "Все хорошо / нейтрально",
            "en": "Good / Neutral",
            "be": "Усё добра / нейтральна"
        },
        {
            "id": "titles.negativeFeedbackShort",
            "ru": "Не рекомендую ",
            "en": "I do not recommend",
            "be": "Не рэкамендую"
        },
        {
            "id": "titles.positiveFeedbackShortQty",
            "ru": "Рекомендую ({Qty})",
            "en": "I recommend ({Qty})",
            "be": "Рэкамендую ({Qty})"
        },
        {
            "id": "titles.neutralFeedbackShortQty",
            "ru": "Все хорошо / нейтрально ({Qty})",
            "en": "Good / Neutral ({Qty})",
            "be": "Усё добра / нейтральна ({Qty})"
        },
        {
            "id": "titles.negativeFeedbackShortQty",
            "ru": "Не рекомендую ({Qty})",
            "en": "I do not recommend ({Qty})",
            "be": "Не рэкамендую ({Qty})"
        },
        {
            "id": "titles.notConfirmedFeedbackShort",
            "ru": "Прием не подтвержден ",
            "en": "Visit not confirmed ",
            "be": "Прыём не пацверджаны"
        },
        {
            "id": "titles.recommendationHeader",
            "ru": "Поделитесь впечатлениями о враче",
            "en": "Share your impressions about the doctor",
            "be": "Падзяліцеся ўражаннямі аб лекары"
        },
        {
            "id": "titles.recommendationText",
            "ru": "Ваша обратная связь поможет другим пользователям сделать правильный выбор",
            "en": "Your feedback will help other users make the right choice",
            "be": "Ваша зваротная сувязь дапаможа іншым карыстальнікам зрабіць правільны выбар"
        },
        {
            "id": "titles.positiveFeedbackExplain",
            "ru": "Хороший врач, я готов(а) рекомендовать этого врача своим коллегам, друзьям, знакомым и другим пользователям",
            "en": "Good doctor, I am ready to recommend this doctor to my colleagues, friends, acquaintances and other users",
            "be": "Добры лекар, я гатовы(ая) рэкамендаваць гэтага лекара сваім калегам, сябрам, знаёмым і іншым карыстальнікам"
        },
        {
            "id": "titles.positiveFeedback",
            "ru": "Рекомендую этого врача",
            "en": "I recommend this doctor",
            "be": "Рэкамендую гэтага лекара"
        },
        {
            "id": "titles.neutralFeedback",
            "ru": "Все хорошо / нейтрально",
            "en": "Good / Neutral",
            "be": "Усё добра / нейтральна"
        },
        {
            "id": "titles.negativeFeedback",
            "ru": "Не рекомендую этого врача",
            "en": "I do not recommend this doctor",
            "be": "Не рэкамендую гэтага лекара"
        },
        {
            "id": "titles.negativeFeedbackExplain",
            "ru": "Не рекомендую другим пользователям обращаться к данному врачу",
            "en": "I do not recommend other users to visit this doctor",
            "be": "Не рэкамендую іншым карыстальнікам звяртацца да гэтага лекара"
        },
        {
            "id": "titles.neutralFeedbackExplain",
            "ru": "В целом все прошло хорошо/нейтрально, но пока не готов(а) рекомендовать этого врача другим пользователям ",
            "en": "Overall, everything went well/neutral, but I'm not ready to recommend this doctor to other users",
            "be": "Усё прайшло добра/нейтральна, але пакуль не гатовы(а) рэкамендаваць гэтага лекара іншым карыстальнікам"
        },
        {
            "id": "titles.notConfirmedFeedbackExplain",
            "ru": "Прием не подтвержден",
            "en": "Visit not confirmed",
            "be": "Прыём не пацверджаны"
        },
        {
            "id": "titles.feedbackDescriptionBigText",
            "ru": "Опишите подробнее",
            "en": "Describe in more detail",
            "be": "Апішыце падрабязней"
        },
        {
            "id": "titles.feedbackDescriptionSmallText",
            "ru": "(не обязательно)",
            "en": "(not necessary)",
            "be": "(не абавязкова)"
        },
        {
            "id": "titles.noVotes",
            "ru": "Нет голосов",
            "en": "No votes",
            "be": "Няма галасоў"
        },
        {
            "id": "titles.countVotes",
            "ru": "(из {countVotes})",
            "en": "(out of {countVotes})",
            "be": "(з {countVotes})"
        },
        {
            "id": "titles.feedbackChartHeader",
            "ru": "Рекомендации",
            "en": "Recommendations",
            "be": "Рэкамендацыі"
        },
        {
            "id": "titles.feedbacksHowTo",
            "ru": "Как мы работаем с рекомендациями и отзывами",
            "en": "How we work with recommendations and feedback",
            "be": "Як мы працуем з рэкамендацыямі і водгукамі"
        },
        {
            "id": "titles.firstFeedbacks",
            "ru": "Собираем первые рекомендации",
            "en": "We are gathering the first recommendations",
            "be": "Збіраем першыя рэкамендацыі"
        },
        {
            "id": "titles.yourFeedback",
            "ru": "Ваш отзыв",
            "en": "Your feedback",
            "be": "Ваш водгук"
        },
        {
            "id": "titles.all",
            "ru": "Все",
            "en": "All",
            "be": "Усе"
        },
        {
            "id": "titles.allQty",
            "ru": "Все ({Qty})",
            "en": "All ({Qty})",
            "be": "Усе ({Qty})"
        },
        {
            "id": "titles.cannotAddFeedback",
            "ru": "Вы не можете оставить отзыв на врача, пока не сходили к нему на прием",
            "en": "You cannot leave a feedback for the doctor until you have visited them for an appointment.",
            "be": "Вы не можаце пакінуць водгук на лекара, пакуль не схадзілі да яго на прыём"
        },
        {
            "id": "titles.howToFeedbacksTitle",
            "ru": "Только достоверные отзывы и рекомендации",
            "en": "Only reliable feedback and recommendations",
            "be": "Толькі дакладныя водгукі і рэкамендацыі"
        },
        {
            "id": "titles.howToFeedbacksText",
            "ru": "Основная задача Aibolit – помочь каждому пользователю выбрать наиболее подходящего специалиста. Отзывы и рекомендации – это обратная связь от реальных людей, основанная на практическом опыте. \n\nКаждый отзыв состоит из рекомендации и текста (необязательное поле). После приема мы предлагаем поделиться мнением о готовности рекомендовать врача другим пользователями. Если отзыв не анонимный, публикуется имя автора и первая буква фамилии. \n\nЕсли пользователь является участником какой-либо Health Care программы – на отзыве будет отображаться соответствующий бейдж. Бейджи могут видеть только участники такой же программы. \n\nAibolit уделяет особое внимание достоверности публикуемой информации. Мы проверяем каждый факт приема у врача. Если у нас нет информации, подтверждающей состоявшийся прием, такой отзыв будет располагаться в конце списка и будет отмечен тегом \"Прием не подтвержден\". Оставленная рекомендация в таком случае не будет засчитана в общий список голосов. \n\nОтзывы могут оставлять только зарегистрированные пользователи. Если врач работает в медцентре с возможностью онлайн записи, добавление рекомендации возможно только после посещения специалиста. Таким образом, все отзывы, у которых отсутствует тег \"Прием не подтвержден\", могут считаться достоверными, т.к. были оставлены пользователями, которые действительно были на приеме у данного врача.",
            "en": "The main goal of Aibolit is to help each user find the right specialist. Feedback and recommendations are a source of information that is based on practical experience of other people.\n\nEach feedback consists of a recommendation and free text (optional). After the appointment, we suggest you share your impression about your willingness to recommend the doctor to other users.\n\nIf feedback is not anonymous then author's first name and first letter of last name are published.\nIf the user belongs to some Health Care program, the corresponding badge will be displayed on the review. Badges are only visible to other participants of the same program.\nAibolit pays special attention to the reliability of the collected information. We check every fact of the doctor's appointment. If we don’t have information that the visit took place then the feedback will be placed into the end of list with tag \"Visit is not confirmed\". Recommendation will not be considered in votes calculation.\n\nFeedback could be left only by registered user. If the doctor works in clinic that support online booking, then feedback could be left only after visiting of corresponding doctor.\n\nTherefore, all feedback without \"Visit is not confirmed\" tag could be considered as reliable because it is left by real user who had a visit to that doctor.",
            "be": "Асноўная мэта Aibolit – дапамагчы кожнаму карыстальніку знайсці найбольш прыдатнага спецыяліста. Водгукі і рэкамендацыі – гэта зваротная сувязь ад рэальных людзей, заснаваная на практычным досведзе.\r\n\r\nКожны водгук складаецца з рэкамендацыі і тэкста (неабавязковае поле). Пасля прыёму мы прапануем падзяліцца меркаваннем аб гатоўнасці параіць лекара іншым карыстальнікам.\r\n\r\nКалі водгук не ананімны, публікуецца імя аўтара і першая літара прозвішча.\r\n\r\nКалі карыстальнік з'яўляецца ўдзельнікам якой-небудзь Health Care праграмы на водгуку будзе адлюстроўвацца адпаведны бэйдж. Бэйджы могуць бачыць толькі іншыя ўдзельнікі такой самай праграмы.\r\n\r\nAibolit надае адмысловую ўвагу дакладнасці збіранай інфармацыі. Мы правяраем кожны факт прыёму лекара. Калі ў нас няма інфармацыі, якая пацвярджае праведзены прыём, такі водгук будзе размяшчацца ў канцы спісу і будзе адзначаны тэгам \"Прыём не пацверджаны\", пакінутая рэкамендацыя ў такім выпадку не будзе залічана ў агульны спіс галасоў.\r\n\r\nВодгукі могуць пакідаць толькі зарэгістраваныя карыстальнікі. Калі лекар працуе ў медцэнтры, з магчымасцю анлайн запісу, даданне рэкамендацыі магчыма толькі пасля наведвання гэтага лекара.\r\n\r\nТакім чынам, усе водгукі, у якіх адсутнічае тэг \"Прыём не пацверджаны\", могуць лічыцца дакладнымі, бо былі пакінуты карыстальнікамі, якія сапраўды былі на прыёме ў дадзенага лекара."
        },
        {
            "id": "titles.findInDrugStores",
            "ru": "ИСКАТЬ В АПТЕКАХ",
            "en": "SEARCH IN PHARMACIES",
            "be": "Шукаць у аптэках"
        },
        {
            "id": "titles.loadingData",
            "ru": "ИДЕТ ЗАГРУЗКА ДАННЫХ...",
            "en": "LOADING DATA...",
            "be": "ІДЗЕ ЗАГРУЗКА ДАНЫХ..."
        },
        {
            "id": "titles.testsStatusInProgress",
            "ru": "В работе",
            "en": "In progress",
            "be": "У працы"
        },
        {
            "id": "titles.testsStatusReady",
            "ru": "Готово",
            "en": "Ready",
            "be": "Гатова"
        },
        {
            "id": "titles.testsResults",
            "ru": "Результаты",
            "en": "Results",
            "be": "Вынікі"
        },
        {
            "id": "titles.testsFilter",
            "ru": "Отбор анализов по статусу",
            "en": "Selection of analyzes by status",
            "be": "Адбор аналізаў па статусе"
        },
        {
            "id": "titles.forClinicVisits",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медыцынскія цэнтры"
        },
        {
            "id": "titles.anyClinics",
            "ru": "Все медцентры",
            "en": "All medical centers",
            "be": "Усе медцэнтры"
        },
        {
            "id": "titles.enter_acode_hint",
            "ru": "Для доступа к медицинской документации введите дополнительный А-код, который можно получить в регистратуре медицинского центра \"{branchName}\" (формат XXXXXX).",
            "en": "Enter the additional A-code that can be received at the reception of the medical center to access medical records \"{branchName}\"(XXXXX format).",
            "be": "Для доступу да медыцынскай дакументацыі ўвядзіце дадатковы А-код, які можна атрымаць у рэгістратуры медыцынскага цэнтра \"{branchName}\"(фармат XXXXX)."
        },
        {
            "id": "error.wrongFormat",
            "ru": "Неверный формат",
            "en": "Wrong format",
            "be": "Няправільны фармат"
        },
        {
            "id": "titles.scanFingerprint",
            "ru": "Чтобы продолжить отсканируйте отпечаток пальца",
            "en": "To proceed, please scan your fingerprint.",
            "be": "Каб працягнуць сканаванне адбіткаў пальцаў"
        },
        {
            "id": "titles.settings",
            "ru": "Настройки",
            "en": "Settings",
            "be": "Налады"
        },
        {
            "id": "titles.chooseConfirmationMethod",
            "ru": "Выберите способ подтверждения: ",
            "en": "Choose a confirmation method:",
            "be": "Выберыце метад пацверджання:"
        },
        {
            "id": "confirmSettingsFaceID.code",
            "ru": "А-код",
            "en": "A-code",
            "be": "А-код"
        },
        {
            "id": "confirmSettingsFaceID.face",
            "ru": "Биометрические данные",
            "en": "Biometric data",
            "be": "Біяметрычныя дадзеныя"
        },
        {
            "id": "confirmSettingsTouchID.code",
            "ru": "А-код",
            "en": "A-code",
            "be": "А-код"
        },
        {
            "id": "confirmSettingsTouchID.touch",
            "ru": "Биометрические данные",
            "en": "Biometric data",
            "be": "Біяметрычныя дадзеныя"
        },
        {
            "id": "confirmSettingsBiometrics.code",
            "ru": "А-код",
            "en": "A-code",
            "be": "А-код"
        },
        {
            "id": "confirmSettingsBiometrics.fingerprint",
            "ru": "Биометрические данные",
            "en": "Biometric data",
            "be": "Біяметрычныя дадзеныя"
        },
        {
            "id": "confirmSettingsBio.code",
            "ru": "А-код",
            "en": "A-code",
            "be": "А-код"
        },
        {
            "id": "bio.NO_ENROLL",
            "ru": "Чтобы использовать биометрические данные, вы должны сначала зарегистрировать их",
            "en": "To use biometric data, you must first register it.",
            "be": "Каб выкарыстоўваць біяметрычныя дадзеныя, іх трэба спачатку зарэгістраваць"
        },
        {
            "id": "bio.NO_BIO",
            "ru": "Нет биометрических датчиков",
            "en": "No biometric sensors",
            "be": "Няма біяметрычных датчыкаў"
        },
        {
            "id": "bio.ERROR_BIO",
            "ru": "Ошибка проверки биометрии",
            "en": "Boimetric verification error",
            "be": "Памылка праверкі біяметрыі"
        },
        {
            "id": "confirmSettingsBio.bio",
            "ru": "Биометрические данные",
            "en": "Biometric data",
            "be": "Біяметрычныя дадзеныя"
        },
        {
            "id": "confirmSettings.code",
            "ru": "А-код",
            "en": "A-code",
            "be": "А-код"
        },
        {
            "id": "confirmSettings.fingerprint",
            "ru": "Биометрические данные",
            "en": "Biometric data",
            "be": "Біяметрычныя дадзеныя"
        },
        {
            "id": "notes.you_have_no_reports",
            "ru": "Просмотр отчетов будет доступен сразу после авторизации.",
            "en": "Viewing reports will be available immediately after authorization.",
            "be": "Прагляд справаздач будзе даступны адразу пасля аўтарызацыі."
        },
        {
            "id": "notes.you_have_no_tests",
            "ru": "Просмотр анализов будет доступен сразу после авторизации.",
            "en": "Viewing tests will be available immediately after authorization.",
            "be": "Прагляд аналізаў будзе даступны адразу пасля аўтарызацыі."
        },
        {
            "id": "titles.anyDoctors",
            "ru": "Все врачи",
            "en": "All doctors",
            "be": "Усе лекары"
        },
        {
            "id": "titles.anySpeciality",
            "ru": "Все специальности",
            "en": "All specialties",
            "be": "Усе спецыяльнасці"
        },
        {
            "id": "titles.forDoctorVisits",
            "ru": "Врачи",
            "en": "Doctors",
            "be": "Лекары"
        },
        {
            "id": "titles.anyStatuses",
            "ru": "Все статусы",
            "en": "All statuses",
            "be": "Усе статуты"
        },
        {
            "id": "titles.forStatusesTests",
            "ru": "Статусы",
            "en": "Statuses",
            "be": "Статусы"
        },
        {
            "id": "titles.forClinicsTests",
            "ru": "Медцентры",
            "en": "Medical centers",
            "be": "Медцентры"
        },
        {
            "id": "titles.forWhomTests",
            "ru": "Для кого анализы",
            "en": "Who are the tests for?",
            "be": "Для каго аналізы"
        },
        {
            "id": "titles.forDoctorSpeciality",
            "ru": "Специальность врача",
            "en": "Doctor's specialty",
            "be": "Спецыяльнасць урача"
        },
        {
            "id": "screenTitles.TestsFilter",
            "ru": "Анализы",
            "en": "Tests",
            "be": "Аналізы"
        },
        {
            "id": "statuses.inProgress",
            "ru": "В работе",
            "en": "Work in progress",
            "be": "У працы"
        },
        {
            "id": "statuses.ready",
            "ru": "Готово",
            "en": "Ready",
            "be": "Гатова"
        },
        {
            "id": "titles.my_test",
            "ru": "Мой анализ",
            "en": "My tests",
            "be": "Мой аналіз"
        },
        {
            "id": "titles.fileSavedIn",
            "ru": "Файл сохранен в '{path}'",
            "en": "The file is saved in '{path}'",
            "be": "Файл захоўваецца ў '{path}'"
        },
        {
            "id": "titles.testsResultsQty",
            "ru": "Результаты ({qty})",
            "en": "Results ({qty})",
            "be": "Вынікі ({qty})"
        },
        {
            "id": "titles.severalResults",
            "ru": "Несколько результатов",
            "en": "Several results",
            "be": "Некалькі вынікаў"
        },
        {
            "id": "titles.severalResultsHint",
            "ru": "Пожалуйста, выберите результат, который вы бы хотели посмотреть.",
            "en": "Please choose the result you would like to see.",
            "be": "Калі ласка, абярыце вынік, які вы хацелі б бачыць."
        },
        {
            "id": "titles.resultNumber",
            "ru": "Результат анализа №{index}",
            "en": "Test result No.{index}",
            "be": "Вынік аналізу №{index}"
        },
        {
            "id": "titles.YouRecommendation",
            "ru": "Ваш отзыв",
            "en": "Your feedback",
            "be": "Ваш водгук"
        },
        {
            "id": "titles.AddRateAfterVisit",
            "ru": "Мы не нашли прием у данного врача в истории ваших визитов. Вы сможете оставить отзыв после того, как сходите на прием.",
            "en": "We did not find an appointment with this doctor in your history of visits. You'll be able to leave a review after you've had an appointment.",
            "be": "Мы не знайшлі прыём у дадзенага лекара ў гісторыі вашых візітаў. Вы зможаце пакінуць водгук на лекара, калі схадзіце да яго на прыём"
        },
        {
            "id": "titles.fillProfileSyncHint",
            "ru": "Заполните ваш профиль для возможности загрузки визитов из клиники: ",
            "en": "Please complete your profile to be able to download clinic visits: ",
            "be": "Запоўніце ваш профіль для магчымасці загрузкі візітаў у клініку: "
        },
        {
            "id": "titles.fillProfileSyncLink",
            "ru": "заполнить",
            "en": "fill in",
            "be": "запаўняць"
        },
        {
            "id": "titles.fillProfileHint",
            "ru": "Заполните ваш профиль для записи к врачам: ",
            "en": "Fill in your profile to schedule appointments with doctors: ",
            "be": "Запоўніце свой профіль для запісу да лекараў: "
        },
        {
            "id": "titles.fillProfileLink",
            "ru": "заполнить",
            "en": "fill in",
            "be": "запаўняць"
        },
        {
            "id": "titles.emptyMyFeedback",
            "ru": "Отзыв не содержит текстовой информации. Вы можете отредактировать его, чтобы подробнее описать свой опыт.",
            "en": "The feedback does not contain any text. You can edit it to describe your experience in more detail.",
            "be": "Адзыў не змяшчае тэкставай інфармацыі. Вы можаце адрэдагаваць яго, каб падрабязней апісаць свой вопыт."
        },
        {
            "id": "titles.loadVisitsHint",
            "ru": "Если у вас есть будущие или прошедшие визиты, загрузите информацию о них из клиники: ",
            "en": "If you have future or past visits, please upload information about them from the clinic:",
            "be": "Калі ў вас ёсць будучыя або прайшлі візіты, загружайце інфармацыю пра іх з клінік:"
        },
        {
            "id": "titles.loadVisitsLink",
            "ru": "загрузить",
            "en": "load",
            "be": "загрузіць"
        },
        {
            "id": "buttons.loadVisits",
            "ru": "Загрузить",
            "en": "Load",
            "be": "Загрузіць"
        },
        {
            "id": "titles.loadVisitsHowToWork",
            "ru": "Здесь можно инициировать прямую загрузку или обновление визитов из клиники за всю историю посещения. Для правильной работы необходимо, чтобы данные из учетной записи, включая номер телефона, совпадали с информацией на стороне медицинского центра. Не все клиники поддерживают загрузку прошедших визитов.",
            "en": "Here you can initiate a direct upload or update of visits from the clinic for the entire vosot history. For proper operation, it is necessary that the data from the account, including the phone number, match the information on the side of the medical center. Not all clinics support uploading past visits.",
            "be": "Тут можна ініцыяваць прамую загрузку ці абнаўленне візітаў з клінікі за ўсю гісторыю наведвання. Для правільнай працы неабходна, каб дадзеныя з уліковага запісу, у тым ліку нумар тэлефона, супадалі з інфармацыяй на баку медыцынскага цэнтра. Не ўсе клінікі падтрымліваюць загрузку мінулых візітаў."
        },
        {
            "id": "titles.loadVisitsForWhoVisit",
            "ru": "Пациент",
            "en": "Patient",
            "be": "Пацыент"
        },
        {
            "id": "titles.loadVisitsClinic",
            "ru": "Медцентр",
            "en": "Medical center",
            "be": "Медцэнтр"
        },
        {
            "id": "titles.loadVisitsClinicSelect",
            "ru": "Выберите медцентр",
            "en": "Choose a medical center",
            "be": "Абярыце медцэнтр"
        },
        {
            "id": "titles.loadVisitsSuccess",
            "ru": "Визиты успешно загружены",
            "en": "Visits successfully uploaded",
            "be": "Візіты паспяхова загружаны"
        },
        {
            "id": "titles.loadVisitsError",
            "ru": "Ошибка загрузки визитов",
            "en": "Error loading visits",
            "be": "Ошибка загрузкі візітов"
        },
        {
            "id": "titles.severalReports",
            "ru": "Несколько заключений",
            "en": "Several conclusions",
            "be": "Некалькі высноў"
        },
        {
            "id": "titles.severalReportsHint",
            "ru": "Пожалуйста, выберите заключение, которое вы бы хотели посмотреть.",
            "en": "Please select the conclusion you would like to see.",
            "be": "Калі ласка, выберыце выснову, якую вы хацелі б бачыць."
        },
        {
            "id": "titles.reportNumber",
            "ru": "Консультативное заключение №{index}",
            "en": "Consultative conclusion No. {index}",
            "be": "Кансультатыўная выснова №{index}"
        },
        {
            "id": "titles.visitsReportsQty",
            "ru": "Заключения ({qty})",
            "en": "Conclusions ({qty})",
            "be": "Высновы ({qty})"
        },
        {
            "id": "titles.report",
            "ru": "Консультативное заключение",
            "en": "Consultative conclusion",
            "be": "Кансультатыўная выснова"
        },
        {
            "id": "titles.visitsAttachmentQty",
            "ru": "Документы ({qty})",
            "en": "Documents ({qty})",
            "be": "Дакументы ({qty})"
        },
        {
            "id": "titles.visitsDrugsQty",
            "ru": "Препараты ({qty})",
            "en": "Drugs ({qty})",
            "be": "Прэпараты ({qty})"
        },
        {
            "id": "titles.visitReports",
            "ru": "ЗАКЛЮЧЕНИЯ",
            "en": "CONCLUSIONS",
            "be": "ВЫСНОВЫ"
        },
        {
            "id": "titles.visitReportsHint",
            "ru": "Выберите заключение, которое хотите посмотреть.",
            "en": "Select the conclusion you would like to see.",
            "be": "Выберыце выснову, якую вы хочаце ўбачыць."
        },
        {
            "id": "titles.reportsPresence",
            "ru": "Наличие заключений",
            "en": "Availability of conclusions",
            "be": "Наяўнасць заключэнняў"
        },
        {
            "id": "buttons.download",
            "ru": "Скачать",
            "en": "Download",
            "be": "Загрузіць"
        },
        {
            "id": "buttons.share",
            "ru": "Поделиться",
            "en": "Share",
            "be": "Падзяліцца"
        },
        {
            "id": "titles.accessSettings",
            "ru": "Безопасность",
            "en": "Security",
            "be": "Бяспека"
        },
        {
            "id": "titles.security",
            "ru": "Настройки",
            "en": "Settings",
            "be": "Налады"
        },
        {
            "id": "titles.accessSettingsHint",
            "ru": "Здесь вы можете настроить проверку доступа к результатам анализов и консультативным заключениям.",
            "en": "Here you can configure access to test results and consultation conclusions.",
            "be": "Тут вы можаце наладзіць тэставанне доступу да вынікаў тэстаў і кансультатыўных высноў."
        },
        {
            "id": "titles.accessSettingsSectionTitle",
            "ru": "Доступ к заключениям и результатам анализов",
            "en": "Access to conclusions and test results",
            "be": "Доступ да высноў і вынікаў выпрабаванняў"
        },
        {
            "id": "fingerprintScannerError.FingerprintScannerNotEnrolled",
            "ru": "Аутентификация не может быть запущена, так как сканер отпечатков пальцев не имеет зарегистрированных пальцев",
            "en": "The authentication cannot be initiated because the fingerprint scanner doesn't have registered fingerprints.",
            "be": "Аўтэнтыфікацыя не можа быць запушчана, бо сканер адбіткаў пальцаў не мае зарэгістраваных пальцаў"
        },
        {
            "id": "fingerprintScannerError.UserCancel",
            "ru": "Аутентификация была отменена пользователем",
            "en": "Authentication was canceled by the user",
            "be": "Аўтэнтыфікацыя была адменена карыстальнікам"
        },
        {
            "id": "fingerprintScannerError.SystemCancel",
            "ru": "Аутентификация отменена системой",
            "en": "Authentication was canceled by the system",
            "be": "Аўтэнтыфікацыя адмяняецца сістэмай"
        },
        {
            "id": "fingerprintScannerError.FingerprintScannerNotSupported",
            "ru": "Сканер отпечатков пальцев недоступен на устройстве",
            "en": "Fingerprint Scanner is not available on the device",
            "be": "Сканер адбіткаў пальцаў недаступны на прыладзе"
        },
        {
            "id": "error.invalid_acode",
            "ru": "Неверный код подтверждения. Пожалуйста, проверьте корректность ввода или запросите повторную отправку кода подтверждения в регистратуре медицинского центра.",
            "en": "Invalid confirmation code. Please check the correctness of the input or request re-sending the confirmation code at the registry of the medical center.",
            "be": "Няправільны код пацверджання. Калі ласка, праверце правільнасць уводу або запытаць, які праводзіць код пацверджання ў рэестры Медыцынскага цэнтра."
        },
        {
            "id": "titles.enter_acode_branch",
            "ru": "Введите А-код, полученный в SMS-сообщении от медицинского центра {branchName}",
            "en": "Enter the A-code received in an SMS message from the medical center  {branchName}",
            "be": "Увядзіце А-код, атрыманы ў SMS-паведамленні ад медыцынскага цэнтра {branchName}"
        },
        {
            "id": "titles.enter_acode",
            "ru": "Введите А-код, полученный в SMS-сообщении от медицинского центра",
            "en": "Enter the A-code received in an SMS message from the medical center",
            "be": "Увядзіце А-код, атрыманы ў SMS-паведамленні ад медыцынскага цэнтра"
        },
        {
            "id": "fingerprintScannerError.FingerprintScannerNotAvailable",
            "ru": "Сканер отпечатков пальцев недоступен на устройстве",
            "en": "The fingerprint scanner is not available on the device",
            "be": "Сканер адбіткаў пальцаў недаступны на прыладзе"
        },
        {
            "id": "fingerprintScannerError.DeviceLockedPermanent",
            "ru": "Использование отпечатка пальца временно недоступно. Попробуйте позже или переключитесь на А-код в настройках учетной записи.",
            "en": "Fingerprint usage is temporarily unavailable. Please try again later or switch to A-code in your account settings.",
            "be": "Выкарыстанне адбіткаў пальцаў часова недаступнае. Паспрабуйце пазней альбо пераключыце на код у наладах уліковага запісу."
        },
        {
            "id": "fingerprintScannerError.DeviceLocked",
            "ru": "Использование отпечатка пальца временно недоступно. Попробуйте позже или переключитесь на А-код в настройках учетной записи.",
            "en": "Fingerprint usage is temporarily unavailable. Please try again later or switch to A-code in your account settings.",
            "be": "Выкарыстанне адбіткаў пальцаў часова недаступнае. Паспрабуйце пазней альбо пераключыце на код у наладах уліковага запісу."
        },
        {
            "id": "titles.visitsForAdultsOnly",
            "ru": "Только совершеннолетние пользователи могут создавать и просматривать визиты. Записать ребенка на прием можно добавив его в раздел \"Моя семья\"",
            "en": "Only adults can create and view appointments. To schedule an appointment for a child, you can add them in the \"My Family\" section.",
            "be": "Толькі паўналетнія карыстачы могуць ствараць і праглядаць візіты. Запісаць дзіця на прыём можна дадаўшы яго ў раздзел \"Мая сям'я\""
        },
        {
            "id": "titles.visitsForAdultsOnly_auth",
            "ru": "Только совершеннолетние пользователи могут создавать и просматривать визиты. Записать ребенка на прием можно добавив его в раздел \"Моя семья\"",
            "en": "Only adults can create and view appointments. To schedule an appointment for a child, you can add them in the \"My Family\" section.",
            "be": "Толькі паўналетнія карыстачы могуць ствараць і праглядаць візіты. Запісаць дзіця на прыём можна дадаўшы яго ў раздзел \"Мая сям'я\""
        },
        {
            "id": "titles.selectProfileForConfirm",
            "ru": "Выберите профиль для подтверждения",
            "en": "Select a profile for confirmation",
            "be": "Абярыце профіль для пацверджання"
        },
        {
            "id": "titles.supportInfo",
            "ru": "Информация для сотрудников техподдержки: профиль {user}, {phone}, {os}, страница: {screen}, {params}, {lastError}, {buildNumber}. Опишите возникшую проблему подробнее:",
            "en": "Information for technical support staff: profile {user}, {phone}, {os}, page: {screen}, {params}, {lastError}, {buildNumber}. Please describe your problem in more detail:",
            "be": "Інфармацыя для супрацоўнікаў тэхпадтрымкі: профіль {user}, {phone}, {os}, старонка: {screen}, {params}, {lastError}, {buildNumber}. Апішыце ўзніклую праблему падрабязней:"
        },
        {
            "id": "titles.safariTest",
            "ru": "Анализ",
            "en": "Test",
            "be": "Аналіз"
        },
        {
            "id": "titles.safariReport",
            "ru": "Заключение",
            "en": "Report",
            "be": "Заключэнне"
        },
        {
            "id": "titles.safariOpen",
            "ru": "ОТКРЫТЬ",
            "en": "OPEN",
            "be": "АДКРЫЦЬ"
        },
        {
            "id": "titles.allFeedbacks",
            "ru": "Все отзывы",
            "en": "All feedbacks",
            "be": "Усе водгукі"
        },
        {
            "id": "titles.allFeedbacksMyFeedbacks",
            "ru": "Здесь можно найти все отзывы, которые вы оставляли в приложении",
            "en": "Here you can find all the reviews you have left in the app",
            "be": "Тут можна знайсці ўсе водгукі, якія вы пакідалі ў дадатку"
        },
        {
            "id": "titles.allFeedbacksMy",
            "ru": "Мои отзывы",
            "en": "Here you can find all the reviews you have left in the app",
            "be": "Мае водгукі"
        },
        {
            "id": "screenTitles.AllFeedbackFilterScreen",
            "ru": "Отзывы пользователя",
            "en": "My reviews",
            "be": "Водгукі карыстальніка"
        },
        {
            "id": "titles.allFeedbacksSearchPlaceholder",
            "ru": "ФИО, текст, специальность",
            "en": "Full name, text, specialty",
            "be": "Прозвішча, імя, спецыяльнасць"
        },
        {
            "id": "titles.toBioSettings",
            "ru": "К настройкам",
            "en": "To the settings",
            "be": "Да налад"
        },
        {
            "id": "titles.notif_permissins_modal",
            "ru": "Разрешение на уведомления",
            "en": "Permission for notifications",
            "be": "Дазвол на апавяшчэнні"
        },
        {
            "id": "titles.notif_permissins_modal_message",
            "ru": "Для получения напоминаний о визитах небходимо разрешить уведомления. Это можно сделать сейчас или позже.",
            "en": "To receive reminders about visits, you need to enable notifications. This can be done now or later.",
            "be": "Каб атрымаць наведванне візітаў, зразумела, каб дазволіць апавяшчэнні. Гэта можна зрабіць зараз ці пазней."
        },
        {
            "id": "buttons.notif_permissins_modal_confirm",
            "ru": "Подтвердить",
            "en": "Confirm",
            "be": "Пацвярджаць"
        },
        {
            "id": "buttons.notif_permissins_modal_cancel",
            "ru": "Позже",
            "en": "Later",
            "be": "Пазней"
        },
        {
            "id": "title.doctorDetailsHasBumba",
            "ru": "Заключения и анализы врача доступны в Aibolit",
            "en": "Doctor's conclusions and tests are available in Aibolit",
            "be": "Заключэнні і аналізы лекара даступныя ў Aibolit"
        },
        {
            "id": "title.bumbaBannerTitle",
            "ru": "NEW!",
            "en": "NEW!",
            "be": "NEW!"
        },
        {
            "id": "title.bumbaBannerText",
            "ru": "Заключения врачей и результаты анализов из некоторых клиник теперь доступны в Aibolit",
            "en": "Doctors' conclusions and test results from some clinics are now available in the Aibolit app",
            "be": "Заключэнні лекараў і вынікі аналізаў з некаторых клінік зараз даступныя ў Aibolit"
        },
        {
            "id": "title.bumbaExplanation",
            "ru": "Электронные заключения и анализы этого врача доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому заключений и анализов требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic conclusions and tests from this doctor are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the conclusions and tests, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical institution.",
            "be": "Электронныя заключэнні і аналізы гэтага лекара даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу заключэнняў і аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "title.bumbaExplanationTitle",
            "ru": "Личный кабинет",
            "en": "Personal account",
            "be": "Асабісты кабінет"
        },
        {
            "id": "coverers.epam",
            "ru": "EPAM Health Care",
            "en": "EPAM Health Care",
            "be": "EPAM Health Care"
        },
        {
            "id": "coverers.bns",
            "ru": "Белнефтестрах",
            "en": "Belneftestrakh",
            "be": "Белнафтастрах"
        },
        {
            "id": "coverers.no",
            "ru": "Без программы",
            "en": "Without a program",
            "be": "Без праграмы"
        },
        {
            "id": "titles.all_doctors_sync",
            "ru": "СИНХРОНИЗАЦИЯ ВРАЧЕЙ",
            "en": "SYNCHRONIZATION OF DOCTORS",
            "be": "СІНХРАНІЗАЦЫЯ ЛЕКАРАУ"
        },
        {
            "id": "titles.bumbaClinicTestsHeader",
            "ru": "Личный кабинет",
            "en": "Personal account",
            "be": "Асабісты кабінет"
        },
        {
            "id": "titles.bumbaClinicTestsText",
            "ru": "Электронные результаты анализов из этой клиники доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому результатов анализов требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic test results from this clinic are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the content of the test results, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical institution.",
            "be": "Электронныя вынікі аналізаў з гэтай клінікі даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу вынікаў аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "titles.bumbaClinicResultsHeader",
            "ru": "Личный кабинет",
            "en": "Personal account",
            "be": "Асабісты кабінет"
        },
        {
            "id": "titles.bumbaClinicResultsText",
            "ru": "Электронные заключения врачей доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому заключений требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic conclusions from doctors are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the reports, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical facility.",
            "be": "Электронныя заключэння ўрачоў даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу зняволення патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "titles.bumbaClinicTestsResultsHeader",
            "ru": "Личный кабинет",
            "en": "Personal account",
            "be": "Асабісты кабінет"
        },
        {
            "id": "titles.bumbaClinicTestsResultsText",
            "ru": "Электронные заключения и анализы из этой клиники доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому заключений и анализов требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic conclusions and tests from this clinic are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the conclusions and tests, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical facility.",
            "be": "Электронныя заключэнні і аналізы з гэтай клінікі даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу заключэнняў і аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "titles.bumbaClinicTests",
            "ru": "Результаты анализов из этой клиники доступны в Aibolit",
            "en": "Test results from this clinic are available at Aibolit",
            "be": "Вынікі аналізаў з гэтай клінікі даступныя ў Aibolit"
        },
        {
            "id": "titles.bumbaClinicResults",
            "ru": "Заключения врачей из этой клиники доступны в Aibolit",
            "en": "The conclusions of the doctors from this clinic are available at Aibolit",
            "be": "Заключэнні лекараў з гэтай клінікі даступныя ў Aibolit"
        },
        {
            "id": "titles.bumbaClinicTestsResults",
            "ru": "Заключения и анализы из этой клиники доступны в Aibolit",
            "en": "Conclusions and tests from this clinic are available at Aibolit",
            "be": "Заключэнні і аналізы з гэтай клінікі даступныя ў Aibolit"
        },
        {
            "id": "titles.addDrugs",
            "ru": "ДОБАВИТЬ ПРЕПАРАТЫ",
            "en": "Add drugs",
            "be": "Дадаць наркотыкі"
        },
        {
            "id": "titles.selectedDrugs",
            "ru": "Выбрано: {count}",
            "en": "Selected: {count}",
            "be": "Выбраны: {count}"
        },
        {
            "id": "titles.doctorDetailsHasBumbaTests",
            "ru": "Результаты анализов доступны в Aibolit",
            "en": "Test results are available at Aibolit",
            "be": "Вынікі аналізаў даступныя ў Aibolit"
        },
        {
            "id": "titles.doctorDetailsHasBumbaReports",
            "ru": "Заключения врача доступны в Aibolit",
            "en": "Doctor's conclisions are available at Aibolit",
            "be": "Заключэнні лекара даступныя ў Aibolit"
        },
        {
            "id": "titles.doctorDetailsHasBumbaTestsReports",
            "ru": "Заключения врача и результаты анализов доступны в Aibolit",
            "en": "Doctor's conclusions and test results are available in Aibolit",
            "be": "Заключэнні лекара і вынікі аналізаў даступныя ў Aibolit"
        },
        {
            "id": "titles.bumbaDoctorExplanationTests",
            "ru": "Электронные результаты анализов из этой клиники доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому анализов требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic test results from this clinic are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the conclusions and tests, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical facility.",
            "be": "Электронныя вынікі аналізаў з гэтай клінікі даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу заключэнняў і аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "titles.bumbaDoctorExplanationReports",
            "ru": "Электронные заключения врачей из этой клиники доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому заключений требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic conclusions of doctors from this clinic are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the conclusions and tests, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical facility.",
            "be": "Электронныя заключэння ўрачоў з гэтай клінікі даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу заключэнняў і аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэгістратуры або кантакт цэнтры вашай медустановы."
        },
        {
            "id": "titles.bumbaDoctorExplanationTestsReports",
            "ru": "Электронные заключения и анализы из этой клиники доступны через приложение Aibolit, раздел \"Карточка\". Медицинские центры, которые поддерживают эту интеграцию, отмечены специальной иконкой. Для доступа к содержимому заключений и анализов требуется ввести а-код, который необходимо получить в клинике. Детали можно уточнить в регистратуре или контакт центре вашего медучреждения.",
            "en": "Electronic conclusions and tests from this clinic are available through the Aibolit application, section \"Card\". Medical centers that support this integration are marked with a special icon. To access the contents of the conclusions and tests, you need to enter an A-code, which must be obtained from the clinic. Details can be clarified at the reception or contact center of your medical facility.",
            "be": "Электронныя заключэнні і аналізы з гэтай клінікі даступныя праз прыкладанне Aibolit, раздзел \"Картачка\". Медыцынскія цэнтры, якія падтрымліваюць гэтую інтэграцыю, адзначаны спецыяльным абразком. Для доступу да зместу заключэнняў і аналізаў патрабуецца ўвесці а-код, які неабходна атрымаць у клініцы. Дэталі можна ўдакладніць у рэг"
        },
        {
            "id": "titles.bumbaDoctorExplanationTitle",
            "ru": "Личный кабинет",
            "en": "Personal account",
            "be": "Асабісты кабінет"
        },
        {
            "id": "titles.chooseDrugs",
            "ru": "Выберите лекарства для поиска",
            "en": "Choose a drug for search",
            "be": "Выберыце лекі для пошуку"
        },
        {
            "id": "titles.allowNotificationsPromptShort",
            "ru": "Для отображения напоминаний приложению требуется разрешение на использование нотификаций.",
            "en": "To display reminders, the app requires permission to user notifications.",
            "be": "Для адлюстравання напамінку дадатку патрабуецца дазвол на карыстанне натыфікацыяй."
        },
        {
            "id": "button.useful",
            "ru": "Полезно",
            "en": "Useful",
            "be": "Карысна"
        },
        {
            "id": "my-card.emptyFavoriteList",
            "ru": "У вас пока нет закладок. Чтобы добавить врача в этот список, просто нажмите на иконку в правом верхнем углу на странице врача",
            "en": "You don't have any bookmarks yet. To add a doctor to this list, simply click on the icon in the top right corner on the doctor's page",
            "be": "У вас пакуль няма закладак. Каб дадаць лекара ў гэты спіс, проста націсніце на абразок у правым верхнім куце на старонцы лекара"
        },
        {
            "id": "title.complainTitle",
            "ru": "Пожаловаться на отзыв",
            "en": "Complain about feedback",
            "be": "Паскардзіцца на водгук"
        },
        {
            "id": "title.complainText"
        },
        {
            "id": "title.complainSubtitle",
            "ru": "Отзыв нарушает права, содержит ненормативную лексику или не является достоверным",
            "en": "Feedback violates rights, contains offensive language or is not reliable",
            "be": "Водгук парушае правы, змяшчае не нарматыўную лексіку або не з'яўляецца дакладным"
        },
        {
            "id": "title.complainSubmit",
            "ru": "ПОЖАЛОВАТЬСЯ",
            "en": "COMPLAIN",
            "be": "ПАДАРАЦЦА"
        },
        {
            "id": "title.complainCancel",
            "ru": "ОТМЕНА",
            "en": "CANCEL",
            "be": "АДМЕНА"
        },
        {
            "id": "my-card.favHeaderTitleLoading",
            "ru": "Загружаем закладки...",
            "en": "Load the bookmarks...",
            "be": "Мы загружаем закладкі..."
        },
        {
            "id": "title.abusePosted",
            "ru": "Ваша жалоба отправлена",
            "en": "Your complaint has been sent",
            "be": "Ваша скарга адпраўлена"
        },
        {
            "id": "title.feedbackIsEdited",
            "ru": "Изменен",
            "en": "Edited",
            "be": "Зменены"
        },
        {
            "id": "mainScreenSettings.favorites",
            "ru": "Закладки",
            "en": "Bookmarks",
            "be": "Закладкі"
        },
        {
            "id": "mainScreenSettings.popularQueries",
            "ru": "Популярные запросы",
            "en": "Popular requests",
            "be": "Папулярныя запыты"
        },
        {
            "id": "titles.mainScreenSettings",
            "ru": "Главный экран",
            "en": "Main screen",
            "be": "Асноўны экран"
        },
        {
            "id": "titles.mainScreenSettingsHint",
            "ru": "Здесь можно включить или отключить отображение некоторых секций на главном экране приложения.",
            "en": "Here you can enable or disable the display of some sections on the main screen of the application.",
            "be": "Тут вы можаце ўключыць або адключыць адлюстраванне некаторых раздзелаў на галоўным экране."
        },
        {
            "id": "titles.warningForAuthorizedOnlyTitle",
            "ru": "Внимание",
            "en": "Attention",
            "be": "Увага"
        },
        {
            "id": "titles.warningForAuthorizedOnlyText",
            "ru": "Данная функция доступна только авторизованным пользователям",
            "en": "This feature is only available to authorized users",
            "be": "Дадзеная функцыя даступная толькі аўтарызаваным карыстальнікам"
        },
        {
            "id": "buttons.warningForAuthorizedOnlyCancel",
            "ru": "Регистрация/Вход",
            "en": "Registration/Login",
            "be": "Рэгістрацыя/Уваход"
        },
        {
            "id": "buttons.warningForAuthorizedOnlyOk",
            "ru": "Понятно",
            "en": "I understand",
            "be": "Ясна"
        },
        {
            "id": "doctorFeedbackSort.byDateConfirmed",
            "ru": "По дате (сначала подтвержденные)",
            "en": "By date (confirmed first)",
            "be": "Па даце (спачатку пацверджаныя)"
        },
        {
            "id": "doctorFeedbackSort.byDate",
            "ru": "По дате",
            "en": "By date",
            "be": "Па даце"
        },
        {
            "id": "doctorFeedbackSort.byUsefulCount",
            "ru": "По количеству отметок \"Полезно\"",
            "en": "By the number of marks \"Useful\"",
            "be": "Па колькасці адзнак \"Карысна\""
        },
        {
            "id": "doctorAllFeedbackSort.byDate",
            "ru": "По дате",
            "en": "By date",
            "be": "Па даце"
        },
        {
            "id": "doctorAllFeedbackSort.byUsefulCount",
            "ru": "По количеству отметок \"Полезно\"",
            "en": "By the number of marks \"Useful\"",
            "be": "Па колькасці адзнак \"Карысна\""
        },
        {
            "id": "titles.sort_list_of_doctor_feedbacks",
            "ru": "Сортировать отзывы",
            "en": "Sort feedback",
            "be": "Сартаваць водгукі"
        },
        {
            "id": "titles.mcNotFound",
            "ru": "Медцентр не найден",
            "en": "Medical center not found",
            "be": "Медыцынскі цэнтр не быў знойдзены"
        },
        {
            "id": "titles.undefinedDoctor",
            "ru": "Неизвестен",
            "en": "Unknown",
            "be": "Невядомы"
        },
        {
            "id": "titles.allowScreenshots",
            "ru": "Разрешить снимки экранов с медицинскими данными",
            "en": "Allow screenshots of medical data",
            "be": "Дазволіць здымкі экранаў з медыцынскімі дадзенымі"
        },
        {
            "id": "titles.loading",
            "ru": "Загрузка...",
            "en": "Loading...",
            "be": "Загрузка..."
        },
        {
            "id": "titles.inAppUpdateTitle",
            "ru": "Обновление",
            "en": "Update",
            "be": "Абнаўленне"
        },
        {
            "id": "titles.inAppUpdateSubtitle",
            "ru": "Новая версия мобильного приложения Aibolit готова к установке",
            "en": "A new version of the Aibolit mobile app is ready for installation",
            "be": "Новая версія мабільнага прыкладання Aibolit гатова да ўстаноўкі"
        },
        {
            "id": "titles.inAppUpdateLater",
            "ru": "ПОЗЖЕ",
            "en": "LATER",
            "be": "ПАЗНЕЙ"
        },
        {
            "id": "titles.inAppUpdateInstall",
            "ru": "УСТАНОВИТЬ",
            "en": "INSTALL",
            "be": "УСТАНАВІЦЬ"
        },
        {
            "id": "buttons.installUpdate",
            "ru": "Установить",
            "en": "Install",
            "be": "Усталяваць"
        },
        {
            "id": "titles.pick_service",
            "ru": "ВЫБЕРИТЕ УСЛУГУ",
            "en": "CHOOSE A SERVICE",
            "be": "АБЯРЫЦЕ ПАСЛУГУ"
        },
        {
            "id": "titles.selectServicePlaceholder",
            "ru": "Название услуги",
            "en": "Service name",
            "be": "Назва паслугі"
        },
        {
            "id": "titles.umsOnline",
            "ru": "ОНЛАЙН ЗАПИСЬ",
            "en": "Online booking",
            "be": "Інтэрнэт -запіс"
        },
        {
            "id": "titles.emailConfirmationSend",
            "ru": "На указанный e-mail отправлено письмо, которое содержит ссылку для подтверждения.",
            "en": "An email has been sent to the specified email address that contains a link for confirmation.",
            "be": "На паказаны e-mail адпраўлена пісьмо, якое змяшчае спасылку для пацверджання."
        },
        {
            "id": "titles.emailConfirmationRetrySupport",
            "ru": "Поддержка",
            "en": "Support",
            "be": "Падтрымка"
        },
        {
            "id": "titles.emailConfirmationRetry",
            "ru": "Повторить запрос",
            "en": "Repeat request",
            "be": "Паўтарыць запыт"
        },
        {
            "id": "titles.drugstores",
            "ru": "АПТЕКИ",
            "en": "Pharmacies",
            "be": "Аптэкі"
        },
        {
            "id": "drugstoresFilter.isOpen",
            "ru": "Открыты сейчас",
            "en": "Open now",
            "be": "Адкрыты зараз"
        },
        {
            "id": "drugstoresFilter.isDelivery",
            "ru": "Доставка",
            "en": "Delivery",
            "be": "Дастаўка"
        },
        {
            "id": "drugstoresFilter.isOrder",
            "ru": "Льготный отпуск",
            "en": "Privileged prescription",
            "be": "Льготны адпачынак"
        },
        {
            "id": "titels.drugstoresFilter",
            "ru": "ФИЛЬТРЫ",
            "en": "Filters",
            "be": "Фільтры"
        },
        {
            "id": "titles.allDay",
            "ru": "Круглосуточно",
            "en": "Round-the-clock ",
            "be": "Кругласутачна"
        },
        {
            "id": "titles.dayOff",
            "ru": "Выходной",
            "en": "Day off",
            "be": "Выхадны дзень"
        },
        {
            "id": "titles.doctorDescription",
            "ru": "Описание",
            "en": "Description",
            "be": "Апісанне"
        },
        {
            "id": "titles.relative",
            "ru": "Родственник",
            "en": "Relative",
            "be": "Сваяк"
        },
        {
            "id": "titles.serviceDescription",
            "ru": "ОПИСАНИЕ",
            "en": "DESCRIPTION",
            "be": "АПІСАННЕ"
        },
        {
            "id": "titles.serviceDescriptionLess",
            "ru": "СВЕРНУТЬ",
            "en": "Collapse",
            "be": "Згарнуць"
        },
        {
            "id": "titles.serviceDescriptionMore",
            "ru": "РАЗВЕРНУТЬ",
            "en": "More",
            "be": "Больш падрабязна"
        },
        {
            "id": "hints.medcentersChooseDoc",
            "ru": "Вы также можете выбрать специалиста самостоятельно и записаться к нему онлайн, уточнив список оказываемых врачом услуг в регистратуре медцентра",
            "en": "You can also choose a specialist on your own and make an appointment online, specifying the list of services provided by the doctor in the medical center reception desk.",
            "be": "Вы таксама можаце выбраць спецыяліста самастойна і зарэгістравацца ў Інтэрнэце, указаўшы спіс паслуг, якія прадастаўляецца лекарам у рэестры медыцынскіх цэнтраў"
        },
        {
            "id": "titles.onlineSection",
            "ru": "ОНЛАЙН ЗАПИСЬ",
            "en": "Online booking",
            "be": "Інтэрнэт -запіс"
        },
        {
            "id": "titles.mcRecordAllDoc",
            "ru": "Все специалисты медцентра",
            "en": "All specialists of the medical center",
            "be": "Усе спецыялісты Медыцынскага цэнтра"
        },
        {
            "id": "titles.priceRange",
            "ru": "Диапазон цен",
            "en": "Price range",
            "be": "Дыяпазон коштаў"
        },
        {
            "id": "titles.priceRangeExplain",
            "ru": "Минимальная стоимость состоит из наименьших цен на каждое отдельное лекарство из аптечки. При этом такие позиции могут находиться в разных аптеках. Поэтому результат поиска заведений, в которых есть одновременно все выбранные лекарства, может отличаться от общей минимальной стоимости аптечки. Для приобретения всех препаратов по наименьшим ценам необходимо будет посетить несколько аптек.",
            "en": "The minimum cost consists of the lowest prices for each individual drug from the first aid kit. Moreover, such positions may be located in different pharmacies. Therefore, the result of the search for establishments that have all the selected drugs at the same time may differ from the total minimum cost of the first-aid kit. To purchase all the drugs at the lowest prices, you will need to visit several pharmacies.",
            "be": "Мінімальны кошт складаецца з найменшых коштаў на кожныя асобныя лекі з аптэчкі. Пры гэтым такія пазіцыі могуць знаходзіцца ў розных аптэках. Таму вынік пошуку ўстаноў, у якіх ёсць адначасова ўсе выбраныя лекі, можа адрознівацца ад агульнага мінімальнага кошту аптэчкі. Для набыцця ўсіх прэпаратаў па найменшых коштах неабходна будзе наведаць некалькі аптэк."
        },
        {
            "id": "buttons.priceRangeConfirm",
            "ru": "ПОНЯТНО",
            "en": "OK",
            "be": "ЗРАЗУМЕЛА"
        },
        {
            "id": "titles.shareDrugsBanner",
            "ru": "Результаты поиска",
            "en": "Searching results",
            "be": "Вынікі пошуку"
        },
        {
            "id": "titles.drugs",
            "ru": "Препараты {{count}}",
            "en": "Drugs {{count}}",
            "be": "Прэпараты {{count}}"
        },
        {
            "id": "titles.addToFirstAidKit",
            "ru": "{drug} добавлен в аптечку",
            "en": "{drug} added to first aid kit",
            "be": "{drug} дададзены ў аптэчку"
        },
        {
            "id": "titles.removeFromAidKit",
            "ru": "{drug}  удален из аптечки",
            "en": "{drug} removed from first aid kit",
            "be": "{drug} выдалены з аптэчкі"
        },
        {
            "id": "titles.shareFirstAidKit",
            "ru": "Список лекарств",
            "en": "List of drugs",
            "be": "Спіс лекаў"
        },
        {
            "id": "titles.shareDrugstore",
            "ru": "Лекарства в аптеке",
            "en": "Drugs in the pharmacy",
            "be": "Лекі ў аптэцы"
        },
        {
            "id": "titles.doctorForChildren",
            "ru": "Детский врач",
            "en": "Children's doctor",
            "be": "Дзіцячы лекар"
        },
        {
            "id": "titles.of",
            "ru": "из",
            "en": "of",
            "be": "з"
        },
        {
            "id": "error.same_patient_feedback",
            "ru": "Невозможно добавить новый отзыв",
            "en": "Unable to add new feedback",
            "be": "Немагчыма дадаць новы водгук"
        },
        {
            "id": "titles.feedbackFromSamePatient",
            "ru": "Отзыв от пользователя уже существует",
            "en": "A feedback from this user already exists",
            "be": "Водгук ад карыстальніка ўжо існуе"
        },
        {
            "id": "titles.addFutureVisitManually",
            "ru": "Добавить будущий визит вручную",
            "en": "Add a future visit manually",
            "be": "Дадаць будучы візіт уручную"
        },
        {
            "id": "titles.addVisitManually",
            "ru": "Добавить визит вручную",
            "en": "Add a visit manually",
            "be": "Дадаць візіт уручную"
        },
        {
            "id": "titles.loadVisits",
            "ru": "Загрузить визиты из клиники",
            "en": "Download clinic visits",
            "be": "Загрузіць візіты з клінікі"
        },
        {
            "id": "titles.makeVisit",
            "ru": "Записаться на прием",
            "en": "Make an appointment",
            "be": "Запісацца на прыём"
        },
        {
            "id": "titles.addVisitManuallyWarning",
            "ru": "Добавленный вручную визит не является записью на прием и сохраняется только на вашем устройстве. Для записи на прием используйте поиск врача/услуги на главном экране.",
            "en": "A manually added visit isn't a scheduled appointment and is saved only on your device. To schedule an appointment, use the search for doctors/services on the main screen.",
            "be": "Дададзены ўручную візіт не з'яўляецца запісам на прыём і захоўваецца толькі на вашым прыладзе. Для запісу на прыём выкарыстоўвайце пошук урача/паслугі на галоўным экране."
        },
        {
            "id": "titles.visitTime",
            "ru": "Время визита",
            "en": "Visit time",
            "be": "Час візіту"
        },
        {
            "id": "titles.visitDate",
            "ru": "Дата визита",
            "en": "Visit date",
            "be": "Дата візіту"
        },
        {
            "id": "titles.choose_the_date",
            "ru": "Выбрать дату",
            "en": "Select date",
            "be": "Выбраць дату"
        },
        {
            "id": "titles.datePlaceholder",
            "ru": "дд.мм.гггг",
            "en": "dd.mm.yyyy",
            "be": "дд.мм.гггг"
        },
        {
            "id": "titles.timePlaceholder",
            "ru": "чч:мм",
            "en": "hh:mm",
            "be": "чч:мм"
        },
        {
            "id": "titles.datetimePlaceholder",
            "ru": "дд.мм.гггг чч:мм",
            "en": "dd.mm.yyyy hh:mm",
            "be": "дд.мм.гггг чч:мм"
        },
        {
            "id": "titles.dateError",
            "ru": "Неверная дата",
            "en": "Invalid date",
            "be": "Няслушная дата"
        },
        {
            "id": "titles.futureError",
            "ru": "Дата и время будущего визита не могут быть в прошлом. Для того, чтобы добавить прошедший визит, перейдите в раздел Карточка",
            "en": "The date and time of a future visit cannot be in the past. To add a past visit, go to the Card section",
            "be": "Дата і час будучага візіту не могуць быць у мінулым. Для таго, каб дадаць мінулы візіт, перайдзіце ў раздзел"
        },
        {
            "id": "titles.pastError",
            "ru": "Дата прошедшего визита не может быть в будущем. Для того, чтобы добавить будущий визит, перейдите на главный экран",
            "en": "The date of the past visit cannot be in the future. To add a future visit, go to the main screen",
            "be": "Дата візіту не можа быць у будучыні. Для таго, каб дадаць будучы візіт, перайдзіце на галоўны экран"
        },
        {
            "id": "titles.timeError",
            "ru": "Неверное время",
            "en": "Wrong time",
            "be": "Няправільны час"
        },
        {
            "id": "titles.address",
            "ru": "Адрес",
            "en": "Address",
            "be": "Адрас"
        },
        {
            "id": "error.errorSaveVisit",
            "ru": "Ошибка сохранения визита",
            "en": "Error saving visit",
            "be": "Памылка захавання візіту"
        },
        {
            "id": "titles.deleteManualVisitConfirmationTitle",
            "ru": "Удаление визита",
            "en": "Deleting a visit",
            "be": "Выдаленне візіту"
        },
        {
            "id": "titles.deleteManualVisitConfirmation",
            "ru": "Вы действительно хотите удалить этот визит? Данный визит создан вручную и не является записью на прием. При необходимости отмены визита обратитесь в регистратуру",
            "en": "Are you sure you want to delete this visit? This visit was created manually and is not a scheduled appointment. If you need to cancel your visit, please contact the reception",
            "be": "Вы сапраўды хочаце выдаліць гэты візіт? Гэты візіт створаны ўручную і не з'яўляецца запісам на прыём. Пры неабходнасці адмены візіту звернецеся ў рэгістратуру"
        },
        {
            "id": "titles.placeholderForClinicManualVisit",
            "ru": "Название",
            "en": "Name",
            "be": "Назва"
        },
        {
            "id": "titles.notRequired",
            "ru": "(Не обязательно)",
            "en": "(Not necessary)",
            "be": "(Не абавязкова)"
        },
        {
            "id": "titles.filterTagChild",
            "ru": "Детский",
            "en": "Children",
            "be": "Дзеці"
        },
        {
            "id": "titles.filterTagFeedbacks",
            "ru": "Отзывы",
            "en": "Feedback",
            "be": "Агляды"
        },
        {
            "id": "titles.futureVisitAdded",
            "ru": "Будущий визит добавлен",
            "en": "Future visit added",
            "be": "Будучы візіт дададзены"
        },
        {
            "id": "titles.pastVisitAdded",
            "ru": "Прошедший визит добавлен",
            "en": "Past visit added",
            "be": "Мінулы візіт дададзены"
        },
        {
            "id": "titles.shareDoctorTitle",
            "ru": "Поделиться",
            "en": "Share",
            "be": "Падзяліцца"
        },
        {
            "id": "shareDoctor.date",
            "ru": "Запись на прием:",
            "en": "Make an appointment:",
            "be": "Запіс на прыём:"
        },
        {
            "id": "shareDoctor.doctor",
            "ru": "Врач:",
            "en": "Doctor:",
            "be": "Лекар:"
        },
        {
            "id": "shareDoctor.clinic",
            "ru": "Медцентр:",
            "en": "Medical center:",
            "be": "Медцэнтр:"
        },
        {
            "id": "shareDoctor.profile",
            "ru": "Пациент:",
            "en": "Patient:",
            "be": "Пацыент:"
        },
        {
            "id": "shareDoctor.comment",
            "ru": "Комментарий:",
            "en": "A comment:",
            "be": "Каментар:"
        },
        {
            "id": "shareDoctor.drugs",
            "ru": "Препараты:",
            "en": "Drugs:",
            "be": "Прэпараты:"
        },
        {
            "id": "shareDoctor.source",
            "ru": "Источник:",
            "en": "Source:",
            "be": "Крыніца:"
        },
        {
            "id": "shareDoctor.service",
            "ru": "Услуга:",
            "en": "Service:",
            "be": "Паслуга:"
        },
        {
            "id": "shareDoctor.sourceLink",
            "ru": "https://ln.aibolit.md/mma",
            "en": "https://ln.aibolit.md/mma",
            "be": "https://ln.aibolit.md/mma"
        },
        {
            "id": "shareDoctor.separator",
            "ru": ",{lineFeed}",
            "en": ",{lineFeed}",
            "be": ",{lineFeed}"
        },
        {
            "id": "titles.addFutureVisitManuallyTitle",
            "ru": "Добавить визит",
            "en": "Add a visit",
            "be": "Дадаць візіт"
        },
        {
            "id": "titles.doctorsSearchSpecialtyPlaceholder",
            "ru": "специальность, ФИО, от 3 символов",
            "en": "specialty, full name, from 3 characters",
            "be": "спецыяльнасць, імя, ад 3 сімвалаў"
        },
        {
            "id": "titles.specialtiesListTitle ",
            "ru": "Специальность врача",
            "en": "Specialty of a doctor",
            "be": "Спецыяльнасць лекара"
        },
        {
            "id": "titles.showMore",
            "ru": "Показать еще",
            "en": "Show more",
            "be": "Паказаць больш"
        },
        {
            "id": "titles.searchDoctorsSection",
            "ru": "Врачи ({count})",
            "en": "Doctors ({count})",
            "be": "Лекары ({count})"
        },
        {
            "id": "titles.searchSpecializationsSection",
            "ru": "Cпециальности ({count})",
            "en": "Specialties ({count})",
            "be": "Навука ({count})"
        },
        {
            "id": "error.ACTION_NOT_GRANTED",
            "ru": "Действие не разрешено владельцем",
            "en": "The action is not allowed by the owner",
            "be": "Дзеянне не дазволена уладальнікам"
        },
        {
            "id": "titles.rememberPatientDataHint",
            "ru": "Вы можете добавить человека к себе в семью, чтобы управлять его визитами: видеть историю и записывать на прием.",
            "en": "You can add a person to your family to manage their visits: see their history and make an appointment.",
            "be": "Вы можаце дадаць чалавека да сябе ў сям'ю, каб кіраваць яго візітамі: бачыць гісторыю і запісваць на прыём."
        },
        {
            "id": "titles.savePatientData",
            "ru": "ДОБАВИТЬ В СЕМЬЮ",
            "en": "ADD TO FAMILY",
            "be": "ДАДАЦЬ У СЯМ'Ю"
        },
        {
            "id": "titles.childRelative",
            "ru": "Ребенок",
            "en": "Child",
            "be": "Дзіця"
        },
        {
            "id": "titles.otherRelative",
            "ru": "Родственник",
            "en": "Relative",
            "be": "Сваяк"
        },
        {
            "id": "titles.newVisitor",
            "ru": "Новый пациент",
            "en": "New patient",
            "be": "Новы пацыент"
        },
        {
            "id": "titles.relativeType",
            "ru": "Кем приходится",
            "en": "What is the relation",
            "be": "Кім даводзіцца"
        },
        {
            "id": "titles.relativeRequestCodeHint",
            "ru": "Для того, чтобы видеть все визиты взрослого пациента (в том числе прошедшие), запросите у него полный доступ к визитам. На указанный номер телефона будет отправлено смс с кодом и просьбой предоставить согласие.",
            "en": "To see all visits of an adult patient (including past ones), request full access to visits. An SMS with a code and a request for consent will be sent to the specified phone number.",
            "be": "Для таго, каб бачыць усе візіты дарослага пацыента (у тым ліку мінулыя), запытайце ў яго поўны доступ да візітаў. На ўказаны нумар тэлефона будзе адпраўлена смс з кодам і просьбай даць згоду."
        },
        {
            "id": "titles.inputCode",
            "ru": "Код из СМС",
            "en": "SMS Code",
            "be": "Код з СМС"
        },
        {
            "id": "titles.requestCode",
            "ru": "ОТПРАВИТЬ",
            "en": "SEND",
            "be": "АДПРАВIЦЬ"
        },
        {
            "id": "titles.phoneForConnection",
            "ru": "НОМЕР ТЕЛЕФОНА ДЛЯ СВЯЗИ",
            "en": "PHONE NUMBER FOR CONTACT",
            "be": "НУМАР ТЭЛЕФОНУ ДЛЯ СУВЯЗІ"
        },
        {
            "id": "titles.useMyPhoneNumber",
            "ru": "Использовать мой номер",
            "en": "Use my number",
            "be": "Выкарыстоўваць мой нумар"
        },
        {
            "id": "titles.addAdHoc",
            "ru": "ДОБАВИТЬ",
            "en": "ADD",
            "be": "ДАДАЦЬ"
        },
        {
            "id": "titles.cancelAdHoc",
            "ru": "ОТМЕНА",
            "en": "CANCEL",
            "be": "АДМЕНА"
        },
        {
            "id": "titles.sendAgainTime",
            "ru": "Отправить повторно {countDown}",
            "en": "Resend {countDown}",
            "be": "Адправіць паўторна {countDown}"
        },
        {
            "id": "titles.sendAgainAdHoc",
            "ru": "Отправить повторно",
            "en": "Resend",
            "be": "Адправіць паўторна"
        },
        {
            "id": "titles.favDelete",
            "ru": "Удалить {name} из закладок?",
            "en": "Delete {name} out of bookmarks?",
            "be": "Выдаліце ​{name} з закладак?"
        },
        {
            "id": "years.1",
            "ru": "год",
            "en": "year",
            "be": "год"
        },
        {
            "id": "years.234",
            "ru": "года",
            "en": "years",
            "be": "гады"
        },
        {
            "id": "years.other",
            "ru": "лет",
            "en": "years",
            "be": "гадоў"
        },
        {
            "id": "titles.addphysiciansBookmark",
            "ru": "Врач добавлен в закладки",
            "en": "Doctor added to bookmarks",
            "be": "Лекар дададзены ў закладкі"
        },
        {
            "id": "titles.removephysiciansBookmark",
            "ru": "Врач удален из закладок",
            "en": "Doctor removed from bookmarks",
            "be": "Лекар выдалены з закладак"
        },
        {
            "id": "titles.addclinicsBookmark",
            "ru": "Медцентр добавлен в закладки",
            "en": "Medical center added to bookmarks",
            "be": "Медцэнтр дададзены ў закладкі"
        },
        {
            "id": "titles.removeclinicsBookmark",
            "ru": "Медцентр удален из закладок",
            "en": "Medical center removed from bookmarks",
            "be": "Медцэнтр выдалены з закладак"
        },
        {
            "id": "titles.aCodeReminder",
            "ru": "{clinic} позволяет просматривать заключения врачей и результаты анализов в Aibolit. Для этого запросите специальный А-код в регистратуре вашего медучреждения.",
            "en": "{clinic} allows you to view doctors' reports and test results in Aibolit. To do this, request a special A-code from the reception desk of your medical institution.",
            "be": "{clinic} дазваляе праглядаць заключэнні лекараў і вынікі аналізаў у Aibolit. Для гэтага запытайце спецыяльны А-код у рэгістратуры вашай медустановы."
        },
        {
            "id": "stub.myFeedbacksNotAuthorizedTitle",
            "ru": "Данная функция доступна только авторизованным пользователям",
            "en": "This function is available only to authorized users",
            "be": "Дадзеная функцыя даступная толькі аўтарызаваным карыстальнікам"
        },
        {
            "id": "stub.myFeedbacksNotAuthorizedSubtitle",
            "ru": "Для того, чтобы пользоваться данным функционалом вы должны авторизоваться",
            "en": "To use this functionality, you must log in",
            "be": "Для таго, каб карыстацца дадзеным функцыяналам вы павінны аўтарызавацца"
        },
        {
            "id": "stub.myFeedbacksEmptyTitle",
            "ru": "Пусто",
            "en": "Empty",
            "be": "Пуста"
        },
        {
            "id": "stub.myFeedbacksEmptySubtitle",
            "ru": "В данной категории пока нет ни одного отзыва",
            "en": "There are no reviews in this category yet",
            "be": "У гэтай катэгорыі пакуль няма ніводнага водгуку"
        },
        {
            "id": "titles.allFeedbacksMyPage",
            "ru": "Мои отзывы",
            "en": "My feedbacks",
            "be": "Мае водгукі"
        },
        {
            "id": "titles.allFeedbacksSearchPage",
            "ru": "Поиск",
            "en": "Search",
            "be": "Пошук"
        },
        {
            "id": "titles.myFeedbacksFilterPublished",
            "ru": "АКТИВНЫЕ",
            "en": "ACTIVE",
            "be": "АКТЫУНЫЯ"
        },
        {
            "id": "titles.myFeedbacksFilterModeration",
            "ru": "НА МОДЕРАЦИИ",
            "en": "ON MODERATION",
            "be": "НА МАДЭРАЦЫІ"
        },
        {
            "id": "titles.myFeedbacksFilterDeclined",
            "ru": "ОТКЛОНЕННЫЕ",
            "en": "REJECTED",
            "be": "АДКЛЁНЕНЫЯ"
        },
        {
            "id": "supportEmail",
            "ru": "support@aibolit.md",
            "en": "support@aibolit.md",
            "be": "support@aibolit.md"
        },
        {
            "id": "titles.shareChildren",
            "ru": "Экспорт детей",
            "en": "Send childrens",
            "be": "Адправіць дзяцей"
        },
        {
            "id": "titles.shareMyFamily",
            "ru": "Экспорт семьи",
            "en": "Send family",
            "be": "Адправіць сям'ю"
        },
        {
            "id": "titles.passwordError",
            "ru": "Ошибка ключа",
            "en": "Key error",
            "be": "Памылка ключа"
        },
        {
            "id": "placeholders.shareFamilyKey",
            "ru": "Ключ доступа",
            "en": "Access key",
            "be": "Ключ доступу"
        },
        {
            "id": "buttons.shareMyFamilyShare",
            "ru": "Отправить",
            "en": "Send",
            "be": "Адправіць"
        },
        {
            "id": "titles.shareMyFamilyTitle",
            "ru": "Отправить состав семьи",
            "en": "Send family composition",
            "be": "Адправіць склад сям'і"
        },
        {
            "id": "titles.shareMyFamilyKey",
            "ru": "Введите ключ доступа, для иморта семьи на другом устройстве",
            "en": "Enter the access key to import your family on another device",
            "be": "Увядзіце ключ доступу, для иморта сям'і на іншай прыладзе"
        },
        {
            "id": "titles.importMyFamilyTitle",
            "ru": "Импорт семьи",
            "en": "Import family",
            "be": "Імпарт сям'і"
        },
        {
            "id": "titles.importMyFamilyKey",
            "ru": "Ключ доступа",
            "en": "Access key",
            "be": "Ключ доступу"
        },
        {
            "id": "titles.importMyFamilyData",
            "ru": "Данные для иморта",
            "en": "Import data",
            "be": "Дадзеныя для імарту"
        },
        {
            "id": "buttons.shareMyFamilyImport",
            "ru": "Импорт",
            "en": "Import",
            "be": "Імпарт"
        },
        {
            "id": "placeholders.importFamilyKey",
            "ru": "Ключ",
            "en": "Key",
            "be": "Ключ"
        },
        {
            "id": "placeholders.importFamilyData",
            "ru": "Данные",
            "en": "Data",
            "be": "Дадзеныя"
        },
        {
            "id": "titles.importMyFamily",
            "ru": "Импорт семьи",
            "en": "Import family",
            "be": "Імпартаваць сям'ю"
        },
        {
            "id": "error.wrongBookPerson",
            "ru": "К сожалению, запись данного пациента невозможна. Выберите, пожалуйста, другого пациента. Ошибка: {reason}",
            "en": "Unfortunately, booking of this person is not possible. Please choose another person. Error: {reason}",
            "be": "Нажаль, запіс дадзенага пацыента немагчымая. Абярыце, калі ласка, іншага пацыента. Памылка: {reason}"
        },
        {
            "id": "titles.importChildren",
            "ru": "Импорт детей",
            "en": "Import of children",
            "be": "Імпарт дзяцей"
        },
        {
            "id": "buttons.shareChildImport",
            "ru": "Импорт",
            "en": "Import",
            "be": "Імпарт"
        },
        {
            "id": "titles.importChildTitle",
            "ru": "Импорт детей",
            "en": "Import of children",
            "be": "Імпарт дзяцей"
        },
        {
            "id": "titles.shareChildTitle",
            "ru": "Отправить детей другому пользователю",
            "en": "Send children to another user",
            "be": "Адправіць дзяцей іншаму карыстальніку"
        },
        {
            "id": "titles.editUserPD",
            "ru": "УЧЕТНАЯ ЗАПИСЬ",
            "en": "ACCOUNT",
            "be": "ЎЛІКОВЫ ЗАПІС"
        },
        {
            "id": "titles.editUserVisits",
            "ru": "ВИЗИТЫ",
            "en": "VISITS",
            "be": "ВІЗІТЫ"
        },
        {
            "id": "titles.editUserReports",
            "ru": "АНАЛИЗЫ",
            "en": "TESTS",
            "be": "АНАЛІЗЫ"
        },
        {
            "id": "titles.fillProfilePDList",
            "ru": "Заполните учетные данные",
            "en": "Fill in the account details",
            "be": "Запоўніце уліковыя дадзеныя"
        },
        {
            "id": "hints.editUserPD",
            "ru": "Можно добавить только несовершеннолетнего ребёнка. Учетные данные детей будут храниться исключительно на вашем устройстве. При смене устройства их необходимо будет ввести повторно. Вы можете использовать информацию о визитах/анализах для правильной идентификации ребёнка.",
            "en": "You can add only a minor child. The children's account data will be stored exclusively on your device. When changing the device, this information will need to be re-entered. You can use visits/tests information for the correct identification of the child.",
            "be": "Можна дадаць толькі непаўналетняе дзіця. Уліковыя дадзеныя дзяцей будуць захоўвацца выключна на вашым прыладзе. Пры змене прылады іх неабходна будзе ўвесці паўторна. Вы можаце выкарыстоўваць інфармацыю аб візітах/аналізах для правільнай ідэнтыфікацыі дзіцяці."
        },
        {
            "id": "button.saveUserPD",
            "ru": "СОХРАНИТЬ",
            "en": "SAVE",
            "be": "ЗАХАВАЦЬ"
        },
        {
            "id": "titles.fillProfilePD"
        },
        {
            "id": "titles.navigationFillProfilePD",
            "ru": "Заполните учетные данные",
            "en": "Fill in the account details",
            "be": "Запоўніце уліковыя дадзеныя"
        },
        {
            "id": "titles.fillFamilyHelpText",
            "ru": "Вы можете добавить детей/супруга(у)/родителей, чтобы записывать их на прием к врачу. Также, можете присоединить к семье супруга(у), чтобы вы оба могли следить за визитами ваших детей, редактировать или переносить их. В случае возникновения вопросов:",
            "en": "You can add your children/spouse/parents to make medical appointments for them. You may also link your spouse to the family so that both of you can track your children's visits, edit or reschedule them. If you have any questions:",
            "be": "Вы можаце дадаць дзяцей/супруга(у)/родителей, каб запісаць іх на прыём да лекара. Таксама вы можаце далучыцца да сям'і мужа(у), каб вы маглі сачыць за візітамі вашых дзяцей, рэдагаваць або перанасіць іх. У выпадку ўзнікнення пытанняў:"
        },
        {
            "id": "titles.fillFamilyHelpLinkText",
            "ru": "обратиться в поддержку",
            "en": "contact support",
            "be": "звярнуцца ў падтрымку"
        },
        {
            "id": "titles.fillRelativeProfilesWindow",
            "ru": "Заполните учетные данные детей. В целях повышения безопасности в ряде случаев Aibolit больше не сохраняет персональные данные детей на сервере. Они хранятся только на вашем устройстве и в медицинских центрах. После смены мобильного телефона эти данные необходимо ввести повторно. При заполнении для идентификации пациента можно использовать информацию о визитах и анализах.",
            "en": "Please fill in children's account details. In order to increase security, in some cases Aibolit no longer stores children's personal data on the server. They are only stored on your device and in medical centers. After changing your mobile phone, this data needs be re-entered. When filling out, you can use information about visits and tests to identify the patient.",
            "be": "Запоўніце уліковыя дадзеныя дзяцей. У мэтах падвышэння бяспекі ў шэрагу выпадкаў Aibolit больш не захоўвае персанальныя дадзеныя дзяцей на серверы. Яны захоўваюцца толькі на вашым прыладзе і ў медыцынскіх цэнтрах. Пасля змены мабільнага тэлефона гэтыя дадзеныя неабходна ўвесці паўторна. Пры запаўненні для ідэнтыфікацыі пацыента можна выкарыстоўваць інфармацыю аб візітах і аналізах."
        },
        {
            "id": "titles.fillRelativeProfilesButton",
            "ru": "ЗАПОЛНИТЬ ДАННЫЕ",
            "en": "FILL IN DATA",
            "be": "ЗАПОЎНІЦЬ ДАДЗЕНЫЯ"
        },
        {
            "id": "titles.fillProfilePopupTitle",
            "ru": "ЗАПОЛНИТЬ ДАННЫЕ",
            "en": "FILL IN DATA",
            "be": "ЗАПОЎНІЦЬ ДАДЗЕНЫЯ"
        },
        {
            "id": "titles.fillProfilePopupText",
            "ru": "Для записи к врачам заполните профиль",
            "en": "To make an appointment with doctors, fill out your profile",
            "be": "Для запісу да лекараў запоўніце профіль"
        },
        {
            "id": "titles.fillProfilePopupButton",
            "ru": "ЗАПОЛНИТЬ",
            "en": "FILL",
            "be": "Запоўніць"
        },
        {
            "id": "titles.newVisitFound",
            "ru": "Найден визит",
            "en": "A visit is found",
            "be": "Знойдзены візіт"
        },
        {
            "id": "titles.savePatientDataOfVisit",
            "ru": "Сохранить данные пациента",
            "en": "Save patient data",
            "be": "Захавать дадзеныя пацыента"
        },
        {
            "id": "hint.savePatientDataOfVisit",
            "ru": "Вы можете сохранить пациента в Aibolit, чтобы в будущем записывать его/ее на прием",
            "en": "You can save the patient in Aibolit to schedule appointments for him/her in the future",
            "be": "Вы можаце захаваць пацыента ў Aibolit, каб у будучыні запісваць яго/яе на прыём"
        },
        {
            "id": "titles.visitInfo",
            "ru": "{date} к {doctor}, {mc}, пациент: {name} ({birthday})",
            "en": "{date} to {doctor}, {mc}, patient: {name} ({birthday})",
            "be": "{date} да {doctor}, {mc}, пацыент: {name} ({birthday})"
        },
        {
            "id": "titles.thisVisitIsFor",
            "ru": "Это визит для: ",
            "en": "This is a visit for:",
            "be": "Гэта візіт для:"
        },
        {
            "id": "titles.forMe",
            "ru": "Меня",
            "en": "Me",
            "be": "Мяне"
        },
        {
            "id": "titles.forMyChild",
            "ru": "Моего ребенка",
            "en": "My child",
            "be": "Майго дзіцяці"
        },
        {
            "id": "titles.other",
            "ru": "Другое",
            "en": "Other",
            "be": "Іншае"
        },
        {
            "id": "titles.newVisitEmailPlaceholder",
            "ru": "используется для доступа к профилю Aibolit",
            "en": "used to access Aibolit profile",
            "be": "выкарыстоўваецца для доступу да профіля Aibolit"
        },
        {
            "id": "titles.newVisitEmail",
            "ru": "ВАШ EMAIL (ДЛЯ ДОСТУПА К AIBOLIT)",
            "en": "YOUR EMAIL (FOR ACCESS TO AIBOLIT)",
            "be": "ВАШ EMAIL (ДЛЯ ДОСТУПУ ДА AIBOLIT)"
        },
        {
            "id": "titles.alreadyImportedTitle",
            "ru": "Визит не найден",
            "en": "Visit not found",
            "be": "Візіт не знойдзены"
        },
        {
            "id": "titles.alreadyImportedText",
            "ru": "К сожалению, мы не смогли найти эту запись среди ваших будущих визитов. Возможно, запись была создана с указанием другого номера телефона, либо уже состоялась, или была отменена/перенесена на стороне медицинского центра. Вы можете создать новый визит с помощью Aibolit",
            "en": "Unfortunately, we couldn't find this record among your upcoming visits. It's possible that the appointment was created with a different phone number, or has already occured, or was canceled/rescheduled by the medical center. You can create a new visit using Aibolit",
            "be": "Нажаль, мы не змаглі знайсці гэты запіс сярод вашых будучых візітаў. Магчыма, запіс быў створаны з указаннем іншага нумара тэлефона, альбо ўжо адбыўся, ці быў адменены/перанесены на баку медыцынскага цэнтра. Вы можаце стварыць новы візіт з дапамогай Aibolit"
        },
        {
            "id": "buttons.chooseDoctor",
            "ru": "ВЫБРАТЬ ВРАЧА",
            "en": "CHOOSE A DOCTOR",
            "be": "ВЫБРАЦЬ ЛЕКАРА"
        },
        {
            "id": "titles.visitTilte",
            "ru": "ВИЗИТ: ",
            "en": "VISIT:",
            "be": "ВІЗІТ:"
        },
        {
            "id": "titles.otherNavigationMwaTitle",
            "ru": "Мобильная версия",
            "en": "Mobile version",
            "be": "Мабільная версія"
        },
        {
            "id": "titles.otherNavigationMwaLinkFallback"
        },
        {
            "id": "titles.otherNavigationMwaLinkDomain",
            "ru": "https://ln.aibolit.md",
            "en": "https://ln.aibolit.md",
            "be": "https://ln.aibolit.md"
        },
        {
            "id": "titles.installMobileVersionLinkDomain",
            "ru": "https://ln.aibolit.md",
            "en": "https://ln.aibolit.md",
            "be": "https://ln.aibolit.md"
        },
        {
            "id": "titles.myCityLabel",
            "ru": "Мой город: {city}",
            "en": "My city: {city}",
            "be": "Мой горад: {city}"
        },
        {
            "id": "titles.doctorsNotFoundStub",
            "ru": "К сожалению, по вашему запросу ничего не найдено.",
            "en": "Unfortunately, your search returned no results.",
            "be": "Нажаль, па вашым запыце нічога не знойдзена."
        },
        {
            "id": "titles.doctorsNotFoundStubTitle",
            "ru": "Врач не найден",
            "en": "Doctor not found",
            "be": "Лекар не знойдзены"
        },
        {
            "id": "titles.installMobileVersionText",
            "ru": "Установите Aibolit на свое устройство, чтобы информация о визитах и удобная запись на прием в любимый медцентр всегда были под рукой. Добавляйте в семью и записывайте к врачам детей, супругов и других родственников в несколько нажатий. Используйте рекомендации и отзывы других пользователей для выбора специалиста, который подойдет именно вам. Ищите лекарства по наиболее выгодной цене не выходя из приложения.",
            "en": "Install Aibolit on your device so that information about visits and convenient appointments at your favorite medical center are always at hand. Add children, spouses and other relatives to your family and schedule appointments with doctors in a few taps. Use recommendations and reviews from other users to choose a specialist that suits you best. Search for medications at the best prices without leaving the app.",
            "be": "Усталюйце Aibolit на сваю прыладу, каб інфармацыя аб візітах і зручная запіс на прыём у любімы медцэнтр заўсёды былі пад рукой. Дадавайце ў сям'ю і запісвайце да лекараў дзяцей, мужа і жонкі і іншых сваякоў у некалькі націскаў. Выкарыстоўвайце рэкамендацыі і водгукі іншых карыстальнікаў для выбару спецыяліста, які падыдзе менавіта вам. Шукайце лекі па найбольш выгаднай цане не выходзячы з прыкладання."
        },
        {
            "id": "titles.installMobileVersionButton",
            "ru": "УСТАНОВИТЬ AIBOLIT",
            "en": "INSTALL AIBOLIT",
            "be": "УСТАНАВІЦЬ"
        },
        {
            "id": "titles.addDoctorToBookmarks",
            "ru": "Добавить врача в закладки",
            "en": "Add a doctor to your bookmarks",
            "be": "Дадаць лекара ў закладкі"
        },
        {
            "id": "dates.today",
            "ru": "Сегодня",
            "en": "Today",
            "be": "Сёння"
        },
        {
            "id": "dates.tomorrow",
            "ru": "Завтра",
            "en": "Tomorrow",
            "be": "Заўтра"
        },
        {
            "id": "dates.ru.monthNames",
            "ru": "[\"Январь\",\"Февраль\",\"Март\",\"Апрель\",\"Май\",\"Июнь\",\"Июль\",\"Август\",\"Сентябрь\",\"Октябрь\",\"Ноябрь\",\"Декабрь\"]",
            "en": "[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"]",
            "be": "[\"Студзень\",\"Люты\",\"Сакавік\",\"Красавік\",\"Май\",\"Чэрвень\",\"Ліпеня\",\"Аўгуст\",\"Верасень\",\"Кастрычнік\",\"Лістапад\",\"Снежань\"]"
        },
        {
            "id": "dates.ru.monthNamesShort",
            "ru": "[\"Янв\",\"Фев\",\"Март\",\"Апр\",\"Май\",\"Июня\",\"Июля\",\"Авг\",\"Сен\",\"Окт\",\"Ноя\",\"Дек\"]",
            "en": "[\"Jan\",\"Feb\",\"March\",\"Apr\",\"May\",\"June\",\"July\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"]",
            "be": "[\"Янв\",\"Фев\",\"Сакавік\",\"Апр\",\"Май\",\"Чэрвеня\",\"Ліпеня\",\"Аўг\",\"Сен\",\"Окт\",\"Ноя\",\"Дэк\"]"
        },
        {
            "id": "dates.ru.monthNamesDeclination",
            "ru": "[\"Января\",\"Февраля\",\"Марта\",\"Апреля\",\"Мая\",\"Июня\",\"Июля\",\"Августа\",\"Сентября\",\"Октября\",\"Ноября\",\"Декабря\"]",
            "en": "[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"]",
            "be": "[\"Студзеня\",\"Лютага\",\"Сакавік\",\"Красавіка\",\"Мая\",\"Чэрвеня\",\"Ліпеня\",\"Аўгуста\",\"Верасні\",\"Кастрычніка\",\"Лістапада\",\"Снежня\"]"
        },
        {
            "id": "dates.ru.dayNames",
            "ru": "[\"Воскресенье\",\"Понедельник\",\"Вторник\",\"Среда\",\"Четверг\",\"Пятница\",\"Суббота\"]",
            "en": "[\"Sunday\",\"Monday\",\"Tuesday\",\"Wednesday\",\"Thursday\",\"Friday\",\"Saturday\"]",
            "be": "[\"Нядзеля\",\"Панядзелак\",\"Аўторак\",\"Асяроддзе\",\"Чацвер\",\"Пятніца\",\"Субота\"]"
        },
        {
            "id": "dates.ru.dayNamesShort",
            "ru": "[\"ВС\",\"ПН\",\"ВТ\",\"СР\",\"ЧТ\",\"ПТ\",\"СБ\"]",
            "en": "[\"SU\",\"MO\",\"TU\",\"WE\",\"TH\",\"FR\",\"SA\"]",
            "be": "[\"НД\",\"ПН\",\"АУ\",\"СР\",\"ЧТ\",\"ПТ\",\"СБ\"]"
        },
        {
            "id": "dates.ru.bookMonthNamesShort",
            "ru": "[\"Янв\",\"Фев\",\"Март\",\"Апр\",\"Май\",\"Июня\",\"Июля\",\"Авг\",\"Сен\",\"Окт\",\"Ноя\",\"Дек\"]",
            "en": "[\"Jan\",\"Feb\",\"March\",\"Apr\",\"May\",\"June\",\"July\",\"Aug\",\"Sep\",\"Oct\",\"Nov\",\"Dec\"]",
            "be": "[\"Янв\",\"Фев\",\"Сакавік\",\"Апр\",\"Май\",\"Чэрвеня\",\"Ліпеня\",\"Аўг\",\"Сен\",\"Окт\",\"Ноя\",\"Дэк\"]"
        },
        {
            "id": "dates.from",
            "ru": "С",
            "en": "From",
            "be": "З"
        },
        {
            "id": "dates.at",
            "ru": "в",
            "en": "at",
            "be": "у"
        },
        {
            "id": "handeledAges.adult",
            "ru": "Взрослые и д",
            "en": "Adults and c",
            "be": "Дарослыя i д"
        },
        {
            "id": "handeledAges.childsStart",
            "ru": "Д",
            "en": "C",
            "be": "Д"
        },
        {
            "id": "handeledAges.childsFrom",
            "ru": "ети (c {minAge})",
            "en": "hildren (from {minAge})",
            "be": "ецi (з {minAge})"
        },
        {
            "id": "handeledAges.childsFromTo",
            "ru": "ети (c {minAge} до {maxAge})",
            "en": "hildren (from {minAge} to {maxAge})",
            "be": "ецi (з {minAge} да {maxAge})"
        },
        {
            "id": "handeledAges.childsContinue",
            "ru": "ети",
            "en": "hildren",
            "be": "ецi"
        },
        {
            "id": "titles.DECLINE_REASON_1",
            "ru": "Бронирование визитов к этом врачу недоступно",
            "en": "Booking appointments with this doctor is not available.",
            "be": "Браніраванне візітаў да гэтага лекара недаступна"
        },
        {
            "id": "titles.DECLINE_REASON_2",
            "ru": "Бронирование визитов в эту клинику недоступно",
            "en": "Booking appointments at this clinic is not available.",
            "be": "Браніраванне візітаў у гэтую клініку недаступна"
        },
        {
            "id": "titles.DECLINE_REASON_3",
            "ru": "Бронирование визитов для вашего профиля отключено администратором.",
            "en": "Booking appointments for your profile has been disabled by the administrator.",
            "be": "Браніраванне візітаў для вашага профілю адключана адміністратарам."
        },
        {
            "id": "titles.DECLINE_REASON_4",
            "ru": "Медицинская карточка отсутствует в клинике.",
            "en": "The medical card is missing in the clinic.",
            "be": "Медыцынская картка адсутнічае ў клініцы."
        },
        {
            "id": "titles.DECLINE_REASON_5",
            "ru": "Бронирование визитов в эту клинику ещё не сделано.",
            "en": "Booking appointments at this clinic has not been made yet.",
            "be": "Браніраванне візітаў у гэтую клініку яшчэ не зроблена."
        },
        {
            "id": "titles.DECLINE_REASON_6",
            "ru": "Внутренняя ошибка: отсутствует physician externalId.",
            "en": "Internal error: physician externalId is missing.",
            "be": "Унутраная памылка: адсутнічае physician externalId."
        },
        {
            "id": "titles.DECLINE_REASON_7",
            "ru": "Бронирование доступно только для совершеннолетних лиц.",
            "en": "Booking is available only for adults.",
            "be": "Браніраванне даступна толькі для паўналетніх асоб."
        },
        {
            "id": "titles.DECLINE_REASON_8",
            "ru": "Врач не принимает пациентов вашего возраста.",
            "en": "The doctor does not accept patients of your age.",
            "be": "Лекар не прымае пацыентаў вашага ўзросту."
        },
        {
            "id": "titles.DECLINE_REASON_9",
            "ru": "Не указан день рождения при записи к врачу с ограничением приёма во возрасту.",
            "en": "The birthday is not specified when booking to the doctor with an age limit.",
            "be": "Не пазначаны дзень нараджэння пры запісе да ўрача з абмежаваннем прыёму ва ўзросце."
        },
        {
            "id": "titles.DECLINE_REASON_10",
            "ru": "Профайл пользователя не заполнен.",
            "en": "User profile is not filled out.",
            "be": "Прафайл карыстальніка не запоўнены."
        },
        {
            "id": "titles.DECLINE_REASON_11",
            "ru": "Медицинская карта для обслуживания по программе еще неактивна в выбранной клинике.",
            "en": "The medical card for the program service is not yet active in the selected clinic.",
            "be": "Медыцынская карта для абслугоўвання па праграме яшчэ неактыўная ў абранай клініцы."
        },
        {
            "id": "titles.DECLINE_REASON_12",
            "ru": "Услуга не оказывается пациентам вашего возраста.",
            "en": "The service is not provided to patients of your age.",
            "be": "Паслуга не аказваецца пацыентам вашага ўзросту."
        },
        {
            "id": "titles.USER_NOT_REGISTERED",
            "ru": "Пользователь не зарегистрирован",
            "en": "The user is not registered.",
            "be": "Карыстальнік не зарэгістраваны"
        },
        {
            "id": "titles.INVALID_ACODE_BLOCKED",
            "ru": "Многократно представлен неверный А-код. Повторный ввод возможен через 2 минут(ы)",
            "en": "Incorrect A-code has been entered multiple times. Another attempt can be made in 2 minutes.",
            "be": "Шматразова прадстаўлены няправільны А-код. Паўторны ўвод магчымы праз 2 хвілін(ы)"
        },
        {
            "id": "error.TIMESLOT_IS_BUSY",
            "ru": "Выбранное время уже занято. Рекомендуется выбрать другое время.",
            "en": "The selected time is already taken. It is recommended to choose another time.",
            "be": "Абраны час ужо заняты. Рэкамендуецца абраць іншы час."
        },
        {
            "id": "sex.OTHER",
            "ru": "Другое",
            "en": "Other",
            "be": "Іншае"
        },
        {
            "id": "error.CODE_DOCTOR_AGE_LIMITS",
            "ru": "Врач не принимает пациентов вашего возраста.",
            "en": "The doctor does not accept patients of your age.",
            "be": "Лекар не прымае пацыентаў вашага ўзросту."
        },
        {
            "id": "screenTitles.MainFeedbacks",
            "ru": "Отзывы",
            "en": "Feedbacks",
            "be": "Водгукі"
        },
        {
            "id": "titles.filterAgeTitle",
            "ru": "ВОЗРАСТ ПАЦИЕНТА",
            "en": "PATIENT AGE",
            "be": "УЗРОСТ ПАТЫЕНТА"
        },
        {
            "id": "titles.filterAgeChild",
            "ru": "Детский",
            "en": "Kids",
            "be": "Дзіцячы"
        },
        {
            "id": "title.filterAgeAdult",
            "ru": "Взрослый",
            "en": "Adults",
            "be": "Дарослы"
        },
        {
            "id": "title.filterAgeAny",
            "ru": "Любой возраст",
            "en": "All ages",
            "be": "Любы ўзрост"
        },
        {
            "id": "titles.filterAgeTitlePopup",
            "ru": "Возраст пациента",
            "en": "Age of the patient",
            "be": "Узрост пацыента"
        },
        {
            "id": "titles.searchInProgress",
            "ru": "Выполняется поиск",
            "en": "Search in progress",
            "be": "Выконваецца пошук"
        },
        {
            "id": "titles.searchSpecializationsSectionNull",
            "ru": "Cпециальности",
            "en": "Specialties",
            "be": "Навука"
        },
        {
            "id": "titles.searchDoctorsSectionNull",
            "ru": "Врачи",
            "en": "Doctors",
            "be": "Лекары"
        },
        {
            "id": "titles.allFeedbacksHasText",
            "ru": "Наличие текста",
            "en": "Text presence",
            "be": "Наяўнасць тэксту"
        },
        {
            "id": "titles.allFeedbacksHideNotRecommend",
            "ru": "Скрыть \"не рекомендую\"",
            "en": "Hide \"I don't recommend\"",
            "be": "Схаваць \"не рэкамендую\""
        },
        {
            "id": "titles.allFeedbacksHideNeutral",
            "ru": "Скрыть \"все хорошо/нейтрально\"",
            "en": "Hide \"everything is good/neutral\"",
            "be": "Схаваць \"усё добра/нейтральна\""
        },
        {
            "id": "titles.allFeedbacksHideRecommend",
            "ru": "Скрыть \"рекомендую\"",
            "en": "Hide \"I recommend\"",
            "be": "Схаваць \"рэкамендую\""
        },
        {
            "id": "titles.usingTheApplication",
            "ru": "Использование приложения Aibolit",
            "en": "Using the Aibolit application",
            "be": "Выкарыстанне прыкладання Aibolit"
        },
        {
            "id": "titles.usingTheApplicationHint",
            "ru": "Для продолжения работы в приложении просим предоставить согласие на обработку персональных данных в связи с его отсутствием или истечением срока действия предыдущего.",
            "en": "To continue working in the application, please provide consent to the processing of personal data due to its absence or expiration of the previous one.",
            "be": "Для працягу працы ў дадатку просім падаць згоду на апрацоўку персанальных дадзеных у сувязі з яго адсутнасцю або заканчэннем тэрміна дзеяння папярэдняга."
        },
        {
            "id": "screenTitles.ConsentConfirmation",
            "ru": "Согласие на обработку персональных данных",
            "en": "Consent to the processing of personal data",
            "be": "Згода на апрацоўку персанальных дадзеных"
        },
        {
            "id": "hints.offline-medcenter-details-record",
            "ru": "Вы можете записаться на визит, позвонив по любому из телефонов.",
            "en": "You can make an appointment by calling any of the numbers.",
            "be": "Вы можаце запісацца на візіт, патэлефанаваўшы па любым з тэлефонаў."
        },
        {
            "id": "error.calendar_permissionIOS",
            "ru": "Для работы с календарем предоставьте приложению к нему доступ в настройках iOS",
            "en": "To work with the calendar, grant the app access to it in the iOS settings",
            "be": "Для працы з календаром падайце з дадаткам да яго доступ у наладах iOS"
        },
        {
            "id": "error.calendar_permissionAndroid",
            "ru": "Для работы с календарем предоставьте приложению к нему доступ в настройках Android",
            "en": "To work with the calendar, grant the app access to it in the Android settings",
            "be": "Для працы з календаром падайце з дадаткам да яго доступ у наладах Android"
        },
        {
            "id": "reminder.confirmEmail",
            "ru": "Электронная почта {email} ожидает верификации. Подтвердите адрес, чтобы получить доступ к профилю после смены устройства",
            "en": "Email {email} is awaiting verification. Confirm the address to access your profile after changing your device",
            "be": "Электронная пошта {email} чакае верыфікацыі. Пацвердзіце адрас, каб атрымаць доступ да профіля пасля змены прылады"
        },
        {
            "id": "reminder.confirmEmailButton",
            "ru": "ПОДТВЕРДИТЬ",
            "en": "CONFIRM",
            "be": "ПАДЦЯРЗІЦЬ"
        },
        {
            "id": "titles.backupRestore",
            "ru": "Сохранить/восстановить данные",
            "en": "Backup/Restore data",
            "be": "Захаваць/аднавіць дадзеныя"
        },
        {
            "id": "screenTitles.Backup",
            "ru": "Сохранить/восстановить данные",
            "en": "Backup/Restore data",
            "be": "Захаваць/аднавіць дадзеныя"
        },
        {
            "id": "titles.backupRestoreHeader",
            "ru": "Сохранить/восстановить данные",
            "en": "Backup/Restore data",
            "be": "Захаваць/аднавіць дадзеныя"
        },
        {
            "id": "screenTitles.BackupHeader",
            "ru": "Сохранить/восстановить данные",
            "en": "Backup/Restore data",
            "be": "Захаваць/аднавіць дадзеныя"
        },
        {
            "id": "warning.lode",
            "ru": "ЛОДЭ временно не работает с Aibolit, поэтому в приложении отключена онлайн-запись в этот МЦ. Также не будет отображаться информация о ваших будущих визитах туда, список врачей, которые работают только в ЛОДЭ, и отзывы о них.\n\nЗаписаться на прием в ЛОДЭ можно по телефону 111, на сайте МЦ (через форму или чат) либо в мобильном приложении LODE.",
            "en": "LODE is temporarily not working with Aibolit, so online booking for this MC is disabled in the app. Also, information about your future visits there, a list of doctors who work only at LODE, and reviews about them will not be displayed.\n\nYou can make an appointment at LODE by calling 111, on the MC website (via form or chat), or in the LODE mobile app.",
            "be": "ЛАДЭ часова не працуе з Aibolit, таму ў дадатку адключаная анлайн-запіс у гэты МЦ. Таксама не будзе адлюстроўвацца інфармацыя аб вашых будучых візітах туды, спіс лекараў, якія працуюць толькі ў ЛОДЭ, і водгукі пра іх.\n\nЗапісацца на прыём у ЛАДЭ можна па тэлефоне 111, на сайце МЦ (праз форму ці чат) альбо ў мабільным дадатку LODE."
        },
        {
            "id": "titles.backupRestoreHeaderBackup",
            "ru": "Сохранить данные в {store} своего аккаунта",
            "en": "Backup data to your account's {store}",
            "be": "Захаваць дадзеныя ў {store} свайго акаўнта"
        },
        {
            "id": "titles.backupRestoreHeaderRestore",
            "ru": "Восстановить данные из {store} своего аккаунта",
            "en": "Restore data from your account's {store}",
            "be": "Ааднавіць дадзеныя з {store} свайго акаўнта"
        },
        {
            "id": "action.backup",
            "ru": "Сохранить данные",
            "en": "Backup",
            "be": "Захаваць дадзеныя"
        },
        {
            "id": "action.restore",
            "ru": "Восстановить данные",
            "en": "Restore",
            "be": "Аднавіць дадзеныя"
        },
        {
            "id": "titles.restoreTitle",
            "ru": "Восстановить данные",
            "en": "Restore",
            "be": "Аднавіць дадзеныя"
        },
        {
            "id": "footer.backupVisitsCount",
            "ru": "Найдено {count} визитов в приложении",
            "en": "Found {count} visits to the app",
            "be": "Знойдзена {count} візітаў у дадатку"
        },
        {
            "id": "warning.lodeSpace",
            "ru": "ЛОДЭ временно не работает с Aibolit, поэтому в приложении отключена онлайн-запись в этот МЦ. Также не будет отображаться информация о ваших будущих визитах туда, список врачей, которые работают только в ЛОДЭ, и отзывы о них.\n\nЗаписаться на прием в ЛОДЭ можно по телефону 111, на сайте МЦ (через форму или чат) либо в мобильном приложении LODE.",
            "en": "LODE is temporarily not working with Aibolit, so online booking for this MC is disabled in the app. Also, information about your future visits there, a list of doctors who work only at LODE, and reviews about them will not be displayed.\n\nYou can make an appointment at LODE by calling 111, on the MC website (via form or chat), or in the LODE mobile app.",
            "be": "ЛАДЭ часова не працуе з Aibolit, таму ў дадатку адключаная анлайн-запіс у гэты МЦ. Таксама не будзе адлюстроўвацца інфармацыя аб вашых будучых візітах туды, спіс лекараў, якія працуюць толькі ў ЛОДЭ, і водгукі пра іх.\n\nЗапісацца на прыём у ЛАДЭ можна па тэлефоне 111, на сайце МЦ (праз форму ці чат) альбо ў мабільным дадатку LODE."
        },
        {
            "id": "footer.backupNoVisits",
            "ru": "Нет визитов в приложении",
            "en": "No visits in the app",
            "be": "Няма візітаў у дадатку"
        },
        {
            "id": "errors.noAccessGoogleDrive",
            "ru": "Нет доступа к Google Drive",
            "en": "No access to Google Drive",
            "be": "Няма доступу да Google Drive"
        },
        {
            "id": "errors.jsonFormatError",
            "ru": "Ошибка формата данных",
            "en": "Data format error",
            "be": "Памылка фармату дадзеных"
        },
        {
            "id": "errors.backupError",
            "ru": "{addInfo}",
            "en": "{addInfo}",
            "be": "{addInfo}"
        },
        {
            "id": "buttons.googleBackup",
            "ru": "Сохранить в Google Drive",
            "en": "Backup to Google Drive",
            "be": "Захаваць у Google Drive"
        },
        {
            "id": "buttons.icloudBackup",
            "ru": "Сохранить в iCloud",
            "en": "Backup to iCloud",
            "be": "Захаваць у iCloud"
        },
        {
            "id": "warning.noDataForBackup",
            "ru": "Нет данных для сохранения",
            "en": "There is no data to backup.",
            "be": "Няма дадзеных для захавання"
        },
        {
            "id": "titles.backupSuccessful",
            "ru": "Данные успешно сохранены",
            "en": "Data saved successfully",
            "be": "Дадзеныя паспяхова захаваны"
        },
        {
            "id": "warning.noDataForRestore",
            "ru": "Нет данных для восстановления",
            "en": "No data to restore",
            "be": "Няма дадзеных для аднаўлення"
        },
        {
            "id": "titles.selectBackupForRestore",
            "ru": "Выберите данные для восстановления",
            "en": "Select a backup to restore",
            "be": "Абярыце дадзеные для аднаўлення"
        },
        {
            "id": "confirmations.restoreVisits",
            "ru": "Вы действительно хотите восстановить из резервной копии {count} визитов? Предыдущие данные будут удалены ({oldCount} визитов)?",
            "en": "Do you really want to restore visits from a backup {Count}? Previous data will be deleted ({OldCount})?",
            "be": "Вы сапраўды хочаце аднавіць наведванне з рэзервовай копіі {Count}? Папярэднія дадзеныя будуць выдалены ({oldCount})?"
        },
        {
            "id": "button.backup",
            "ru": "СОЗДАТЬ КОПИЮ",
            "en": "BACKUP",
            "be": "СТВАРЫЦЬ КОПІЮ"
        },
        {
            "id": "button.restore",
            "ru": "ВОССТАНОВИТЬ",
            "en": "RESTORE",
            "be": "УСПАЎСЮДЖВАЦЬ"
        },
        {
            "id": "titles.restoreTitle",
            "ru": "Восстановление",
            "en": "Restoring",
            "be": "Знаходка"
        },
        {
            "id": "buttons.googleBackupRestore",
            "ru": "Восстановить данные из Google Drive",
            "en": "Restore data from Google Drive",
            "be": "Аднаўленне дадзеных з Google Drive"
        },
        {
            "id": "buttons.iCloudBackupRestore",
            "ru": "Восстановить данные из iCloud",
            "en": "Restore data from iCloud",
            "be": "Аднаўленне дадзеных з iCloud"
        },
        {
            "id": "warning.sameDataForRestore",
            "ru": "Данные для восстановления идентичные текущим данным",
            "en": "Data for recovery identical to current data",
            "be": "Дадзеныя для аднаўлення, ідэнтычныя бягучым дадзеных"
        },
        {
            "id": "warning.restoreFailed",
            "ru": "Ошибка восстановления",
            "en": "Restore error",
            "be": "Памылка аднаўлення"
        },
        {
            "id": "titles.noAuthBackupTitle",
            "ru": "Внимание",
            "en": "Attention",
            "be": "Увага"
        },
        {
            "id": "titles.noAuthBackupSubtitle",
            "ru": "Данная функция доступна только авторизованным пользователям",
            "en": "This function is available only to authorized users",
            "be": "Дадзеная функцыя даступная толькі аўтарызаваным карыстальнікам"
        },
        {
            "id": "titles.restoreSuccessful",
            "ru": "Восстановление выполнено успешно",
            "en": "Data restored successful",
            "be": "Аднаўленне выканана паспяхова"
        },
        {
            "id": "errors.restoreFailed",
            "ru": "Ошибка восстановления данных",
            "en": "Data restore error",
            "be": "Памылка аднаўлення дадзеных"
        },
        {
            "id": "reminder.connectGoogleDrive",
            "ru": "Включите синхронизацию с облаком для того, чтобы не потерять историю визитов, закладки и другую информацию при смене устройства",
            "en": "Enable cloud synchronization to avoid losing your browsing history, bookmarks, and other information when changing devices",
            "be": "Уключыце сінхранізацыю з воблакам для таго, каб не страціць гісторыю візітаў, закладкі і іншую інфармацыю пры змене прылады"
        },
        {
            "id": "reminder.connectGoogleDriveButton",
            "ru": "АКТИВИРОВАТЬ",
            "en": "ACTIVATE",
            "be": "АКТЫВАВАЦЬ"
        },
        {
            "id": "section.backup",
            "ru": "Резервное копирование",
            "en": "Backup",
            "be": "Рэзервовае капіраванне"
        },
        {
            "id": "errors.googleDriveNotConnected",
            "ru": "Google Drive не подключен",
            "en": "Google Drive is not connected",
            "be": "Google Drive не падлучаны"
        },
        {
            "id": "titles.googleDriveBackupInfo",
            "ru": "{date}, {size} мб{device}",
            "en": "{date},\n{size} MB{device}",
            "be": "{date},\n{size} мб{device}"
        },
        {
            "id": "titles.googleDriveBackupInfoWithoutSize",
            "ru": "{date}{device}",
            "en": "{date}{device}",
            "be": "{date}{device}"
        },
        {
            "id": "titles.googleDriveBackupInfoTitle",
            "ru": "Последняя резервная копия:",
            "en": "Last backup:",
            "be": "Апошняя рэзервовая копія:"
        },
        {
            "id": "titles.backupScreenNotification",
            "ru": "Сохраните историю визитов, закладки и другую информацию, чтобы восстановить ее при переустановке Aibolit или смене устройства. Хранение данных регулируется правилами и политиками {cloud}.",
            "en": "Save your visits history, bookmarks, and other information to restore it when reinstalling Aibolit or changing your device. Data storage is governed by {cloud} rules and policies.",
            "be": "Захавайце гісторыю візітаў, закладкі і іншую інфармацыю, каб аднавіць яе пры пераўсталёўцы Aibolit або змене прылады. Захоўванне дадзеных рэгулюецца правіламі і палітыкамі {cloud}."
        },
        {
            "id": "titles.backupAlsoReserved",
            "ru": "ВКЛЮЧИТЬ В КОПИЮ",
            "en": "INCLUDE IN COPY",
            "be": "ВКЛЮЧЫЦЬ У КОПІЮ"
        },
        {
            "id": "titles.backupVisitAttachmentsCheckbox",
            "ru": "Файлы, прикрепленные к визитам",
            "en": "Files attached to visits",
            "be": "Файлы, прымацаваныя да візітаў"
        },
        {
            "id": "titles.backupVisitDocumentsCheckbox",
            "ru": "Мои документы",
            "en": "My documents",
            "be": "Мае дакументы"
        },
        {
            "id": "titles.googleDrive",
            "ru": "Google drive",
            "en": "Google drive",
            "be": "Google drive"
        },
        {
            "id": "titles.iCloud",
            "ru": "iCloud",
            "en": "iCloud",
            "be": "iCloud"
        },
        {
            "id": "titles.backupAttachmentsWifiCheckbox",
            "ru": "Только через Wi-Fi",
            "en": "Only via Wi-Fi",
            "be": "Толькі праз Wi-Fi"
        },
        {
            "id": "titles.useCloudText",
            "ru": "ИCПОЛЬЗОВАТЬ ОБЛАКО",
            "en": "Use the cloud",
            "be": "Выкарыстоўваць воблака"
        },
        {
            "id": "errors.googleDriveBackupAlreadyStarted",
            "ru": "Резервирование в Google Drive уже запущено",
            "en": "Backup to the Google Drive has already been launched",
            "be": "Рэзерваванне ў Google Drive ўжо запушчана"
        },
        {
            "id": "info.googleDriveBackupFinished",
            "ru": "Резервирование в Google Drive завершено успешно",
            "en": "Google Drive backup completed successfully",
            "be": "Рэзерваванне ў Google Drive завершана паспяхова"
        },
        {
            "id": "errors.googleDriveBackupDisabled",
            "ru": "Резервирование в Google Drive отключено",
            "en": "Google Drive backup is disabled",
            "be": "Рэзерваванне ў Google Drive адключана"
        },
        {
            "id": "errors.googleDriveBackupAttachmentsFailed",
            "ru": "Резервирование прикрепленных файлов прошло с ошибкой ({count} файлов)",
            "en": "Backing up attached files failed with an error ({count} files)",
            "be": "Рэзерваванне прымацаваных файлаў прайшло з памылкай ({count} файлаў)"
        },
        {
            "id": "errors.googleDriveBackupAttachmentsError",
            "ru": "Ошибка резервирования прикрепленных файлов{addInfo}",
            "en": "Error backing up attached files{addInfo}",
            "be": "Памылка рэзервавання прымацаваных файлаў{addInfo}"
        },
        {
            "id": "section.restore",
            "ru": "Восстановить из резервной копии",
            "en": "Restore from backup",
            "be": "Аднавіць з рэзервовай копіі"
        },
        {
            "id": "titles.restoreScreenNotification",
            "ru": "Восстановите историю визитов, закладки и другую информацию. Хранение данных регулируется правилами и политиками {cloud}.",
            "en": "Restore visit history, bookmarks and other information. Data storage is regulated by {cloud} rules and policies.",
            "be": "Аднавіце гісторыю візітаў, закладкі і іншую інфармацыю. Захоўванне дадзеных рэгулюецца правіламі і палітыкамі {cloud}."
        },
        {
            "id": "errors.googleDriveRestoreAlreadyStarted",
            "ru": "Восстановление уже запущено",
            "en": "Recovery has already started",
            "be": "Аднаўленне ўжо запушчана"
        },
        {
            "id": "errors.googleDriveRestoreNoData",
            "ru": "Нет данных для восстановления",
            "en": "No data to recover",
            "be": "Няма дадзеных для аднаўлення"
        },
        {
            "id": "errors.googleDriveRestoreDecryptError",
            "ru": "Ошибка расшифровки данных",
            "en": "Error decrypting data",
            "be": "Памылка расшыфроўкі дадзеных"
        },
        {
            "id": "errors.googleDriveRestoreProfileMismatch",
            "ru": "Неверный профиль",
            "en": "Invalid profile",
            "be": "Няправільны профіль"
        },
        {
            "id": "errors.googleDriveRestoreNotSupported",
            "ru": "Восстановление с Google Drive отключено",
            "en": "Google Drive recovery disabled",
            "be": "Аднаўленне з Google Drive адключана"
        },
        {
            "id": "errors.googleDriveRestoreAlreadyStarted",
            "ru": "Восстановление уже идет",
            "en": "Recovery is already in progress",
            "be": "Аднаўленне ўжо ідзе"
        },
        {
            "id": "errors.noDataOrProfileForBackup",
            "ru": "Нет данных для сохранения или неверный прифиль",
            "en": "No data to save or invalid profile",
            "be": "Няма дадзеных для захавання або няправільны профіль"
        },
        {
            "id": "errors.googleDriveBackupError",
            "ru": "Ошибка сохранения данных на Google Drive {addInfo}",
            "en": "Error saving data to Google Drive {addInfo}",
            "be": "Памылка захавання дадзеных на Google Drive {addInfo}"
        },
        {
            "id": "errors.lastBackupError",
            "ru": "Ошибка создания резервной копии: {message}",
            "en": "Error creating backup: {message}",
            "be": "Памылка стварэння рэзервовай копіі: {message}"
        },
        {
            "id": "titles.restoreGoogleBackup",
            "ru": "Восстановить из резервной копии",
            "en": "Restore from backup",
            "be": "Аднавіць з рэзервовай копіі"
        },
        {
            "id": "titles.restoreICloudBackup",
            "ru": "Восстановить из резервной копии",
            "en": "Restore from backup",
            "be": "Аднавіць з рэзервовай копіі"
        },
        {
            "id": "errors.iCloudRestoreAlreadyStarted",
            "ru": "Восстановление уже запущено",
            "en": "Recovery has already started",
            "be": "Аднаўленне ўжо запушчана"
        },
        {
            "id": "titles.restoreAfterLogin",
            "ru": "После смены устройства или переустановки приложения можно выполнить восстановление данных из резервной копии. Запустить процедуру сейчас?",
            "en": "After changing the device or reinstalling the application, you can restore data from a backup copy. Start the procedure now?",
            "be": "Пасля змены прылады або пераўсталёўкі прыкладання можна выканаць аднаўленне дадзеных з рэзервовай копіі. Запусціць працэдуру зараз?"
        },
        {
            "id": "buttons.execute",
            "ru": "ЗАПУСК",
            "en": "LAUNCH",
            "be": "ЗАПУСК"
        },
        {
            "id": "notifications.restoreCompleted",
            "ru": "Данные загружены",
            "en": "Data loaded",
            "be": "Дадзеныя загружаны"
        },
        {
            "id": "errors.restoreFailed",
            "ru": "Ошибка загрузки данных",
            "en": "Error loading data",
            "be": "Памылка загрузкі даных"
        },
        {
            "id": "errors.noCloudSelected",
            "ru": "Не выбрано облако",
            "en": "No cloud selected",
            "be": "Не выбрана воблака"
        },
        {
            "id": "errors.noProfileIdForBackup",
            "ru": "Ошибка. Не выбран профиль {message}",
            "en": "Error: Profile not selected {message}",
            "be": "Памылка. Не абраны профіль {message}"
        },
        {
            "id": "errors.googleDriveNoAccess",
            "ru": "Нет доступа к Google Drive",
            "en": "No access to Google Drive",
            "be": "Няма доступу да Google Drive"
        },
        {
            "id": "errors.iCloudRestoreNoData",
            "ru": "Нет данных для восстановления",
            "en": "No data to recover",
            "be": "Няма дадзеных для аднаўлення"
        },
        {
            "id": "titles.unknownDate",
            "ru": "Дата неизвестна",
            "en": "Date unknown",
            "be": "Дата невядома"
        },
        {
            "id": "titles.googleDriveNoBackupInfo",
            "ru": "Нет данных о резервных копиях",
            "en": "No backup data available",
            "be": "Няма дадзеных аб рэзервовых копіях"
        },
        {
            "id": "titles.iCloudNoBackupInfo",
            "ru": "Нет данных о резервных копиях",
            "en": "No backup data available",
            "be": "Няма дадзеных аб рэзервовых копіях"
        },
        {
            "id": "buttons.restoreBackup",
            "ru": "ВОССТАНОВИТЬ",
            "en": "RESTORE",
            "be": "АДНАВІЦЬ"
        },
        {
            "id": "errors.noProfile",
            "ru": "Нет профиля",
            "en": "No profile",
            "be": "Няма профілю"
        },
        {
            "id": "titles.localFileAddedMakeBackup",
            "ru": "Сейчас файлы хранятся только на этом устройстве. Включите облачное резервное копирование в настройках, чтобы иметь доступ к файлам на новом устройстве в будущем.",
            "en": "Currently, files are stored only on this device. Enable cloud backup in settings to access files on a new device in the future.",
            "be": "Цяпер файлы захоўваюцца толькі на гэтай прыладзе. Уключыце хмарнае рэзервовае капіраванне ў наладах, каб мець доступ да файлаў на новым прыладзе ў будучыні."
        },
        {
            "id": "errors.wifiDisconnect",
            "ru": "Ошибка создания резервной копии, WiFi отключен",
            "en": "Error creating backup, WiFi is off",
            "be": "Памылка стварэння рэзервовай копіі, WiFi адключаны"
        },
        {
            "id": "errors.googleDriveUploadError",
            "ru": "Ошибка создания резервной копии{addInfo}",
            "en": "Error creating backup{addInfo}",
            "be": "Памылка стварэння рэзервовай копіі{addInfo}"
        },
        {
            "id": "google.usageLimits.storageQuotaExceeded",
            "ru": ": недостаточно свободного места",
            "en": ": not enough free space",
            "be": ": недастаткова вольнага месца"
        },
        {
            "id": "titles.userCancelled",
            "ru": "Отменено пользователем",
            "en": "Cancelled by user",
            "be": "Адменена карыстальнікам"
        },
        {
            "id": "errors.googleDriveRestoreFailed",
            "ru": "Ошибка восстановления данных{addInfo}",
            "en": "Error restoring data{addInfo}",
            "be": "Памылка аднаўлення даных {addInfo}"
        },
        {
            "id": "google.global.insufficientPermissions",
            "ru": "Недостаточно прав доступа к файлам",
            "en": "Insufficient file permissions",
            "be": "Недастаткова правоў доступу да файлаў"
        },
        {
            "id": "google.global.authError",
            "ru": "Ошибка доступа к Google Drive",
            "en": "Error accessing Google Drive",
            "be": "Памылка доступу да Google Drive"
        },
        {
            "id": "notifications.attachmentsRestored",
            "ru": "Файлы восстановлены",
            "en": "Файлы восстановлены",
            "be": "Файлы адноўлены"
        },
        {
            "id": "error.wrongGooleAccount"
        },
        {
            "id": "allFeedbacks.DoctorNotFound",
            "ru": "[Доктор не найден]",
            "en": "[Doctor not found]",
            "be": "[Доктар не знойдзены]"
        },
        {
            "id": "errors.iCloudNotAccessible",
            "ru": "iCloud недоступен. Возможно нужно включить iCloud Drive в настройках устройства.",
            "en": "iCloud is unavailable. You may need to enable iCloud Drive in your device settings.",
            "be": "iCloud недаступны. Магчыма трэба ўключыць iCloud Drive у наладах прылады."
        },
        {
            "id": "buttons.executeBackupAction",
            "ru": "ЗАПУСК",
            "en": "LAUNCH",
            "be": "ЗАПУСК"
        },
        {
            "id": "titles.networkCondition",
            "ru": "УСЛОВИЯ СЕТИ",
            "en": "NETWORK CONDITIONS",
            "be": "УМОВЫ СЕЦІ"
        },
        {
            "id": "google.global.internalError",
            "ru": "Внутренняя ошибка Google Drive. Повторите позже.",
            "en": "Google Drive internal error. Please try again later.",
            "be": "Унутраная памылка Google Drive. Паўтарыце пазней."
        },
        {
            "id": "titles.consentsSubtitle",
            "ru": "Для продолжения работы просим принять условия Пользовательского соглашения и предоставить согласия на обработку персональных данных в связи с их отсутствием или истечением срока действия.",
            "en": "To continue working, please accept the terms of the User Agreement and provide consent to the processing of personal data in connection with their absence or expiration.",
            "be": "Для працягу працы просім прыняць умовы Карыстальніцкай дамовы і падаць згоды на апрацоўку персанальных дадзеных у сувязі з іх адсутнасцю або заканчэннем тэрміна дзеяння."
        },
        {
            "id": "titles.consentsSecondarySubtitle",
            "ru": "Просим предоставить согласия на обработку персональных данных в связи с их отсутствием или истечением срока действия.",
            "en": "For practical purposes, we ask you to use the minds of the Karistalnitskaya ladies and fall in time for the application of personal data in connection with their adjudication or the end of the terminology.",
            "be": "Просім прадаставіць згоды на апрацоўку персанальных дадзеных у сувязі з іх адсутнасцю або заканчэннем тэрміну дзеяння."
        },
        {
            "id": "titles.consentsOptionalSubtitle",
            "ru": "Согласия, указанные ниже, не являются обязательными, однако их отсутствие приведёт к отключению соответствующей функциональности и/или удалению данных на стороне Aibolit в отношении всех или отдельных клиник.",
            "en": "The consents specified below are not mandatory, but their absence will lead to the disabling of the relevant functionality and/or deletion of data on the Aibolit side in relation to all or individual clinics.",
            "be": "Згоды, паказаныя ніжэй, не з'яўляюцца абавязковымі, аднак іх адсутнасць прывядзе да адключэння адпаведнай функцыянальнасці і/ці выдаленні дадзеных на боку Aibolit у адносінах усіх ці асобных клінік."
        },
        {
            "id": "titles.consentsClinicSubtitle",
            "ru": "Я даю согласие на передачу в Aibolit информации обо мне, составляющей врачебную тайну (истории визитов/услуг):",
            "en": "I agree to the transfer of information about me to Aibolit that constitutes a medical secret (visit/service history):",
            "be": "Я даю згоду на перадачу ў Aibolit інфармацыі пра мяне, якая складае медычную таямніцу (гісторыі візітаў/паслуг):"
        },
        {
            "id": "titles.consentsPolicy",
            "ru": "Вы можете ознакомиться с нашей {политикой конфиденциальности::links.confidential}",
            "en": "You can read our {privacy policy::links.confidential}",
            "be": "Вы можаце азнаёміцца ​​з нашай {палітыкай прыватнасці::links.confidential}"
        },
        {
            "id": "titles.MHConsentsRetractionSubtitle",
            "ru": "Без согласия на обработку персональных данных с целью хранения и отображения истории визитов/услуг Aibolit не сможет хранить информацию об истории визитов и услуг. Все эти данные будут удалены при их наличии. Подтвердите удаление для:",
            "en": "Without consent to the processing of personal data for the purpose of storing and displaying visit/service history, Aibolit will not be able to store information about the history of visits and services. All this data will be deleted. Confirm deletion for:",
            "be": "Без згоды на апрацоўку персанальных дадзеных з мэтай захоўвання і адлюстравання гісторыі візітаў / паслуг Aibolit не зможа захоўваць інфармацыю аб гісторыі візітаў і паслуг. Усе гэтыя дадзеныя будуць выдаленыя пры іх наяўнасці. Пацвердзіце выдаленне для:"
        },
        {
            "id": "titles.MHCConsentsRetractionSubtitle",
            "ru": "Без согласия на передачу в Aibolit информации, составляющей врачебную тайну (истории визитов/услуг) приложение не сможет загружать актуальные данные об истории визитов и списках анализов из следующих медицинских центров:",
            "en": "Without consent to transfer confidential medical information (visit/service history) to Aibolit, the app will not be able to download up-to-date visit history data and test lists from the following medical centers:",
            "be": "Без згоды на перадачу ў Aibolit інфармацыі, якая складае медычную таямніцу (гісторыі візітаў/паслуг) прыкладанне не зможа загружаць актуальныя дадзеныя аб гісторыі візітаў і спісах аналізаў з наступных медыцынскіх цэнтраў:"
        },
        {
            "id": "titles.StoreProfileRetractionSubtitle",
            "ru": "Без согласия на обработку персональных данных ребенка с целью внесения информации о нем в профиль Aibolit не сможет хранить информацию о нем. Все данные о ребёнке будут удалены при их наличии. Подтвердите удаление для:",
            "en": "Without consent to process the child's personal data for the purpose of adding information about them to their profile, Aibolit will not be able to store their information. All data about the child will be deleted if available. Confirm deletion for:",
            "be": "Без згоды на апрацоўку персанальных дадзеных дзіцяці з мэтай занясення інфармацыі аб ім у профіль Aibolit не зможа захоўваць інфармацыю ім. Усе дадзеныя аб дзіцяці будуць выдаленыя пры іх наяўнасці. Пацвердзіце выдаленне для:"
        },
        {
            "id": "buttons.deleteData",
            "ru": "УДАЛИТЬ ДАННЫЕ",
            "en": "DELETE DATA",
            "be": "ВЫДАЛIТЬ ДАДЗЕНЫЯ"
        },
        {
            "id": "consents.MEDICAL_DATA_HISTORY_CHILD",
            "ru": "{aibolitPrefix} [согласие на обработку персональных данных моего ребенка с целью хранения и отображения истории визитов/услуг::links.MEDICAL_DATA_HISTORY_CHILD]",
            "en": "{aibolitPrefix} [processing my child's personal data for the purpose of storing and displaying visits/services history::links.MEDICAL_DATA_HISTORY_CHILD]",
            "be": "{aibolitPrefix} [згоду на апрацоўку персанальных дадзеных майго дзіцяці з мэтай захоўвання і адлюстравання гісторыі візітаў/паслуг::links.MEDICAL_DATA_HISTORY_CHILD]"
        },
        {
            "id": "consents.MEDICAL_DATA_HISTORY_CHILD_CLINIC",
            "ru": "{clinicPrefix} [согласие на передачу в {aibolit} информации о моем ребенке, составляющей врачебную тайну (истории визитов/услуг)::links.MEDICAL_DATA_HISTORY_CHILD_CLINIC]",
            "en": "{clinicPrefix} [transfering to Aibolit information about my child constituting medical confidentiality (history of visits/services)::links.MEDICAL_DATA_HISTORY_CHILD_CLINIC]",
            "be": "{clinicPrefix} [згоду на перадачу ў {aibolit} інфармацыі аб маім дзіцяці, якая складае медычную таямніцу (гісторыі візітаў/паслуг)::links.MEDICAL_DATA_HISTORY_CHILD_CLINIC]"
        },
        {
            "id": "consents.MEDICAL_DATA_HISTORY",
            "ru": "{aibolitPrefix} [согласие на обработку моих персональных данных с целью хранения и отображения истории визитов/услуг::links.MEDICAL_DATA_HISTORY]",
            "en": "{aibolitPrefix}[ processing my personal data for the purpose of storing and displaying the history of visits/services::links.MEDICAL_DATA_HISTORY]",
            "be": "{aibolitPrefix}{згоду на апрацоўку маіх персанальных дадзеных з мэтай захоўвання і адлюстравання гісторыі візітаў/паслуг::links.MEDICAL_DATA_HISTORY}"
        },
        {
            "id": "consents.MEDICAL_DATA_HISTORY_CLINIC",
            "ru": "{clinicPrefix} [согласие на передачу в {aibolit} информации обо мне, составляющей врачебную тайну (истории визитов/услуг)::links.MEDICAL_DATA_HISTORY_CLINIC]",
            "en": "{clinicPrefix} [transferring to Aibolit information about me constituting medical confidentiality (history of visits/services)::links.MEDICAL_DATA_HISTORY_CLINIC]",
            "be": "{clinicPrefix} [згоду на перадачу ў {aibolit} інфармацыі пра мяне, якая складае медычную таямніцу (гісторыі візітаў/паслуг)::links.MEDICAL_DATA_HISTORY_CLINIC]"
        },
        {
            "id": "consents.ONLINE_BOOKING_CLINIC",
            "ru": "{clinicPrefix} [согласие на обработку моих персональных данных для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы(ресурсы)::links.ONLINE_BOOKING_CLINIC]",
            "en": "{clinicPrefix} [processing my personal data for online appointment booking for medical services, including entering information into medical information systems/resources::links.ONLINE_BOOKING_CLINIC]",
            "be": "{clinicPrefix} [згоду на апрацоўку маіх персанальных дадзеных для анлайн-запісу на аказанне медыцынскай дапамогі з унясеннем звестак у медыцынскія інфармацыйныя сістэмы(рэсурсы)::links.ONLINE_BOOKING_CLINIC]"
        },
        {
            "id": "consents.USER_AGREEMENT",
            "ru": "Я принимаю условия [Пользовательского соглашения::links.USER_AGREEMENT]",
            "en": "I accept the terms of the [User Agreement::links.USER AGREEMENT]",
            "be": "Я прымаю ўмовы [Карыстацкай дамовы::links.USER AGREEMENT]"
        },
        {
            "id": "consents.FEEDBACK_AUTHOR_NAME",
            "ru": "{aibolitPrefix} [согласие на обработку моих персональных данных с целью размещения моих отзывов/комментариев::links.FEEDBACK_AUTTHOR_NAME]",
            "en": "{aibolitPrefix} [processing my personal data for the purpose of posting my reviews/comments::links.FEEDBACK_AUTTHOR_NAME]",
            "be": "{aibolitPrefix} [згоду на апрацоўку маіх персанальных дадзеных з мэтай размяшчэння маіх водгукаў/каментароў::links.FEEDBACK_AUTTHOR_NAME]"
        },
        {
            "id": "consents.STORE_PROFILE_CHILD",
            "ru": "{aibolitPrefix} [согласие на обработку персональных данных моего ребенка с целью внесения информации о нём в профиль::links.STORE_PROFILE_CHILD]",
            "en": "{aibolitPrefix} [processing my child's personal data for the purpose of adding their information to their profile::links.STORE_PROFILE_CHILD]",
            "be": "{aibolitPrefix} [згоду на апрацоўку персанальных дадзеных майго дзіцяці з мэтай унясення інфармацыі аб ім у профіль::links.STORE_PROFILE_CHILD]"
        },
        {
            "id": "consents.ONLINE_BOOKING_CHILD_CLINIC",
            "ru": "{clinicPrefix} [согласие на обработку персональных данных моего ребенка для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы (ресурсы)::links.ONLINE_BOOKING_CHILD_CLINIC]",
            "en": "{clinicPrefix} [processing my child's personal data for online appointment booking for medical services, including entering information into medical information systems/resources::links.ONLINE_BOOKING_CHILD_CLINIC]",
            "be": "{clinicPrefix} [згоду на апрацоўку персанальных дадзеных майго дзіцяці для анлайн-запісу на аказанне медыцынскай дапамогі з унясеннем звестак у медыцынскія інфармацыйныя сістэмы (рэсурсы)::links.ONLINE_BOOKING_CHILD_CLINIC]"
        },
        {
            "id": "titles.iGive",
            "ru": "Я даю {clinic}",
            "en": "I consent to {clinic}",
            "be": "Я даю {clinic}"
        },
        {
            "id": "titles.aibolit",
            "ru": "Aibolit",
            "en": "Aibolit",
            "be": "Aibolit"
        },
        {
            "id": "links.MEDICAL_DATA_HISTORY_CHILD",
            "ru": "https://aibolit.by/userChildAgreement",
            "en": "https://aibolit.by/userChildAgreement",
            "be": "https://aibolit.by/userChildAgreement"
        },
        {
            "id": "links.MEDICAL_DATA_HISTORY_CHILD_CLINIC",
            "ru": "https://aibolit.by/userChildClinicAgreement",
            "en": "https://aibolit.by/userChildClinicAgreement",
            "be": "https://aibolit.by/userChildClinicAgreement"
        },
        {
            "id": "links.MEDICAL_DATA_HISTORY",
            "ru": "https://aibolit.by/userClinicAgreement",
            "en": "https://aibolit.by/userClinicAgreement",
            "be": "https://aibolit.by/userClinicAgreement"
        },
        {
            "id": "links.MEDICAL_DATA_HISTORY_CLINIC",
            "ru": "https://aibolit.by/userAgreement",
            "en": "https://aibolit.by/userAgreement",
            "be": "https://aibolit.by/userAgreement"
        },
        {
            "id": "links.ONLINE_BOOKING_CLINIC",
            "ru": "https://aibolit.by/onlineBookingAgreement",
            "en": "https://aibolit.by/onlineBookingAgreement",
            "be": "https://aibolit.by/onlineBookingAgreement"
        },
        {
            "id": "links.USER_AGREEMENT",
            "ru": "https://aibolit.by/userMainAgreement",
            "en": "https://aibolit.by/userMainAgreement",
            "be": "https://aibolit.by/userMainAgreement"
        },
        {
            "id": "links.FEEDBACK_AUTHOR_NAME",
            "ru": "https://aibolit.by/userMainAgreement",
            "en": "https://aibolit.by/userMainAgreement",
            "be": "https://aibolit.by/userMainAgreement"
        },
        {
            "id": "links.STORE_PROFILE_CHILD",
            "ru": "https://aibolit.by/userMainAgreement",
            "en": "https://aibolit.by/userMainAgreement",
            "be": "https://aibolit.by/userMainAgreement"
        },
        {
            "id": "links.ONLINE_BOOKING_CHILD_CLINIC",
            "ru": "https://aibolit.by/onlineBookingChildAgreement",
            "en": "https://aibolit.by/onlineBookingChildAgreement",
            "be": "https://aibolit.by/onlineBookingChildAgreement"
        },
        {
            "id": "titles.bookConsentConfiramtionTitle1",
            "ru": "Подтверждение действия",
            "en": "Confirmation of action",
            "be": "Пацвярджэнне дзеяння"
        },
        {
            "id": "titles.bookConsentConfiramtionText1",
            "ru": "Без согласия на передачу в Aibolit информации, составляющей врачебную тайну (только история визитов и услуг, включая списки анализов, но без заключений врачей и данных о результатах исследований), а также без согласия на обработку персональных данных для хранения и отображения истории визитов и услуг, Aibolit не сможет загружать актуальные данные о вашей истории визитов и списках анализов.",
            "en": "Without your consent to transfer information constituting medical confidentiality to Aibolit (only the history of visits and services, including lists of tests, but without doctors' conclusions and data on test results), and without your consent to the processing of personal data for storing and displaying the history of visits and services, Aibolit will not be able to upload up-to-date data about your visit history and test results.",
            "be": "Без згоды на перадачу ў Aibolit інфармацыі, якая складае медычную таямніцу (толькі гісторыя візітаў і паслуг, у тым ліку спісы аналізаў, але без заключэнняў лекараў і дадзеных аб выніках даследаванняў), а таксама без згоды на апрацоўку персанальных дадзеных для захоўвання і адлюстравання гісторыі візітаў і паслуг, Aibolit не зможа загружаць актуальныя дадзеныя аб вашай гісторыі візітаў."
        },
        {
            "id": "titles.bookConsentConfiramtionTitle2",
            "ru": "Это ограничит функциональность приложения следующим образом:",
            "en": "This will limit the application's functionality in the following ways:",
            "be": "Гэта абмяжуе функцыянальнасць прыкладання наступным чынам:"
        },
        {
            "id": "titles.bookConsentConfiramtionTableItem1",
            "ru": "История визитов, совершённых вне приложения, не будет отображаться.",
            "en": "The history of visits made outside the application will not be displayed.",
            "be": "Гісторыя візітаў, здзейсненых па-за дадаткам, не будзе адлюстроўвацца."
        },
        {
            "id": "titles.bookConsentConfiramtionTableItem2",
            "ru": "Если визит будет отменён на стороне клиники, приложение продолжит отображать его как актуальный.",
            "en": "If the appointment is canceled by the clinic, the application will continue to display it as active.",
            "be": "Калі візіт будзе адменены на баку клінікі, дадатак працягне адлюстроўваць яго як актуальны."
        },
        {
            "id": "titles.bookConsentConfiramtionTableItem3",
            "ru": "Отзывы о враче будут отображаться с пометкой «Приём не подтверждён» и не будут учитываться в общем рейтинге врача.",
            "en": "Reviews of the doctor will be displayed with the label \"Appointment not confirmed\" and will not be included in the doctor's overall rating.",
            "be": "Водгукі аб лекары будуць адлюстроўвацца з пазнакай \"Прыём не пацверджаны\" і не будуць улічвацца ў агульным рэйтынгу лекара."
        },
        {
            "id": "titles.bookConsentConfiramtionFooter",
            "ru": "Пожалуйста, подтвердите продолжение работы без предоставления соответствующих согласий.",
            "en": "Please confirm that you wish to continue without providing the necessary consents.",
            "be": "Калі ласка, пацвердзіце працяг працы без прадастаўлення адпаведных згод."
        },
        {
            "id": "titles.bookConsentConfiramtionCheckbox",
            "ru": "Больше не показывать",
            "en": "Do not show again",
            "be": "Больш не паказваць"
        },
        {
            "id": "titles.DocumentsPhoto",
            "ru": "ФОТО",
            "en": "PHOTO",
            "be": "ФОТА"
        },
        {
            "id": "titles.DocumentsConsents",
            "ru": "СОГЛАСИЯ",
            "en": "CONSENTS",
            "be": "ЗГОДЫ"
        },
        {
            "id": "hints.ConsentsRevokeHint",
            "ru": "Здесь можно отозвать данные ранее согласия.",
            "en": "Here you can revoke your previous consent.",
            "be": "Тут можна адклікаць дадзеныя раней згоды."
        },
        {
            "id": "titles.ChildConsentsRevokeMDTitle",
            "ru": "Я даю согласие на обработку персональных данных моего ребенка для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы (ресурсы):",
            "en": "I agree to the processing of my child's personal data for online registration for medical care with the entry of information into medical information systems (resources):",
            "be": "Я даю згоду на апрацоўку персанальных дадзеных майго дзіцяці для анлайн-запісу на аказанне медыцынскай дапамогі з унясеннем звестак у медыцынскія інфармацыйныя сістэмы (рэсурсы):"
        },
        {
            "id": "titles.ConsentsRevokeMDTitle",
            "ru": "Я даю согласие на обработку моих персональных данных для онлайн-записи на оказание медицинской помощи с внесением сведений в медицинские информационные системы (ресурсы):",
            "en": "I agree to the processing of my personal data for online registration for medical care with the entry of information into medical information systems (resources):",
            "be": "Я даю згоду на апрацоўку маіх персанальных дадзеных для анлайн-запісу на аказанне медыцынскай дапамогі з унясеннем звестак у медыцынскія інфармацыйныя сістэмы (рэсурсы):"
        },
        {
            "id": "titles.ChildConsentsRevokeMDCTitle",
            "ru": "Я даю согласие на передачу в Aibolit информации о моем ребёнке, составляющей врачебную тайну (истории визитов/услуг):",
            "en": "I agree to the transfer of confidential medical information about my child (visit/service history) to Aibolit:",
            "be": "Я даю згоду на перадачу ў Aibolit інфармацыі пра маё дзіця, якое складае медычную таямніцу (гісторыі візітаў/паслуг):"
        },
        {
            "id": "titles.ProfileSection",
            "ru": "ПРОФИЛЬ",
            "en": "PROFILE",
            "be": "ПРОФІЛЬ"
        },
        {
            "id": "titles.unsavedChangesWillBeLost",
            "ru": "Все несохраненные изменения для {profile} будут утеряны. Переключить профиль?",
            "en": "All unsaved changes to {profile} will be lost. Switch profile?",
            "be": "Усе незахаваныя зьмены для {profile} будуць страчаны. Пераключыць профіль?"
        },
        {
            "id": "buttons.OK",
            "ru": "ОК",
            "en": "OK",
            "be": "ОК"
        },
        {
            "id": "hints.consentsLoading",
            "ru": "Обновление данных",
            "en": "Updating data",
            "be": "Абнаўленне дадзеных"
        },
        {
            "id": "errors.ErrorSetClinicConsent",
            "ru": "Ошибка установки: {consent} для клиники/клиник: {clinic}",
            "en": "Error setting: {consent} for clinic(s): {clinic}",
            "be": "Памылка ўстаноўкі: {consent} для клінікі/клінік: {clinic}"
        },
        {
            "id": "errors.ErrorSetConsent",
            "ru": "Ошибка установки согласия {consent}",
            "en": "Error setting consent {consent}",
            "be": "Памылка налады згоды {згоды}"
        },
        {
            "id": "titles.select_profile",
            "ru": "Выберите профиль",
            "en": "Select a profile",
            "be": "Абярыце профіль"
        },
        {
            "id": "titles.myProfile",
            "ru": "Мой профиль",
            "en": "My profile",
            "be": "Мой профіль"
        },
        {
            "id": "error.NoProfileIdProvided",
            "ru": "Нет идентификатора профиля",
            "en": "No profile ID",
            "be": "Няма ідэнтыфікатара профілю"
        },
        {
            "id": "errors.ErrorClinicConsent",
            "ru": "Ошибка выдачи/отзыва согласия/согласий для клиники/клиник: {clinic}",
            "en": "Error issuing/revoking consent/consents for clinic/clinics: {clinic}",
            "be": "Памылка выдачы/водгуку згоды/згоды для клінікі/клінік: {clinic}"
        },
        {
            "id": "warning.suspects",
            "ru": "Мошенники!",
            "en": "Scammers!",
            "be": "Ашуканцы!"
        }
    ],
    "locations": [
        {
            "id": "Minsk",
            "code": 17,
            "tabletkaCode": 23,
            "tabletkaCodev3": 1001,
            "latitude": 53.9045397999999,
            "longitude": 27.5615244,
            "banners": "doctors;ums;"
        },
        {
            "id": "Gomel",
            "code": 232,
            "tabletkaCode": 36,
            "tabletkaCodev3": 36,
            "latitude": 52.4411761,
            "longitude": 30.9878461,
            "banners": "doctors;ums;"
        },
        {
            "id": "Mogilev",
            "code": 222,
            "tabletkaCode": 40,
            "tabletkaCodev3": 40,
            "latitude": 53.9007158999999,
            "longitude": 30.3313598,
            "banners": "doctors;ums;"
        },
        {
            "id": "Vitebsk",
            "code": 212,
            "tabletkaCode": 19,
            "tabletkaCodev3": 19,
            "latitude": 55.1848061,
            "longitude": 30.201622,
            "banners": "doctors;ums;"
        },
        {
            "id": "Grodno",
            "code": 152,
            "tabletkaCode": 38,
            "tabletkaCodev3": 38,
            "latitude": 53.6693538,
            "longitude": 23.8131306,
            "banners": "doctors;ums"
        },
        {
            "id": "Brest",
            "code": 162,
            "tabletkaCode": 41,
            "tabletkaCodev3": 41,
            "latitude": 52.0976213999999,
            "longitude": 23.7340503,
            "banners": "doctors;ums;"
        },
        {
            "id": "Baranovichi",
            "code": 163,
            "tabletkaCode": 42,
            "tabletkaCodev3": 42,
            "latitude": 53.1255737,
            "longitude": 26.0091684,
            "banners": "doctors;ums;"
        },
        {
            "id": "Baran",
            "code": 2160001,
            "tabletkaCode": 92,
            "tabletkaCodev3": 92,
            "latitude": 54.4788881,
            "longitude": 30.3160067,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Beloozersk",
            "code": 16430001,
            "tabletkaCode": 121,
            "tabletkaCodev3": 121,
            "latitude": 52.4717355,
            "longitude": 25.1783133,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Belynichi",
            "code": 2232,
            "tabletkaCode": 14,
            "tabletkaCodev3": 145,
            "latitude": 53.9969111,
            "longitude": 29.707695,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Birch tree",
            "code": 1643,
            "tabletkaCode": 91,
            "tabletkaCodev3": 91,
            "latitude": 52.5373125,
            "longitude": 24.9788566,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Berezino",
            "code": 1715,
            "tabletkaCode": 161,
            "tabletkaCodev3": 161,
            "latitude": 53.8446885,
            "longitude": 28.9892932,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Berezovka",
            "code": 1545,
            "tabletkaCode": 43,
            "tabletkaCodev3": 43,
            "latitude": 53.7221714999999,
            "longitude": 25.5004738,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Berestovitsa",
            "code": 1511,
            "tabletkaCode": 153,
            "tabletkaCodev3": 153,
            "latitude": 53.1948656,
            "longitude": 24.0191604,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Beshenkovichi",
            "code": 2131,
            "tabletkaCode": 90,
            "tabletkaCodev3": 90,
            "latitude": 55.0437816,
            "longitude": 29.4541258,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Bobruisk",
            "code": 225,
            "tabletkaCode": 56,
            "tabletkaCodev3": 56,
            "latitude": 53.1446069,
            "longitude": 29.2213754,
            "banners": "doctors;ums;"
        },
        {
            "id": "Borisov",
            "code": 1777,
            "tabletkaCode": 48,
            "tabletkaCodev3": 48,
            "latitude": 54.2144309,
            "longitude": 28.5084359,
            "banners": "doctors;ums;"
        },
        {
            "id": "Borovliany",
            "code": 170004,
            "tabletkaCode": 95,
            "tabletkaCodev3": 95,
            "latitude": 53.9973059,
            "longitude": 27.6702388,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Bragin",
            "code": 2344,
            "tabletkaCode": 211,
            "tabletkaCodev3": 211,
            "latitude": 51.7807334,
            "longitude": 30.2746627,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Braslav",
            "code": 2153,
            "tabletkaCode": 94,
            "tabletkaCodev3": 94,
            "latitude": 55.6296375,
            "longitude": 27.0637097,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Buda-Koshelevo",
            "code": 2336,
            "tabletkaCode": 168,
            "tabletkaCodev3": 168,
            "latitude": 52.720166,
            "longitude": 30.5692564,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Byhov",
            "code": 2231,
            "tabletkaCode": 151,
            "tabletkaCodev3": 151,
            "latitude": 53.5180441,
            "longitude": 30.2402914,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Verhnedvinsk",
            "code": 2151,
            "tabletkaCode": 93,
            "tabletkaCodev3": 93,
            "latitude": 55.7784607,
            "longitude": 27.9323817,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Branch",
            "code": 2330,
            "tabletkaCode": 155,
            "tabletkaCodev3": 155,
            "latitude": 52.5662086,
            "longitude": 31.1730798,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Vileika",
            "code": 1771,
            "tabletkaCode": 89,
            "tabletkaCodev3": 89,
            "latitude": 54.4980118999999,
            "longitude": 26.9200749,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Volkovysk",
            "code": 1512,
            "tabletkaCode": 37,
            "tabletkaCodev3": 37,
            "latitude": 53.1516417,
            "longitude": 24.4422029,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Volozhin",
            "code": 1772,
            "tabletkaCode": 162,
            "tabletkaCodev3": 162,
            "latitude": 54.0878914,
            "longitude": 26.533109,
            "banners": "medcenters;drugs"
        },
        {
            "id": "raven",
            "code": 1594,
            "tabletkaCode": 167,
            "tabletkaCodev3": 167,
            "latitude": 54.1499032,
            "longitude": 25.3160275,
            "banners": "medcenters;drugs"
        },
        {
            "id": "high",
            "code": 16310001,
            "tabletkaCode": 122,
            "tabletkaCodev3": 122,
            "latitude": 52.367978,
            "longitude": 23.3759718,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Gantsevichi",
            "code": 1646,
            "tabletkaCode": 123,
            "tabletkaCodev3": 123,
            "latitude": 52.7634482,
            "longitude": 26.4275001,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Gatovo",
            "code": 170005,
            "tabletkaCode": 185,
            "tabletkaCodev3": 185,
            "latitude": 53.7852624,
            "longitude": 27.6290067,
            "banners": "medcenters;drugs"
        },
        {
            "id": "deep",
            "code": 2156,
            "tabletkaCode": 141,
            "tabletkaCodev3": 141,
            "latitude": 55.1391321,
            "longitude": 27.6842905,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Glusk",
            "code": 2230,
            "tabletkaCode": 179,
            "tabletkaCodev3": 179,
            "latitude": 52.8996249,
            "longitude": 28.6709271,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Gorki",
            "code": 2233,
            "tabletkaCode": 59,
            "tabletkaCodev3": 59,
            "latitude": 54.2825201,
            "longitude": 30.990449,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Town",
            "code": 2139,
            "tabletkaCode": 198,
            "tabletkaCodev3": 198,
            "latitude": 55.4618616,
            "longitude": 29.9874438,
            "banners": "medcenters;drugs"
        },
        {
            "id": "David-Gorodok",
            "code": 16550001,
            "tabletkaCode": 71,
            "tabletkaCodev3": 71,
            "latitude": 52.0546671,
            "longitude": 27.2119237,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Dzerzhinsk",
            "code": 1716,
            "tabletkaCode": 102,
            "tabletkaCodev3": 102,
            "latitude": 53.6855172,
            "longitude": 27.1308282,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Dobrush",
            "code": 2333,
            "tabletkaCode": 86,
            "tabletkaCodev3": 86,
            "latitude": 52.4031652,
            "longitude": 31.3294618,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Dokshitsy",
            "code": 2157,
            "tabletkaCode": 201,
            "tabletkaCodev3": 201,
            "latitude": 54.8953858,
            "longitude": 27.7599272,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Drybin",
            "code": 2248,
            "tabletkaCode": 154,
            "tabletkaCodev3": 154,
            "latitude": 54.1198580999999,
            "longitude": 31.0842154,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Drogichin",
            "code": 1644,
            "tabletkaCode": 124,
            "tabletkaCodev3": 124,
            "latitude": 52.1930413,
            "longitude": 25.1471719,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Amicable settlement.",
            "code": 17130001,
            "tabletkaCode": 96,
            "tabletkaCodev3": 96,
            "latitude": 53.6232372,
            "longitude": 27.8996001,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Dubrovno",
            "code": 2137,
            "tabletkaCode": 200,
            "tabletkaCodev3": 200,
            "latitude": 54.5734035,
            "longitude": 30.6828298,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Dyatlovo",
            "code": 1563,
            "tabletkaCode": 142,
            "tabletkaCodev3": 142,
            "latitude": 53.4651358,
            "longitude": 25.4074899,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Yelsk",
            "code": 2354,
            "tabletkaCode": 204,
            "tabletkaCodev3": 204,
            "latitude": 51.8137357,
            "longitude": 29.1596054,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Zhabinka",
            "code": 1641,
            "tabletkaCode": 50,
            "tabletkaCodev3": 50,
            "latitude": 52.1954273,
            "longitude": 24.0152827,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Zhitkovichi",
            "code": 2353,
            "tabletkaCode": 68,
            "tabletkaCodev3": 68,
            "latitude": 52.2160819,
            "longitude": 27.8502774,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Zhlobin",
            "code": 2334,
            "tabletkaCode": 24,
            "tabletkaCodev3": 24,
            "latitude": 52.8888952,
            "longitude": 30.0282481,
            "banners": "doctors;ums"
        },
        {
            "id": "Zhodino",
            "code": 1775,
            "tabletkaCode": 62,
            "tabletkaCodev3": 62,
            "latitude": 54.0957845,
            "longitude": 28.3288073,
            "banners": "doctors;ums"
        },
        {
            "id": "Zaslavl",
            "code": 170003,
            "tabletkaCode": 143,
            "tabletkaCodev3": 143,
            "latitude": 54.0006143,
            "longitude": 27.276841,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Zelva",
            "code": 1564,
            "tabletkaCode": 166,
            "tabletkaCodev3": 166,
            "latitude": 53.1482206,
            "longitude": 24.8178688,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ivanovo",
            "code": 1652,
            "tabletkaCode": 125,
            "tabletkaCodev3": 125,
            "latitude": 52.1458869999999,
            "longitude": 25.5329454,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ivatsevichi",
            "code": 1645,
            "tabletkaCode": 126,
            "tabletkaCodev3": 126,
            "latitude": 52.7079631999999,
            "longitude": 25.3353752,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ivie",
            "code": 1595,
            "tabletkaCode": 77,
            "tabletkaCodev3": 77,
            "latitude": 53.9323017,
            "longitude": 25.7774859,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kalinkovichi",
            "code": 2345,
            "tabletkaCode": 103,
            "tabletkaCodev3": 103,
            "latitude": 52.1253898999999,
            "longitude": 29.3297633,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kamenetz",
            "code": 1631,
            "tabletkaCode": 74,
            "tabletkaCodev3": 74,
            "latitude": 52.3979454,
            "longitude": 23.8257811,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kirovsk",
            "code": 2237,
            "tabletkaCode": 152,
            "tabletkaCodev3": 152,
            "latitude": 53.2691975,
            "longitude": 29.4765175,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kleck",
            "code": 1793,
            "tabletkaCode": 76,
            "tabletkaCodev3": 76,
            "latitude": 53.0637214,
            "longitude": 26.6392615,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Klimovichi",
            "code": 2244,
            "tabletkaCode": 187,
            "tabletkaCodev3": 187,
            "latitude": 53.6091856,
            "longitude": 31.9594674,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Klichev",
            "code": 2236,
            "tabletkaCode": 197,
            "tabletkaCodev3": 197,
            "latitude": 53.4917756,
            "longitude": 29.3327582,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kobrin",
            "code": 1642,
            "tabletkaCode": 127,
            "tabletkaCodev3": 127,
            "latitude": 52.2141108999999,
            "longitude": 24.3581792,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kolodishchi",
            "code": 170006,
            "tabletkaCode": 158,
            "tabletkaCodev3": 158,
            "latitude": 53.940319,
            "longitude": 27.7743309,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kopyl",
            "code": 1719,
            "tabletkaCode": 163,
            "tabletkaCodev3": 163,
            "latitude": 53.1511461,
            "longitude": 27.0908004,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Korelichi",
            "code": 1596,
            "tabletkaCode": 160,
            "tabletkaCodev3": 160,
            "latitude": 53.5666638,
            "longitude": 26.1406893,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Stern",
            "code": 2337,
            "tabletkaCode": 21,
            "tabletkaCodev3": 216,
            "latitude": 53.1307962,
            "longitude": 30.7935908999999,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kossovo",
            "code": 16450002,
            "tabletkaCode": 132,
            "tabletkaCodev3": 132,
            "latitude": 52.7567886999999,
            "longitude": 25.1531057,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Kostyukovichi",
            "code": 2245,
            "tabletkaCode": 180,
            "tabletkaCodev3": 180,
            "latitude": 53.3449659,
            "longitude": 32.0532332,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Krasnopole",
            "code": 2238,
            "tabletkaCode": 196,
            "tabletkaCodev3": 196,
            "latitude": 53.3383537,
            "longitude": 31.3972255,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Krichev",
            "code": 2241,
            "tabletkaCode": 144,
            "tabletkaCodev3": 144,
            "latitude": 53.7093085,
            "longitude": 31.7171894,
            "banners": "medcenters;drugs"
        },
        {
            "id": "round",
            "code": 2234,
            "tabletkaCode": 157,
            "tabletkaCodev3": 157,
            "latitude": 54.2483092,
            "longitude": 29.796286,
            "banners": "medcenters;drugs"
        },
        {
            "id": "grits",
            "code": 1796,
            "tabletkaCode": 164,
            "tabletkaCodev3": 164,
            "latitude": 54.3269605,
            "longitude": 29.1426031,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Lelchitsy",
            "code": 2356,
            "tabletkaCode": 69,
            "tabletkaCodev3": 69,
            "latitude": 51.7893693,
            "longitude": 28.3219949,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Lepel",
            "code": 2132,
            "tabletkaCode": 192,
            "tabletkaCodev3": 192,
            "latitude": 54.878179,
            "longitude": 28.6980563,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Lida",
            "code": 154,
            "tabletkaCode": 34,
            "tabletkaCodev3": 34,
            "latitude": 53.8873843,
            "longitude": 25.2894383,
            "banners": "doctors;ums;"
        },
        {
            "id": "Liozno",
            "code": 2138,
            "tabletkaCode": 205,
            "tabletkaCodev3": 205,
            "latitude": 55.024145,
            "longitude": 30.8005553,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Logoisk",
            "code": 1774,
            "tabletkaCode": 10,
            "tabletkaCodev3": 10,
            "latitude": 54.2042169,
            "longitude": 27.8532022,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Loev",
            "code": 2347,
            "tabletkaCode": 215,
            "tabletkaCodev3": 215,
            "latitude": 51.9377873,
            "longitude": 30.7892014,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Luninets",
            "code": 1647,
            "tabletkaCode": 128,
            "tabletkaCodev3": 128,
            "latitude": 52.2513941,
            "longitude": 26.8066432,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Luban",
            "code": 1794,
            "tabletkaCode": 165,
            "tabletkaCodev3": 165,
            "latitude": 52.7990255,
            "longitude": 27.9918895,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Lyahovichi",
            "code": 1633,
            "tabletkaCode": 129,
            "tabletkaCodev3": 129,
            "latitude": 53.0400198,
            "longitude": 26.2614111,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Malorita",
            "code": 1651,
            "tabletkaCode": 130,
            "tabletkaCodev3": 130,
            "latitude": 51.7925615,
            "longitude": 24.0739629,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Marina Gorka",
            "code": 1713,
            "tabletkaCode": 87,
            "tabletkaCodev3": 87,
            "latitude": 53.506761,
            "longitude": 28.1527803,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Machulishchy",
            "code": 170007,
            "tabletkaCode": 195,
            "tabletkaCodev3": 195,
            "latitude": 53.7741001,
            "longitude": 27.5912437,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Mikashevichi",
            "code": 16470001,
            "tabletkaCode": 70,
            "tabletkaCodev3": 70,
            "latitude": 52.2160531,
            "longitude": 27.4751997,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Miory",
            "code": 2152,
            "tabletkaCode": 99,
            "tabletkaCodev3": 99,
            "latitude": 55.6226563,
            "longitude": 27.633435,
            "banners": "medcenters;drugs"
        },
        {
            "id": "World",
            "code": 15960001,
            "tabletkaCode": 156,
            "tabletkaCodev3": 156,
            "latitude": 53.4539951,
            "longitude": 26.4698363,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Mihanovichi",
            "code": 170002,
            "tabletkaCode": 184,
            "tabletkaCodev3": 184,
            "latitude": 53.736442,
            "longitude": 27.6897704,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Mozyr",
            "code": 2351,
            "tabletkaCode": 39,
            "tabletkaCodev3": 39,
            "latitude": 52.0322082,
            "longitude": 29.222313,
            "banners": "doctors;ums"
        },
        {
            "id": "Molodechno",
            "code": 176,
            "tabletkaCode": 46,
            "tabletkaCodev3": 46,
            "latitude": 54.3104099,
            "longitude": 26.8488823,
            "banners": "medcenters;drugs"
        },
        {
            "id": "bridges",
            "code": 1515,
            "tabletkaCode": 149,
            "tabletkaCodev3": 149,
            "latitude": 53.4100252,
            "longitude": 24.5339944,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Mstislavl",
            "code": 2240,
            "tabletkaCode": 147,
            "tabletkaCodev3": 147,
            "latitude": 54.0188307,
            "longitude": 31.7244374,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Myadel",
            "code": 1797,
            "tabletkaCode": 175,
            "tabletkaCodev3": 175,
            "latitude": 54.8768843999999,
            "longitude": 26.9411901,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Narovlya",
            "code": 2355,
            "tabletkaCode": 213,
            "tabletkaCodev3": 213,
            "latitude": 51.8010382,
            "longitude": 29.4967759,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Naroch",
            "code": 17970001,
            "tabletkaCode": 176,
            "tabletkaCodev3": 176,
            "latitude": 54.9377761,
            "longitude": 26.6910443,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Nesvish",
            "code": 1770,
            "tabletkaCode": 75,
            "tabletkaCodev3": 75,
            "latitude": 53.2226037999999,
            "longitude": 26.6766138,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Novogrudok",
            "code": 1597,
            "tabletkaCode": 81,
            "tabletkaCodev3": 81,
            "latitude": 53.597736,
            "longitude": 25.8243706,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Novolukoml",
            "code": 2133,
            "tabletkaCode": 206,
            "tabletkaCodev3": 206,
            "latitude": 54.6575917,
            "longitude": 29.1509792,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Novopolotsk",
            "code": 2140001,
            "tabletkaCode": 100,
            "tabletkaCodev3": 100,
            "latitude": 55.5146431999999,
            "longitude": 28.5606438,
            "banners": "doctors;ums"
        },
        {
            "id": "October",
            "code": 2357,
            "tabletkaCode": 214,
            "tabletkaCodev3": 214,
            "latitude": 52.6473109,
            "longitude": 28.8851643999999,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Olshany",
            "code": 16550002,
            "tabletkaCode": 219,
            "tabletkaCodev3": 219,
            "latitude": 52.0718205,
            "longitude": 27.3427231,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Orsha",
            "code": 216,
            "tabletkaCode": 51,
            "tabletkaCodev3": 51,
            "latitude": 54.5071478,
            "longitude": 30.4119546,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Osipovichi",
            "code": 2235,
            "tabletkaCode": 80,
            "tabletkaCodev3": 80,
            "latitude": 53.312572,
            "longitude": 28.6411258,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ostrowiec",
            "code": 1591,
            "tabletkaCode": 169,
            "tabletkaCodev3": 169,
            "latitude": 54.6105209,
            "longitude": 25.9524709,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ostroshitsky town",
            "code": 170008,
            "tabletkaCode": 203,
            "tabletkaCodev3": 203,
            "latitude": 54.0675316,
            "longitude": 27.6962923,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Oshmjany",
            "code": 1593,
            "tabletkaCode": 150,
            "tabletkaCodev3": 150,
            "latitude": 54.4243464,
            "longitude": 25.9351597,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Petrikov",
            "code": 235,
            "tabletkaCode": 212,
            "tabletkaCodev3": 212,
            "latitude": 52.1267722,
            "longitude": 28.4919521,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Pinsk",
            "code": 165,
            "tabletkaCode": 52,
            "tabletkaCodev3": 52,
            "latitude": 52.1124966999999,
            "longitude": 26.0634602,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Pleshchenitsy",
            "code": 17740001,
            "tabletkaCode": 171,
            "tabletkaCodev3": 171,
            "latitude": 54.4225141,
            "longitude": 27.8338499,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Polotsk",
            "code": 214,
            "tabletkaCode": 72,
            "tabletkaCodev3": 72,
            "latitude": 55.4831573,
            "longitude": 28.7990619,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Postavy",
            "code": 2155,
            "tabletkaCode": 193,
            "tabletkaCodev3": 193,
            "latitude": 55.1134117,
            "longitude": 26.8433285,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Pruzhany",
            "code": 1632,
            "tabletkaCode": 65,
            "tabletkaCodev3": 65,
            "latitude": 52.5557638,
            "longitude": 24.4554644,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Rechitsa",
            "code": 2340,
            "tabletkaCode": 88,
            "tabletkaCodev3": 88,
            "latitude": 52.3635403,
            "longitude": 30.3923965,
            "banners": "doctors;ums"
        },
        {
            "id": "Rogachev",
            "code": 2339,
            "tabletkaCode": 191,
            "tabletkaCodev3": 191,
            "latitude": 53.0746613,
            "longitude": 30.0511917,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Rossony",
            "code": 2159,
            "tabletkaCode": 208,
            "tabletkaCodev3": 208,
            "latitude": 55.9014488,
            "longitude": 28.8200362,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Rudensk",
            "code": 17130002,
            "tabletkaCode": 172,
            "tabletkaCodev3": 172,
            "latitude": 53.5977081,
            "longitude": 27.8611129,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ruzhany",
            "code": 16320001,
            "tabletkaCode": 140,
            "tabletkaCodev3": 140,
            "latitude": 52.8669497,
            "longitude": 24.8920219,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Samokhvalovichy",
            "code": 170001,
            "tabletkaCode": 186,
            "tabletkaCodev3": 186,
            "latitude": 53.7411781,
            "longitude": 27.4991937,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Svetlogorsk",
            "code": 2342,
            "tabletkaCode": 79,
            "tabletkaCodev3": 79,
            "latitude": 52.6266995,
            "longitude": 29.7490257,
            "banners": "doctors;ums"
        },
        {
            "id": "Svisloch",
            "code": 1513,
            "tabletkaCode": 78,
            "tabletkaCodev3": 78,
            "latitude": 53.0358086,
            "longitude": 24.0942729,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Senno",
            "code": 2135,
            "tabletkaCode": 207,
            "tabletkaCodev3": 207,
            "latitude": 54.8133814,
            "longitude": 29.7063314,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Skidel",
            "code": 1520001,
            "tabletkaCode": 148,
            "tabletkaCodev3": 148,
            "latitude": 53.5866599,
            "longitude": 24.2503492,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Slavgorod",
            "code": 2246,
            "tabletkaCode": 146,
            "tabletkaCodev3": 146,
            "latitude": 53.4431223,
            "longitude": 30.9995629,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Slonim",
            "code": 1562,
            "tabletkaCode": 57,
            "tabletkaCodev3": 57,
            "latitude": 53.0875127,
            "longitude": 25.3087192,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Slutsk",
            "code": 1795,
            "tabletkaCode": 98,
            "tabletkaCodev3": 98,
            "latitude": 53.0210495,
            "longitude": 27.554013,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Smilovichi",
            "code": 17140001,
            "tabletkaCode": 173,
            "tabletkaCodev3": 173,
            "latitude": 53.7532734,
            "longitude": 28.0135008,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Smolevichi",
            "code": 1776,
            "tabletkaCode": 170,
            "tabletkaCodev3": 170,
            "latitude": 54.0297214,
            "longitude": 28.0892299,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Smorgon",
            "code": 1592,
            "tabletkaCode": 55,
            "tabletkaCodev3": 55,
            "latitude": 54.4762327,
            "longitude": 26.3981493,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Soligorsk",
            "code": 174,
            "tabletkaCode": 35,
            "tabletkaCodev3": 35,
            "latitude": 52.7899466,
            "longitude": 27.5359617,
            "banners": "doctors;ums"
        },
        {
            "id": "old Roads",
            "code": 1792,
            "tabletkaCode": 174,
            "tabletkaCodev3": 174,
            "latitude": 53.0389896999999,
            "longitude": 28.2605495,
            "banners": "medcenters;drugs"
        },
        {
            "id": "columns",
            "code": 1717,
            "tabletkaCode": 64,
            "tabletkaCodev3": 64,
            "latitude": 53.4806125,
            "longitude": 26.7364226,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Stolin",
            "code": 1655,
            "tabletkaCode": 131,
            "tabletkaCodev3": 131,
            "latitude": 51.8857552,
            "longitude": 26.8427098,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Telekhany",
            "code": 16450001,
            "tabletkaCode": 139,
            "tabletkaCodev3": 139,
            "latitude": 52.5153421,
            "longitude": 25.8418719,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Tolochin",
            "code": 2136,
            "tabletkaCode": 199,
            "tabletkaCodev3": 199,
            "latitude": 54.4098787,
            "longitude": 29.6935064,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Turov",
            "code": 23530001,
            "tabletkaCode": 218,
            "tabletkaCodev3": 218,
            "latitude": 52.0663389,
            "longitude": 27.7405068,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Bridle",
            "code": 1718,
            "tabletkaCode": 178,
            "tabletkaCodev3": 178,
            "latitude": 53.4619521,
            "longitude": 27.215089,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Ushachi",
            "code": 2158,
            "tabletkaCode": 209,
            "tabletkaCodev3": 209,
            "latitude": 55.1786995,
            "longitude": 28.6159395,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Fanipol",
            "code": 17160001,
            "tabletkaCode": 47,
            "tabletkaCodev3": 47,
            "latitude": 53.746238,
            "longitude": 27.3375641,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Khoiniki",
            "code": 2346,
            "tabletkaCode": 97,
            "tabletkaCodev3": 97,
            "latitude": 51.9109552,
            "longitude": 29.9994415,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Hotimsk",
            "code": 2247,
            "tabletkaCode": 188,
            "tabletkaCodev3": 188,
            "latitude": 53.4099308,
            "longitude": 32.5773652,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Chausy",
            "code": 2242,
            "tabletkaCode": 181,
            "tabletkaCodev3": 181,
            "latitude": 53.8017532,
            "longitude": 30.953397,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Chashniki",
            "code": 21330001,
            "tabletkaCode": 210,
            "tabletkaCodev3": 210,
            "latitude": 54.847813,
            "longitude": 29.1730689999999,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Cherven",
            "code": 1714,
            "tabletkaCode": 177,
            "tabletkaCodev3": 177,
            "latitude": 53.7117479,
            "longitude": 28.4244728,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Cherikov",
            "code": 2243,
            "tabletkaCode": 194,
            "tabletkaCodev3": 194,
            "latitude": 53.569694,
            "longitude": 31.37973,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Chechersk",
            "code": 2332,
            "tabletkaCode": 217,
            "tabletkaCodev3": 217,
            "latitude": 52.9186475,
            "longitude": 30.91628,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Sharkovshchina",
            "code": 2154,
            "tabletkaCode": 73,
            "tabletkaCodev3": 73,
            "latitude": 55.3682716,
            "longitude": 27.4703402,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Shklov",
            "code": 2239,
            "tabletkaCode": 53,
            "tabletkaCodev3": 53,
            "latitude": 54.2023958,
            "longitude": 30.2955436,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Shumilino",
            "code": 2130,
            "tabletkaCode": 202,
            "tabletkaCodev3": 202,
            "latitude": 55.297258,
            "longitude": 29.6092429,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Shchuchin",
            "code": 1514,
            "tabletkaCode": 67,
            "tabletkaCodev3": 67,
            "latitude": 53.6040518,
            "longitude": 24.741899,
            "banners": "medcenters;drugs"
        },
        {
            "id": "Guadalajara",
            "code": 33,
            "tabletkaCode": 0,
            "tabletkaCodev3": 0,
            "latitude": 20.6977458,
            "longitude": -103.3754735,
            "banners": "doctors;medcenters"
        },
        {
            "id": "All regions",
            "code": 0,
            "tabletkaCode": 1000,
            "tabletkaCodev3": 0,
            "latitude": 53.709807,
            "longitude": 27.953389,
            "banners": "medcenters;drugs"
        }
    ],
    "providerCode": [
        {
            "id": "tomography-minsk",
            "name": "МЦ \"Томография\"",
            "link": "https://google.com",
            "info": "{\"branches\": [{\"id\": \"5c0f8d15872be90a6\", \"name\": \"Жилуновича\"}, {\"id\": \"l1y23pk1bf4c494f7\", \"name\": \"Революционная\"}]}",
            "addInfo": "Test"
        },
        {
            "id": "lode-minsk",
            "name": "МЦ \"Лодэ\" г. Минск"
        },
        {
            "id": "semyazdorovie-gomel",
            "name": "СиЗ Гомель",
            "link": "https://f-med.by/"
        },
        {
            "id": "vnuki-minsk",
            "name": "Внуки Гиппократа из Минска",
            "link": "https://www.vgclinic.ru/"
        },
        {
            "id": "medpractika-minsk",
            "name": "Медпрактика - Минск",
            "link": "https://med-praktika.by/"
        },
        {
            "id": "horizont2-minsk",
            "name": "Два горизонта из Минска",
            "link": "https://горизонт2.бел"
        }
    ],
    "enums": {
        "detailsNavigation": [
            {
                "id": "MedCenterInfo"
            },
            {
                "id": "MedCenterServices"
            },
            {
                "id": "DoctorList"
            },
            {
                "id": "MedCenterFeedbacks"
            }
        ],
        "doctorsDetailsNavigation": [
            {
                "id": "DoctorInfo"
            },
            {
                "id": "DoctorFeedbacks"
            }
        ],
        "doctorsDetailsNavigationWithFeedbacks": [
            {
                "id": "myFeedback"
            }
        ],
        "drugstoresSortItems": [
            {
                "id": "totalPrice"
            },
            {
                "id": "distance"
            },
            {
                "id": "rank"
            }
        ],
        "locations": [
            {
                "id": "17"
            },
            {
                "id": "152"
            },
            {
                "id": "232"
            },
            {
                "id": "212"
            },
            {
                "id": "222"
            },
            {
                "id": "162"
            }
        ],
        "othersNavigation": [
            {
                "id": "about",
                "routeTo": "https://aibolit.by/about"
            },
            {
                "id": "user_agreement",
                "routeTo": "https://aibolit.by/user-agreement"
            },
            {
                "id": "privacy",
                "routeTo": "https://aibolit.by/privacy"
            },
            {
                "id": "personalData",
                "routeTo": "https://aibolit.by/pdp"
            },
            {
                "id": "support",
                "routeTo": "mailto:support@aibolit.md"
            },
            {
                "id": "improving",
                "routeTo": "https://aibolit.uservoice.com/"
            }
        ],
        "preferredDates": [
            {
                "id": "0"
            },
            {
                "id": "3"
            },
            {
                "id": "7"
            },
            {
                "id": "30"
            }
        ],
        "preferredTimes": [
            {
                "id": "0"
            },
            {
                "id": "1"
            },
            {
                "id": "2"
            },
            {
                "id": "3"
            },
            {
                "id": "4"
            }
        ],
        "preferredAges": [
            {
                "id": "0"
            },
            {
                "id": "1"
            },
            {
                "id": "2"
            }
        ],
        "popularQueries.doctors": [
            {
                "id": "Терапевт"
            },
            {
                "id": "Педиатр"
            },
            {
                "id": "Хирург"
            },
            {
                "id": "Гинеколог"
            },
            {
                "id": "Офтальмолог"
            }
        ],
        "popularQueries.drugs": [
            {
                "id": "Маска_медицинская"
            },
            {
                "id": "Фурасол"
            }
        ],
        "feedbacksSortItems": [
            {
                "id": "allFeedbacks"
            },
            {
                "id": "myFeedbacks"
            }
        ],
        "timeSortItems": [
            {
                "id": "all",
                "filterIndex": -1,
                "count": 0
            },
            {
                "id": "morning",
                "filterIndex": 0,
                "count": 0
            },
            {
                "id": "afternoon",
                "filterIndex": 1,
                "count": 0
            },
            {
                "id": "evening",
                "filterIndex": 2,
                "count": 0
            }
        ],
        "navigationItemsList": [
            {
                "id": "doctors"
            },
            {
                "id": "drugs"
            },
            {
                "id": "ums"
            },
            {
                "id": "medcenters"
            }
        ],
        "doctorSort": [
            {
                "id": "byDate"
            },
            {
                "id": "byName"
            },
            {
                "id": "byFeedbacks"
            },
            {
                "id": "byRecommend"
            },
            {
                "id": "byRecommendIndex"
            }
        ],
        "rel": [
            {
                "id": "CHILD"
            },
            {
                "id": "SPOUSE"
            },
            {
                "id": "OWNER"
            }
        ],
        "sex": [
            {
                "id": "FEMALE"
            },
            {
                "id": "MALE"
            }
        ],
        "relKindWithOther": [
            {
                "id": "SPOUSE"
            },
            {
                "id": "PARENT"
            },
            {
                "id": "OTHER"
            }
        ],
        "relKind": [
            {
                "id": "SPOUSE"
            },
            {
                "id": "PARENT"
            }
        ],
        "corporatePrograms": [
            {
                "id": "no",
                "routeTo": "Home"
            },
            {
                "id": "epam",
                "routeTo": "EpamSignIn"
            },
            {
                "id": "bns",
                "routeTo": "BnsSignIn"
            }
        ],
        "visitsInvoicesItems": [
            {
                "id": "visits",
                "filterIndex": 0
            },
            {
                "id": "invoices",
                "filterIndex": 1
            }
        ],
        "language": [
            {
                "id": "ru"
            },
            {
                "id": "en"
            },
            {
                "id": "be"
            }
        ],
        "medcenterFilter": [
            {
                "id": "any"
            },
            {
                "id": "byProgram"
            },
            {
                "id": "byOnlineService"
            }
        ],
        "doctorProfile": [
            {
                "id": "adults"
            },
            {
                "id": "children"
            }
        ],
        "reminderTime": [
            {
                "id": "30minutes"
            },
            {
                "id": "1hour"
            },
            {
                "id": "2hours"
            },
            {
                "id": "4hours"
            },
            {
                "id": "1dayMorning"
            },
            {
                "id": "1dayEvening"
            }
        ],
        "medcenterSort": [
            {
                "id": "byDoctorsCount"
            },
            {
                "id": "byMedcenterName"
            },
            {
                "id": "byFeedbacksMedcenter"
            }
        ],
        "serviceMedcentersSort": [
            {
                "id": "byOnlineBooking"
            },
            {
                "id": "byDoctorsCount"
            },
            {
                "id": "byMedcenterName"
            },
            {
                "id": "byFeedbacks"
            },
            {
                "id": "byPrice"
            }
        ],
        "preEnrollVisit": [
            {
                "id": "forMe",
                "routeTo": "EditAccount"
            },
            {
                "id": "forChild",
                "routeTo": "EditRelative"
            },
            {
                "id": "forRelative",
                "routeTo": "AddAdultRelative"
            }
        ],
        "preferredProfile": [
            {
                "id": "0"
            },
            {
                "id": "1"
            },
            {
                "id": "2"
            }
        ],
        "mcMapDetailsNavigation": [
            {
                "id": "ChooseDoctor"
            },
            {
                "id": "MedCenterInfo"
            },
            {
                "id": "MedCenterServices"
            },
            {
                "id": "MedCenterFeedbacks"
            }
        ],
        "confirmSettings": [
            {
                "id": "code"
            },
            {
                "id": "fingerprint"
            }
        ],
        "confirmSettingsFaceID": [
            {
                "id": "code"
            },
            {
                "id": "face"
            }
        ],
        "confirmSettingsTouchID": [
            {
                "id": "code"
            },
            {
                "id": "touch"
            }
        ],
        "confirmSettingsBiometrics": [
            {
                "id": "code"
            },
            {
                "id": "fingerprint"
            }
        ],
        "confirmSettingsBio": [
            {
                "id": "code"
            },
            {
                "id": "bio"
            }
        ],
        "mainScreenSettings": [
            {
                "id": "popularQueries"
            },
            {
                "id": "favorites"
            }
        ],
        "doctorFeedbackSort": [
            {
                "id": "byDateConfirmed"
            },
            {
                "id": "byDate"
            },
            {
                "id": "byUsefulCount"
            }
        ],
        "doctorAllFeedbackSort": [
            {
                "id": "byDate"
            },
            {
                "id": "byUsefulCount"
            }
        ],
        "drugstoresFilter": [
            {
                "id": "isOpen"
            },
            {
                "id": "isDelivery"
            },
            {
                "id": "isOrder"
            }
        ],
        "сlinicWarning": [
            {
                "id": "medpractika-minsk"
            },
            {
                "id": "lode-minsk"
            },
            {
                "id": "lode-brest"
            },
            {
                "id": "lode-grodno"
            },
            {
                "routeTo": "warning.suspects"
            }
        ],
        "сlinicOfflineWarning": [
            {
                "id": "lu2m4yj728d81ad29"
            },
            {
                "id": "l8jfv93u8a8c8c199"
            },
            {
                "id": "l6e9zrs0aeade99fb"
            },
            {
                "id": "kj9xyy8r216d0083c"
            },
            {
                "id": "5df0c5330b8ad9007"
            },
            {
                "id": "5bfbf3ffeee022cd3"
            },
            {
                "id": "5b3f5faa72b310212"
            },
            {
                "id": "5b3f5fa7eaf998e58"
            },
            {
                "id": "5b3f5ac1f2075180c"
            },
            {
                "id": "5b3f5fa4529813245"
            },
            {
                "routeTo": "warning.suspects"
            }
        ]
    },
    "fields": {
        "medcenterInfoFields": [
            {
                "id": "name"
            },
            {
                "id": "address",
                "type": "address"
            },
            {
                "id": "phones",
                "type": "phone"
            },
            {
                "id": "emails",
                "type": "email"
            },
            {
                "id": "schedule"
            }
        ],
        "doctorsInfoFields": [
            {
                "id": "qualification"
            },
            {
                "id": "fullName"
            },
            {
                "id": "specialization"
            },
            {
                "id": "profile",
                "type": "profile"
            },
            {
                "id": "workStart"
            },
            {
                "id": "worksAt",
                "type": "medcenter"
            }
        ],
        "doctorsInfoFieldsWithDescription": [
            {
                "id": "qualification"
            },
            {
                "id": "fullName"
            },
            {
                "id": "specialization"
            },
            {
                "id": "profile",
                "type": "profile"
            },
            {
                "id": "experienceYears"
            },
            {
                "id": "category"
            },
            {
                "id": "academicTitle"
            },
            {
                "id": "degree"
            },
            {
                "id": "workStart"
            },
            {
                "id": "worksAt",
                "type": "medcenterWithDescription",
                "typeSpec": "customRender",
                "required": "head"
            }
        ],
        "visitInfoFields": [
            {
                "id": "service",
                "type": "service"
            },
            {
                "id": "doctorInfo",
                "type": "physicianLinked"
            },
            {
                "id": "mdInfo",
                "type": "medcenterLinked"
            },
            {
                "id": "targetDateInfo"
            },
            {
                "id": "visitorNameInfo"
            },
            {
                "id": "paymentMethod",
                "type": "paymentMethod"
            }
        ],
        "enrollVisitInfoFields": [
            {
                "id": "service",
                "type": "service"
            },
            {
                "id": "serviceDescription"
            },
            {
                "id": "doctorInfo",
                "type": "physician"
            },
            {
                "id": "mdInfo",
                "type": "medcenter"
            },
            {
                "id": "date"
            },
            {
                "id": "time"
            }
        ],
        "userInfoFields": [
            {
                "id": "phone",
                "type": "text"
            },
            {
                "id": "email",
                "type": "personalEmail"
            }
        ],
        "userFields": [
            {
                "id": "phones",
                "type": "text"
            },
            {
                "id": "lastName",
                "type": "text"
            },
            {
                "id": "firstName",
                "type": "text"
            },
            {
                "id": "middleName",
                "type": "text"
            },
            {
                "id": "birthday",
                "type": "date"
            },
            {
                "id": "email",
                "type": "text"
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex"
            }
        ],
        "editAccount": [
            {
                "id": "lastName",
                "type": "text",
                "required": true
            },
            {
                "id": "firstName",
                "type": "text",
                "required": true
            },
            {
                "id": "middleName",
                "type": "text",
                "required": true
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": true
            },
            {
                "id": "birthday",
                "type": "date",
                "required": true
            }
        ],
        "addChild": [
            {
                "id": "lastName",
                "type": "text",
                "required": true
            },
            {
                "id": "firstName",
                "type": "text",
                "required": true
            },
            {
                "id": "middleName",
                "type": "text",
                "required": true
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": true
            },
            {
                "id": "birthday",
                "type": "childDate",
                "required": true
            }
        ],
        "addRelativeWithOtherInt": [
            {
                "id": "relKind",
                "type": "enum",
                "typeSpec": "relKindWithOther",
                "required": "ИСТИНА"
            },
            {
                "id": "phones",
                "type": "phone",
                "required": "ИСТИНА"
            },
            {
                "id": "lastName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "firstName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "middleName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": "ИСТИНА"
            },
            {
                "id": "birthday",
                "type": "date",
                "required": "ИСТИНА"
            }
        ],
        "addRelativeWithOther": [
            {
                "id": "relKind",
                "type": "enum",
                "typeSpec": "relKindWithOther",
                "required": "ИСТИНА"
            },
            {
                "id": "phones",
                "type": "phone",
                "required": "ИСТИНА"
            },
            {
                "id": "lastName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "firstName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "middleName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": "ИСТИНА"
            },
            {
                "id": "birthday",
                "type": "date",
                "required": "ИСТИНА"
            }
        ],
        "addRelative": [
            {
                "id": "relKind",
                "type": "enum",
                "typeSpec": "relKind",
                "required": "ИСТИНА"
            },
            {
                "id": "phones",
                "type": "phone",
                "required": "ИСТИНА"
            },
            {
                "id": "lastName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "firstName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "middleName",
                "type": "text",
                "required": "ИСТИНА"
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": "ИСТИНА"
            },
            {
                "id": "birthday",
                "type": "date",
                "required": "ИСТИНА"
            }
        ],
        "programFields": [
            {
                "id": "coverer",
                "type": "programName",
                "typeSpec": "coverer"
            },
            {
                "id": "programCaption",
                "type": "text"
            }
        ],
        "epamProgramFields": [
            {
                "id": "coverer",
                "type": "programName",
                "typeSpec": "coverer"
            },
            {
                "id": "programCaption",
                "type": "text"
            }
        ],
        "editUserAccount": [
            {
                "id": "lastName",
                "type": "text",
                "required": true
            },
            {
                "id": "firstName",
                "type": "text",
                "required": true
            },
            {
                "id": "middleName",
                "type": "text",
                "required": true
            },
            {
                "id": "sex",
                "type": "enum",
                "typeSpec": "sex",
                "required": true
            },
            {
                "id": "birthday",
                "type": "date",
                "required": true
            },
            {
                "id": "email",
                "type": "email",
                "required": true
            }
        ]
    },
    "errors": [
        {
            "code": "auth/invalid-verification-code"
        },
        {
            "code": "auth/invalid-phone-number"
        },
        {
            "code": "auth/claims-too-large"
        },
        {
            "code": "auth/code-expired"
        },
        {
            "code": "auth/id-token-expired"
        },
        {
            "code": "auth/id-token-revoked"
        },
        {
            "code": "auth/invalid-argument"
        },
        {
            "code": "auth/invalid-claims"
        },
        {
            "code": "auth/invalid-continue-uri"
        },
        {
            "code": "auth/invalid-creation-time"
        },
        {
            "code": "auth/invalid-disabled-field"
        },
        {
            "code": "auth/invalid-display-name"
        },
        {
            "code": "auth/invalid-dynamic-link-domain"
        },
        {
            "code": "auth/invalid-email-verified"
        },
        {
            "code": "auth/invalid-email"
        },
        {
            "code": "auth/invalid-hash-algorithm"
        },
        {
            "code": "auth/invalid-hash-block-size"
        },
        {
            "code": "auth/invalid-hash-derived-key-length"
        },
        {
            "code": "auth/invalid-hash-key"
        },
        {
            "code": "auth/invalid-hash-memory-cost"
        },
        {
            "code": "auth/invalid-hash-parallelization"
        },
        {
            "code": "auth/invalid-hash-rounds"
        },
        {
            "code": "auth/invalid-hash-salt-separator"
        },
        {
            "code": "auth/invalid-id-token"
        },
        {
            "code": "auth/invalid-last-sign-in-time"
        },
        {
            "code": "auth/invalid-page-token"
        },
        {
            "code": "auth/invalid-password"
        },
        {
            "code": "auth/invalid-password-hash"
        },
        {
            "code": "auth/invalid-password-salt"
        },
        {
            "code": "auth/invalid-photo-url"
        },
        {
            "code": "auth/invalid-provider-data"
        },
        {
            "code": "auth/invalid-provider-id"
        },
        {
            "code": "auth/invalid-session-cookie-duration"
        },
        {
            "code": "auth/invalid-uid"
        },
        {
            "code": "auth/invalid-user-import"
        },
        {
            "code": "auth/maximum-user-count-exceeded"
        },
        {
            "code": "auth/missing-android-pkg-name"
        },
        {
            "code": "auth/missing-continue-uri"
        },
        {
            "code": "auth/missing-hash-algorithm"
        },
        {
            "code": "auth/missing-ios-bundle-id"
        },
        {
            "code": "auth/missing-uid"
        },
        {
            "code": "auth/reserved-claims"
        },
        {
            "code": "auth/session-cookie-expired"
        },
        {
            "code": "auth/session-cookie-revoked"
        },
        {
            "code": "auth/session-expired"
        },
        {
            "code": "auth/uid-already-exists"
        },
        {
            "code": "auth/unauthorized-continue-uri"
        },
        {
            "code": "auth/email-already-exists"
        },
        {
            "code": "auth/user-not-found"
        },
        {
            "code": "auth/operation-not-allowed"
        },
        {
            "code": "auth/invalid-credential"
        },
        {
            "code": "auth/phone-number-already-exists"
        },
        {
            "code": "auth/project-not-found"
        },
        {
            "code": "auth/insufficient-permission"
        },
        {
            "code": "auth/internal-error"
        },
        {
            "code": "auth/too-many-requests"
        },
        {
            "code": "auth/app-not-authorized"
        },
        {
            "code": "auth/unknown"
        },
        {
            "code": "auth/network-request-failed"
        },
        {
            "code": "auth/network-error"
        },
        {
            "code": "ERROR_INVALID_VERIFICATION_CODE"
        },
        {
            "code": "INCORRECT_CONTRACT_CODE"
        },
        {
            "code": "EXPIRED_CONTRACT"
        },
        {
            "code": "SERVICE_IS_NOT_SUPPORTED"
        },
        {
            "code": "INCORRECT_PHONE_NUMBER"
        },
        {
            "code": "INVALID_ARGUMENT"
        },
        {
            "code": "CONTRACT_IS_NOT_SYNCHRONIZED"
        },
        {
            "code": "ERROR_NETWORK_REQUEST_FAILED"
        },
        {
            "code": "ERROR_TOO_MANY_REQUESTS"
        },
        {
            "code": "ERROR_SESSION_EXPIRED"
        },
        {
            "code": "PROFILE_MISSING"
        },
        {
            "code": "NO_CARD_FROM_COVERER"
        },
        {
            "code": "CODE_COVERER_CARD_INACTIVE"
        },
        {
            "code": "INVALID_CONTRACT_KEY"
        },
        {
            "code": "CONTRACT_NOT_READY"
        },
        {
            "code": "NO_ASSIGNMENT_BOOKING"
        }
    ],
    "synonyms": [
        {
            "name": "оториноларинголог",
            "synonyms": "лор"
        },
        {
            "name": "офтальмолог",
            "synonyms": "окулист"
        },
        {
            "name": "стоматолог",
            "synonyms": "дантист"
        },
        {
            "name": "врач ультразвуковой диагностики",
            "synonyms": "узист узи"
        },
        {
            "name": "ультразвуковой",
            "synonyms": "узист узи"
        },
        {
            "name": "стоматолог-хирург",
            "synonyms": "дантист"
        },
        {
            "name": "РЦМРиБ",
            "synonyms": "бальнео макаенка реабилитац"
        },
        {
            "name": 8,
            "synonyms": "восьмая 8гп"
        },
        {
            "name": "3я",
            "synonyms": "третья"
        },
        {
            "name": "Лодэ",
            "synonyms": "лоде lode"
        },
        {
            "name": "ЛОДЭ",
            "synonyms": "лоде lode"
        },
        {
            "name": "Элеос",
            "synonyms": "Элиос"
        },
        {
            "name": "Инвитро",
            "synonyms": "Invitro"
        },
        {
            "name": "Синэво",
            "synonyms": "Сенево Synevo"
        },
        {
            "name": "Verba",
            "synonyms": "Верба"
        },
        {
            "name": "covid",
            "synonyms": "ковид коронавирус корона тест"
        }
    ]
}